const translations = {
  en: {
    // Navigation
    nav: {
      installEsim: "Install eSIM",
      admin: "Business",
      faqs: "FAQs",
      browsePlans: "Browse Plans",
      partnerships: "Partnerships",
      dashboard: "Dashboard",
      signOut: "Sign Out",
      signIn: "Sign In",
      getTheApp: "Get the app"
    },
    // Hero Section
    hero: {
      badge: "Join thousands of travelers using Airvoy eSIM.",
      title: "The Global",
      titleHighlight: "eSIM",
      subtitle: "Stay connected like you're at home—instant setup, flexible data, and global coverage in 200+ countries.",
      searchPlaceholder: "Where are you traveling?",
      appStore: "App Store",
      googlePlay: "Google Play"
    },
    // Popular Countries
    popularCountries: {
      title: "Popular Destinations",
      subtitle: "Get connected instantly in these top travel destinations",
      fromPrice: "From",
      perDay: "/day",
      unlimited: "Unlimited",
      startingAt: "Starting at",
      getStarted: "Get Started",
      viewAllCountries: "View All Countries",
      noPlansAvailable: "No unlimited plans available"
    },
    // How It Works
    howItWorks: {
      title: "How Airvoy eSIM Works",
      subtitle: "Get connected in three simple steps",
      step1Title: "Choose Your Destination",
      step1Desc: "Browse 200+ destinations with transparent pricing. No hidden fees, no surprises—just the perfect plan for your adventure.",
      step2Title: "Install in Seconds", 
      step2Desc: "Get your eSIM instantly via email. One quick QR code scan and you're ready to go—no store visits or physical SIM swapping.",
      step3Title: "Connect Automatically",
      step3Desc: "Land and connect instantly. Your eSIM activates automatically when you arrive—skip the airport WiFi hunt forever.",
      learnMore: "Learn more"
    },
    // Benefits
    benefits: {
      whyAirvoy: "Why Airvoy?",
      title: "Stay connected wherever you go",
      item1Title: "Find a plan for you",
      item1Desc: "Flexible data plans that work for your budget. From a weekly 1 GB plan to 100 GB of data that lasts half a year — find them all in one app.",
      item2Title: "Easy to use",
      item2Desc: "Just download Airvoy, install the eSIM, and get a data plan — it will activate automatically the moment you reach your destination.",
      item3Title: "Avoid roaming costs",
      item3Desc: "Sneaky roaming fees are a thing of the past. Know how much your internet connection will cost before you leave for your trip!",
      item4Title: "One eSIM for all your trips",
      item4Desc: "Add new destinations to your existing Airvoy eSIM — no need to install new eSIMs every time. Simply top up and connect!",
      item5Title: "Never run out of data",
      item5Desc: "Don't risk running out of data at the worst possible moment — we'll notify you when you've used up 80% of your plan.",
      item6Title: "+200 countries",
      item6Desc: "Stay online in over 200 countries and territories worldwide."
    },
    // Videos
    videos: {
      title: "Watch & get connected fast",
      subtitle: "Two quick walkthroughs—one for iPhone, one for Samsung.",
      iPhoneTitle: "eSIM setup & activation — iPhone",
      iPhoneDesc: "Step-by-step guide to install and activate your Airvoy eSIM on iPhone. Scan, install, and you're online in minutes.",
      samsungTitle: "eSIM setup & activation — Samsung",
      samsungDesc: "Learn how to add your Airvoy eSIM on Samsung Galaxy devices. A quick, clear walkthrough from install to first connection.",
      iOSGuide: "iOS Guide",
      samsungGuide: "Samsung Guide",
      installationGuide: "Or read the full installation guide"
    },
    // Footer
    footer: {
      description: "Join thousands of travelers using Airvoy eSIM. Travel smart, stay connected — wherever your journey takes you.",
      company: "Company",
      aboutUs: "About Us",
      support: "Support",
      legal: "Legal",
      resources: "Resources",
      documentation: "Documentation",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      followUs: "Follow Us",
      copyright: "All rights reserved.",
      madeWith: "Made with",
      forTravelers: "for travelers worldwide"
    },
    // Auth
    aut: {
      authenticationRequired: "Authentication Required",
      signInPrompt: "Please sign in to access the dashboard and purchase eSIM plans."
    },
    // Common
    common: {
      close: "Close",
      loading: "Loading...",
      tryAgain: "Try again",
      noResults: "No countries found for"
    },
    activate: {
    altText: "Airvoy eSIM global activation",
    activeInThailand: "Airvoy active in Thailand",
    activeInSpain: "Airvoy active in Spain", 
    activeWorldwide: "Airvoy active worldwide",
    activeInGreece: "Airvoy active in Greece",
    activeInMexico: "Airvoy active in Mexico",
    title: "Keep your WhatsApp number",
    description: "You can call and message all your contacts on WhatsApp, like you're in the same country.\nDon't lose touch with family and friends."
    },
    regionalPlans: {
      multiCountryCoverage: "Multi-country coverage",
      title: "Regional Plans", 
      subtitle: "Pick a region, then choose the plan duration/data you need.",
      noPlansAvailable: "No regional plans available.",
      from: "From",
      seePlans: "See plans",
      countries: "countries",
      plans: "plans", 
      startingFrom: "Starting from",
      browseOptions: "Browse options",
      viewPlans: "View plans"
    },
    partnerships: {
      headerLabel: "PARTNERSHIPS",
      title: "Airvoy Partnerships",
      subtitle: "Let's partner up and do great things together.",
      join: "Join",
      airvoyAffiliate: "Airvoy\nAffiliate Program", 
      affiliateDescription: "Earn up to 20% commission by promoting Airvoy eSIM - join our official affiliate network today!",
      joinNow: "Join Now!",
      learnMore: "Learn more",
      partnershipImageAlt: "Airvoy Partnership",
      
      // Partnership types
      affiliateProgram: "Affiliate Program",
      eventPartnership: "Event Partnership", 
      travelPartnership: "Travel Partnership",
      contentPartnership: "Content Partnership",
      sportsPartnership: "Sports Partnership",
      musicCulturePartnership: "Music & Culture Partnership",
      athleteCollaboration: "Athlete Collaboration",
      other: "Other",
      
      // Partnership descriptions
      eventPartnerships: "Event Partnerships",
      eventDescription1: "Are you organizing an international event and you want to provide your attendees with a super useful perk: free mobile data?",
      eventDescription2: "We can custom-tailor the right solution for you and for your guests so that they can stay connected seamlessly before, during and after the event.",
      
      travelPartnerships: "Travel Partnerships",
      travelDescription1: "Are you interested in offering seamless and cheaper mobile data and voice call capabilities to your clients' employees and customers traveling abroad?",
      travelDescription2: "With our integrated mobile connectivity suite, we can help you offer your clients' value-added travel solutions with minimal effort and maximum utility.",
      
      contentPartnerships: "Content Partnerships", 
      contentDescription1: "Are you a content creator on social media with creative ideas, an engaged audience and a keen eye for useful #TravelHacks and #LifeHacks?",
      contentDescription2: "Or you simply like Airvoy and want to spread the word so that others can also enjoy seamless mobile connectivity around the globe?",
      
      sportsPartnerships: "Sports Partnerships",
      sportsDescription1: "Are you managing a sports competition and want to offer athletes, teams, and fans a reliable way to stay connected throughout the event?",
      sportsDescription2: "Partner with Airvoy to provide seamless mobile data solutions that keep everyone connected, from the opening ceremony to the final whistle.",
      
      musicCulturePartnerships: "Music & Culture Partnerships",
      musicDescription1: "Are you organizing a music festival, cultural event, or live performance and looking for ways to enhance the experience for attendees?",
      musicDescription2: "Airvoy can provide your audience with reliable mobile data services, ensuring they can share, stream, and stay connected while enjoying the event.",
      
      athleteCollaborations: "Athlete Collaborations",
      athleteDescription1: "Are you an athlete traveling the world from one competition to the next, with no space left in your trophy cabinet?",
      athleteDescription2: "Partner with Airvoy to stay connected wherever your sport takes you, and share your journey with your fans, no matter where you are.",
      
      letsTalk: "Let's Talk",
      
      // Contact form
      getInTouch: "Get in touch",
      successMessage: "Thanks for reaching out! We'll get back to you soon.",
      errorMessage: "Something went wrong. Please try again.",
      emailPlaceholder: "Enter your email",
      fullNamePlaceholder: "Full name",
      partnerTypePlaceholder: "What do you want to partner up on?",
      messagePlaceholder: "Briefly tell us what you have in mind",
      privacyConsent: "You agree to our friendly",
      privacyPolicy: "privacy policy",
      sending: "Sending...",
      send: "Send"
    },
    faq: {
      headerLabel: "FAQ",
      title: "Find the answers to some of the more frequently asked questions",
      learnMore: "Learn more",
      
      whatIsEsim: {
        question: "What is an eSIM?",
        answer: "An eSIM is an industry-standard digital SIM that allows you to activate a cellular plan from your carrier without having to use a physical SIM. You can install eight or more eSIMs on an iPhone and use two phone numbers at the same time."
      },
      
      howToSetup: {
        question: "How to setup your eSIM?",
        answer: "eSIM technology is very convenient. Setting up your eSIM however can be slightly annoying, especially if you're doing it for the first time. But fear not, we have the step-by-step guides right here to have you going Airvoy in no time."
      },
      
      whatIsAirvoy: {
        question: "What is Airvoy?",
        answer: "Airvoy is a mobile app that provides global mobile connectivity solutions. It offers a seamless way to stay connected when you travel, without the need for physical SIM cards or high roaming charges."
      },
      
      howSaveRoaming: {
        question: "How does Airvoy help me save on roaming charges?",
        answer: "It provides mobile data at rates up to 90% cheaper than typical roaming charges. This way, you can avoid the high costs associated with traditional roaming services."
      },
      
      needNewSim: {
        question: "Do I need to get a new SIM card every time I travel with Airvoy?",
        answer: "No, Airvoy uses eSIM technology, which means there's no physical SIM card involved. The Airvoy eSIM is global which means once you've downloaded and activated your eSIM, you can use it to roam globally, or you can buy new ones for specific countries."
      },
      
      constantConnectivity: {
        question: "How does Airvoy ensure constant connectivity when I travel?",
        answer: "It provides mobile data at rates up to 90% cheaper than typical roaming charges. This way, you can avoid the high costs associated with traditional roaming services."
      },
      
      freeCallsTexts: {
        question: "Does Airvoy offer free calling and texting?",
        answer: "Not yet. But Airvoy will offer free Airvoy-to-Airvoy calling and texting soon. This means you will be able stay connected with other Airvoy users at no extra cost."
      },
      
      whyChooseAirvoy: {
        question: "Why should I choose Airvoy over other roaming alternatives?",
        answer: "You should choose Airvoy over other roaming alternatives because Airvoy offers seamless global connectivity with a single eSIM, cost-effective model, and additional features like messaging (soon), and local numbers (soon), all within a user-friendly app. It is affordable, easy and puts you in full control of how you want to connect, wherever you go."
      }
    },
    browse: {
      main: {
        title: "Browse eSIM Plans",
        subtitle: "Discover eSIM plans for destinations worldwide with real-time pricing"
      },
      search: {
        placeholder: "Search countries (e.g., United States, Spain, Japan)...",
        clearSearch: "Clear search",
        noCountriesFound: "No countries found matching your search.",
        noCountriesAvailable: "No countries available.",
        clearSearchButton: "Clear search",
        searching: "Searching countries...",
        country: "country",
        countries: "countries", 
        foundFor: "found for"
      },
      loading: {
        loadingText: "Loading...",
        allCountriesLoaded: "All countries loaded",
        total: "total"
      },
      buttons: {
        showMoreCountries: "Show More Countries",
        showLessPlans: "Show Less Plans",
        showLess: "Show Less",
        seeMorePlans: "See More Plans",
        more: "more",
        buyNow: "Buy Now"
      },
      navigation: {
        backToCountries: "Back to countries"
      }, 
      countryDetails: {
        description: "Explore {{country}} with flexibility using our eSIM data plans. Whether you're visiting for a short stay or an extended trip, our plans keep you connected without the hassle."
      },
      plans: {
        noPlansAvailable: "No plans available for the selected filters.",
        planDetails: "Plan Details",
        details: "Details",
        unlimited: "Unlimited",
        for: "For",
        day: "day",
        days: "days"
      },
      checkout: {
        total: "Total"
      },
      planDetails: {
        title: "Plan Details",
        unlimitedData: "Unlimited Data",
        data: "Data",
        country: "Country",
        duration: "Duration",
        day: "day",
        days: "days",
        network: "Network", 
        autoStart: "Auto-start",
        enabled: "Enabled",
        disabled: "Disabled",
        planType: "Plan Type",
        description: "Description",
        purchaseThisPlan: "Purchase This Plan",
        signInToPurchase: "Sign In to Purchase"
      }
    },
    installation: {
      title: "How do I install and set up my eSIM?",
      metaUpdated: "2 months ago • Updated",
      intro: {
        p1: "Whether you're on Android or Apple, first check that your phone is eSIM-compatible and network-unlocked. You'll also need a stable internet connection (preferably Wi-Fi).",
        p2: "Then, you can either:",
        ol1: "Scan the QR code for automatic installation",
        ol2: "Install your eSIM manually",
        note: "Installing with a QR code is the easiest way."
      },
      ios: {
        qr: {
          title: "Install your eSIM using the QR code (iOS)",
          s1: "1. Go to Settings > Mobile Data",
          s2: "2. Tap “Add eSIM” and select Use QR code",
          s3: "3. Scan the QR code",
          s4: "4. Label your eSIM and select “Cellular Data Only” under Default Line",
          s5: "5. You should now see your eSIM under “Mobile Data”"
        },
        manual: {
          title: "How to install your eSIM manually (iOS)",
          s1: "1. Settings > Mobile Data > Add eSIM",
          s2: "2. Tap “Add eSIM” and select Use QR code",
          s3: "3. Instead of scanning, tap Enter details manually",
          s4: "4. Enter the SM-DP+ Address, Activation Code, and optional Confirmation Code from your Airvoy app",
          s5: "5. Label your eSIM and select “Cellular Data Only” under Default Line",
          s6: "6. You should now see your eSIM under Mobile Data"
        }
      },
      android: {
        qr: {
          title: "Install your eSIM using the QR code (Android)",
          s1: "1. Go to Settings > Network & Internet > SIMs",
          s2: "2. Tap the “+” icon to the right of “SIMs”",
          s3: "3. Tap “Download a SIM instead?” at the bottom",
          s4: "4. On “Download your SIM”, tap “Next” — you’ll see “Checking network info...”",
          s5: "5. After the check, a viewfinder appears to scan your QR code",
          s6: "6. Point it at a printed QR or another device displaying the code",
          s7: "7. After scanning, your device checks the info again",
          s8: "8. Tap Download to confirm — the eSIM data will download",
          s9: "9. When complete, you’ll see “Download finished”",
          s10: "10. Set up the eSIM for internet access when you’re ready."
        }
      },
      notes: {
        title: "Important Notes",
        n1: "Make sure your device is eSIM-compatible and network-unlocked",
        n2: "You'll need a stable Wi-Fi connection during installation",
        n3: "The eSIM can be installed only once — start when you’re ready",
        n4: "Keep your primary SIM active for calls and texts from your home number",
        n5: "Your eSIM will activate when you reach your destination country"
      },
      support: {
        title: "Need Help?",
        body: "If you're having trouble installing your eSIM, our support team is here to help!",
        emailLabel: "Email:",
        websiteLabel: "Website:"
      }
    },
    installGuide: {
      header: {
        title: "Complete eSIM Installation Guide",
        subtitle: "Everything you need to know to install, activate, and use your eSIM for seamless global connectivity. Follow our device-specific instructions for the smoothest setup experience.",
        link: "Check the detailed guide to install on Android too",
        ios: "Detailed guide for iOS",
        android: "Detailed guide for Android"
      },
      iphoneHero: "Install and activate your eSIM on iPhone",
      cards: {
        c1: {
          alt: "iPhone with toggle switch and clock icon",
          install: "Install",
          activate: "activate",
          textA: "just hours before your trip and",
          textB: "during your flight or when you arrive at your destination."
        },
        c2: {
          alt: "iPhone with QR code scanner interface",
          line1: "Select “Install with QR Code”",
          line2: "if you have the code on another device",
          line3: "to scan."
        },
        c3: {
          alt: "iPhone with manual installation interface",
          line1: "Select “Install Manually”",
          line2: "if you are unable to scan the QR code."
        }
      },
      learn: {
        title: "Learn step by step",
        subtitle: "Select the type of installation you wish to perform",
        btnQr: "Installation with QR code",
        btnManual: "Manual Installation"
      },
      prep: {
        alt: "Phone warning icon",
        qr: {
          title: "Before you begin installation with a QR code, there are a few important points to be aware of:",
          i1: "You must have the QR code on another screen or device to scan it with your phone camera.",
          i2: "Make sure you have a stable internet connection throughout the process.",
          i3: "Please note that the QR code can only be scanned once.",
          i4: "Do not remove the eSIM from your device as you will not be able to use it again."
        },
        manual: {
          title: "Before you begin manual installation, there are a few important points to be aware of:",
          i1: "Manual installation codes can only be used once."
        },
        shared: {
          i2: "Make sure you have a stable internet connection throughout the process.",
          i3: "Do not remove the eSIM from your device as you will not be able to use it again."
        }
      },
      start: {
        title: "Let's get started together",
        c1: {
          title: "Open your email",
          qr: { p1: "Open your email on a different device from the one you will use for installation and find the email we sent you with the QR code." },
          manual: { p1: "Check the email we sent you with both the “SM-DP+ address” and the “Activation Code” and keep them handy to start the installation. We also text them to you as an SMS." },
          shared: { missing: "If you have not received your code(s), please", contact: "contact us" }
        },
        c2: {
          qr: { title: "Scan the QR code", p1: "Open the camera on the iPhone where you will install the eSIM and scan the code. You can also go to Settings → Mobile Data and select “Add Data Plan” to scan from there." },
          manual: { title: "Open “Settings” on your iPhone", p1: "Next, go to Mobile Data, tap “Add eSIM” or “Add Data Plan” and select “Use QR Code”. Then choose “Enter Details Manually” when prompted." }
        },
        c3: {
          title: "Follow the installation steps on your iPhone",
          qr: { p1: "Scanning the code will start the installation process. Use our guide below for step-by-step configuration." },
          manual: { p1: "Once you get to “Scan QR Code”, select “Enter Details Manually” and follow the steps shown on your iPhone." }
        }
      },
      compat: {
        title: "Device Compatibility Checker",
        subtitle: "Check if your device supports eSIM technology. Use the search function to quickly find your specific device model.",
        iosTab: "iPhone / iPad",
        androidTab: "Android",
        searchIos: "Search iPhone/iPad models...",
        searchAndroid: "Search Android models...",
        iphones: "Compatible iPhones",
        ipads: "Compatible iPads (4G only)",
        androids: "Compatible Android Devices",
        noMatch: "No devices found matching your search.",
        iosNotesTitle: "Important Notes:",
        iosNotes: {
          i1: "iPhone 13 and 14 models can have two eSIMs activated simultaneously",
          i2: "iPhones from mainland China and Hong Kong lack eSIM capability (except some models)",
          i3: "iPhone 14+ models sold in the USA don't support physical SIM cards"
        },
        androidNotesTitle: "Important Restrictions:",
        androidNotes: {
          i1: "Samsung devices from the US and Hong Kong may not support eSIM",
          i2: "Google Pixel devices from Australia, Japan, and Taiwan lack eSIM support",
          i3: "Phones sold in Hong Kong generally don't support eSIM",
          i4: "Device must be carrier unlocked to use eSIM"
        },
        empty: "Start typing your device model to check compatibility"
      },
      tips: {
        title: "Pro Tips: Activate Before You Travel",
        body: "For a seamless travel experience, install your eSIM before departure and activate it upon arrival. This ensures you're connected as soon as you land, without hunting for Wi-Fi or local SIM cards.",
        before: {
          title: "Before Departure",
          i1: "Install the eSIM profile at home",
          i2: "Test the installation process",
          i3: "Keep your QR code screenshot as backup",
          i4: "Ensure your device is carrier unlocked"
        },
        after: {
          title: "Upon Arrival",
          i1: "Turn on cellular data for your eSIM",
          i2: "Wait 2–3 minutes for network registration",
          i3: "Test connectivity with a web search",
          i4: "Configure data roaming if needed"
        }
      },
      support: {
        title: "Need Additional Support?",
        body: "Our expert support team is here to help you every step of the way. From device compatibility questions to installation assistance, we've got your back.",
        btnEmail: "Email Support",
        btnCenter: "Visit Support Center"
      },
      steps: {
        ios: {
          s1: { title: "Open Settings", desc: "Go to Settings → Cellular (or Mobile Data in some regions)", detail: "Look for the “Cellular” option in your main Settings menu. In some countries, this may be labeled as “Mobile Data”." },
          s2: { title: "Add Cellular Plan", desc: "Tap “Add Cellular Plan” or “Add eSIM”", detail: "This option appears at the bottom of the Cellular settings page. If you don't see it, your device may not support eSIM." },
          s3: { title: "Scan QR Code", desc: "Choose “Use QR Code” and scan the code from your email", detail: "Point your camera at the QR code. Ensure good lighting and hold the phone steady until it recognizes the code." },
          s4: { title: "Add Cellular Plan", desc: "Tap “Add Cellular Plan” when the plan details appear", detail: "Review the carrier information and plan details before confirming. This step downloads your eSIM profile." },
          s5: { title: "Label Your Plans", desc: "Choose labels for your plans (e.g., “Primary”, “Travel”, “Secondary”)", detail: "This helps you identify which plan to use for data, calls, and messages. Most travelers use eSIM for data only." },
          s6: { title: "Configure Default Line", desc: "Select which line to use for cellular data", detail: "You can choose your eSIM for data while keeping your original SIM for calls and texts." }
        },
        android: {
          s1: { title: "Open Settings", desc: "Go to Settings → Network & Internet → SIMs", detail: "The exact path may vary by manufacturer. On Samsung devices, it might be Settings → Connections → SIM card manager." },
          s2: { title: "Add Mobile Plan", desc: "Tap the “+” button or “Add mobile plan”", detail: "Look for options like “Add mobile plan”, “Download a SIM instead”, or “Add carrier” depending on your device." },
          s3: { title: "Download SIM", desc: "Select “Don't have a SIM card?” or “Download a SIM instead”", detail: "This option tells your phone you want to install an eSIM rather than insert a physical SIM card." },
          s4: { title: "Scan QR Code", desc: "Choose “Scan QR code” and point your camera at the code", detail: "Ensure good lighting and steady hands. The camera will automatically detect and scan the QR code from your email." },
          s5: { title: "Download Profile", desc: "Tap “Download” when the carrier profile appears", detail: "Your device will connect to the internet to download the eSIM profile. This may take a few moments." },
          s6: { title: "Activate eSIM", desc: "Enable the eSIM and set it as your preferred data connection", detail: "You can choose which SIM to use for data, calls, and SMS. Most travelers use eSIM for data only." }
        }
      }
    },
    profile: {
      loading: "Loading your profile…",
      errors: {
        load: "Failed to load your eSIMs",
        delete: "Failed to delete eSIM. Please try again.",
        bundle: "Failed to fetch bundle status",
        network: "Network error while fetching bundle status",
        invoice: "Failed to download invoice"
      },
      auth: {
        title: "Authentication Required",
        subtitle: "Please sign in to view your profile and eSIM history.",
        cta: "Sign In"
      },
      header: {
        fallback: "User Profile",
        count: "{{count}} eSIM{{count, plural, =1{} other{s}}} purchased"
      }, 
      list: {
        title: "Your eSIMs",
        subtitle: "Manage your purchased profiles and access QR codes & invoices.",
        total: "{{count}} total"
      },
      empty: {
        title: "No eSIMs yet",
        subtitle: "Browse our plans to get connected in seconds—no physical SIM required.",
        cta: "Browse Plans",
        tip: "Tip: You can install an eSIM before your trip and activate it on arrival."
      },
      item: {
        country: "Country",
        statusTitle: "Current status",
        pricePaid: "Price Paid",
        purchaseDate: "Purchase Date"
      },
      actions: {
        details: "See details",
        showQr: "Show QR",
        invoice: "Invoice"
      },
      hint: "Need help installing an eSIM? On iOS: Settings → Cellular → Add eSIM. On Android: Settings → Network & Internet → SIMs → Add eSIM.",
      delete: {
        title: "Delete eSIM",
        confirm: "Are you sure you want to remove this eSIM from your history? This action cannot be undone.",
        deleting: "Deleting…",
        cta: "Delete eSIM"
      },
      details: {
        title: "eSIM Details & Live Status",
        refresh: "Refresh bundle status",
        live: "Live Bundle Status",
        updated: "Updated:",
        fetching: "Fetching real-time status...",
        ref: "Ref:",
        discount: "Discount Applied",
        usage: {
          title: "Data Usage",
          used: "Used",
          remaining: "Remaining",
          total: "Total"
        },
        assigned: "Bundle Assigned",
        plan: {
          title: "Plan Information",
          destination: "Destination",
          name: "Plan Name",
          allowance: "Data Allowance",
          validity: "Validity"
        },
        tech: {
          title: "Technical Details",
          activation: "Activation Code",
          copyActivation: "Copy activation code",
          iccid: "ICCID",
          copyIccid: "Copy ICCID",
          orderRef: "GOeSIM Order Reference"
        },
        install: {
          title: "Installation Instructions",
          iosTitle: "For iOS:",
          androidTitle: "For Android:",
          ios: "Settings → Cellular → Add eSIM → Use QR Code",
          android: "Settings → Network & Internet → SIMs → Add eSIM → Scan QR Code",
          important: "Important:",
          once: "You can only install this eSIM once. Make sure your device is unlocked and eSIM-compatible before proceeding."
        },
        purchase: {
          title: "Purchase Information",
          date: "Purchase Date",
          amount: "Amount Paid",
          method: "Payment Method",
          txn: "Transaction ID"
        },
        referral: {
          title: "Referral Discount Applied",
          code: "Referral Code",
          original: "Original Price",
          saved: "You Saved"
        },
        billing: {
          title: "Billing Information",
          name: "Full Name",
          email: "Email",
          country: "Country",
          zip: "ZIP Code"
        }
      },
      qr: {
        title: "eSIM QR Code",
        alt: "eSIM QR Code",
        copy: "Copy activation code",
        tip: "Tip: Open your phone’s camera and scan the QR. You can install an eSIM only once."
      },
      common: {
        usd: "USD",
        days: "days",
        na: "N/A",
        invalidDate: "Invalid date",
        cancel: "Cancel",
        close: "Close",
        copied: "copied"
      }
    },
    countryDetails: {
  loading: "Loading country details...",
  errors: {
    notFound: "Country not found",
    loadFail: "Failed to load country data"
  },
  notFound: {
    title: "Country Not Found",
    subtitle: "The country you're looking for doesn't exist or has no available plans.",
    cta: "Browse All Countries"
  },
  back: "Back to countries",
  blurb: "Explore {{country}} with flexibility using our eSIM data plans. Whether you're visiting for a short stay or an extended trip, our plans keep you connected without the hassle.",
  noPlans: "No plans available for the selected filters.",
  plan: {
    details: "Plan Details",
    detailsShort: "Details",
    networkBadge: "5G",
    unlimited: "Unlimited",
    unlimitedData: "Unlimited Data",
    gb: "GB",
    gbShort: "GB",
    data: "Data",
    forDays: "For {count, plural, one {# DAY} other {# DAYS}}"
  },
  currency: {
    usd: "USD" 
  },
  duration: {
    days: "{count, plural, one {# day} other {# days}}"
  },
  more: {
    more: "See More Plans",
    moreShort: "+{extra} More",
    less: "Show Less Plans",
    lessShort: "Show Less"
  },
  modal: {
    title: "Plan Details",
    country: "Country:",
    duration: "Duration:",
    network: "Network:",
    autostart: "Auto-start:",
    enabled: "Enabled",
    disabled: "Disabled",
    planType: "Plan Type:",
    description: "Description",
    purchase: "Purchase This Plan",
    signInToPurchase: "Sign In to Purchase"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "Total",
    buy: "Buy Now"
  }
    },
    checkout: {
      loading: "Loading secure checkout...",
      invalidPlan: {
        title: "Invalid Plan Data",
        subtitle: "The selected plan information could not be loaded.",
        cta: "Return to Dashboard"
      },
      success: {
        title: "Purchase Successful!",
        message: "eSIM purchased successfully! ICCID: {{iccid}}. {{targetEmail}}",
        sentBoth: "QR code and installation instructions have been sent to both {{a}} and {{b}}",
        sentOne: "QR code and installation instructions have been sent to {{email}}",
        view: "View My eSIMs"
      },
      common: {
        close: "Close"
      },
      header: {
        title: "Secure Checkout",
        subtitle: "Complete your eSIM purchase securely"
      },
      benefits: {
        title: "Sign in for benefits",
        copy: "Create an account to save your purchase history, access exclusive deals, and manage your eSIMs.",
        cta: "Sign Up / Sign In"
      },
      billing: {
        title: "Billing Information",
        subtitle: "Your invoice and eSIM will be sent to this email address"
      },
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        referral: "Referral Code (Optional)"
      },
      placeholder: {
        firstName: "Enter first name",
        lastName: "Enter last name",
        email: "Enter email address",
        referral: "Enter referral code",
        altEmail: "Enter alternative email"
      },
      referral: {
        validating: "Validating...",
        invalid: "Invalid referral code",
        ownCode: "Cannot use your own referral code",
        inactive: "This referral code is no longer active",
        used: "This referral code has been used",
        valid: "Valid! {{percent}}% discount applied",
        error: "Error validating code"
      },
      altEmail: {
        title: "Use a different email address",
        copy: "The eSIM will be sent to the different email too and saved to your account",
        input: "Alternative Email Address"
      },
      createAccount: {
        title: "Create account to save purchase history",
        copy: "Optional - helps you manage eSIMs and access support"
      },
      payment: {
        title: "Payment Details",
        secured: "Secured by Stripe",
        method: "Payment Method",
        card: "Credit or Debit Card",
        cardTypes: "Visa, Mastercard, American Express",
        paypalCopy: "Pay with PayPal",
        cardInfo: "Card Information",
        loadingSecure: "Loading secure payment form...",
        cardComplete: "Card information is complete",
        processing: "Processing Payment...",
        complete: "Complete Purchase • ${{total}}"
      },
      legal: {
        agree: "By completing the order, you agree to our",
        terms: "Terms & Conditions",
        and: "and",
        privacy: "Privacy & Refund Policies"
      },
      summary: {
        title: "Order Summary",
        planLabel: "eSIM Plan",
        digital: "Digital",
        data: "Data Allowance:",
        validity: "Validity:",
        coverage: "Coverage:",
        nationwide: "Nationwide"
      },
      pricing: {
        planPrice: "Plan Price",
        referralDiscount: "Referral Discount ({{percent}}%)",
        stripeFee: "Stripe Processing Fee",
        paypalFee: "PayPal Processing Fee",
        taxes: "Taxes & Service Fee",
        included: "Included",
        total: "Total"
      },
      paypal: {
        description: "eSIM for {{country}} - {{data}} for {{days}} days"
      },
      duration: {
        days: "{count, plural, one {# day} other {# days}}"
      },
      alerts: {
        enterName: "Please enter your complete name",
        formNotReady: "Payment form is not ready. Please wait a moment and try again.",
        cardIncomplete: "Please enter complete card information",
        paypalFailed: "PayPal payment failed: {{msg}}",
        paypalGeneric: "PayPal payment failed. Please try again.",
        purchaseFailed: "Purchase failed: {{msg}}"
      }
    },
    privacy: {
      title: "Privacy Policy",
      subtitle:
        "Statement of practices regarding the collection, use, and protection of personal information by Routed Labs, Inc.",
      lastUpdated: {
        label: "Last updated:",
        date: "August 1, 2025"
      },
      sections: {
        intro: {
          heading: "Introduction",
          p1:
            "Routed Labs, Inc. (“Routed Labs,” “we,” “our,” or “us”) operates the Airvoy website and mobile application (the “Service”). This Privacy Policy sets forth how we collect, use, disclose, and safeguard personal information. By using the Service, you consent to these practices as described herein.",
          p2:
            "Routed Labs is committed to maintaining the confidentiality, integrity, and security of your personal information. Our data practices are designed to be transparent, proportionate, and compliant with applicable laws and regulations."
        },
        collect: {
          heading: "Information We Collect",
          p1:
            "We adhere to principles of data minimization and collect only the information necessary to provide eSIM services. Specifically, we collect:",
          email: {
            title: "Email Address",
            collectedWhen: "Collected when you:",
            items: [
              "Create an account",
              "Purchase an eSIM plan",
              "Subscribe to a newsletter",
              "Contact support"
            ],
            purposeLabel: "Purpose:",
            purpose:
              "To manage accounts, deliver eSIMs, provide confirmations, and enable customer support."
          },
          notCollect: {
            title: "We do not collect:",
            items: [
              "Phone numbers or device identifiers",
              "Location or geotracking data",
              "Browsing history or behavioral cookies",
              "Social media profiles or personal photographs",
              "Financial data (payments are handled by third-party providers)"
            ]
          }
        },
        use: {
          heading: "How We Use Information",
          p1: "The collected information is used exclusively for defined purposes:",
          items: [
            "Delivery of eSIM credentials, purchase confirmations, and receipts",
            "Provision of technical and customer support",
            "Transmission of essential service updates and security notices",
            "Optional distribution of marketing materials (subject to consent)"
          ],
          optOut: "You may opt out of marketing communications at any time."
        },
        share: {
          heading: "Data Sharing and Disclosure",
          p1:
            "Personal information is not sold, rented, or traded. It may be shared only under the following circumstances:",
          items: [
            { title: "Service Providers:", body: "For functions such as payment processing or email delivery" },
            { title: "Legal Requirements:", body: "Where mandated by law, regulation, or legal proceeding" },
            { title: "Business Transactions:", body: "In connection with mergers, acquisitions, or reorganization" },
            { title: "Security:", body: "To protect the rights, property, and safety of Routed Labs and its users" }
          ]
        },
        retain: {
          heading: "Data Retention and Deletion",
          p1: "Information is retained only for as long as necessary for the purposes outlined herein:",
          items: [
            "Active accounts: Data is retained while the account remains active and up to two years following last interaction.",
            "Guest purchases: Retained for up to one year to ensure customer support and fulfillment.",
            "Upon account deletion: All personal information is permanently erased from active systems."
          ]
        },
        rights: {
          heading: "Individual Rights",
          p1: "You may exercise the following rights:",
          items: [
            "Access and obtain a copy of personal information",
            "Request correction of inaccurate data",
            "Request deletion of records",
            "Withdraw consent from marketing communications at any time"
          ],
          contactPreamble: "Requests may be submitted to"
        },
        security: {
          heading: "Data Security",
          p1:
            "Routed Labs applies appropriate technical and organizational measures to safeguard personal information, including:",
          items: [
            "Encryption in transit and at rest",
            "Regular audits and vulnerability assessments",
            "Strict access controls and authentication protocols",
            "Secure infrastructure and data centers"
          ]
        },
        contact: {
          heading: "Contact Information",
          p1:
            "Questions or concerns about this Privacy Policy may be directed to:",
          company: "Routed Labs, Inc.",
          emailLabel: "Email:",
          addressLabel: "Address:",
          address: "451 Niantic Avenue, Daly City, CA 94014, United States",
          subjectLabel: "Subject line for correspondence:",
          subject: "“Privacy Policy Inquiry”"
        },
        updates: {
          heading: "Updates to This Policy",
          p1:
            "This Privacy Policy may be revised periodically to reflect operational, legal, or regulatory changes. Material modifications will be published on this page with an updated “Last Updated” date.",
          p2:
            "Users are encouraged to review this document at regular intervals to remain informed about how Routed Labs manages personal information."
        }
      }
    },
    tos: {
  title: "Terms of Service",
  subtitle:
    "Legal terms and conditions governing use of the Airvoy platform and services provided by Routed Labs, Inc.",
  lastUpdated: { label: "Last updated:", date: "August 1, 2025" },
  sections: {
    agreement: {
      heading: "Agreement to Terms",
      p1:
        "These Terms of Service (“Terms”) constitute a legally binding agreement between the user (“you”) and Routed Labs, Inc. (“Routed Labs,” “we,” “our,” or “us”) regarding use of the Airvoy website, mobile application, and related eSIM services (collectively, the “Service”).",
      p2:
        "By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree, you must refrain from accessing or using the Service."
    },
    service: {
      heading: "Service Description",
      p1:
        "The Service provides eSIM (embedded SIM) functionality enabling users to access cellular data networks internationally. Offerings include:",
      items: [
        "Digital eSIM profiles for global connectivity",
        "Multiple data plan options with varying durations",
        "QR code delivery for activation and installation",
        "Customer support for technical inquiries",
        "Account management tools for registered users"
      ],
      notice:
        "Important: The Service requires a compatible, unlocked device. We do not guarantee compatibility with all devices or coverage in all geographic areas."
    },
    eligibility: {
      heading: "Eligibility",
      p1: "To use the Service, you represent and warrant that you:",
      items: [
        "Are at least 18 years of age or have parental consent",
        "Have the legal capacity to enter into a binding contract",
        "Provide accurate and complete registration information",
        "Possess or are authorized to use a compatible device",
        "Will comply with applicable laws and regulations"
      ]
    },
    account: {
      heading: "Account Registration",
      p1:
        "Users may purchase eSIMs either as registered account holders or as guests. Registration provides additional features, including account history and broader support.",
      registered: {
        title: "Registered Accounts",
        items: [
          "Valid email address required",
          "Responsibility to maintain account security",
          "Obligation to keep information accurate",
          "Immediate notice of unauthorized access"
        ]
      },
      guest: {
        title: "Guest Purchases",
        items: [
          "Requires email address only",
          "eSIM delivered electronically",
          "Support limited to purchase-specific matters",
          "No ongoing purchase history retained"
        ]
      }
    },
    payment: {
      heading: "Payment Terms",
      p1:
        "By completing a purchase, you authorize Routed Labs and its payment processors to charge the payment method you provide. Key terms include:",
      items: [
        "All prices are quoted in U.S. dollars and include applicable taxes",
        "Payment is due at the time of purchase",
        "Payment processing is handled by third-party providers",
        "Failure to complete payment may result in service suspension"
      ]
    },
    refunds: {
      heading: "Refund Policy",
      p1: "Refund requests are considered subject to the following conditions:",
      items: [
        "Eligible if requested within 24 hours of purchase",
        "Ineligible once eSIM has been activated or used",
        "Technical issues will be reviewed case by case",
        "Device compatibility is the responsibility of the user"
      ],
      p2: {
        prefix: "Refund requests must be submitted to ",
        suffix: ", with order details and reason provided."
      }
    },
    limitations: {
      heading: "Service Limitations",
      p1: "The Service is subject to limitations, including:",
      items: [
        "Device must be eSIM-compatible and unlocked",
        "Coverage depends on local partner networks",
        "Speed and availability vary by location",
        "Unused data expires and does not roll over",
        "Plans may not be transferred between devices"
      ]
    },
    prohibited: {
      heading: "Prohibited Uses",
      p1:
        "You agree not to use the Service for any unlawful or prohibited purpose, including but not limited to:",
      items: [
        "Unlawful activity or regulatory violations",
        "Harassment, abuse, or fraudulent activity",
        "Unauthorized network access or interference",
        "Resale or sharing of credentials without consent",
        "Excessive use impairing network performance"
      ]
    },
    liability: {
      heading: "Limitation of Liability",
      p1:
        "To the fullest extent permitted by law, Routed Labs shall not be liable for indirect, incidental, or consequential damages resulting from your use of the Service. Total liability shall not exceed the amount paid by you for the Service giving rise to the claim during the twelve (12) months preceding the claim."
    },
    indemnity: {
      heading: "Indemnification",
      p1:
        "You agree to indemnify and hold harmless Routed Labs and its affiliates against claims, damages, or expenses arising from your misuse of the Service or violation of these Terms."
    },
    termination: {
      heading: "Termination",
      p1:
        "We may suspend or terminate access to the Service immediately if you breach these Terms, engage in unlawful conduct, or otherwise act in a manner detrimental to Routed Labs or its users. Upon termination, your rights to use the Service cease immediately."
    },
    law: {
      heading: "Governing Law",
      p1:
        "These Terms are governed by the laws of the State of Delaware, United States. You agree to submit to the exclusive jurisdiction of courts located in Delaware for resolution of disputes."
    },
    amend: {
      heading: "Amendments",
      p1:
        "Routed Labs reserves the right to amend these Terms at its discretion. Updates will be published on the website and will take effect immediately unless otherwise stated. Continued use of the Service after amendments constitutes acceptance of the revised Terms."
    },
    contact: {
      heading: "Contact Information",
      p1: "For questions regarding these Terms, please contact:"
    }
  }
    },
    about: {
      title: "About Airvoy",
      sections: {
        overview: {
          heading: "Overview",
          body:
            "Airvoy is an eSIM platform developed by Routed Labs, Inc. The platform provides international travelers with accessible, affordable, and reliable mobile connectivity. By eliminating the need for physical SIM cards, the service enables seamless activation of data plans across more than 200 destinations."
        },
        mission: {
          heading: "Mission",
          body:
            "Routed Labs, Inc. operates with a singular mission: to simplify mobile connectivity. The company aims to remove uncertainty, hidden costs, and logistical obstacles associated with international roaming and SIM procurement, thereby ensuring that travelers can remain connected with ease."
        },
        background: {
          heading: "Background",
          p1:
            "Routed Labs, Inc. is headquartered in Daly City, California. Our company’s inception arose from direct experiences of the difficulties associated with staying connected internationally, including high roaming charges and limited SIM availability.",
          p2:
            "Observing these challenges, the founder identified an opportunity to leverage eSIM technology for improved global connectivity.",
          p3:
            "Today, the company supports thousands of users worldwide, with an emphasis on reliability, transparency, and accessibility."
        },
        operations: {
          heading: "Operations",
          items: [
            { title: "Global Coverage:", desc: "Access to high-speed networks in over 200 countries and territories." },
            { title: "eSIM Provisioning:", desc: "Digital plan installation within minutes, without physical SIM cards." },
            { title: "Customer Orientation:", desc: "Service and support designed to prioritize clarity and user needs." }
          ]
        },
        corporate: {
          heading: "Corporate Information",
          company: {
            title: "Company Details",
            nameLabel: "Company Name:",
            name: "Routed Labs, Inc.",
            repLabel: "Representative:",
            rep: "Hector Diaz",
            addrLabel: "Headquarters Address:",
            addr: "451 Niantic Avenue, Daly City, CA 94014, United States",
            contactLabel: "Contact:"
          },
          agent: {
            title: "Registered Agent Information",
            nameLabel: "Registered Agent Name:",
            name: "Legalinc Corporate Services Inc.",
            addrLabel: "Registered Agent Address:",
            addr: "131 Continental Dr, Suite 305, Newark, DE 19713, United States"
          }
        },
        comms: {
          heading: "Communications",
          p1: {
            prefix: "For official inquiries or correspondence, please write to",
            suffix:
              ". Corporate and legal correspondence may also be directed to the company’s registered agent, Legalinc Corporate Services Inc., at its Newark, Delaware address."
          }
        }
      }
    },
   auth: {
      titles: {
        signin: 'Welcome Back',
        signup: 'Create Account',
        forgot: 'Reset Password',
      },
      subtitles: {
        signin: 'Sign in to purchase eSIM plans',
        signup: 'Join Airvoy today',
        forgot: 'Enter your email to reset your password',
      },
      fields: {
        email: 'Email Address',
        password: 'Password',
        confirmPassword: 'Confirm Password',
      },
      placeholders: {
        email: 'Enter your email',
        password: 'Enter your password',
        confirmPassword: 'Confirm your password',
      },
      actions: {
        close: 'Close',
        continueWithGoogle: 'Continue with Google',
        signingIn: 'Signing in...',
        pleaseWait: 'Please wait...',
        signIn: 'Sign In',
        createAccount: 'Create Account',
        sendReset: 'Send Reset Email',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
      },
      labels: {
        orEmail: 'Or continue with email',
      },
      links: {
        noAccount: "Don't have an account?",
        signUp: 'Sign up',
        forgot: 'Forgot your password?',
        haveAccount: 'Already have an account?',
        signIn: 'Sign in',
        remembered: 'Remember your password?',
        backToSignIn: 'Back to sign in',
      },
      messages: {
        resetSent: 'Password reset email sent! Check your inbox.',
      },
      errors: {
        fillAll: 'Please fill in all fields',
        userNotFound: 'No account found with this email address',
        wrongPassword: 'Incorrect email or password',
        emailInUse: 'An account with this email already exists',
        weakPassword: 'Password is too weak',
        invalidEmail: 'Invalid email address',
        tooManyRequests: 'Too many failed attempts. Please try again later',
        popupClosed: 'Sign-in popup was closed before completing',
        popupCancelled: 'Sign-in was cancelled',
        popupBlocked: 'The sign-in popup was blocked by your browser',
        passwordMismatch: 'Passwords do not match',
        passwordMin: 'Password must be at least 6 characters long',
        enterEmail: 'Please enter your email address',
        generic: 'An error occurred. Please try again',
      },
      legal: {
        prefix: 'By creating an account, you agree to our',
        terms: 'Terms of Service',
        and: 'and',
        privacy: 'Privacy Policy',
      },
    },
    support: {
      title: "Support",
      contactInfo: "Contact Information",
      channels: {
        email: {
          title: "Email Support",
          description: "For inquiries, incident reports, and requests for assistance.",
          contact: "support@routedlabs.com",
          action: "Compose Email"
        },
        chat: {
          title: "Live Chat",
          description: "Real-time assistance for time-sensitive matters, subject to availability.",
          contact: "Available 09:00–18:00 Pacific Time",
          action: "Open Chat"
        }
      },
      faqTitle: "Frequently Asked Questions",
      noResults: "No entries match the current query.",
      categoryLabel: "Category:",
      show: "Show",
      hide: "Hide",
      noticesTitle: "Notices and Correspondence",
      noticesLine1: {
        before: "Official inquiries and correspondence should be directed to",
        after: "."
      },
      noticesLine2:
        "This page is intended to describe support processes and reference materials. It does not modify or replace any applicable terms of service or policies, which govern in all cases.",
      categories: {
        overview: "eSIM Overview",
        compatibility: "Device Compatibility",
        installation: "Installation",
        dualSim: "Dual SIM",
        dataUsage: "Data Usage",
        planMgmt: "Plan Management",
        deviceReqs: "Device Requirements",
        troubleshooting: "Troubleshooting",
        refunds: "Refunds",
        supportHours: "Support Availability"
      },
      faqs: {
        1: {
          q: "What is an eSIM and how does it operate?",
          a: "An eSIM (embedded SIM) is a programmable, device-resident SIM that enables activation of cellular service without a physical card. Users provision a profile digitally and can obtain connectivity by scanning a code or following configuration steps in Airvoy."
        },
        2: {
          q: "Which devices support eSIM functionality?",
          a: "Many modern smartphones implement eSIM functionality, including recent models from major manufacturers. Check device settings (often under “Cellular” or “Mobile Data”) to see if the “Add Data Plan” option is available."
        },
        3: {
          q: "How is an eSIM installed?",
          a: "After purchase, you receive installation instructions and a QR code by email. On your device, go to Settings → Cellular/Mobile Data → Add Data Plan and scan the code. Activation completes automatically after the prompts."
        },
        4: {
          q: "May a physical SIM and an eSIM be used concurrently on the same device?",
          a: "Most eSIM-capable devices support dual-SIM. You can keep your primary number for voice and messaging while using the eSIM for data. Selection is controlled in device settings."
        },
        5: {
          q: "What occurs if the allocated data is not fully consumed?",
          a: "Unused data does not roll over and is not refundable. Plans expire at the end of their validity period. Choose a plan sized to your expected travel usage."
        },
        6: {
          q: "Is it possible to add data or extend an active plan?",
          a: "Yes. You can obtain additional data or extend service by purchasing another plan through the website or your account portal, subject to availability for the destination."
        },
        7: {
          q: "Must the device be unlocked?",
          a: "Yes. To use an eSIM from a provider other than the original carrier, your device must be unlocked. If it is carrier-locked, contact your carrier to request an unlock before activation."
        },
        8: {
          q: "What steps should be taken if the eSIM does not function as expected?",
          a: "Verify the device is unlocked and eSIM-capable. Ensure data roaming is enabled, the correct data plan is selected, and try restarting the device. If issues persist, contact support."
        },
        9: {
          q: "Are refunds available?",
          a: "Refunds may be available within 24 hours of purchase if the eSIM has not been activated or used. Once activated, sales are final. For technical issues, support will attempt remediation or issue account credit where appropriate."
        },
        10: {
          q: "What are the support hours and response expectations?",
          a: "Email support is available continuously. Typical response times are within several hours. Time-sensitive issues reported while traveling receive elevated priority."
        }
      }
    }
  },
  ar: {
    // Navigation
    nav: {
      installEsim: "تثبيت eSIM",
      admin: "لوحة الإدارة",
      faqs: "الأسئلة الشائعة",
      browsePlans: "تصفح الخطط",
      partnerships: "الشراكات",
      dashboard: "لوحة التحكم",
      signOut: "تسجيل الخروج",
      signIn: "تسجيل الدخول",
      getTheApp: "احصل على التطبيق"
    },
    // Hero Section
    hero: {
      badge: "انضم إلى أكثر من 30,000 مسافر يستخدمون Airvoy eSIM.",
      title: "الـ",
      titleHighlight: "eSIM العالمي",
      subtitle: "ابق متصلاً كما لو كنت في المنزل - إعداد فوري، بيانات مرنة، وتغطية عالمية في أكثر من 200 دولة.",
      searchPlaceholder: "إلى أين تسافر؟",
      appStore: "متجر التطبيقات",
      googlePlay: "جوجل بلاي"
    },
    // Popular Countries
    popularCountries: {
      title: "الوجهات الشائعة",
      subtitle: "تواصل فورياً في هذه الوجهات السياحية الرائدة",
      fromPrice: "من",
      perDay: "/يوم",
      unlimited: "غير محدود",
      startingAt: "ابتداء من",
      getStarted: "ابدأ الآن",
      viewAllCountries: "عرض جميع البلدان",
      noPlansAvailable: "لا توجد خطط غير محدودة متاحة"
    },
    // How It Works
    howItWorks: {
      title: "كيف يعمل Airvoy eSIM",
      subtitle: "تواصل في ثلاث خطوات بسيطة",
      step1Title: "اختر وجهتك",
      step1Desc: "تصفح أكثر من 200 وجهة بأسعار شفافة. لا رسوم مخفية، لا مفاجآت - فقط الخطة المثالية لمغامرتك.",
      step2Title: "التثبيت في ثوان",
      step2Desc: "احصل على eSIM فورياً عبر البريد الإلكتروني. مسح سريع لرمز QR وستكون جاهزاً - لا حاجة لزيارة المتجر أو تبديل SIM فعلي.",
      step3Title: "الاتصال التلقائي",
      step3Desc: "اهبط واتصل فورياً. سيتم تفعيل eSIM تلقائياً عند وصولك - تخطى البحث عن WiFi في المطار إلى الأبد.",
      learnMore: "تعلم أكثر"
    },
    // Benefits
    benefits: {
      whyAirvoy: "لماذا Airvoy؟",
      title: "ابق متصلاً أينما ذهبت",
      item1Title: "اعثر على خطة لك",
      item1Desc: "خطط بيانات مرنة تناسب ميزانيتك. من خطة أسبوعية 1 جيجا إلى 100 جيجا تدوم نصف سنة - اعثر عليها جميعاً في تطبيق واحد.",
      item2Title: "سهل الاستخدام",
      item2Desc: "فقط حمل Airvoy، ثبت eSIM، واحصل على خطة بيانات - ستتفعل تلقائياً لحظة وصولك إلى وجهتك.",
      item3Title: "تجنب تكاليف التجوال",
      item3Desc: "رسوم التجوال الخفية أصبحت من الماضي. اعرف كم ستكلف اتصالك بالإنترنت قبل مغادرتك لرحلتك!",
      item4Title: "eSIM واحد لجميع رحلاتك",
      item4Desc: "أضف وجهات جديدة لـ Airvoy eSIM الموجود لديك - لا حاجة لتثبيت eSIMs جديدة في كل مرة. فقط اشحن واتصل!",
      item5Title: "لن تنفد البيانات أبداً",
      item5Desc: "لا تخاطر بنفاد البيانات في أسوأ لحظة ممكنة - سنخطرك عندما تستخدم 80% من خطتك.",
      item6Title: "+200 دولة",
      item6Desc: "ابق متصلاً في أكثر من 200 دولة وإقليم حول العالم."
    },
    // Videos
    videos: {
      title: "شاهد واتصل بسرعة",
      subtitle: "شرحان سريعان - واحد لآيفون، وواحد لسامسونج.",
      iPhoneTitle: "إعداد وتفعيل eSIM — آيفون",
      iPhoneDesc: "دليل خطوة بخطوة لتثبيت وتفعيل Airvoy eSIM على آيفون. امسح، ثبت، وستكون متصلاً في دقائق.",
      samsungTitle: "إعداد وتفعيل eSIM — سامسونج",
      samsungDesc: "تعلم كيفية إضافة Airvoy eSIM على أجهزة سامسونج جالاكسي. شرح سريع وواضح من التثبيت حتى الاتصال الأول.",
      iOSGuide: "دليل iOS",
      samsungGuide: "دليل سامسونج",
      installationGuide: "أو اقرأ دليل التثبيت الكامل"
    },
    // Footer
    footer: {
      description: "انضم إلى أكثر من 30,000 مسافر يستخدمون Airvoy eSIM. سافر بذكاء، ابق متصلاً - أينما أخذتك رحلتك.",
      company: "الشركة",
      aboutUs: "معلومات عنا",
      resources: "الموارد",
      documentation: "التوثيق",
      support: "الدعم",
      legal: "قانوني",
      privacyPolicy: "سياسة الخصوصية",
      termsOfService: "شروط الخدمة",
      followUs: "تابعنا",
      copyright: "جميع الحقوق محفوظة.",
      madeWith: "صنع بـ",
      forTravelers: "للمسافرين حول العالم"
    },
    // Auth
    aut: {
      authenticationRequired: "المصادقة مطلوبة",
      signInPrompt: "يرجى تسجيل الدخول للوصول إلى لوحة التحكم وشراء خطط eSIM."
    },
    // Common
    common: {
      close: "إغلاق",
      loading: "جاري التحميل...",
      tryAgain: "حاول مرة أخرى",
      noResults: "لم يتم العثور على دول لـ"
    },
    activate: {
    altText: "تفعيل Airvoy eSIM العالمي",
    activeInThailand: "Airvoy نشط في تايلاند",
    activeInSpain: "Airvoy نشط في إسبانيا",
    activeWorldwide: "Airvoy نشط في جميع أنحاء العالم",
    activeInGreece: "Airvoy نشط في اليونان",
    activeInMexico: "Airvoy نشط في المكسيك",
    title: "احتفظ برقم واتساب الخاص بك",
    description: "يمكنك الاتصال ومراسلة جميع جهات الاتصال على واتساب، كما لو كنت في نفس البلد.\nلا تفقد التواصل مع العائلة والأصدقاء."
    },
    regionalPlans: {
      multiCountryCoverage: "تغطية متعددة البلدان",
      title: "الخطط الإقليمية",
      subtitle: "اختر منطقة، ثم اختر مدة الخطة/البيانات التي تحتاجها.",
      noPlansAvailable: "لا توجد خطط إقليمية متاحة.",
      from: "من",
      seePlans: "عرض الخطط", 
      countries: "دولة",
      plans: "خطة",
      startingFrom: "ابتداء من",
      browseOptions: "تصفح الخيارات",
      viewPlans: "عرض الخطط"
    },
    partnerships: {
    headerLabel: "الشراكات",
    title: "شراكات Airvoy",
    subtitle: "دعونا نشارك ونقوم بأشياء عظيمة معاً.",
    join: "انضم",
    airvoyAffiliate: "برنامج\nشركاء Airvoy", 
    affiliateDescription: "اكسب عمولة تصل إلى 20% من خلال الترويج لـ Airvoy eSIM - انضم إلى شبكة الشركاء الرسمية اليوم!",
    joinNow: "انضم الآن!",
    learnMore: "تعلم أكثر",
    partnershipImageAlt: "شراكة Airvoy",
    
    // Partnership types
    affiliateProgram: "برنامج الشركاء",
    eventPartnership: "شراكة الأحداث", 
    travelPartnership: "شراكة السفر",
    contentPartnership: "شراكة المحتوى",
    sportsPartnership: "شراكة الرياضة",
    musicCulturePartnership: "شراكة الموسيقى والثقافة",
    athleteCollaboration: "تعاون مع الرياضيين",
    other: "أخرى",
    
    // Partnership descriptions
    eventPartnerships: "شراكات الأحداث",
    eventDescription1: "هل تنظم حدثاً دولياً وتريد أن توفر للحضور ميزة مفيدة للغاية: بيانات الجوال المجانية؟",
    eventDescription2: "يمكننا تخصيص الحل المناسب لك ولضيوفك حتى يتمكنوا من البقاء متصلين بسلاسة قبل وأثناء وبعد الحدث.",
    
    travelPartnerships: "شراكات السفر",
    travelDescription1: "هل أنت مهتم بتقديم قدرات بيانات الجوال والمكالمات الصوتية السلسة والأرخص لموظفي عملائك والعملاء الذين يسافرون إلى الخارج؟",
    travelDescription2: "مع مجموعة الاتصال المحمول المتكاملة لدينا، يمكننا مساعدتك في تقديم حلول السفر ذات القيمة المضافة لعملائك بأقل جهد وأقصى فائدة.",
    
    contentPartnerships: "شراكات المحتوى", 
    contentDescription1: "هل أنت منشئ محتوى على وسائل التواصل الاجتماعي مع أفكار إبداعية وجمهور متفاعل وعين حادة للـ #نصائح_السفر و #نصائح_الحياة المفيدة؟",
    contentDescription2: "أم أنك ببساطة تحب Airvoy وتريد نشر الكلمة حتى يتمكن الآخرون أيضاً من الاستمتاع بالاتصال المحمول السلس حول العالم؟",
    
    sportsPartnerships: "شراكات الرياضة",
    sportsDescription1: "هل تدير مسابقة رياضية وتريد أن توفر للرياضيين والفرق والمشجعين طريقة موثوقة للبقاء متصلين طوال الحدث؟",
    sportsDescription2: "شارك مع Airvoy لتوفير حلول بيانات الجوال السلسة التي تبقي الجميع متصلين، من حفل الافتتاح إلى الصافرة الأخيرة.",
    
    musicCulturePartnerships: "شراكات الموسيقى والثقافة",
    musicDescription1: "هل تنظم مهرجاناً موسيقياً أو حدثاً ثقافياً أو أداءً مباشراً وتبحث عن طرق لتعزيز تجربة الحضور؟",
    musicDescription2: "يمكن لـ Airvoy أن توفر لجمهورك خدمات بيانات الجوال الموثوقة، مما يضمن قدرتهم على المشاركة والبث والبقاء متصلين أثناء الاستمتاع بالحدث.",
    
    athleteCollaborations: "تعاون مع الرياضيين",
    athleteDescription1: "هل أنت رياضي تسافر حول العالم من مسابقة إلى أخرى، بدون مساحة متبقية في خزانة الجوائز؟",
    athleteDescription2: "شارك مع Airvoy لتبقى متصلاً أينما تأخذك رياضتك، وشارك رحلتك مع معجبيك، بغض النظر عن مكان وجودك.",
    
    letsTalk: "لنتحدث",
    
    // Contact form
    getInTouch: "تواصل معنا",
    successMessage: "شكراً لتواصلك معنا! سنعود إليك قريباً.",
    errorMessage: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    fullNamePlaceholder: "الاسم الكامل",
    partnerTypePlaceholder: "ما نوع الشراكة التي تريدها؟",
    messagePlaceholder: "أخبرنا باختصار بما تفكر فيه",
    privacyConsent: "أنت توافق على",
    privacyPolicy: "سياسة الخصوصية",
    sending: "جاري الإرسال...",
    send: "إرسال"
    },
    faq: {
      headerLabel: "الأسئلة الشائعة",
      title: "اعثر على إجابات لبعض الأسئلة الأكثر شيوعاً",
      learnMore: "تعلم أكثر",
      
      whatIsEsim: {
        question: "ما هو eSIM؟",
        answer: "eSIM هو SIM رقمي معياري في الصناعة يسمح لك بتفعيل خطة خلوية من مقدم الخدمة بدون الحاجة لاستخدام SIM فعلي. يمكنك تثبيت ثمانية أو أكثر من eSIMs على آيفون واستخدام رقمين هاتف في نفس الوقت."
      },
      
      howToSetup: {
        question: "كيفية إعداد eSIM؟",
        answer: "تقنية eSIM مريحة جداً. إعداد eSIM الخاص بك قد يكون مزعجاً قليلاً، خاصة إذا كنت تفعل ذلك لأول مرة. لكن لا تخف، لدينا أدلة خطوة بخطوة هنا لتجعلك تستخدم Airvoy في وقت قصير."
      },
      
      whatIsAirvoy: {
        question: "ما هو Airvoy؟",
        answer: "Airvoy هو تطبيق محمول يوفر حلول الاتصال المحمول العالمي. يقدم طريقة سلسة للبقاء متصلاً عند السفر، بدون الحاجة لبطاقات SIM فعلية أو رسوم تجوال عالية."
      },
      
      howSaveRoaming: {
        question: "كيف يساعدني Airvoy في توفير رسوم التجوال؟",
        answer: "يوفر بيانات محمولة بأسعار أرخص بنسبة تصل إلى 90% من رسوم التجوال التقليدية. بهذه الطريقة، يمكنك تجنب التكاليف العالية المرتبطة بخدمات التجوال التقليدية."
      },
      
      needNewSim: {
        question: "هل أحتاج للحصول على بطاقة SIM جديدة في كل مرة أسافر فيها مع Airvoy؟",
        answer: "لا، يستخدم Airvoy تقنية eSIM، مما يعني عدم وجود بطاقة SIM فعلية. Airvoy eSIM عالمي مما يعني أنه بمجرد تحميل وتفعيل eSIM، يمكنك استخدامه للتجوال عالمياً، أو يمكنك شراء بطاقات جديدة لدول محددة."
      },
      
      constantConnectivity: {
        question: "كيف يضمن Airvoy الاتصال المستمر عند السفر؟",
        answer: "يوفر بيانات محمولة بأسعار أرخص بنسبة تصل إلى 90% من رسوم التجوال التقليدية. بهذه الطريقة، يمكنك تجنب التكاليف العالية المرتبطة بخدمات التجوال التقليدية."
      },
      
      freeCallsTexts: {
        question: "هل يقدم Airvoy مكالمات ورسائل مجانية؟",
        answer: "ليس بعد. لكن Airvoy سيقدم مكالمات ورسائل مجانية من Airvoy إلى Airvoy قريباً. هذا يعني أنه يمكنك البقاء متصلاً مع مستخدمي Airvoy الآخرين بدون تكلفة إضافية."
      },
      
      whyChooseAirvoy: {
        question: "لماذا يجب أن أختار Airvoy على بدائل التجوال الأخرى؟",
        answer: "يجب أن تختار Airvoy على بدائل التجوال الأخرى لأن Airvoy يقدم اتصال عالمي سلس مع eSIM واحد، نموذج فعال من حيث التكلفة، وميزات إضافية مثل المراسلة (قريباً)، والأرقام المحلية (قريباً)، كل ذلك في تطبيق سهل الاستخدام. إنه ميسور التكلفة وسهل ويضعك في تحكم كامل بكيفية الاتصال، أينما ذهبت."
      }
    },
    browse: {
      main: {
        title: "تصفح خطط eSIM",
        subtitle: "اكتشف خطط eSIM للوجهات في جميع أنحاء العالم مع الأسعار في الوقت الفعلي"
      },
      search: {
        placeholder: "البحث في البلدان (مثل، الولايات المتحدة، إسبانيا، اليابان)...",
        clearSearch: "مسح البحث",
        noCountriesFound: "لم يتم العثور على دول تطابق بحثك.",
        noCountriesAvailable: "لا توجد دول متاحة.",
        clearSearchButton: "مسح البحث",
        searching: "البحث في البلدان...",
        country: "دولة",
        countries: "دول",
        foundFor: "تم العثور عليها لـ"
      },
      loading: {
        loadingText: "جاري التحميل...",
        allCountriesLoaded: "تم تحميل جميع البلدان",
        total: "المجموع"
      },
      buttons: {
        showMoreCountries: "عرض المزيد من البلدان",
        showLessPlans: "عرض خطط أقل",
        showLess: "عرض أقل",
        seeMorePlans: "عرض المزيد من الخطط",
        more: "المزيد",
        buyNow: "اشتر الآن"
      },
      navigation: {
        backToCountries: "العودة إلى البلدان"
      },
      countryDetails: {
        description: "استكشف {{country}} بمرونة باستخدام خطط بيانات eSIM الخاصة بنا. سواء كنت تزور لإقامة قصيرة أو رحلة طويلة، تبقيك خططنا متصلاً دون عناء."
      },
      plans: {
        noPlansAvailable: "لا توجد خطط متاحة للمرشحات المحددة.",
        planDetails: "تفاصيل الخطة",
        details: "التفاصيل",
        unlimited: "غير محدود",
        for: "لمدة",
        day: "يوم",
        days: "أيام"
      },
      checkout: {
        total: "المجموع"
      },
      planDetails: {
        title: "تفاصيل الخطة",
        unlimitedData: "بيانات غير محدودة",
        data: "بيانات",
        country: "البلد",
        duration: "المدة",
        day: "يوم",
        days: "أيام",
        network: "الشبكة",
        autoStart: "البدء التلقائي",
        enabled: "مفعل",
        disabled: "معطل",
        planType: "نوع الخطة",
        description: "الوصف",
        purchaseThisPlan: "شراء هذه الخطة",
        signInToPurchase: "تسجيل الدخول للشراء"
      }
    },
    installation: {
      title: "كيف أقوم بتثبيت eSIM وإعداده؟",
      metaUpdated: "تم التحديث • منذ شهرين",
      intro: {
        p1: "سواءً كنت على أندرويد أو آيفون، تحقّق أولاً أن هاتفك يدعم eSIM وأنه غير مقفل على شبكة واحدة. ستحتاج أيضاً إلى اتصال إنترنت مستقر (يفضّل عبر Wi-Fi).",
        p2: "بعد ذلك يمكنك إما:",
        ol1: "مسح رمز QR للتثبيت التلقائي",
        ol2: "تثبيت eSIM يدوياً",
        note: "استخدام رمز QR هو أسهل طريقة."
      },
      ios: {
        qr: {
          title: "تثبيت eSIM باستخدام رمز QR (iOS)",
          s1: "1. انتقل إلى الإعدادات > بيانات الهاتف",
          s2: "2. اضغط \"إضافة eSIM\" ثم اختر استخدام رمز QR",
          s3: "3. امسح رمز QR وأدخل رمز التأكيد المكوّن من 4 أرقام إن طُلب",
          s4: "4. عيّن اسماً لـ eSIM واختر \"بيانات خلوية فقط\" ضمن الخط الافتراضي",
          s5: "5. ينبغي أن ترى eSIM ضمن \"بيانات الهاتف\""
        },
        manual: {
          title: "طريقة التثبيت اليدوي لـ eSIM (iOS)",
          s1: "1. الإعدادات > بيانات الهاتف > إضافة eSIM",
          s2: "2. اضغط \"إضافة eSIM\" ثم اختر استخدام رمز QR",
          s3: "3. بدلاً من المسح، اضغط إدخال التفاصيل يدوياً",
          s4: "4. أدخل عنوان SM-DP+ ورمز التفعيل ورمز التأكيد (اختياري) من تطبيق Airvoy",
          s5: "5. عيّن اسماً لـ eSIM واختر \"بيانات خلوية فقط\" ضمن الخط الافتراضي",
          s6: "6. ينبغي أن ترى eSIM ضمن بيانات الهاتف"
        }
      },
      android: {
        qr: {
          title: "تثبيت eSIM باستخدام رمز QR (Android)",
          s1: "1. الإعدادات > الشبكة والإنترنت > بطاقات SIM",
          s2: "2. اضغط أيقونة “+” بجانب \"بطاقات SIM\"",
          s3: "3. اضغط \"تنزيل بطاقة بدلاً من ذلك؟\" في الأسفل",
          s4: "4. في \"تنزيل بطاقتك\" اضغط \"التالي\" — سترى \"جارٍ فحص معلومات الشبكة...\"",
          s5: "5. بعد الفحص سيظهر إطار لمسح رمز QR",
          s6: "6. وجّه الإطار نحو رمز QR المطبوع أو المعروض على جهاز آخر",
          s7: "7. بعد المسح سيجري الجهاز فحص المعلومات مرة أخرى",
          s8: "8. اضغط تنزيل للتأكيد — سيتم تنزيل بيانات eSIM",
          s9: "9. عند اكتمال العملية سترى \"اكتمل التنزيل\"",
          s10: "10. أكمِل إعداد eSIM لاستخدام الإنترنت عندما تكون جاهزاً."
        }
      },
      notes: {
        title: "ملاحظات مهمة",
        n1: "تأكّد أن جهازك يدعم eSIM وغير مقفل على شبكة واحدة",
        n2: "ستحتاج إلى اتصال Wi-Fi مستقر أثناء التثبيت",
        n3: "يمكن تثبيت eSIM مرة واحدة فقط — ابدأ عندما تكون مستعداً",
        n4: "أبقِ شريحةك الأساسية مفعلة للمكالمات والرسائل على رقمك المحلي",
        n5: "سيتم تفعيل eSIM عند وصولك إلى بلد الوجهة"
      },
      support: {
        title: "هل تحتاج مساعدة؟",
        body: "إذا واجهت أي مشكلة في تثبيت eSIM، فإن فريق الدعم لدينا جاهز للمساعدة!",
        emailLabel: "البريد الإلكتروني:",
        websiteLabel: "الموقع:"
      }
    },
    installGuide: {
      header: {
        title: "الدليل الكامل لتثبيت eSIM",
        subtitle: "كل ما تحتاج لمعرفته لتثبيت eSIM وتفعيله واستخدامه لاتصال عالمي سلس. اتبع تعليمات الأجهزة للحصول على تجربة إعداد سلسة.",
        link: "اطّلع أيضاً على دليل التثبيت المفصل على أندرويد",
        ios: "دليل مُفصّل لنظام iOS",
        android: "دليل مُفصّل لنظام Android"
      },
      iphoneHero: "تثبيت وتفعيل eSIM على iPhone",
      cards: {
        c1: {
          alt: "آيفون مع أيقونة تبديل وساعة",
          install: "ثبّت",
          activate: "فعّل",
          textA: "قبل رحلتك بساعات قليلة و",
          textB: "أثناء رحلتك أو عند وصولك إلى وجهتك."
        },
        c2: {
          alt: "آيفون بواجهة ماسح رمز QR",
          line1: "اختر «التثبيت عبر رمز QR»",
          line2: "إذا كان لديك الرمز على جهاز آخر",
          line3: "من أجل المسح."
        },
        c3: {
          alt: "آيفون بواجهة التثبيت اليدوي",
          line1: "اختر «التثبيت اليدوي»",
          line2: "إذا لم تتمكن من مسح رمز QR."
        }
      },
      learn: {
        title: "تعلم خطوة بخطوة",
        subtitle: "اختر نوع التثبيت الذي ترغب بتنفيذه",
        btnQr: "التثبيت برمز QR",
        btnManual: "تثبيت يدوي"
      },
      prep: {
        alt: "أيقونة تحذير الهاتف",
        qr: {
          title: "قبل البدء بالتثبيت عبر رمز QR، انتبه للنقاط التالية:",
          i1: "يجب أن يتوفر رمز QR على شاشة أخرى لمسحه بكاميرا هاتفك.",
          i2: "تأكّد من وجود اتصال إنترنت مستقر طوال العملية.",
          i3: "يمكن مسح رمز QR مرة واحدة فقط.",
          i4: "لا تقم بإزالة eSIM من جهازك لأنه لن يكون قابلاً للاستخدام مرة أخرى."
        },
        manual: {
          title: "قبل البدء بالتثبيت اليدوي، انتبه للنقاط التالية:",
          i1: "أكواد التثبيت اليدوي تُستخدم مرة واحدة فقط."
        },
        shared: {
          i2: "تأكّد من وجود اتصال إنترنت مستقر طوال العملية.",
          i3: "لا تقم بإزالة eSIM من جهازك لأنه لن يكون قابلاً للاستخدام مرة أخرى."
        }
      },
      start: {
        title: "لنبدأ معاً",
        c1: {
          title: "افتح بريدك الإلكتروني",
          qr: { p1: "افتح بريدك الإلكتروني على جهاز آخر غير جهاز التثبيت وابحث عن الرسالة التي تحتوي على رمز QR." },
          manual: { p1: "تحقّق من البريد الذي أرسلناه لك وفيه «عنوان SM-DP+» و«رمز التفعيل»، واحتفظ بهما للبدء. نرسلها أيضاً كرسالة نصية." },
          shared: { missing: "إذا لم تتلقَّ الرموز، يرجى", contact: "التواصل معنا" }
        },
        c2: {
          qr: { title: "امسح رمز QR", p1: "افتح الكاميرا على الـ iPhone الذي ستثبت عليه eSIM وامسح الرمز. يمكنك أيضاً الذهاب إلى الإعدادات ← بيانات الهاتف واختيار «إضافة خطة بيانات» للمسح من هناك." },
          manual: { title: "افتح «الإعدادات» على iPhone", p1: "اذهب إلى بيانات الهاتف، واضغط «إضافة eSIM» أو «إضافة خطة بيانات» واختر «استخدام رمز QR»، ثم «إدخال التفاصيل يدوياً» عند الطلب." }
        },
        c3: {
          title: "اتبع خطوات التثبيت على iPhone",
          qr: { p1: "سيبدأ المسح عملية التثبيت. استخدم دليلنا أدناه للتهيئة خطوة بخطوة." },
          manual: { p1: "عندما تصل إلى «مسح رمز QR»، اختر «إدخال التفاصيل يدوياً» واتبع الخطوات على جهازك." }
        }
      },
      compat: {
        title: "مدقق توافق الجهاز",
        subtitle: "تحقّق مما إذا كان جهازك يدعم تقنية eSIM. استخدم البحث للعثور بسرعة على طراز جهازك.",
        iosTab: "iPhone / iPad",
        androidTab: "Android",
        searchIos: "ابحث عن طرازات iPhone/iPad...",
        searchAndroid: "ابحث عن طرازات Android...",
        iphones: "أجهزة iPhone المتوافقة",
        ipads: "أجهزة iPad المتوافقة (4G فقط)",
        androids: "أجهزة Android المتوافقة",
        noMatch: "لا توجد أجهزة مطابقة لبحثك.",
        iosNotesTitle: "ملاحظات مهمة:",
        iosNotes: {
          i1: "يمكن تشغيل شريحتي eSIM في الوقت نفسه على iPhone 13 و14",
          i2: "أجهزة iPhone من الصين القارية وهونغ كونغ لا تدعم eSIM (باستثناء بعض الطرازات)",
          i3: "طرازات iPhone 14+ المباعة في الولايات المتحدة لا تدعم بطاقات SIM الفعلية"
        },
        androidNotesTitle: "قيود مهمة:",
        androidNotes: {
          i1: "أجهزة Samsung من الولايات المتحدة وهونغ كونغ قد لا تدعم eSIM",
          i2: "أجهزة Google Pixel من أستراليا واليابان وتايوان لا تدعم eSIM",
          i3: "الهواتف المباعة في هونغ كونغ غالباً لا تدعم eSIM",
          i4: "يجب فتح قفل الشبكة على الجهاز لاستخدام eSIM"
        },
        empty: "ابدأ بكتابة طراز جهازك للتحقق من التوافق"
      },
      tips: {
        title: "نصائح احترافية: فعّل قبل السفر",
        body: "لرحلة سلسة، ثبّت eSIM قبل المغادرة وفعّله عند الوصول. هكذا ستكون متصلاً فور الهبوط دون البحث عن Wi-Fi أو شرائح محلية.",
        before: {
          title: "قبل المغادرة",
          i1: "ثبّت ملف eSIM في المنزل",
          i2: "اختبر عملية التثبيت",
          i3: "احتفظ بلقطة شاشة لرمز QR كنسخة احتياطية",
          i4: "تأكّد أن جهازك غير مقفل على شبكة واحدة"
        },
        after: {
          title: "عند الوصول",
          i1: "شغّل البيانات الخلوية على eSIM",
          i2: "انتظر 2–3 دقائق لتسجيل الشبكة",
          i3: "اختبر الاتصال عبر بحث ويب",
          i4: "قم بضبط التجوال إذا لزم الأمر"
        }
      },
      support: {
        title: "تحتاج دعماً إضافياً؟",
        body: "فريق الدعم الخبير لدينا هنا لمساعدتك في كل خطوة—من أسئلة التوافق إلى التثبيت.",
        btnEmail: "دعم عبر البريد",
        btnCenter: "زيارة مركز الدعم"
      },
      steps: {
        ios: {
          s1: { title: "افتح الإعدادات", desc: "الإعدادات ← الخلوي (أو بيانات الهاتف في بعض المناطق)", detail: "ابحث عن خيار «الخلوي». قد يظهر باسم «بيانات الهاتف» حسب الدولة." },
          s2: { title: "إضافة خطة خلوية", desc: "اضغط «إضافة خطة خلوية» أو «إضافة eSIM»", detail: "قد يظهر الخيار أسفل صفحة الإعدادات الخلوية." },
          s3: { title: "مسح رمز QR", desc: "اختر «استخدام رمز QR» وامسح الرمز من بريدك", detail: "احرص على إضاءة جيدة وثبات الهاتف حتى يتعرف على الرمز." },
          s4: { title: "إضافة خطة خلوية", desc: "اضغط «إضافة خطة خلوية» عند ظهور التفاصيل", detail: "راجع معلومات الشركة والتفاصيل قبل التأكيد." },
          s5: { title: "تسمية الخطط", desc: "اختر تسميات مثل «أساسي»، «سفر»، «ثانوي»", detail: "يساعدك ذلك على تحديد خطة البيانات والمكالمات والرسائل." },
          s6: { title: "تعيين الخط الافتراضي", desc: "اختر الخط المستخدم للبيانات الخلوية", detail: "يمكنك إبقاء شريحةك الأساسية للمكالمات والرسائل." }
        },
        android: {
          s1: { title: "افتح الإعدادات", desc: "الإعدادات ← الشبكة والإنترنت ← بطاقات SIM", detail: "قد يختلف المسار. على Samsung: الاتصالات ← مدير بطاقة SIM." },
          s2: { title: "إضافة خطة محمول", desc: "اضغط زر «+» أو «إضافة خطة»", detail: "ابحث عن «إضافة خطة»، «تنزيل بطاقة بدلاً من ذلك»، أو «إضافة مزود»." },
          s3: { title: "تنزيل بطاقة", desc: "اختر «ألا تملك بطاقة SIM؟» أو «تنزيل بطاقة بدلاً من ذلك»", detail: "لإخبار الهاتف أنك تريد تثبيت eSIM." },
          s4: { title: "مسح رمز QR", desc: "اختر «مسح رمز QR» ووجّه الكاميرا نحو الرمز", detail: "إضاءة جيدة وثبات اليدين يسهّلان التعرف." },
          s5: { title: "تنزيل الملف التعريفي", desc: "اضغط «تنزيل» عند ظهور الملف التعريفي", detail: "سيتصل الجهاز بالإنترنت لتنزيل ملف eSIM." },
          s6: { title: "تفعيل eSIM", desc: "فعّل eSIM واجعله اتصال البيانات المفضل", detail: "يمكنك اختيار الشريحة للبيانات والمكالمات والرسائل." }
        }
      }
    },
    profile: {
      loading: "جارٍ تحميل ملفك الشخصي…",
      errors: {
        load: "فشل تحميل شرائح eSIM الخاصة بك",
        delete: "تعذّر حذف شريحة eSIM. حاول مرة أخرى.",
        bundle: "فشل جلب حالة الباقة",
        network: "خطأ في الشبكة أثناء جلب حالة الباقة",
        invoice: "تعذّر تنزيل الفاتورة"
      },
      auth: {
        title: "يتطلب تسجيل الدخول",
        subtitle: "يُرجى تسجيل الدخول للاطّلاع على ملفك وسجل شرائح eSIM.",
        cta: "تسجيل الدخول"
      },
      header: {
        fallback: "الملف الشخصي",
        count: "تم شراء {{count}} شريحة eSIM"
      },
      list: {
        title: "شرائح eSIM الخاصة بك",
        subtitle: "أدِر الشرائح التي اشتريتها واطّلع على رموز QR والفواتير.",
        total: "الإجمالي {{count}}"
      },
      empty: {
        title: "لا توجد شرائح حتى الآن",
        subtitle: "استعرض باقاتنا للاتصال خلال ثوانٍ — دون شريحة فعلية.",
        cta: "استعراض الباقات",
        tip: "نصيحة: يمكنك تثبيت eSIM قبل السفر وتفعيلها عند الوصول."
      },
      item: {
        country: "الدولة",
        statusTitle: "الحالة الحالية",
        pricePaid: "المبلغ المدفوع",
        purchaseDate: "تاريخ الشراء"
      },
      actions: {
        details: "عرض التفاصيل",
        showQr: "إظهار رمز QR",
        invoice: "فاتورة"
      },
      hint: "تحتاج مساعدة في تثبيت eSIM؟ على iOS: الإعدادات ← الخلوي ← إضافة eSIM. على Android: الإعدادات ← الشبكة والإنترنت ← بطاقات SIM ← إضافة eSIM.",
      delete: {
        title: "حذف شريحة eSIM",
        confirm: "هل أنت متأكد من إزالة هذه الشريحة من السجل؟ هذا الإجراء لا يمكن التراجع عنه.",
        deleting: "جارٍ الحذف…",
        cta: "حذف الشريحة"
      },
      details: {
        title: "تفاصيل eSIM والحالة المباشرة",
        refresh: "تحديث حالة الباقة",
        live: "الحالة المباشرة للباقة",
        updated: "تم التحديث:",
        fetching: "جارٍ جلب الحالة اللحظية...",
        ref: "مرجع:",
        discount: "تم تطبيق الخصم",
        usage: {
          title: "استهلاك البيانات",
          used: "المستخدم",
          remaining: "المتبقي",
          total: "الإجمالي"
        },
        assigned: "تاريخ تعيين الباقة",
        plan: {
          title: "معلومات الخطة",
          destination: "الوجهة",
          name: "اسم الخطة",
          allowance: "حجم البيانات",
          validity: "الصلاحية"
        },
        tech: {
          title: "تفاصيل تقنية",
          activation: "رمز التفعيل",
          copyActivation: "نسخ رمز التفعيل",
          iccid: "ICCID",
          copyIccid: "نسخ ICCID",
          orderRef: "مرجع طلب GOeSIM"
        },
        install: {
          title: "إرشادات التثبيت",
          iosTitle: "لنظام iOS:",
          androidTitle: "لنظام Android:",
          ios: "الإعدادات ← الخلوي ← إضافة eSIM ← استخدام رمز QR",
          android: "الإعدادات ← الشبكة والإنترنت ← بطاقات SIM ← إضافة eSIM ← مسح رمز QR",
          important: "مهم:",
          once: "يمكن تثبيت هذه الشريحة مرة واحدة فقط. تأكد أن جهازك غير مقفل ويدعم eSIM قبل المتابعة."
        },
        purchase: {
          title: "معلومات الشراء",
          date: "تاريخ الشراء",
          amount: "المبلغ المدفوع",
          method: "طريقة الدفع",
          txn: "معرّف العملية"
        },
        referral: {
          title: "تم تطبيق خصم الإحالة",
          code: "رمز الإحالة",
          original: "السعر الأصلي",
          saved: "وفّرت"
        },
        billing: {
          title: "معلومات الفوترة",
          name: "الاسم الكامل",
          email: "البريد الإلكتروني",
          country: "الدولة",
          zip: "الرمز البريدي"
        }
      },
      qr: {
        title: "رمز QR لشريحة eSIM",
        alt: "رمز QR لشريحة eSIM",
        copy: "نسخ رمز التفعيل",
        tip: "نصيحة: افتح كاميرا هاتفك وامسح الرمز. يمكن تثبيت eSIM مرة واحدة فقط."
      },
      common: {
        usd: "دولار أمريكي",
        days: "يومًا",
        na: "غير متوفر",
        invalidDate: "تاريخ غير صالح",
        cancel: "إلغاء",
        close: "إغلاق",
        copied: "تم النسخ"
      }
    },
    countryDetails: {
  loading: "جارٍ تحميل تفاصيل الدولة...",
  errors: {
    notFound: "الدولة غير موجودة",
    loadFail: "فشل تحميل بيانات الدولة"
  },
  notFound: {
    title: "لم يتم العثور على الدولة",
    subtitle: "الدولة التي تبحث عنها غير موجودة أو لا تتوفر لها باقات.",
    cta: "استعراض جميع الدول"
  },
  back: "الرجوع إلى الدول",
  blurb: "استكشف {{country}} بمرونة مع باقات eSIM لدينا. سواء كانت زيارتك قصيرة أو طويلة، ستبقى متصلاً بدون عناء.",
  noPlans: "لا توجد باقات مطابقة لخيارات التصفية.",
  plan: {
    details: "تفاصيل الباقة",
    detailsShort: "تفاصيل",
    networkBadge: "5G",
    unlimited: "غير محدود",
    unlimitedData: "بيانات غير محدودة",
    gb: "جيجابايت",
    gbShort: "GB",
    data: "بيانات",
    forDays: "لمدة {count, plural, one {يوم} other {# أيام}}"
  },
  currency: {
    usd: "دولار"
  },
  duration: {
    days: "{count, plural, one {يوم واحد} other {# أيام}}"
  },
  more: {
    more: "عرض المزيد من الباقات (‏{extra} إضافية)",
    moreShort: "+{extra} إضافية",
    less: "عرض باقات أقل",
    lessShort: "عرض أقل"
  },
  modal: {
    title: "تفاصيل الباقة",
    country: "الدولة:",
    duration: "المدة:",
    network: "الشبكة:",
    autostart: "بدء تلقائي:",
    enabled: "مفعل",
    disabled: "معطل",
    planType: "نوع الباقة:",
    description: "الوصف",
    purchase: "اشترِ هذه الباقة",
    signInToPurchase: "سجّل الدخول للشراء"
  },
  bar: {
    title: "eSIM لـ {{country}}",
    total: "الإجمالي",
    buy: "اشترِ الآن"
  }
    },
    checkout: {
      loading: "جارٍ تحميل صفحة الدفع الآمن...",
      invalidPlan: {
        title: "بيانات الباقة غير صالحة",
        subtitle: "تعذّر تحميل معلومات الباقة المحددة.",
        cta: "الرجوع إلى لوحة التحكم"
      },
      success: {
        title: "تم الشراء بنجاح!",
        message: "تم شراء eSIM بنجاح! رقم ICCID: {{iccid}}. {{targetEmail}}",
        sentBoth: "تم إرسال رمز QR وتعليمات التثبيت إلى {{a}} و{{b}}",
        sentOne: "تم إرسال رمز QR وتعليمات التثبيت إلى {{email}}",
        view: "عرض شرائح eSIM الخاصة بي"
      },
      common: { close: "إغلاق" },
      header: {
        title: "الدفع الآمن",
        subtitle: "أكمل شراء eSIM الخاص بك بأمان"
      },
      benefits: {
        title: "سجّل للاستفادة من المزايا",
        copy: "أنشئ حساباً لحفظ سجل المشتريات والوصول إلى العروض الحصرية وإدارة شرائح eSIM.",
        cta: "إنشاء حساب / تسجيل الدخول"
      },
      billing: {
        title: "معلومات الفوترة",
        subtitle: "سيتم إرسال الفاتورة و eSIM إلى هذا البريد الإلكتروني"
      },
      form: {
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        email: "البريد الإلكتروني",
        referral: "رمز الإحالة (اختياري)"
      },
      placeholder: {
        firstName: "أدخل الاسم الأول",
        lastName: "أدخل اسم العائلة",
        email: "أدخل البريد الإلكتروني",
        referral: "أدخل رمز الإحالة",
        altEmail: "أدخل بريداً بديلاً"
      },
      referral: {
        validating: "جارٍ التحقق...",
        invalid: "رمز إحالة غير صالح",
        ownCode: "لا يمكنك استخدام رمز الإحالة الخاص بك",
        inactive: "رمز الإحالة لم يعد نشطاً",
        used: "تم استخدام رمز الإحالة هذا",
        valid: "صالح! تم تطبيق خصم {{percent}}%",
        error: "خطأ أثناء التحقق من الرمز"
      },
      altEmail: {
        title: "استخدام بريد إلكتروني مختلف",
        copy: "سيتم إرسال eSIM إلى البريد البديل أيضاً وسيُحفظ في حسابك",
        input: "البريد الإلكتروني البديل"
      },
      createAccount: {
        title: "إنشاء حساب لحفظ سجل المشتريات",
        copy: "اختياري — يساعدك على إدارة شرائح eSIM والوصول إلى الدعم"
      },
      payment: {
        title: "تفاصيل الدفع",
        secured: "محمي بواسطة Stripe",
        method: "طريقة الدفع",
        card: "بطاقة ائتمان أو خصم",
        cardTypes: "Visa و Mastercard و American Express",
        paypalCopy: "ادفع عبر PayPal",
        cardInfo: "معلومات البطاقة",
        loadingSecure: "جارٍ تحميل نموذج الدفع الآمن...",
        cardComplete: "تم إدخال معلومات البطاقة بالكامل",
        processing: "جارٍ معالجة الدفع...",
        complete: "إتمام الشراء • ${{total}}"
      },
      legal: {
        agree: "بإكمال الطلب، فإنك توافق على",
        terms: "الشروط والأحكام",
        and: "و",
        privacy: "سياسات الخصوصية والاسترداد"
      },
      summary: {
        title: "ملخص الطلب",
        planLabel: "باقة eSIM",
        digital: "رقمي",
        data: "حجم البيانات:",
        validity: "الصلاحية:",
        coverage: "التغطية:",
        nationwide: "على مستوى الدولة"
      },
      pricing: {
        planPrice: "سعر الباقة",
        referralDiscount: "خصم إحالة ({{percent}}%)",
        stripeFee: "رسوم معالجة Stripe",
        paypalFee: "رسوم معالجة PayPal",
        taxes: "الضرائب ورسوم الخدمة",
        included: "مشمول",
        total: "الإجمالي"
      },
      paypal: {
        description: "eSIM لـ {{country}} - {{data}} لمدة {{days}} يوم"
      },
      duration: {
        days: "{count, plural, one {يوم واحد} other {# أيام}}"
      },
      alerts: {
        enterName: "يرجى إدخال الاسم الكامل",
        formNotReady: "نموذج الدفع غير جاهز. يرجى الانتظار قليلاً وإعادة المحاولة.",
        cardIncomplete: "يرجى إدخال معلومات البطاقة كاملة",
        paypalFailed: "فشل دفع PayPal: {{msg}}",
        paypalGeneric: "فشل دفع PayPal. يرجى المحاولة مرة أخرى.",
        purchaseFailed: "فشل الشراء: {{msg}}"
      }
    },
    privacy: {
      title: "سياسة الخصوصية",
      subtitle:
        "بيان الممارسات المتعلقة بجمع المعلومات الشخصية واستخدامها وحمايتها من قبل شركة Routed Labs, Inc.",
      lastUpdated: { label: "آخر تحديث:", date: "1 أغسطس 2025" },
      sections: {
        intro: {
          heading: "مقدمة",
          p1:
            "تدير شركة Routed Labs, Inc. (“Routed Labs” أو “نحن”) موقع وتطبيق Airvoy (“الخدمة”). توضّح هذه السياسة كيفية جمع المعلومات الشخصية واستخدامها والإفصاح عنها وحمايتها. باستخدامك للخدمة فإنك توافق على هذه الممارسات.",
          p2:
            "تلتزم Routed Labs بالحفاظ على سرية معلوماتك الشخصية ونزاهتها وأمنها، وبتطبيق ممارسات شفافة ومتوافقة مع القوانين والأنظمة المعمول بها."
        },
        collect: {
          heading: "المعلومات التي نجمعها",
          p1:
            "نلتزم بمبدأ تقليل البيانات ولا نجمع إلا ما يلزم لتقديم خدمات eSIM. على وجه التحديد، نجمع:",
          email: {
            title: "عنوان البريد الإلكتروني",
            collectedWhen: "يُجمع عند:",
            items: [
              "إنشاء حساب",
              "شراء باقة eSIM",
              "الاشتراك في النشرة البريدية",
              "التواصل مع الدعم"
            ],
            purposeLabel: "الغرض:",
            purpose:
              "إدارة الحسابات، تسليم شرائح eSIM، إرسال التأكيدات، وتمكين دعم العملاء."
          },
          notCollect: {
            title: "لا نجمع:",
            items: [
              "أرقام الهواتف أو معرفات الأجهزة",
              "بيانات الموقع أو التتبع الجغرافي",
              "سجل التصفح أو ملفات تعريف الارتباط السلوكية",
              "ملفات تعريف التواصل الاجتماعي أو الصور الشخصية",
              "بيانات مالية (تُدار المدفوعات عبر مزودي خدمة خارجيين)"
            ]
          }
        },
        use: {
          heading: "كيفية استخدام المعلومات",
          p1: "تُستخدم المعلومات المجموعة حصراً للأغراض التالية:",
          items: [
            "تسليم بيانات eSIM وإيصالات الشراء",
            "تقديم الدعم الفني وخدمة العملاء",
            "إرسال تحديثات الخدمة الأساسية وإشعارات الأمان",
            "إرسال مواد تسويقية اختيارية (بناءً على الموافقة)"
          ],
          optOut: "يمكنك إلغاء الاشتراك في الرسائل التسويقية في أي وقت."
        },
        share: {
          heading: "مشاركة المعلومات والإفصاح عنها",
          p1:
            "لا تُباع المعلومات الشخصية أو تُؤجَّر أو تُتاجر. قد تتم مشاركتها فقط في الحالات التالية:",
          items: [
            { title: "مزودو الخدمات:", body: "لوظائف مثل معالجة المدفوعات أو إرسال البريد الإلكتروني" },
            { title: "المتطلبات القانونية:", body: "عند الطلب بموجب القانون أو الإجراءات القانونية" },
            { title: "المعاملات التجارية:", body: "في سياق الاندماج أو الاستحواذ أو إعادة الهيكلة" },
            { title: "الأمان:", body: "لحماية حقوق وممتلكات وسلامة Routed Labs ومستخدميها" }
          ]
        },
        retain: {
          heading: "الاحتفاظ بالبيانات وحذفها",
          p1: "نحتفظ بالمعلومات فقط للمدة اللازمة للأغراض الموضحة هنا:",
          items: [
            "الحسابات النشطة: تُحفظ البيانات طوال فترة نشاط الحساب وحتى سنتين بعد آخر تفاعل.",
            "مشتريات الضيوف: حتى سنة لضمان الدعم والوفاء بالطلبات.",
            "عند حذف الحساب: تُمحى جميع المعلومات الشخصية نهائياً من الأنظمة الفعّالة."
          ]
        },
        rights: {
          heading: "حقوق الأفراد",
          p1: "يمكنك ممارسة الحقوق التالية:",
          items: [
            "الوصول إلى معلوماتك الشخصية والحصول على نسخة منها",
            "طلب تصحيح البيانات غير الدقيقة",
            "طلب حذف السجلات",
            "سحب الموافقة على الرسائل التسويقية في أي وقت"
          ],
          contactPreamble: "يمكن إرسال الطلبات إلى"
        },
        security: {
          heading: "أمن البيانات",
          p1:
            "تطبق Routed Labs إجراءات تقنية وتنظيمية مناسبة لحماية المعلومات الشخصية، بما في ذلك:",
          items: [
            "التشفير أثناء النقل وفي حالة السكون",
            "عمليات تدقيق وتقييم ثغرات منتظمة",
            "ضوابط وصول صارمة وبروتوكولات مصادقة",
            "بنية تحتية ومراكز بيانات آمنة"
          ]
        },
        contact: {
          heading: "معلومات الاتصال",
          p1: "يمكن توجيه الأسئلة أو المخاوف حول سياسة الخصوصية هذه إلى:",
          company: "Routed Labs, Inc.",
          emailLabel: "البريد الإلكتروني:",
          addressLabel: "العنوان:",
          address: "451 Niantic Avenue, Daly City, CA 94014, United States",
          subjectLabel: "سطر الموضوع للمراسلات:",
          subject: "“استفسار سياسة الخصوصية”"
        },
        updates: {
          heading: "تحديثات هذه السياسة",
          p1:
            "قد تُحدَّث سياسة الخصوصية بصفة دورية لتعكس تغييرات تشغيلية أو قانونية أو تنظيمية. سيتم نشر التعديلات الجوهرية هنا مع تحديث تاريخ “آخر تحديث”.",
          p2:
            "يُستحسن مراجعة هذه الوثيقة دورياً لمعرفة كيفية إدارة Routed Labs للمعلومات الشخصية."
        }
      }
    },
    tos: {
  title: "شروط الخدمة",
  subtitle:
    "الشروط والأحكام القانونية لاستخدام منصة Airvoy والخدمات المقدمة من شركة Routed Labs, Inc.",
  lastUpdated: { label: "آخر تحديث:", date: "1 أغسطس 2025" },
  sections: {
    agreement: {
      heading: "الموافقة على الشروط",
      p1:
        "تشكل هذه الشروط اتفاقاً ملزماً قانونياً بين المستخدم (“أنت”) وشركة Routed Labs, Inc. (“Routed Labs” أو “نحن”) بشأن استخدام موقع Airvoy وتطبيقه وخدمات eSIM ذات الصلة (“الخدمة”).",
      p2:
        "باستخدامك للخدمة، فأنت تقر بأنك قرأت هذه الشروط وفهمتها وتوافق على الالتزام بها. إذا لم توافق، فيجب عليك الامتناع عن استخدام الخدمة."
    },
    service: {
      heading: "وصف الخدمة",
      p1:
        "توفر الخدمة وظائف eSIM التي تتيح للمستخدمين الوصول إلى شبكات البيانات الخلوية دولياً. وتشمل العروض:",
      items: [
        "شرائح eSIM رقمية للاتصال حول العالم",
        "خيارات متعددة لخطط البيانات بمدد مختلفة",
        "تسليم رمز QR للتفعيل والتثبيت",
        "دعم العملاء للاستفسارات التقنية",
        "أدوات لإدارة الحساب للمستخدمين المسجلين"
      ],
      notice:
        "مهم: تتطلب الخدمة جهازاً متوافقاً ومفتوح الشبكة. لا نضمن التوافق مع جميع الأجهزة أو التغطية في جميع المناطق."
    },
    eligibility: {
      heading: "الأهلية",
      p1: "لاستخدام الخدمة، فإنك تقر وتضمن أنك:",
      items: [
        "تبلغ 18 عاماً على الأقل أو لديك موافقة الوالدين",
        "تملك الأهلية القانونية لإبرام عقد ملزم",
        "تقدم معلومات تسجيل دقيقة وكاملة",
        "تمتلك أو مخول لك استخدام جهاز متوافق",
        "ستلتزم بالقوانين واللوائح المعمول بها"
      ]
    },
    account: {
      heading: "تسجيل الحساب",
      p1:
        "يمكن للمستخدمين شراء شرائح eSIM كمستخدمين مسجلين أو كضيوف. يوفر التسجيل ميزات إضافية مثل سجل الحساب ودعم أوسع.",
      registered: {
        title: "الحسابات المسجلة",
        items: [
          "يتطلب عنوان بريد إلكتروني صالح",
          "المسؤولية عن الحفاظ على أمان الحساب",
          "الالتزام بتحديث المعلومات بدقة",
          "الإبلاغ الفوري عن أي وصول غير مصرح به"
        ]
      },
      guest: {
        title: "مشتريات الضيوف",
        items: [
          "يتطلب عنوان بريد إلكتروني فقط",
          "يتم تسليم eSIM إلكترونياً",
          "الدعم مقتصر على أمور الشراء",
          "لا يتم الاحتفاظ بسجل شراء مستمر"
        ]
      }
    },
    payment: {
      heading: "شروط الدفع",
      p1:
        "بإتمامك عملية الشراء، فإنك تفوض Routed Labs ومعالجي الدفع بتحصيل المبلغ من وسيلة الدفع التي تقدمها. وتشمل الشروط الرئيسية:",
      items: [
        "جميع الأسعار بالدولار الأمريكي وتشمل الضرائب المطبقة",
        "يستحق الدفع وقت الشراء",
        "تتم معالجة المدفوعات عبر مزودي خدمة تابعين لجهات خارجية",
        "قد يؤدي عدم إتمام الدفع إلى تعليق الخدمة"
      ]
    },
    refunds: {
      heading: "سياسة الاسترداد",
      p1: "تُنظر طلبات الاسترداد وفق الشروط التالية:",
      items: [
        "مؤهل إذا طُلب خلال 24 ساعة من الشراء",
        "غير مؤهل بعد تفعيل eSIM أو استخدامه",
        "يُراجع كل خلل تقني حالةً بحالة",
        "مسؤولية توافق الجهاز تقع على المستخدم"
      ],
      p2: {
        prefix: "يجب إرسال طلبات الاسترداد إلى ",
        suffix: "، مع تزويدنا بتفاصيل الطلب وسبب الطلب."
      }
    },
    limitations: {
      heading: "قيود الخدمة",
      p1: "تخضع الخدمة لقيود، منها:",
      items: [
        "يجب أن يكون الجهاز متوافقاً مع eSIM ومفتوح الشبكة",
        "تعتمد التغطية على شبكات الشركاء المحليين",
        "تختلف السرعة والتوفر حسب الموقع",
        "تنتهي صلاحية البيانات غير المستخدمة ولا تُرحّل",
        "لا يمكن نقل الخطط بين الأجهزة"
      ]
    },
    prohibited: {
      heading: "الاستخدامات المحظورة",
      p1:
        "توافق على عدم استخدام الخدمة لأي غرض غير قانوني أو محظور، بما في ذلك على سبيل المثال لا الحصر:",
      items: [
        "نشاط غير قانوني أو مخالف للأنظمة",
        "التحرش أو الإساءة أو الاحتيال",
        "الوصول غير المصرح به إلى الشبكات أو التدخل بها",
        "إعادة البيع أو مشاركة بيانات الاعتماد دون موافقة",
        "الاستخدام المفرط الذي يضر بأداء الشبكة"
      ]
    },
    liability: {
      heading: "تحديد المسؤولية",
      p1:
        "إلى أقصى حد يسمح به القانون، لا تتحمل Routed Labs المسؤولية عن الأضرار غير المباشرة أو العرضية أو المترتبة الناشئة عن استخدامك للخدمة. ولا تتجاوز المسؤولية الإجمالية المبلغ الذي دفعته مقابل الخدمة ذات الصلة خلال الاثني عشر (12) شهراً السابقة للمطالبة."
    },
    indemnity: {
      heading: "التعويض",
      p1:
        "توافق على تعويض Routed Labs والشركات التابعة لها وحمايتها من أي مطالبات أو أضرار أو نفقات تنشأ عن إساءة استخدامك للخدمة أو مخالفتك لهذه الشروط."
    },
    termination: {
      heading: "إنهاء الخدمة",
      p1:
        "يجوز لنا تعليق أو إنهاء الوصول إلى الخدمة فوراً إذا خالفت هذه الشروط أو مارست سلوكاً غير قانوني أو أضررت بـ Routed Labs أو مستخدميها. عند الإنهاء، تنتهي حقوقك في استخدام الخدمة فوراً."
    },
    law: {
      heading: "القانون الحاكم",
      p1:
        "تخضع هذه الشروط لقوانين ولاية ديلاوير، الولايات المتحدة. وتوافق على الاختصاص القضائي الحصري لمحاكم ديلاوير لحل النزاعات."
    },
    amend: {
      heading: "التعديلات",
      p1:
        "تحتفظ Routed Labs بالحق في تعديل هذه الشروط وفق تقديرها. ستُنشر التحديثات على الموقع وتصبح نافذة فوراً ما لم يُذكر خلاف ذلك. ويُعد استمرار استخدامك للخدمة قبولاً للشروط المعدلة."
    },
    contact: {
      heading: "معلومات الاتصال",
      p1: "للاستفسارات المتعلقة بهذه الشروط، يرجى التواصل معنا:"
    }
  }
    },
    about: {
      title: "نبذة عن Airvoy",
      sections: {
        overview: {
          heading: "نظرة عامة",
          body:
            "Airvoy هي منصة eSIM طورتها شركة Routed Labs, Inc. وتوفر للمسافرين الدوليين اتصالاً محمولاً سهلاً وميسور التكلفة وموثوقاً. ومن خلال الاستغناء عن بطاقات SIM الفعلية، تتيح الخدمة تفعيل خطط البيانات بسلاسة في أكثر من 200 وجهة."
        },
        mission: {
          heading: "الرسالة",
          body:
            "تعمل Routed Labs, Inc. وفق رسالة واحدة: تبسيط الاتصال المحمول. وتهدف إلى إزالة عدم اليقين والتكاليف الخفية والعوائق اللوجستية المرتبطة بالتجوال الدولي والحصول على شرائح SIM، لضمان بقاء المسافرين متصلين بسهولة."
        },
        background: {
          heading: "الخلفية",
          p1:
            "يقع المقر الرئيسي لشركة Routed Labs, Inc. في دالي سيتي، كاليفورنيا. وقد نشأت فكرة الشركة من تجارب مباشرة مع صعوبات البقاء على اتصال دولياً، بما في ذلك رسوم التجوال المرتفعة وقلة توفر شرائح SIM.",
          p2:
            "وبملاحظة هذه التحديات، رأى المؤسس فرصة للاستفادة من تقنية eSIM لتحسين الاتصال العالمي.",
          p3:
            "اليوم تدعم الشركة آلاف المستخدمين حول العالم، مع التركيز على الموثوقية والشفافية وإمكانية الوصول."
        },
        operations: {
          heading: "العمليات",
          items: [
            { title: "التغطية العالمية:", desc: "الوصول إلى شبكات عالية السرعة في أكثر من 200 دولة وإقليم." },
            { title: "تزويد eSIM:", desc: "تثبيت الخطط رقمياً خلال دقائق دون بطاقات SIM فعلية." },
            { title: "توجّه العملاء:", desc: "خدمة ودعم يركزان على الوضوح واحتياجات المستخدم." }
          ]
        },
        corporate: {
          heading: "المعلومات المؤسسية",
          company: {
            title: "تفاصيل الشركة",
            nameLabel: "اسم الشركة:",
            name: "Routed Labs, Inc.",
            repLabel: "الممثل:",
            rep: "Hector Diaz",
            addrLabel: "عنوان المقر:",
            addr: "451 Niantic Avenue, Daly City, CA 94014, United States",
            contactLabel: "جهة الاتصال:"
          },
          agent: {
            title: "معلومات الوكيل المسجل",
            nameLabel: "اسم الوكيل المسجل:",
            name: "Legalinc Corporate Services Inc.",
            addrLabel: "عنوان الوكيل المسجل:",
            addr: "131 Continental Dr, Suite 305, Newark, DE 19713, United States"
          }
        },
        principles: {
          heading: "المبادئ الأساسية",
          items: [
            { title: "البساطة", desc: "عمليات الاتصال مصممة لتكون فعالة وسهلة." },
            { title: "الموثوقية", desc: "الخدمة ثابتة ويمكن التنبؤ بها وجديرة بالثقة." },
            { title: "الابتكار", desc: "تحسين مستمر للمنصة وتوسيع نطاقها." },
            { title: "الشفافية", desc: "يتم توضيح الأسعار والسياسات بوضوح." },
            { title: "التركيز على العميل", desc: "تسترشد القرارات وال تحسينات باحتياجات المستخدم." },
            { title: "الحرية", desc: "تمكين المسافرين من الاستكشاف دون قيود الاتصال." }
          ]
        },
        comms: {
          heading: "الاتصالات",
          p1: {
            prefix: "للمراسلات أو الاستفسارات الرسمية، يرجى الكتابة إلى",
            suffix:
              ". كما يمكن توجيه المراسلات المؤسسية والقانونية إلى الوكيل المسجل للشركة Legalinc Corporate Services Inc. على عنوانه في نيوآرك، ديلاوير."
          }
        }
      }
    },
    auth: {
      titles: {
        signin: 'مرحبًا بعودتك',
        signup: 'إنشاء حساب',
        forgot: 'إعادة تعيين كلمة المرور',
      },
      subtitles: {
        signin: 'سجّل الدخول لشراء باقات eSIM',
        signup: 'انضم إلى Airvoy اليوم',
        forgot: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور',
      },
      fields: {
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
      },
      placeholders: {
        email: 'أدخل بريدك الإلكتروني',
        password: 'أدخل كلمة المرور',
        confirmPassword: 'أعد إدخال كلمة المرور',
      },
      actions: {
        close: 'إغلاق',
        continueWithGoogle: 'المتابعة عبر Google',
        signingIn: 'جاري تسجيل الدخول...',
        pleaseWait: 'يرجى الانتظار...',
        signIn: 'تسجيل الدخول',
        createAccount: 'إنشاء حساب',
        sendReset: 'إرسال رسالة إعادة التعيين',
        showPassword: 'إظهار كلمة المرور',
        hidePassword: 'إخفاء كلمة المرور',
      },
      labels: {
        orEmail: 'أو المتابعة عبر البريد الإلكتروني',
      },
      links: {
        noAccount: 'لا تملك حسابًا؟',
        signUp: 'إنشاء حساب',
        forgot: 'هل نسيت كلمة المرور؟',
        haveAccount: 'لديك حساب بالفعل؟',
        signIn: 'تسجيل الدخول',
        remembered: 'تذكّرت كلمة المرور؟',
        backToSignIn: 'العودة لتسجيل الدخول',
      },
      messages: {
        resetSent: 'تم إرسال رسالة إعادة تعيين كلمة المرور! يرجى تفقد بريدك.',
      },
      errors: {
        fillAll: 'يرجى تعبئة جميع الحقول',
        userNotFound: 'لا يوجد حساب بهذا البريد الإلكتروني',
        wrongPassword: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
        emailInUse: 'يوجد حساب مسجل بهذا البريد الإلكتروني',
        weakPassword: 'كلمة المرور ضعيفة',
        invalidEmail: 'بريد إلكتروني غير صالح',
        tooManyRequests: 'محاولات عديدة فاشلة. حاول لاحقًا',
        popupClosed: 'تم إغلاق نافذة التسجيل قبل الإكمال',
        popupCancelled: 'تم إلغاء عملية التسجيل',
        popupBlocked: 'قام المتصفح بحظر نافذة التسجيل المنبثقة',
        passwordMismatch: 'كلمتا المرور غير متطابقتين',
        passwordMin: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
        enterEmail: 'يرجى إدخال بريدك الإلكتروني',
        generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى',
      },
      legal: {
        prefix: 'بإنشاء حساب، فإنك توافق على',
        terms: 'شروط الخدمة',
        and: 'و',
        privacy: 'سياسة الخصوصية',
      },
    },
    support: {
      title: "الدعم",
      contactInfo: "معلومات الاتصال",
      channels: {
        email: {
          title: "الدعم عبر البريد الإلكتروني",
          description: "للاستفسارات وتقديم البلاغات وطلبات المساعدة.",
          contact: "support@routedlabs.com",
          action: "إنشاء رسالة"
        },
        chat: {
          title: "الدردشة المباشرة",
          description: "مساعدة فورية للحالات العاجلة، حسب التوفر.",
          contact: "متاح من 09:00 إلى 18:00 بتوقيت المحيط الهادئ",
          action: "فتح الدردشة"
        }
      },
      faqTitle: "الأسئلة الشائعة",
      noResults: "لا توجد نتائج مطابقة لعملية البحث الحالية.",
      categoryLabel: "الفئة:",
      show: "عرض",
      hide: "إخفاء",
      noticesTitle: "الإشعارات والمراسلات",
      noticesLine1: {
        before: "يُوجَّه الاستفسارات والمراسلات الرسمية إلى",
        after: "."
      },
      noticesLine2:
        "تهدف هذه الصفحة إلى وصف إجراءات الدعم والمواد المرجعية. ولا تُعدّل أو تحل محل أي شروط خدمة أو سياسات معمول بها، والتي تُطبّق في جميع الحالات.",
      categories: {
        overview: "نظرة عامة على eSIM",
        compatibility: "توافق الأجهزة",
        installation: "التثبيت",
        dualSim: "شريحتي اتصال",
        dataUsage: "استخدام البيانات",
        planMgmt: "إدارة الباقات",
        deviceReqs: "متطلبات الجهاز",
        troubleshooting: "استكشاف الأخطاء",
        refunds: "الرديات",
        supportHours: "ساعات الدعم"
      },
      faqs: {
        1: {
          q: "ما هي شريحة eSIM وكيف تعمل؟",
          a: "‏eSIM هي شريحة مدمجة قابلة للبرمجة داخل الجهاز تمكّن من تفعيل الخدمة الخلوية دون بطاقة فعلية. يتم تهيئة الملف التعريفي رقمياً ويمكن الحصول على الاتصال بمسح رمز QR أو اتباع خطوات الضبط في Airvoy."
        },
        2: {
          q: "ما الأجهزة التي تدعم eSIM؟",
          a: "تدعم العديد من الهواتف الذكية الحديثة eSIM، بما في ذلك الطرازات الأخيرة من الشركات الكبرى. تحقّق من الإعدادات (غالباً ضمن «الخلوي» أو «بيانات الجوال») للتأكد من وجود خيار «إضافة باقة بيانات»."
        },
        3: {
          q: "كيف يتم تثبيت eSIM؟",
          a: "بعد الشراء، ستتلقى تعليمات التثبيت ورمز QR عبر البريد الإلكتروني. على جهازك، انتقل إلى الإعدادات ← الخلوي/بيانات الجوال ← إضافة باقة بيانات ثم امسح الرمز. يكتمل التفعيل تلقائياً بعد الإرشادات."
        },
        4: {
          q: "هل يمكن استخدام شريحة فعلية وeSIM معاً؟",
          a: "تدعم معظم الأجهزة المتوافقة مع eSIM وضع الشريحتين. يمكنك الاحتفاظ برقمك الأساسي للمكالمات والرسائل واستخدام eSIM للبيانات. يتم التحكم بالاختيار من إعدادات الجهاز."
        },
        5: {
          q: "ماذا لو لم أستهلك كامل البيانات؟",
          a: "لا تنتقل البيانات غير المستخدمة للشهر التالي ولا تُسترد قيمتها. تنتهي صلاحية الباقة بنهاية مدة صلاحيتها. اختر باقة تناسب استخدامك المتوقع أثناء السفر."
        },
        6: {
          q: "هل يمكن إضافة بيانات أو تمديد الباقة؟",
          a: "نعم. يمكنك شراء باقة إضافية عبر الموقع أو حسابك لزيادة البيانات أو تمديد الخدمة، وذلك حسب التوفر للوجهة."
        },
        7: {
          q: "هل يجب أن يكون الجهاز غير مقفل؟",
          a: "نعم. لاستخدام eSIM من مزود آخر غير شركة الاتصالات الأصلية، يجب فتح قفل الجهاز. إذا كان مقفلاً، تواصل مع الشركة لطلب فتح القفل قبل التفعيل."
        },
        8: {
          q: "ما الخطوات إذا لم تعمل eSIM كما هو متوقع؟",
          a: "تحقّق من أن الجهاز غير مقفل ويدعم eSIM. فعّل تجوال البيانات، واختر باقة البيانات الصحيحة، وجرب إعادة تشغيل الجهاز. إذا استمرت المشكلة، تواصل مع الدعم."
        },
        9: {
          q: "هل تتوفر ردّيات؟",
          a: "قد تتوفر ردّيات خلال 24 ساعة من الشراء إذا لم تُفعّل eSIM ولم تُستخدم. بعد التفعيل تصبح المبيعات نهائية. في حال المشكلات التقنية، سيعمل الدعم على الحل أو منح رصيداً بالحساب عند الاقتضاء."
        },
        10: {
          q: "ما هي ساعات الدعم وأوقات الاستجابة؟",
          a: "الدعم عبر البريد الإلكتروني متاح بشكل مستمر. عادةً ما نرد خلال ساعات قليلة. تحظى الحالات العاجلة أثناء السفر بأولوية أعلى."
        }
      }
    }
  },
  ko: {
    // Navigation
    nav: {
      installEsim: "eSIM 설치",
      admin: "관리자",
      faqs: "자주 묻는 질문",
      browsePlans: "요금제 둘러보기",
      partnerships: "파트너십",
      dashboard: "대시보드",
      signOut: "로그아웃",
      signIn: "로그인",
      getTheApp: "앱 받기"
    },
    // Hero Section
    hero: {
      badge: "Airvoy eSIM을 사용하는 30,000명 이상의 여행자와 함께하세요.",
      title: "글로벌 ",
      titleHighlight: "eSIM",
      subtitle: "집에 있는 것처럼 연결을 유지하세요 - 즉시 설정, 유연한 데이터, 200개 이상 국가의 글로벌 커버리지.",
      searchPlaceholder: "어디로 여행하시나요?",
      appStore: "앱 스토어",
      googlePlay: "구글 플레이"
    },
    // Popular Countries
    popularCountries: {
      title: "인기 목적지",
      subtitle: "인기 여행 목적지에서 즉시 연결하세요",
      fromPrice: "부터",
      perDay: "/일",
      unlimited: "무제한",
      startingAt: "시작 가격",
      getStarted: "시작하기",
      viewAllCountries: "모든 국가 보기",
      noPlansAvailable: "사용 가능한 무제한 요금제가 없습니다"
    },
    // How It Works
    howItWorks: {
      title: "Airvoy eSIM 작동 방식",
      subtitle: "간단한 3단계로 연결하세요",
      step1Title: "목적지 선택",
      step1Desc: "투명한 가격으로 200개 이상의 목적지를 둘러보세요. 숨겨진 수수료나 놀라운 비용 없이 - 모험에 완벽한 요금제만 제공합니다.",
      step2Title: "몇 초 만에 설치",
      step2Desc: "이메일을 통해 즉시 eSIM을 받으세요. 빠른 QR 코드 스캔으로 준비 완료 - 매장 방문이나 물리적 SIM 교체가 필요 없습니다.",
      step3Title: "자동 연결",
      step3Desc: "도착하면 즉시 연결하세요. 도착하는 순간 eSIM이 자동으로 활성화됩니다 - 공항 WiFi 찾기는 이제 그만.",
      learnMore: "더 알아보기"
    },
    // Benefits
    benefits: {
      whyAirvoy: "왜 Airvoy인가요?",
      title: "어디를 가든 연결을 유지하세요",
      item1Title: "당신에게 맞는 요금제 찾기",
      item1Desc: "예산에 맞는 유연한 데이터 요금제. 주간 1GB 요금제부터 6개월간 지속되는 100GB까지 - 모두 한 앱에서 찾으세요.",
      item2Title: "사용하기 쉬움",
      item2Desc: "Airvoy를 다운로드하고, eSIM을 설치하고, 데이터 요금제를 선택하면 - 목적지에 도착하는 순간 자동으로 활성화됩니다.",
      item3Title: "로밍 비용 회피",
      item3Desc: "숨겨진 로밍 수수료는 과거의 일입니다. 여행을 떠나기 전에 인터넷 연결 비용을 미리 알아보세요!",
      item4Title: "모든 여행에 하나의 eSIM",
      item4Desc: "기존 Airvoy eSIM에 새로운 목적지를 추가하세요 - 매번 새로운 eSIM을 설치할 필요가 없습니다. 충전하고 연결하기만 하면 됩니다!",
      item5Title: "데이터 부족 걱정 없음",
      item5Desc: "최악의 순간에 데이터가 떨어질 위험을 감수하지 마세요 - 요금제의 80%를 사용하면 알려드립니다.",
      item6Title: "200개 이상 국가",
      item6Desc: "전 세계 200개 이상의 국가와 지역에서 온라인 상태를 유지하세요."
    },
    // Videos
    videos: {
      title: "시청하고 빠르게 연결하기",
      subtitle: "두 개의 빠른 설명 - 하나는 iPhone용, 하나는 삼성용.",
      iPhoneTitle: "eSIM 설정 및 활성화 — iPhone",
      iPhoneDesc: "iPhone에서 Airvoy eSIM을 설치하고 활성화하는 단계별 가이드. 스캔, 설치, 몇 분 안에 온라인 연결.",
      samsungTitle: "eSIM 설정 및 활성화 — 삼성",
      samsungDesc: "삼성 갤럭시 기기에 Airvoy eSIM을 추가하는 방법을 알아보세요. 설치부터 첫 연결까지 빠르고 명확한 안내.",
      iOSGuide: "iOS 가이드",
      samsungGuide: "삼성 가이드",
      installationGuide: "또는 전체 설치 가이드 읽기"
    },
    // Footer
    footer: {
      description: "Airvoy eSIM을 사용하는 30,000명 이상의 여행자와 함께하세요. 스마트하게 여행하고, 연결을 유지하세요 - 여행이 당신을 어디로 데려가든.",
      company: "회사",
      aboutUs: "회사 소개",
      resources: "리소스",
      documentation: "문서",
      support: "지원",
      legal: "법적 고지",
      privacyPolicy: "개인정보 처리방침",
      termsOfService: "서비스 약관",
      followUs: "팔로우",
      copyright: "모든 권리 보유.",
      madeWith: "전 세계 여행자를 위해",
      forTravelers: "로 제작"
    },
    // Auth
    aut: {
      authenticationRequired: "인증 필요",
      signInPrompt: "대시보드에 액세스하고 eSIM 요금제를 구매하려면 로그인하세요."
    },
    // Common
    common: {
      close: "닫기",
      loading: "로딩 중...",
      tryAgain: "다시 시도",
      noResults: "검색 결과가 없습니다"
    },
    activate: {
    altText: "Airvoy eSIM 글로벌 활성화",
    activeInThailand: "태국에서 Airvoy 활성화",
    activeInSpain: "스페인에서 Airvoy 활성화",
    activeWorldwide: "전 세계에서 Airvoy 활성화",
    activeInGreece: "그리스에서 Airvoy 활성화", 
    activeInMexico: "멕시코에서 Airvoy 활성화",
    title: "WhatsApp 번호를 유지하세요",
    description: "같은 국가에 있는 것처럼 WhatsApp에서 모든 연락처와 통화하고 메시지를 보낼 수 있습니다.\n가족과 친구들과의 연락을 잃지 마세요."
    },
    regionalPlans: {
      multiCountryCoverage: "다국가 커버리지",
      title: "지역 요금제",
      subtitle: "지역을 선택한 후 필요한 요금제 기간/데이터를 선택하세요.",
      noPlansAvailable: "사용 가능한 지역 요금제가 없습니다.",
      from: "부터",
      seePlans: "요금제 보기",
      countries: "개국",
      plans: "개 요금제",
      startingFrom: "시작 가격",
      browseOptions: "옵션 둘러보기", 
      viewPlans: "요금제 보기"
    },
    partnerships: {
    headerLabel: "파트너십",
    title: "Airvoy 파트너십",
    subtitle: "함께 파트너가 되어 훌륭한 일을 해보세요.",
    join: "가입",
    airvoyAffiliate: "Airvoy\n제휴 프로그램", 
    affiliateDescription: "Airvoy eSIM을 홍보하여 최대 20% 커미션을 받으세요 - 지금 공식 제휴 네트워크에 가입하세요!",
    joinNow: "지금 가입!",
    learnMore: "더 알아보기",
    partnershipImageAlt: "Airvoy 파트너십",
    
    // Partnership types
    affiliateProgram: "제휴 프로그램",
    eventPartnership: "이벤트 파트너십", 
    travelPartnership: "여행 파트너십",
    contentPartnership: "콘텐츠 파트너십",
    sportsPartnership: "스포츠 파트너십",
    musicCulturePartnership: "음악 및 문화 파트너십",
    athleteCollaboration: "운동선수 협업",
    other: "기타",
    
    // Partnership descriptions
    eventPartnerships: "이벤트 파트너십",
    eventDescription1: "국제 이벤트를 조직하고 참석자들에게 매우 유용한 혜택인 무료 모바일 데이터를 제공하고 싶으신가요?",
    eventDescription2: "귀하와 게스트를 위한 맞춤형 솔루션을 제공하여 이벤트 전, 중, 후에 원활하게 연결될 수 있도록 도와드립니다.",
    
    travelPartnerships: "여행 파트너십",
    travelDescription1: "고객의 직원과 해외 여행 고객에게 원활하고 저렴한 모바일 데이터 및 음성 통화 기능을 제공하는 데 관심이 있으신가요?",
    travelDescription2: "통합 모바일 연결 제품군을 통해 최소한의 노력으로 최대한의 유틸리티로 고객에게 부가가치 여행 솔루션을 제공할 수 있도록 도와드립니다.",
    
    contentPartnerships: "콘텐츠 파트너십", 
    contentDescription1: "창의적인 아이디어, 참여도 높은 오디언스, 유용한 #여행꿀팁과 #생활꿀팁에 대한 예리한 안목을 가진 소셜 미디어 콘텐츠 크리에이터이신가요?",
    contentDescription2: "아니면 단순히 Airvoy를 좋아하고 다른 사람들도 전 세계적으로 원활한 모바일 연결을 즐길 수 있도록 알리고 싶으신가요?",
    
    sportsPartnerships: "스포츠 파트너십",
    sportsDescription1: "스포츠 경기를 관리하고 있으며 선수, 팀, 팬들에게 이벤트 전반에 걸쳐 안정적으로 연결될 수 있는 방법을 제공하고 싶으신가요?",
    sportsDescription2: "Airvoy와 파트너가 되어 개막식부터 마지막 휘슬까지 모든 사람이 연결된 상태를 유지할 수 있는 원활한 모바일 데이터 솔루션을 제공하세요.",
    
    musicCulturePartnerships: "음악 및 문화 파트너십",
    musicDescription1: "음악 페스티벌, 문화 행사 또는 라이브 공연을 조직하고 참석자들의 경험을 향상시킬 방법을 찾고 계신가요?",
    musicDescription2: "Airvoy는 청중에게 안정적인 모바일 데이터 서비스를 제공하여 이벤트를 즐기는 동안 공유하고, 스트리밍하고, 연결된 상태를 유지할 수 있도록 합니다.",
    
    athleteCollaborations: "운동선수 협업",
    athleteDescription1: "한 경기에서 다른 경기로 전 세계를 여행하는 운동선수로서 트로피 캐비닛에 더 이상 공간이 없나요?",
    athleteDescription2: "Airvoy와 파트너가 되어 스포츠가 데려가는 곳 어디든 연결된 상태를 유지하고, 어디에 있든 팬들과 여정을 공유하세요.",
    
    letsTalk: "이야기해 보세요",
    
    // Contact form
    getInTouch: "연락하기",
    successMessage: "연락해 주셔서 감사합니다! 곧 연락드리겠습니다.",
    errorMessage: "문제가 발생했습니다. 다시 시도해 주세요.",
    emailPlaceholder: "이메일을 입력하세요",
    fullNamePlaceholder: "성명",
    partnerTypePlaceholder: "어떤 파트너십을 원하시나요?",
    messagePlaceholder: "간단히 생각하고 계신 내용을 알려주세요",
    privacyConsent: "친근한 우리의",
    privacyPolicy: "개인정보 처리방침",
    sending: "전송 중...",
    send: "보내기"
    },
    faq: {
      headerLabel: "자주 묻는 질문",
      title: "자주 묻는 질문들에 대한 답변을 찾아보세요",
      learnMore: "더 알아보기",
      
      whatIsEsim: {
        question: "eSIM이 무엇인가요?",
        answer: "eSIM은 물리적 SIM을 사용하지 않고 통신사에서 셀룰러 요금제를 활성화할 수 있는 업계 표준 디지털 SIM입니다. iPhone에 8개 이상의 eSIM을 설치하고 두 개의 전화번호를 동시에 사용할 수 있습니다."
      },
      
      howToSetup: {
        question: "eSIM을 어떻게 설정하나요?",
        answer: "eSIM 기술은 매우 편리합니다. 하지만 eSIM 설정은 특히 처음 하는 경우 약간 번거로울 수 있습니다. 하지만 걱정하지 마세요. 여기에 단계별 가이드가 있어 곧바로 Airvoy를 사용할 수 있도록 도와드립니다."
      },
      
      whatIsAirvoy: {
        question: "Airvoy가 무엇인가요?",
        answer: "Airvoy는 글로벌 모바일 연결 솔루션을 제공하는 모바일 앱입니다. 물리적 SIM 카드나 높은 로밍 요금 없이 여행할 때 연결 상태를 유지할 수 있는 원활한 방법을 제공합니다."
      },
      
      howSaveRoaming: {
        question: "Airvoy는 어떻게 로밍 요금을 절약하는 데 도움이 되나요?",
        answer: "일반적인 로밍 요금보다 최대 90% 저렴한 요금으로 모바일 데이터를 제공합니다. 이렇게 하면 기존 로밍 서비스와 관련된 높은 비용을 피할 수 있습니다."
      },
      
      needNewSim: {
        question: "Airvoy로 여행할 때마다 새로운 SIM 카드가 필요한가요?",
        answer: "아니요, Airvoy는 eSIM 기술을 사용하므로 물리적 SIM 카드가 필요하지 않습니다. Airvoy eSIM은 글로벌이므로 eSIM을 다운로드하고 활성화하면 전 세계적으로 로밍하거나 특정 국가용으로 새 eSIM을 구매할 수 있습니다."
      },
      
      constantConnectivity: {
        question: "Airvoy는 여행할 때 지속적인 연결을 어떻게 보장하나요?",
        answer: "일반적인 로밍 요금보다 최대 90% 저렴한 요금으로 모바일 데이터를 제공합니다. 이렇게 하면 기존 로밍 서비스와 관련된 높은 비용을 피할 수 있습니다."
      },
      
      freeCallsTexts: {
        question: "Airvoy에서 무료 통화와 문자를 제공하나요?",
        answer: "아직은 아닙니다. 하지만 Airvoy는 곧 Airvoy 간 무료 통화와 문자를 제공할 예정입니다. 즉, 추가 비용 없이 다른 Airvoy 사용자와 연결 상태를 유지할 수 있습니다."
      },
      
      whyChooseAirvoy: {
        question: "다른 로밍 대안 대신 Airvoy를 선택해야 하는 이유는 무엇인가요?",
        answer: "Airvoy는 단일 eSIM으로 원활한 글로벌 연결, 비용 효율적인 모델, 메시징(곧 출시)과 현지 번호(곧 출시) 같은 추가 기능을 모두 사용하기 쉬운 앱 내에서 제공하므로 다른 로밍 대안보다 Airvoy를 선택해야 합니다. 저렴하고 쉬우며 어디를 가든 원하는 방식으로 연결할 수 있는 완전한 제어권을 제공합니다."
      }
    },
    browse: {
      main: {
        title: "eSIM 요금제 둘러보기",
        subtitle: "실시간 가격으로 전 세계 목적지의 eSIM 요금제를 발견하세요"
      },
      search: {
        placeholder: "국가 검색 (예: 미국, 스페인, 일본)...",
        clearSearch: "검색 지우기",
        noCountriesFound: "검색과 일치하는 국가를 찾을 수 없습니다.",
        noCountriesAvailable: "사용 가능한 국가가 없습니다.",
        clearSearchButton: "검색 지우기",
        searching: "국가 검색 중...",
        country: "개 국가",
        countries: "개 국가",
        foundFor: "검색 결과:"
      },
      loading: {
        loadingText: "로딩 중...",
        allCountriesLoaded: "모든 국가 로드됨",
        total: "총"
      },
      buttons: {
        showMoreCountries: "더 많은 국가 보기",
        showLessPlans: "적은 요금제 보기",
        showLess: "적게 보기",
        seeMorePlans: "더 많은 요금제 보기",
        more: "더보기",
        buyNow: "지금 구매"
      },
      navigation: {
        backToCountries: "국가로 돌아가기"
      },
      countryDetails: {
        description: "eSIM 데이터 요금제로 {{country}}를 유연하게 탐험하세요. 단기 체류든 장기 여행이든, 저희 요금제는 번거로움 없이 연결 상태를 유지해드립니다."
      },
      plans: {
        noPlansAvailable: "선택한 필터에 사용 가능한 요금제가 없습니다.",
        planDetails: "요금제 세부정보",
        details: "세부정보",
        unlimited: "무제한",
        for: "기간:",
        day: "일",
        days: "일"
      },
      checkout: {
        total: "총액"
      },
      planDetails: {
        title: "요금제 세부 정보",
        unlimitedData: "무제한 데이터",
        data: "데이터",
        country: "국가",
        duration: "기간",
        day: "일",
        days: "일",
        network: "네트워크",
        autoStart: "자동 시작",
        enabled: "활성화됨",
        disabled: "비활성화됨",
        planType: "요금제 유형",
        description: "설명",
        purchaseThisPlan: "이 요금제 구매",
        signInToPurchase: "구매하려면 로그인"
      }
    },
    installation: {
      title: "eSIM을 어떻게 설치하고 설정하나요?",
      metaUpdated: "업데이트 • 2개월 전",
      intro: {
        p1: "Android든 iPhone이든 먼저 휴대폰이 eSIM을 지원하고 통신사 잠금이 해제되어 있는지 확인하세요. 또한 안정적인 인터넷 연결(가능하면 Wi-Fi)이 필요합니다.",
        p2: "그 다음 아래 중에서 선택할 수 있습니다:",
        ol1: "QR 코드를 스캔하여 자동 설치",
        ol2: "수동으로 eSIM 설치",
        note: "QR 코드를 사용하는 방법이 가장 간단합니다."
      },
      ios: {
        qr: {
          title: "QR 코드로 eSIM 설치 (iOS)",
          s1: "1. 설정 > 셀룰러(모바일 데이터)로 이동",
          s2: "2. “eSIM 추가”를 탭하고 QR 코드 사용 선택",
          s3: "3. QR 코드를 스캔하고 요청 시 4자리 확인 코드를 입력",
          s4: "4. eSIM에 라벨을 지정하고 기본 회선에서 “데이터 전용” 선택",
          s5: "5. 이제 “모바일 데이터”에 eSIM이 표시됩니다"
        },
        manual: {
          title: "eSIM 수동 설치 (iOS)",
          s1: "1. 설정 > 모바일 데이터 > eSIM 추가",
          s2: "2. “eSIM 추가”를 탭하고 QR 코드 사용 선택",
          s3: "3. 스캔 대신 ‘세부정보 직접 입력’을 탭",
          s4: "4. Airvoy 앱에 표시된 SM-DP+ 주소, 활성화 코드, (선택) 확인 코드를 입력",
          s5: "5. eSIM 라벨을 지정하고 기본 회선에서 “데이터 전용” 선택",
          s6: "6. 이제 모바일 데이터에 eSIM이 표시됩니다"
        }
      },
      android: {
        qr: {
          title: "QR 코드로 eSIM 설치 (Android)",
          s1: "1. 설정 > 네트워크 및 인터넷 > SIM",
          s2: "2. “SIM” 오른쪽의 “+” 아이콘을 탭",
          s3: "3. 하단의 “대신 SIM 다운로드?”를 탭",
          s4: "4. “SIM 다운로드” 화면에서 “다음”을 탭 — “네트워크 정보 확인 중...” 표시",
          s5: "5. 확인 후 QR 코드를 스캔할 뷰파인더가 표시됨",
          s6: "6. 인쇄된 QR 또는 다른 기기에 표시된 코드를 뷰파인더에 맞춤",
          s7: "7. 스캔이 끝나면 기기가 정보를 다시 확인함",
          s8: "8. 다운로드를 탭해 확인 — eSIM 데이터가 다운로드됨",
          s9: "9. 완료되면 “다운로드 완료”가 표시됨",
          s10: "10. 준비되면 인터넷 사용을 위해 eSIM 설정을 마치세요."
        }
      },
      notes: {
        title: "중요한 안내",
        n1: "기기가 eSIM을 지원하고 통신사 잠금이 해제되어 있는지 확인하세요",
        n2: "설치 중에는 안정적인 Wi-Fi 연결이 필요합니다",
        n3: "eSIM은 한 번만 설치할 수 있으니 준비가 되었을 때 시작하세요",
        n4: "집 번호의 통화/문자를 위해 기본 SIM은 계속 활성화해 두세요",
        n5: "목적지 국가에 도착하면 eSIM이 활성화됩니다"
      },
      support: {
        title: "도움이 필요하신가요?",
        body: "eSIM 설치에 문제가 있으면 지원팀이 도와드릴게요!",
        emailLabel: "이메일:",
        websiteLabel: "웹사이트:"
      }
    },
    installGuide: {
      header: {
        title: "완벽한 eSIM 설치 가이드",
        subtitle: "eSIM을 설치·활성화·사용하는 데 필요한 모든 내용을 한곳에. 기기별 안내를 따라 가장 매끄럽게 설정하세요.",
        link: "Android 설치 상세 가이드도 확인하기",
        ios: "iOS용 상세 가이드",
        android: "Android용 상세 가이드"
      },
      iphoneHero: "iPhone에서 eSIM 설치 및 활성화",
      cards: {
        c1: {
          alt: "토글/시계 아이콘이 있는 iPhone",
          install: "설치",
          activate: "활성화",
          textA: "여행 몇 시간 전에",
          textB: "비행 중 또는 도착 시 진행하세요."
        },
        c2: {
          alt: "QR 스캐너 인터페이스가 있는 iPhone",
          line1: "“QR 코드로 설치”를 선택",
          line2: "다른 기기에 코드가 있을 때",
          line3: "스캔하세요."
        },
        c3: {
          alt: "수동 설치 인터페이스가 있는 iPhone",
          line1: "“수동으로 설치”를 선택",
          line2: "QR 코드를 스캔할 수 없을 때 사용하세요."
        }
      },
      learn: {
        title: "단계별로 알아보기",
        subtitle: "진행하려는 설치 유형을 선택하세요",
        btnQr: "QR 코드로 설치",
        btnManual: "수동 설치"
      },
      prep: {
        alt: "휴대폰 경고 아이콘",
        qr: {
          title: "QR 코드 설치 전 꼭 확인하세요:",
          i1: "QR 코드를 스캔할 수 있도록 다른 화면/기기에 코드를 준비하세요.",
          i2: "진행 내내 안정적인 인터넷 연결이 필요합니다.",
          i3: "QR 코드는 한 번만 스캔할 수 있습니다.",
          i4: "eSIM을 삭제하면 다시 사용할 수 없습니다."
        },
        manual: {
          title: "수동 설치 전 꼭 확인하세요:",
          i1: "수동 설치 코드는 1회만 사용할 수 있습니다."
        },
        shared: {
          i2: "진행 내내 안정적인 인터넷 연결이 필요합니다.",
          i3: "eSIM을 삭제하면 다시 사용할 수 없습니다."
        }
      },
      start: {
        title: "함께 시작해볼까요",
        c1: {
          title: "이메일 열기",
          qr: { p1: "설치에 사용할 기기와 다른 기기에서 이메일을 열고, QR 코드가 포함된 메일을 확인하세요." },
          manual: { p1: "이메일에서 “SM-DP+ 주소”와 “활성화 코드”를 확인하고 준비하세요. SMS로도 전송됩니다." },
          shared: { missing: "코드를 받지 못했다면", contact: "문의하세요" }
        },
        c2: {
          qr: { title: "QR 코드 스캔", p1: "설치할 iPhone의 카메라로 코드를 스캔하세요. 또는 설정 → 모바일 데이터 → “데이터 요금제 추가”에서 스캔할 수 있습니다." },
          manual: { title: "iPhone의 “설정” 열기", p1: "모바일 데이터로 이동하여 “eSIM 추가/데이터 요금제 추가” → “QR 코드 사용”을 선택한 다음, “세부정보 직접 입력”을 선택하세요." }
        },
        c3: {
          title: "iPhone의 지시에 따라 설치 완료",
          qr: { p1: "코드를 스캔하면 설치가 시작됩니다. 아래 안내에 따라 단계별로 구성하세요." },
          manual: { p1: "“QR 코드 스캔” 단계에서 “세부정보 직접 입력”을 선택하고 화면 안내를 따르세요." }
        }
      },
      compat: {
        title: "기기 호환성 확인",
        subtitle: "내 기기가 eSIM을 지원하는지 확인하세요. 검색으로 모델을 빠르게 찾아볼 수 있습니다.",
        iosTab: "iPhone / iPad",
        androidTab: "Android",
        searchIos: "iPhone/iPad 모델 검색...",
        searchAndroid: "Android 모델 검색...",
        iphones: "호환 iPhone",
        ipads: "호환 iPad (4G 전용)",
        androids: "호환 Android 기기",
        noMatch: "검색과 일치하는 기기가 없습니다.",
        iosNotesTitle: "중요 안내:",
        iosNotes: {
          i1: "iPhone 13/14는 eSIM 2개 동시 활성화 가능",
          i2: "중국 본토·홍콩판 iPhone은 eSIM 미지원(일부 예외)",
          i3: "미국 판매 iPhone 14+는 물리 SIM 미지원"
        },
        androidNotesTitle: "중요 제한 사항:",
        androidNotes: {
          i1: "미국/홍콩판 Samsung은 eSIM 미지원일 수 있음",
          i2: "호주·일본·대만판 Google Pixel은 eSIM 미지원",
          i3: "홍콩 판매폰은 일반적으로 eSIM 미지원",
          i4: "eSIM 사용을 위해서는 통신사 잠금 해제가 필요"
        },
        empty: "기기 모델을 입력해 호환성을 확인하세요"
      },
      tips: {
        title: "프로 팁: 여행 전 활성화 준비",
        body: "출국 전에 eSIM을 설치하고, 도착 후 활성화하면 공항에서 바로 연결됩니다. Wi-Fi나 현지 SIM을 찾느라 시간 낭비하지 마세요.",
        before: {
          title: "출국 전",
          i1: "집에서 eSIM 프로필 설치",
          i2: "설치 과정을 미리 테스트",
          i3: "QR 코드 스크린샷을 백업으로 보관",
          i4: "기기의 통신사 잠금 해제 확인"
        },
        after: {
          title: "도착 후",
          i1: "eSIM의 셀룰러 데이터를 켜기",
          i2: "네트워크 등록까지 2–3분 대기",
          i3: "웹 검색으로 연결 테스트",
          i4: "필요 시 데이터 로밍 설정"
        }
      },
      support: {
        title: "추가 지원이 필요하신가요?",
        body: "호환성부터 설치 지원까지 모든 단계에서 도와드립니다.",
        btnEmail: "이메일 지원",
        btnCenter: "지원 센터 방문"
      },
      steps: {
        ios: {
          s1: { title: "설정 열기", desc: "설정 → 셀룰러(일부 지역은 ‘모바일 데이터’)", detail: "설정에서 ‘셀룰러/모바일 데이터’를 찾으세요." },
          s2: { title: "셀룰러 요금제 추가", desc: "“셀룰러 요금제 추가” 또는 “eSIM 추가” 탭", detail: "해당 옵션이 보이지 않으면 eSIM 미지원일 수 있습니다." },
          s3: { title: "QR 코드 스캔", desc: "“QR 코드 사용” 선택 후 이메일의 코드를 스캔", detail: "조명이 밝고 흔들림 없도록 하세요." },
          s4: { title: "셀룰러 요금제 추가", desc: "요금제 세부정보가 보이면 “추가” 탭", detail: "통신사/요금제 정보를 확인 후 진행하세요." },
          s5: { title: "플랜 라벨 지정", desc: "“기본/여행/보조” 등 라벨 선택", detail: "데이터/통화/문자에 사용할 플랜 구분에 유용합니다." },
          s6: { title: "기본 회선 설정", desc: "데이터용 회선을 선택", detail: "통화/문자는 기존 SIM, 데이터는 eSIM 사용 가능." }
        },
        android: {
          s1: { title: "설정 열기", desc: "설정 → 네트워크 및 인터넷 → SIM", detail: "제조사에 따라 경로가 다를 수 있음. Samsung: 연결 → SIM 카드 관리자." },
          s2: { title: "모바일 요금제 추가", desc: "“+” 또는 “모바일 요금제 추가” 탭", detail: "“모바일 요금제 추가/대신 SIM 다운로드/제공자 추가” 등." },
          s3: { title: "SIM 다운로드", desc: "“SIM 카드가 없나요?” 또는 “대신 SIM 다운로드” 선택", detail: "물리 SIM 대신 eSIM을 설치하려는 경우입니다." },
          s4: { title: "QR 코드 스캔", desc: "“QR 코드 스캔” 선택 후 코드를 인식", detail: "밝은 조명과 안정적인 손이 도움이 됩니다." },
          s5: { title: "프로필 다운로드", desc: "프로필이 표시되면 “다운로드” 탭", detail: "인터넷을 통해 eSIM 프로필을 내려받습니다." },
          s6: { title: "eSIM 활성화", desc: "eSIM을 켜고 데이터 연결 우선으로 설정", detail: "데이터/통화/SMS에 사용할 SIM을 선택할 수 있습니다." }
        }
      }
    },
    profile: {
      loading: "프로필을 불러오는 중…",
      errors: {
        load: "eSIM 목록을 불러오지 못했습니다",
        delete: "eSIM 삭제에 실패했습니다. 다시 시도하세요.",
        bundle: "번들 상태를 가져오지 못했습니다",
        network: "번들 상태 조회 중 네트워크 오류",
        invoice: "영수증을 다운로드할 수 없습니다"
      },
      auth: {
        title: "로그인이 필요합니다",
        subtitle: "프로필과 eSIM 기록을 보려면 로그인하세요.",
        cta: "로그인"
      },
      header: {
        fallback: "사용자 프로필",
        count: "구매한 eSIM {{count}}개"
      },
      list: {
        title: "내 eSIM",
        subtitle: "구매한 프로필을 관리하고 QR 코드와 영수증을 확인하세요.",
        total: "총 {{count}}개"
      },
      empty: {
        title: "아직 eSIM이 없습니다",
        subtitle: "요금제를 둘러보고 몇 초 만에 연결하세요—물리 SIM이 필요 없습니다.",
        cta: "요금제 보기",
        tip: "팁: 출국 전에 설치하고 도착 후 활성화할 수 있어요."
      },
      item: {
        country: "국가",
        statusTitle: "현재 상태",
        pricePaid: "결제 금액",
        purchaseDate: "구매일"
      },
      actions: {
        details: "자세히 보기",
        showQr: "QR 보기",
        invoice: "영수증"
      },
      hint: "eSIM 설치가 필요하신가요? iOS: 설정 → 셀룰러 → eSIM 추가. Android: 설정 → 네트워크와 인터넷 → SIM → eSIM 추가.",
      delete: {
        title: "eSIM 삭제",
        confirm: "기록에서 이 eSIM을 제거하시겠습니까? 되돌릴 수 없습니다.",
        deleting: "삭제 중…",
        cta: "eSIM 삭제"
      },
      details: {
        title: "eSIM 상세 & 실시간 상태",
        refresh: "번들 상태 새로고침",
        live: "실시간 번들 상태",
        updated: "업데이트:",
        fetching: "실시간 상태를 불러오는 중...",
        ref: "참조:",
        discount: "할인 적용됨",
        usage: {
          title: "데이터 사용량",
          used: "사용됨",
          remaining: "남은 용량",
          total: "총 용량"
        },
        assigned: "번들 할당 시각",
        plan: {
          title: "플랜 정보",
          destination: "목적지",
          name: "플랜 이름",
          allowance: "데이터 제공량",
          validity: "유효기간"
        },
        tech: {
          title: "기술 정보",
          activation: "활성화 코드",
          copyActivation: "활성화 코드 복사",
          iccid: "ICCID",
          copyIccid: "ICCID 복사",
          orderRef: "GOeSIM 주문 참조"
        },
        install: {
          title: "설치 안내",
          iosTitle: "iOS:",
          androidTitle: "Android:",
          ios: "설정 → 셀룰러 → eSIM 추가 → QR 코드 사용",
          android: "설정 → 네트워크와 인터넷 → SIM → eSIM 추가 → QR 코드 스캔",
          important: "중요:",
          once: "이 eSIM은 한 번만 설치할 수 있습니다. 진행 전에 기기가 잠금 해제되어 있고 eSIM을 지원하는지 확인하세요."
        },
        purchase: {
          title: "구매 정보",
          date: "구매일",
          amount: "결제 금액",
          method: "결제 수단",
          txn: "거래 ID"
        },
        referral: {
          title: "추천 할인 적용",
          code: "추천 코드",
          original: "원래 가격",
          saved: "절약한 금액"
        },
        billing: {
          title: "청구 정보",
          name: "이름",
          email: "이메일",
          country: "국가",
          zip: "우편번호"
        }
      },
      qr: {
        title: "eSIM QR 코드",
        alt: "eSIM QR 코드",
        copy: "활성화 코드 복사",
        tip: "팁: 휴대폰 카메라로 QR을 스캔하세요. eSIM은 한 번만 설치할 수 있습니다."
      },
      common: {
        usd: "USD",
        days: "일",
        na: "해당 없음",
        invalidDate: "잘못된 날짜",
        cancel: "취소",
        close: "닫기",
        copied: "복사됨"
      }
    },
    countryDetails: {
  loading: "국가 정보를 불러오는 중...",
  errors: {
    notFound: "국가를 찾을 수 없습니다",
    loadFail: "국가 데이터를 불러오지 못했습니다"
  },
  notFound: {
    title: "국가를 찾을 수 없음",
    subtitle: "찾으시는 국가가 존재하지 않거나 이용 가능한 요금제가 없습니다.",
    cta: "모든 국가 보기"
  },
  back: "국가 목록으로 돌아가기",
  blurb: "eSIM 데이터 요금제로 {{country}}를 자유롭게 여행하세요. 짧은 방문이든 장기 체류든 번거로움 없이 연결을 유지합니다.",
  noPlans: "선택한 필터에 해당하는 요금제가 없습니다.",
  plan: {
    details: "요금제 상세",
    detailsShort: "상세",
    networkBadge: "5G",
    unlimited: "무제한",
    unlimitedData: "무제한 데이터",
    gb: "GB",
    gbShort: "GB",
    data: "데이터",
    forDays: "{count, plural, one {# DAY} other {# DAYS}}"
  },
  currency: {
    usd: "USD"
  },
  duration: {
    days: "{count, plural, one {#일} other {#일}}"
  },
  more: {
    more: "더 많은 요금제 보기 (추가 {extra}개)",
    moreShort: "+{extra} 더 보기",
    less: "요금제 접기",
    lessShort: "접기"
  },
  modal: {
    title: "요금제 상세",
    country: "국가:",
    duration: "기간:",
    network: "네트워크:",
    autostart: "자동 시작:",
    enabled: "사용",
    disabled: "해제",
    planType: "요금제 유형:",
    description: "설명",
    purchase: "이 요금제 구매",
    signInToPurchase: "구매하려면 로그인"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "합계",
    buy: "지금 구매"
  }
    },
    checkout: {
      loading: "보안 결제 화면을 불러오는 중...",
      invalidPlan: {
        title: "요금제 데이터가 유효하지 않습니다",
        subtitle: "선택한 요금제 정보를 불러올 수 없습니다.",
        cta: "대시보드로 돌아가기"
      },
      success: {
        title: "구매가 완료되었습니다!",
        message: "eSIM을 성공적으로 구매했습니다! ICCID: {{iccid}}. {{targetEmail}}",
        sentBoth: "QR 코드와 설치 안내가 {{a}} 및 {{b}}로 발송되었습니다",
        sentOne: "QR 코드와 설치 안내가 {{email}}로 발송되었습니다",
        view: "내 eSIM 보기"
      },
      common: { close: "닫기" },
      header: {
        title: "보안 결제",
        subtitle: "eSIM 구매를 안전하게 완료하세요"
      },
      benefits: {
        title: "로그인하고 혜택을 받으세요",
        copy: "계정을 만들면 구매 내역 저장, 전용 할인, eSIM 관리가 가능합니다.",
        cta: "회원가입 / 로그인"
      },
      billing: {
        title: "결제 정보",
        subtitle: "영수증과 eSIM은 이 이메일로 전송됩니다"
      },
      form: {
        firstName: "이름",
        lastName: "성",
        email: "이메일 주소",
        referral: "추천 코드 (선택)"
      },
      placeholder: {
        firstName: "이름 입력",
        lastName: "성 입력",
        email: "이메일 입력",
        referral: "추천 코드 입력",
        altEmail: "대체 이메일 입력"
      },
      referral: {
        validating: "확인 중...",
        invalid: "유효하지 않은 추천 코드입니다",
        ownCode: "본인이 만든 추천 코드는 사용할 수 없습니다",
        inactive: "이 추천 코드는 더 이상 활성 상태가 아닙니다",
        used: "이미 사용된 추천 코드입니다",
        valid: "유효합니다! {{percent}}% 할인 적용됨",
        error: "코드 확인 중 오류가 발생했습니다"
      },
      altEmail: {
        title: "다른 이메일 주소 사용",
        copy: "eSIM은 대체 이메일로도 전송되며 계정에 저장됩니다",
        input: "대체 이메일 주소"
      },
      createAccount: {
        title: "구매 내역을 저장하려면 계정 만들기",
        copy: "선택 사항 — eSIM 관리 및 지원 이용에 도움이 됩니다"
      },
      payment: {
        title: "결제 정보",
        secured: "Stripe 보안 적용",
        method: "결제 수단",
        card: "신용/체크카드",
        cardTypes: "Visa, Mastercard, American Express",
        paypalCopy: "PayPal로 결제",
        cardInfo: "카드 정보",
        loadingSecure: "보안 결제 양식을 불러오는 중...",
        cardComplete: "카드 정보 입력이 완료되었습니다",
        processing: "결제 처리 중...",
        complete: "결제 완료 • ${{total}}"
      },
      legal: {
        agree: "주문을 완료하면 아래 약관에 동의하는 것으로 간주됩니다:",
        terms: "이용약관",
        and: "및",
        privacy: "개인정보 및 환불 정책"
      },
      summary: {
        title: "주문 요약",
        planLabel: "eSIM 요금제",
        digital: "디지털",
        data: "데이터 용량:",
        validity: "유효기간:",
        coverage: "커버리지:",
        nationwide: "전국"
      },
      pricing: {
        planPrice: "요금제 가격",
        referralDiscount: "추천 할인 ({{percent}}%)",
        stripeFee: "Stripe 처리 수수료",
        paypalFee: "PayPal 처리 수수료",
        taxes: "세금 및 서비스 요금",
        included: "포함됨",
        total: "총액"
      },
      paypal: {
        description: "{{country}} eSIM - {{days}}일 동안 {{data}}"
      },
      duration: {
        days: "{count, plural, one {#일} other {#일}}"
      },
      alerts: {
        enterName: "성함을 모두 입력해 주세요",
        formNotReady: "결제 양식이 아직 준비되지 않았습니다. 잠시 후 다시 시도해 주세요.",
        cardIncomplete: "카드 정보를 모두 입력해 주세요",
        paypalFailed: "PayPal 결제 실패: {{msg}}",
        paypalGeneric: "PayPal 결제에 실패했습니다. 다시 시도해 주세요.",
        purchaseFailed: "구매 실패: {{msg}}"
      } 
    },
    privacy: {
      title: "개인정보 처리방침",
      subtitle:
        "Routed Labs, Inc.가 개인 정보를 수집·이용·보호하는 방법에 대한 안내입니다.",
      lastUpdated: { label: "최종 업데이트:", date: "2025년 8월 1일" },
      sections: {
        intro: {
          heading: "개요",
          p1:
            "Routed Labs, Inc.(“Routed Labs”, “당사”)는 Airvoy 웹사이트와 모바일 앱(“서비스”)을 운영합니다. 본 방침은 개인 정보의 수집, 이용, 공개, 보호에 대해 설명합니다. 서비스를 이용하면 이에 동의하는 것으로 간주됩니다.",
          p2:
            "당사는 개인 정보의 기밀성, 무결성, 보안을 유지하기 위해 투명하고 법규를 준수하는 데이터 처리 관행을 적용합니다."
        },
        collect: {
          heading: "수집하는 정보",
          p1:
            "데이터 최소화 원칙을 따르며 eSIM 서비스 제공에 필요한 정보만 수집합니다:",
          email: {
            title: "이메일 주소",
            collectedWhen: "다음 상황에서 수집됩니다:",
            items: ["계정 생성", "eSIM 요금제 구매", "뉴스레터 구독", "고객지원 문의"],
            purposeLabel: "수집 목적:",
            purpose:
              "계정 관리, eSIM 전달, 구매 확인, 고객 지원 제공을 위해 사용합니다."
          },
          notCollect: {
            title: "다음 정보는 수집하지 않습니다:",
            items: [
              "전화번호 또는 기기 식별자",
              "위치/추적 데이터",
              "검색/브라우징 기록 또는 행태 쿠키",
              "소셜 프로필 또는 개인 사진",
              "금융 데이터(결제는 제3자에서 처리)"
            ]
          }
        },
        use: {
          heading: "정보 이용 목적",
          p1: "수집된 정보는 다음 목적에 한해 사용됩니다:",
          items: [
            "eSIM 자격증명, 구매 확인 및 영수증 발송",
            "기술/고객 지원 제공",
            "중요 서비스 업데이트 및 보안 공지 전송",
            "선택적 마케팅 자료 발송(동의 시)"
          ],
          optOut: "마케팅 이메일은 언제든지 수신 거부할 수 있습니다."
        },
        share: {
          heading: "정보 공유 및 공개",
          p1:
            "개인 정보는 판매·대여·거래하지 않습니다. 다음의 경우에 한해 공유될 수 있습니다:",
          items: [
            { title: "서비스 제공자:", body: "결제 처리, 이메일 발송 등" },
            { title: "법적 요구:", body: "법률·규정·법적 절차에 따른 경우" },
            { title: "기업 거래:", body: "합병, 인수 또는 조직 개편과 관련된 경우" },
            { title: "보안:", body: "사용자와 당사의 권리·재산·안전을 보호하기 위해" }
          ]
        },
        retain: {
          heading: "보관 및 삭제",
          p1: "다음 기간 동안 필요한 범위 내에서만 정보를 보관합니다:",
          items: [
            "활성 계정: 계정이 활성인 동안 및 마지막 활동 후 최대 2년",
            "비회원 구매: 지원 및 이행을 위해 최대 1년",
            "계정 삭제 시: 모든 개인 정보는 운영 시스템에서 영구 삭제"
          ]
        },
        rights: {
          heading: "이용자 권리",
          p1: "다음 권리를 행사할 수 있습니다:",
          items: [
            "개인 정보 열람 및 사본 요구",
            "부정확한 데이터 정정 요구",
            "기록 삭제 요구",
            "마케팅 동의 철회"
          ],
          contactPreamble: "요청은 다음 주소로 제출할 수 있습니다:"
        },
        security: {
          heading: "정보 보안",
          p1:
            "당사는 개인 정보를 보호하기 위해 다음과 같은 기술·관리적 조치를 적용합니다:",
          items: [
            "전송 및 저장 시 암호화",
            "정기 감사 및 취약점 평가",
            "엄격한 접근 제어와 인증",
            "안전한 인프라/데이터센터"
          ]
        },
        contact: {
          heading: "연락처",
          p1: "본 개인정보 처리방침에 관한 문의는 아래로 연락하세요:",
          company: "Routed Labs, Inc.",
          emailLabel: "이메일:",
          addressLabel: "주소:",
          address: "451 Niantic Avenue, Daly City, CA 94014, United States",
          subjectLabel: "제목:",
          subject: "“Privacy Policy Inquiry”"
        },
        updates: {
          heading: "정책 변경",
          p1:
            "운영·법률·규제 변경을 반영하기 위해 본 방침은 주기적으로 개정될 수 있습니다. 중요한 변경은 본 페이지에 공지하고 “최종 업데이트” 일자를 갱신합니다.",
          p2:
            "사용자는 정기적으로 본 문서를 확인하여 당사의 개인 정보 처리 방식을 숙지하시기 바랍니다."
        }
      }
    },
    tos: {
  title: "이용약관",
  subtitle:
    "Routed Labs, Inc.가 제공하는 Airvoy 플랫폼 및 서비스 이용에 관한 법적 약관입니다.",
  lastUpdated: { label: "최종 업데이트:", date: "2025년 8월 1일" },
  sections: {
    agreement: {
      heading: "약관 동의",
      p1:
        "본 이용약관(“약관”)은 사용자(“귀하”)와 Routed Labs, Inc.(“Routed Labs”, “당사”) 간에 Airvoy 웹사이트·모바일 앱 및 관련 eSIM 서비스(총칭하여 “서비스”) 이용에 관한 법적 계약입니다.",
      p2:
        "서비스에 접근하거나 이용함으로써 귀하는 본 약관을 읽고 이해하였으며 이에 동의함을 인정합니다. 동의하지 않는 경우 서비스 이용을 중단해야 합니다."
    },
    service: {
      heading: "서비스 설명",
      p1:
        "서비스는 eSIM 기능을 제공하여 국제적으로 이동통신 데이터망을 이용할 수 있게 합니다. 제공 항목:",
      items: [
        "글로벌 연결용 디지털 eSIM 프로필",
        "다양한 기간의 데이터 요금제",
        "활성화/설치를 위한 QR 코드 제공",
        "기술 문의를 위한 고객지원",
        "등록 사용자용 계정 관리 도구"
      ],
      notice:
        "중요: 서비스 이용에는 호환되고 잠금 해제된 기기가 필요합니다. 모든 기기/모든 지역에서의 호환성 또는 커버리지를 보장하지 않습니다."
    },
    eligibility: {
      heading: "이용 자격",
      p1: "서비스를 이용하기 위해 귀하는 다음을 보증합니다:",
      items: [
        "만 18세 이상 또는 법정대리인 동의 보유",
        "법적으로 구속력 있는 계약 체결 능력 보유",
        "정확하고 완전한 등록 정보 제공",
        "호환 기기를 보유하거나 사용할 권한 보유",
        "관련 법령 준수"
      ]
    },
    account: {
      heading: "계정 등록",
      p1:
        "사용자는 등록 또는 비회원 상태로 eSIM을 구매할 수 있습니다. 등록 시 구매 내역 및 확장 지원 등 추가 기능을 제공합니다.",
      registered: {
        title: "등록 계정",
        items: [
          "유효한 이메일 주소 필요",
          "계정 보안 유지 책임",
          "정보의 정확성 유지 의무",
          "무단 액세스 발생 시 즉시 통지"
        ]
      },
      guest: {
        title: "비회원 구매",
        items: [
          "이메일 주소만 필요",
          "eSIM은 전자적으로 전달",
          "지원은 해당 구매 범위로 제한",
          "지속적인 구매 내역은 보관되지 않음"
        ]
      }
    },
    payment: {
      heading: "결제 조건",
      p1:
        "구매를 완료함으로써 귀하는 당사 및 결제 대행사가 귀하의 결제 수단으로 요금을 청구하는 것에 동의합니다. 주요 조건:",
      items: [
        "모든 가격은 미화 기준이며 적용 세금 포함",
        "결제는 구매 시점에 즉시 이루어짐",
        "결제 처리는 제3자 제공업체가 담당",
        "결제 미완료 시 서비스가 중단될 수 있음"
      ]
    },
    refunds: {
      heading: "환불 정책",
      p1: "다음 조건에 따라 환불 요청을 검토합니다:",
      items: [
        "구매 후 24시간 이내 요청 시 가능",
        "eSIM이 활성화되거나 사용된 경우 불가",
        "기술적인 문제는 개별 검토",
        "기기 호환성 책임은 사용자에게 있음"
      ],
      p2: {
        prefix: "환불 요청은 다음 주소로 보내주세요: ",
        suffix: " (주문 상세 및 사유 포함)."
      }
    },
    limitations: {
      heading: "서비스 제한",
      p1: "서비스에는 다음과 같은 제한이 있습니다:",
      items: [
        "기기는 eSIM 호환 및 잠금 해제 상태여야 함",
        "커버리지는 현지 파트너망에 따라 달라짐",
        "속도/가용성은 지역에 따라 상이",
        "미사용 데이터는 소멸되며 이월되지 않음",
        "요금제는 기기 간 이전 불가"
      ]
    },
    prohibited: {
      heading: "금지된 사용",
      p1:
        "다음과 같은 불법적 또는 금지된 목적으로 서비스를 사용하지 않기로 동의합니다:",
      items: [
        "불법 활동 또는 규정 위반",
        "괴롭힘, 남용, 사기 행위",
        "무단 네트워크 접근 또는 간섭",
        "동의 없이 자격 증명 재판매/공유",
        "네트워크 성능을 저해하는 과도한 사용"
      ]
    },
    liability: {
      heading: "책임의 제한",
      p1:
        "법이 허용하는 최대 범위 내에서, 당사는 서비스 이용으로 인한 간접·부수·결과적 손해에 대해 책임지지 않습니다. 총 책임은 청구 전 12개월 동안 해당 서비스에 대해 귀하가 지불한 금액을 초과하지 않습니다."
    },
    indemnity: {
      heading: "면책",
      p1:
        "귀하는 서비스 오용 또는 본 약관 위반으로부터 발생하는 청구·손해·비용에 대해 당사 및 계열사를 면책하고 보호하는 데 동의합니다."
    },
    termination: {
      heading: "해지",
      p1:
        "귀하가 본 약관을 위반하거나 불법 행위를 하거나 사용자/당사에 해를 끼치는 경우, 당사는 서비스 접근을 즉시 중단 또는 해지할 수 있습니다. 해지 시 서비스 이용 권리는 즉시 종료됩니다."
    },
    law: {
      heading: "준거법",
      p1:
        "본 약관은 미국 델라웨어주 법률의 적용을 받습니다. 분쟁 해결을 위해 델라웨어 주 법원의 전속 관할에 따르기로 동의합니다."
    },
    amend: {
      heading: "약관 변경",
      p1:
        "당사는 재량에 따라 본 약관을 수정할 수 있습니다. 업데이트는 웹사이트에 게시되며 별도 고지가 없는 한 즉시 효력을 가집니다. 이후에도 서비스를 계속 이용하면 변경된 약관에 동의한 것으로 간주됩니다."
    },
    contact: {
      heading: "연락처",
      p1: "본 약관과 관련된 문의는 다음으로 연락해 주세요:"
    }
  }
    },
    about: {
      title: "Airvoy 소개",
      sections: {
        overview: {
          heading: "개요",
          body:
            "Airvoy는 Routed Labs, Inc.가 개발한 eSIM 플랫폼입니다. 해외 여행자에게 쉽고 합리적이며 신뢰할 수 있는 모바일 연결을 제공합니다. 물리적 SIM 카드가 필요 없어 200개 이상의 목적지에서 데이터 요금제를 손쉽게 활성화할 수 있습니다."
        },
        mission: {
          heading: "미션",
          body:
            "Routed Labs, Inc.의 단일한 미션은 모바일 연결을 단순화하는 것입니다. 국제 로밍과 SIM 조달에 수반되는 불확실성·숨은 비용·물류적 장애물을 제거해 여행자가 편하게 연결 상태를 유지하도록 돕습니다."
        },
        background: {
          heading: "배경",
          p1:
            "Routed Labs, Inc.의 본사는 캘리포니아 데일리시티에 있습니다. 높은 로밍 요금, 제한적인 SIM 가용성 등 국제 연결의 어려움을 직접 겪은 경험에서 회사가 탄생했습니다.",
          p2:
            "이러한 문제를 관찰한 창업자는 eSIM 기술을 활용해 글로벌 연결을 개선할 기회를 발견했습니다.",
          p3:
            "현재 당사는 전 세계 수천 명의 사용자를 지원하며, 신뢰성·투명성·접근성을 중시합니다."
        },
        operations: {
          heading: "운영",
          items: [
            { title: "글로벌 커버리지:", desc: "200개 이상 국가/지역의 고속 네트워크 이용." },
            { title: "eSIM 프로비저닝:", desc: "물리 SIM 없이 수분 내 디지털 설치." },
            { title: "고객 지향:", desc: "명확성과 사용자 니즈를 우선하는 서비스·지원." }
          ]
        },
        corporate: {
          heading: "기업 정보",
          company: {
            title: "회사 세부 정보",
            nameLabel: "회사명:",
            name: "Routed Labs, Inc.",
            repLabel: "대표:",
            rep: "Hector Diaz",
            addrLabel: "본사 주소:",
            addr: "451 Niantic Avenue, Daly City, CA 94014, United States",
            contactLabel: "문의:"
          },
          agent: {
            title: "등록 대리인 정보",
            nameLabel: "등록 대리인:",
            name: "Legalinc Corporate Services Inc.",
            addrLabel: "등록 대리인 주소:",
            addr: "131 Continental Dr, Suite 305, Newark, DE 19713, United States"
          }
        },
        principles: {
          heading: "핵심 원칙",
          items: [
            { title: "단순성", desc: "연결 과정은 효율적이고 접근 가능하도록 설계됩니다." },
            { title: "신뢰성", desc: "서비스는 일관되고 예측 가능하며 신뢰할 수 있습니다." },
            { title: "혁신", desc: "플랫폼을 지속적으로 개선하고 범위를 확장합니다." },
            { title: "투명성", desc: "요금 및 정책을 명확하게 안내합니다." },
            { title: "고객 중심", desc: "의사결정과 개선은 사용자 요구에 의해 이끌어집니다." },
            { title: "자유", desc: "여행자가 연결 제약 없이 탐험하도록 돕습니다." }
          ]
        },
        comms: {
          heading: "커뮤니케이션",
          p1: {
            prefix: "공식 문의 또는 서신은 다음으로 보내주세요:",
            suffix:
              ". 회사의 등록 대리인 Legalinc Corporate Services Inc.(델라웨어 뉴어크 소재)로도 법무/기업 서신을 보낼 수 있습니다."
          }
        }
      }
    },
    auth: {
      titles: {
        signin: '다시 오신 걸 환영합니다',
        signup: '계정 만들기',
        forgot: '비밀번호 재설정',
      },
      subtitles: {
        signin: 'eSIM 플랜 구매를 위해 로그인하세요',
        signup: '지금 Airvoy에 가입하세요',
        forgot: '비밀번호를 재설정할 이메일을 입력하세요',
      },
      fields: {
        email: '이메일 주소',
        password: '비밀번호',
        confirmPassword: '비밀번호 확인',
      },
      placeholders: {
        email: '이메일을 입력하세요',
        password: '비밀번호를 입력하세요',
        confirmPassword: '비밀번호를 다시 입력하세요',
      },
      actions: {
        close: '닫기',
        continueWithGoogle: 'Google로 계속',
        signingIn: '로그인 중...',
        pleaseWait: '잠시만 기다려주세요...',
        signIn: '로그인',
        createAccount: '계정 생성',
        sendReset: '재설정 이메일 보내기',
        showPassword: '비밀번호 표시',
        hidePassword: '비밀번호 숨기기',
      },
      labels: {
        orEmail: '또는 이메일로 계속하기',
      },
      links: {
        noAccount: '계정이 없으신가요?',
        signUp: '회원가입',
        forgot: '비밀번호를 잊으셨나요?',
        haveAccount: '이미 계정이 있으신가요?',
        signIn: '로그인',
        remembered: '비밀번호가 기억나셨나요?',
        backToSignIn: '로그인으로 돌아가기',
      },
      messages: {
        resetSent: '비밀번호 재설정 이메일을 보냈습니다. 메일함을 확인하세요.',
      },
      errors: {
        fillAll: '모든 항목을 입력해 주세요',
        userNotFound: '해당 이메일의 계정을 찾을 수 없습니다',
        wrongPassword: '이메일 또는 비밀번호가 올바르지 않습니다',
        emailInUse: '이미 사용 중인 이메일입니다',
        weakPassword: '비밀번호가 너무 약합니다',
        invalidEmail: '유효하지 않은 이메일 주소입니다',
        tooManyRequests: '시도 횟수가 많습니다. 잠시 후 다시 시도해 주세요',
        popupClosed: '완료 전에 팝업이 닫혔습니다',
        popupCancelled: '로그인이 취소되었습니다',
        popupBlocked: '브라우저가 팝업을 차단했습니다',
        passwordMismatch: '비밀번호가 일치하지 않습니다',
        passwordMin: '비밀번호는 최소 6자 이상이어야 합니다',
        enterEmail: '이메일 주소를 입력해 주세요',
        generic: '오류가 발생했습니다. 다시 시도해 주세요',
      },
      legal: {
        prefix: '계정을 생성하면 다음에 동의하게 됩니다:',
        terms: '이용약관',
        and: '및',
        privacy: '개인정보 처리방침',
      },
    },
    support: {
      title: "지원",
      contactInfo: "연락처 안내",
      channels: {
        email: {
          title: "이메일 지원",
          description: "문의, 장애 신고, 지원 요청을 위한 채널입니다.",
          contact: "support@routedlabs.com",
          action: "이메일 작성"
        },
        chat: {
          title: "라이브 채팅",
          description: "긴급 이슈에 대한 실시간 지원(상황에 따라 이용 가능).",
          contact: "태평양 표준시 09:00–18:00 제공",
          action: "채팅 열기"
        }
      },
      faqTitle: "자주 묻는 질문",
      noResults: "검색 조건과 일치하는 항목이 없습니다.",
      categoryLabel: "분류:",
      show: "열기",
      hide: "닫기",
      noticesTitle: "공지 및 공식 연락",
      noticesLine1: {
        before: "공식 문의 및 서신은 다음 주소로 보내주세요:",
        after: "."
      },
      noticesLine2:
        "이 페이지는 지원 절차와 참고 자료를 설명하기 위한 것입니다. 적용 가능한 서비스 약관 또는 정책을 변경하거나 대체하지 않으며, 항상 해당 약관/정책이 우선합니다.",
      categories: {
        overview: "eSIM 개요",
        compatibility: "기기 호환성",
        installation: "설치",
        dualSim: "듀얼 SIM",
        dataUsage: "데이터 사용",
        planMgmt: "요금제 관리",
        deviceReqs: "기기 조건",
        troubleshooting: "문제 해결",
        refunds: "환불",
        supportHours: "지원 시간"
      },
      faqs: {
        1: {
          q: "eSIM은 무엇이며 어떻게 동작하나요?",
          a: "eSIM(임베디드 SIM)은 기기에 내장된 프로그래머블 SIM으로, 실물 카드 없이도 셀룰러 서비스를 활성화할 수 있습니다. 사용자는 디지털 프로파일을 발급받아 QR 코드를 스캔하거나 Airvoy의 안내에 따라 설정하여 연결할 수 있습니다."
        },
        2: {
          q: "어떤 기기가 eSIM을 지원하나요?",
          a: "대부분의 최신 스마트폰이 eSIM을 지원합니다. 기기 설정(대개 ‘셀룰러’ 또는 ‘모바일 데이터’)에서 ‘데이터 요금제 추가’ 옵션이 있는지 확인하세요."
        },
        3: {
          q: "eSIM 설치 방법은?",
          a: "구매 후 이메일로 설치 안내와 QR 코드가 전송됩니다. 기기에서 설정 → 셀룰러/모바일 데이터 → 데이터 요금제 추가로 이동해 코드를 스캔하세요. 지시에 따라 진행하면 자동으로 활성화됩니다."
        },
        4: {
          q: "물리 SIM과 eSIM을 동시에 사용할 수 있나요?",
          a: "대부분의 eSIM 지원 기기는 듀얼 SIM을 지원합니다. 음성/메시지는 기존 번호를 유지하고, 데이터는 eSIM을 선택할 수 있습니다. 선택은 기기 설정에서 할 수 있습니다."
        },
        5: {
          q: "데이터를 다 쓰지 못하면 어떻게 되나요?",
          a: "미사용 데이터는 이월되지 않으며 환불되지 않습니다. 요금제는 유효기간 종료 시 만료됩니다. 여행 중 예상 사용량에 맞는 요금제를 선택하세요."
        },
        6: {
          q: "데이터 추가나 연장이 가능한가요?",
          a: "가능합니다. 목적지에서 제공되는 경우 웹사이트 또는 계정 포털을 통해 추가 요금제를 구매해 데이터를 늘리거나 기간을 연장할 수 있습니다."
        },
        7: {
          q: "기기 잠금 해제가 필요한가요?",
          a: "예. 원래 통신사가 아닌 다른 제공업체의 eSIM을 사용하려면 기기가 잠금 해제되어 있어야 합니다. 잠금 상태라면 활성화 전에 통신사에 잠금 해제를 요청하세요."
        },
        8: {
          q: "eSIM이 예상대로 작동하지 않을 때?",
          a: "기기가 잠금 해제되어 있고 eSIM을 지원하는지 확인하세요. 데이터 로밍 활성화, 올바른 데이터 요금제 선택 여부를 점검하고 기기를 재시동해 보세요. 문제가 지속되면 지원팀에 문의하세요."
        },
        9: {
          q: "환불이 가능한가요?",
          a: "구매 후 24시간 이내이며 eSIM이 활성화 또는 사용되지 않은 경우 환불이 가능할 수 있습니다. 활성화 후에는 환불이 불가합니다. 기술적 문제의 경우 상황에 따라 문제 해결을 시도하거나 계정 크레딧을 제공할 수 있습니다."
        },
        10: {
          q: "지원 시간과 응답 시간은?",
          a: "이메일 지원은 상시 제공되며, 일반적으로 몇 시간 내 응답합니다. 여행 중 긴급 이슈는 우선 순위로 처리됩니다."
        }
      }
    }
  },
  es: {
    // Navigation
nav: {
  installEsim: "Instalar eSIM",
  admin: "Empresas",
  faqs: "Preguntas frecuentes",
  browsePlans: "Explorar planes",
  partnerships: "Alianzas",
  dashboard: "Panel de control",
  signOut: "Cerrar sesión",
  signIn: "Iniciar sesión",
  getTheApp: "Obtener la app"
},

    // Hero Section
hero: {
  badge: "Únete a más de 30,000 viajeros que usan Airvoy eSIM.",
  title: "La Global",
  titleHighlight: "eSIM",
  subtitle: "Mantente conectado como en casa: configuración instantánea, datos flexibles y cobertura global en más de 200 países.",
  searchPlaceholder: "¿A dónde viajas?",
  appStore: "App Store",
  googlePlay: "Google Play"
},

    // Popular Countries
popularCountries: {
  title: "Destinos populares",
  subtitle: "Conéctate al instante en estos principales destinos de viaje",
  fromPrice: "Desde",
  perDay: "/día",
  unlimited: "Ilimitado",
  startingAt: "Desde",
  getStarted: "Comenzar",
  viewAllCountries: "Ver todos los países",
  noPlansAvailable: "No hay planes ilimitados disponibles"
},

    // How It Works
howItWorks: {
  title: "Cómo funciona Airvoy eSIM",
  subtitle: "Conéctate en tres simples pasos",
  step1Title: "Elige tu destino",
  step1Desc: "Explora más de 200 destinos con precios transparentes. Sin tarifas ocultas, sin sorpresas: solo el plan perfecto para tu aventura.",
  step2Title: "Instala en segundos",
  step2Desc: "Recibe tu eSIM al instante por correo electrónico. Un rápido escaneo de código QR y estarás listo para usarlo—sin visitas a tiendas ni cambiar SIM física.",
  step3Title: "Conéctate automáticamente",
  step3Desc: "Aterriza y conéctate al instante. Tu eSIM se activa automáticamente cuando llegas—olvídate de buscar WiFi en el aeropuerto para siempre.",
  learnMore: "Saber más"
},

    // Benefits
benefits: {
  whyAirvoy: "¿Por qué Airvoy?",
  title: "Mantente conectado dondequiera que vayas",
  item1Title: "Encuentra un plan para ti",
  item1Desc: "Planes de datos flexibles que se ajustan a tu presupuesto. Desde un plan semanal de 1 GB hasta 100 GB que duran medio año — encuéntralos todos en una sola app.",
  item2Title: "Fácil de usar",
  item2Desc: "Solo descarga Airvoy, instala la eSIM y adquiere un plan de datos — se activará automáticamente en cuanto llegues a tu destino.",
  item3Title: "Evita costos de roaming",
  item3Desc: "Las tarifas de roaming ocultas son cosa del pasado. Sabrás cuánto costará tu conexión a internet antes de salir de viaje.",
  item4Title: "Una sola eSIM para todos tus viajes",
  item4Desc: "Agrega nuevos destinos a tu eSIM de Airvoy existente — sin necesidad de instalar nuevas eSIM cada vez. Simplemente recarga y conéctate.",
  item5Title: "Nunca te quedes sin datos",
  item5Desc: "No corras el riesgo de quedarte sin datos en el peor momento — te notificaremos cuando hayas usado el 80% de tu plan.",
  item6Title: "+200 países",
  item6Desc: "Mantente en línea en más de 200 países y territorios alrededor del mundo."
},

    // Videos
videos: {
  title: "Mira y conéctate rápido",
  subtitle: "Dos tutoriales rápidos: uno para iPhone y otro para Samsung.",
  iPhoneTitle: "Configuración y activación de eSIM — iPhone",
  iPhoneDesc: "Guía paso a paso para instalar y activar tu eSIM de Airvoy en iPhone. Escanea, instala y estarás en línea en minutos.",
  samsungTitle: "Configuración y activación de eSIM — Samsung",
  samsungDesc: "Aprende cómo agregar tu eSIM de Airvoy en dispositivos Samsung Galaxy. Un tutorial rápido y claro desde la instalación hasta la primera conexión.",
  iOSGuide: "Guía para iOS",
  samsungGuide: "Guía para Samsung",
  installationGuide: "O lee la guía completa de instalación"
},


    // Footer
footer: {
  description: "Únete a más de 30,000 viajeros que usan Airvoy eSIM. Viaja de manera inteligente, mantente conectado — dondequiera que te lleve tu aventura.",
  company: "Compañía",
  aboutUs: "Sobre nosotros",
  resources: "Recursos",
  documentation: "Documentación",
  support: "Soporte",
  legal: "Legal",
  privacyPolicy: "Política de privacidad",
  termsOfService: "Términos de servicio",
  followUs: "Síguenos",
  copyright: "Todos los derechos reservados.",
  madeWith: "Hecho con",
  forTravelers: "para viajeros de todo el mundo"
},

    // Auth
aut: {
  authenticationRequired: "Autenticación requerida",
  signInPrompt: "Por favor, inicia sesión para acceder al panel de control y comprar planes eSIM."
},


    // Common
common: {
  close: "Cerrar",
  loading: "Cargando...",
  tryAgain: "Inténtalo de nuevo",
  noResults: "No se encontraron países para"
},

activate: {
  altText: "Activación global de Airvoy eSIM",
  activeInThailand: "Airvoy activo en Tailandia",
  activeInSpain: "Airvoy activo en España",
  activeWorldwide: "Airvoy activo en todo el mundo",
  activeInGreece: "Airvoy activo en Grecia",
  activeInMexico: "Airvoy activo en México",
  title: "Mantén tu número de WhatsApp",
  description: "Puedes llamar y enviar mensajes a todos tus contactos en WhatsApp, como si estuvieras en el mismo país.\nNo pierdas el contacto con familiares y amigos."
},

regionalPlans: {
  multiCountryCoverage: "Cobertura multinacional",
  title: "Planes regionales",
  subtitle: "Elige una región y luego selecciona la duración/datos que necesitas.",
  noPlansAvailable: "No hay planes regionales disponibles.",
  from: "Desde",
  seePlans: "Ver planes",
  countries: "países",
  plans: "planes",
  startingFrom: "Desde",
  browseOptions: "Explorar opciones",
  viewPlans: "Ver planes"
},


partnerships: {
  headerLabel: "ALIANZAS",
  title: "Alianzas de Airvoy",
  subtitle: "Asociémonos y hagamos grandes cosas juntos.",
  join: "Unirse",
  airvoyAffiliate: "Programa\nAfiliados Airvoy",
  affiliateDescription: "Gana hasta un 20% de comisión promocionando Airvoy eSIM — ¡únete hoy a nuestra red oficial de afiliados!",
  joinNow: "¡Únete ahora!",
  learnMore: "Saber más",
  partnershipImageAlt: "Alianza Airvoy",
  
  // Partnership types
  affiliateProgram: "Programa de afiliados",
  eventPartnership: "Alianza para eventos",
  travelPartnership: "Alianza de viajes",
  contentPartnership: "Alianza de contenido",
  sportsPartnership: "Alianza deportiva",
  musicCulturePartnership: "Alianza musical y cultural",
  athleteCollaboration: "Colaboración con atletas",
  other: "Otro",
  
  // Partnership descriptions
  eventPartnerships: "Alianzas para eventos",
  eventDescription1: "¿Organizas un evento internacional y quieres ofrecer a tus asistentes un beneficio súper útil: datos móviles gratis?",
  eventDescription2: "Podemos personalizar la solución adecuada para ti y tus invitados, para que se mantengan conectados antes, durante y después del evento.",
  
  travelPartnerships: "Alianzas de viajes",
  travelDescription1: "¿Te interesa ofrecer datos móviles y llamadas más económicas y sin interrupciones a los empleados y clientes de tus clientes que viajan al extranjero?",
  travelDescription2: "Con nuestra suite integrada de conectividad móvil, te ayudamos a ofrecer soluciones de viaje de valor agregado con mínimo esfuerzo y máxima utilidad.",
  
  contentPartnerships: "Alianzas de contenido",
  contentDescription1: "¿Eres creador de contenido en redes sociales con ideas creativas, una audiencia comprometida y un buen ojo para #TravelHacks y #LifeHacks?",
  contentDescription2: "¿O simplemente te gusta Airvoy y quieres difundirlo para que otros también disfruten de una conectividad móvil sin interrupciones alrededor del mundo?",
  
  sportsPartnerships: "Alianzas deportivas",
  sportsDescription1: "¿Organizas una competencia deportiva y quieres ofrecer a atletas, equipos y fanáticos una forma confiable de mantenerse conectados durante todo el evento?",
  sportsDescription2: "Asóciate con Airvoy para brindar soluciones de datos móviles sin interrupciones que mantengan a todos conectados, desde la ceremonia de apertura hasta el silbato final.",
  
  musicCulturePartnerships: "Alianzas musicales y culturales",
  musicDescription1: "¿Organizas un festival de música, evento cultural o espectáculo en vivo y buscas mejorar la experiencia de los asistentes?",
  musicDescription2: "Airvoy puede ofrecer a tu público servicios de datos móviles confiables, asegurando que puedan compartir, transmitir y mantenerse conectados mientras disfrutan del evento.",
  
  athleteCollaborations: "Colaboraciones con atletas",
  athleteDescription1: "¿Eres un atleta que viaja por el mundo de una competencia a otra y ya no tienes espacio en tu vitrina de trofeos?",
  athleteDescription2: "Asóciate con Airvoy para mantenerte conectado donde sea que te lleve tu deporte y comparte tu viaje con tus fans sin importar dónde estés.",
  
  letsTalk: "Hablemos",
  
  // Contact form
  getInTouch: "Ponte en contacto",
  successMessage: "¡Gracias por contactarnos! Te responderemos pronto.",
  errorMessage: "Algo salió mal. Por favor, inténtalo de nuevo.",
  emailPlaceholder: "Introduce tu correo electrónico",
  fullNamePlaceholder: "Nombre completo",
  partnerTypePlaceholder: "¿Sobre qué quieres asociarte?",
  messagePlaceholder: "Cuéntanos brevemente lo que tienes en mente",
  privacyConsent: "Aceptas nuestra amigable",
  privacyPolicy: "política de privacidad",
  sending: "Enviando...",
  send: "Enviar"
},

faq: {
  headerLabel: "PREGUNTAS FRECUENTES",
  title: "Encuentra las respuestas a algunas de las preguntas más frecuentes",
  learnMore: "Saber más",
  
  whatIsEsim: {
    question: "¿Qué es una eSIM?",
    answer: "Una eSIM es una SIM digital estándar de la industria que te permite activar un plan celular de tu operador sin necesidad de usar una tarjeta SIM física. Puedes instalar ocho o más eSIM en un iPhone y usar dos números de teléfono al mismo tiempo."
  },
  
  howToSetup: {
    question: "¿Cómo configurar tu eSIM?",
    answer: "La tecnología eSIM es muy conveniente. Sin embargo, configurarla puede ser un poco molesto, especialmente si es tu primera vez. Pero no te preocupes, tenemos guías paso a paso aquí para que empieces a usar Airvoy en poco tiempo."
  },
  
  whatIsAirvoy: {
    question: "¿Qué es Airvoy?",
    answer: "Airvoy es una aplicación móvil que ofrece soluciones de conectividad móvil global. Proporciona una forma sencilla de mantenerte conectado cuando viajas, sin necesidad de tarjetas SIM físicas ni costosos cargos de roaming."
  },
  
  howSaveRoaming: {
    question: "¿Cómo me ayuda Airvoy a ahorrar en cargos de roaming?",
    answer: "Ofrece datos móviles con tarifas hasta un 90% más económicas que las tarifas de roaming típicas. Así puedes evitar los altos costos asociados a los servicios de roaming tradicionales."
  },
  
  needNewSim: {
    question: "¿Necesito una nueva tarjeta SIM cada vez que viajo con Airvoy?",
    answer: "No, Airvoy utiliza tecnología eSIM, lo que significa que no se requiere una tarjeta SIM física. La eSIM de Airvoy es global, por lo que una vez que la descargas y activas, puedes usarla para roaming en todo el mundo o comprar nuevas para países específicos."
  },
  
  constantConnectivity: {
    question: "¿Cómo asegura Airvoy conectividad constante cuando viajo?",
    answer: "Ofrece datos móviles con tarifas hasta un 90% más económicas que las tarifas de roaming típicas. Así puedes evitar los altos costos asociados a los servicios de roaming tradicionales."
  },
  
  freeCallsTexts: {
    question: "¿Airvoy ofrece llamadas y mensajes gratis?",
    answer: "Aún no. Pero Airvoy pronto ofrecerá llamadas y mensajes gratuitos entre usuarios de Airvoy. Esto significa que podrás mantenerte conectado con otros usuarios sin costo adicional."
  },
  
  whyChooseAirvoy: {
    question: "¿Por qué debería elegir Airvoy sobre otras alternativas de roaming?",
    answer: "Deberías elegir Airvoy sobre otras alternativas de roaming porque ofrece conectividad global sin interrupciones con una sola eSIM, un modelo rentable y funciones adicionales como mensajería (próximamente) y números locales (próximamente), todo dentro de una aplicación fácil de usar. Es asequible, simple y te da control total sobre cómo quieres conectarte, dondequiera que vayas."
  }
},

browse: {
  main: {
    title: "Explorar planes eSIM",
    subtitle: "Descubre planes eSIM para destinos en todo el mundo con precios en tiempo real"
  },
  search: {
    placeholder: "Buscar países (ej.: Estados Unidos, España, Japón)...",
    clearSearch: "Borrar búsqueda",
    noCountriesFound: "No se encontraron países que coincidan con tu búsqueda.",
    noCountriesAvailable: "No hay países disponibles.",
    clearSearchButton: "Borrar búsqueda",
    searching: "Buscando países...",
    country: "país",
    countries: "países",
    foundFor: "encontrados para"
  },
  loading: {
    loadingText: "Cargando...",
    allCountriesLoaded: "Todos los países cargados",
    total: "total"
  },
  buttons: {
    showMoreCountries: "Mostrar más países",
    showLessPlans: "Mostrar menos planes",
    showLess: "Mostrar menos",
    seeMorePlans: "Ver más planes",
    more: "más",
    buyNow: "Comprar ahora"
  },
  navigation: {
    backToCountries: "Volver a países"
  },
  countryDetails: {
    description: "Explora {{country}} con flexibilidad usando nuestros planes de datos eSIM. Ya sea que visites por poco tiempo o por un viaje prolongado, nuestros planes te mantienen conectado sin complicaciones."
  },
  plans: {
    noPlansAvailable: "No hay planes disponibles para los filtros seleccionados.",
    planDetails: "Detalles del plan",
    details: "Detalles",
    unlimited: "Ilimitado",
    for: "Por",
    day: "día",
    days: "días"
  },
  checkout: {
    total: "Total"
  },
  planDetails: {
    title: "Detalles del plan",
    unlimitedData: "Datos ilimitados",
    data: "Datos",
    country: "País",
    duration: "Duración",
    day: "día",
    days: "días",
    network: "Red",
    autoStart: "Inicio automático",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    planType: "Tipo de plan",
    description: "Descripción",
    purchaseThisPlan: "Comprar este plan",
    signInToPurchase: "Inicia sesión para comprar"
  }
},

installation: {
  title: "¿Cómo instalo y configuro mi eSIM?",
  metaUpdated: "Hace 2 meses • Actualizado",
  intro: {
    p1: "Ya sea que uses Android o Apple, primero verifica que tu teléfono sea compatible con eSIM y que esté desbloqueado para todas las redes. También necesitarás una conexión a internet estable (preferiblemente Wi-Fi).",
    p2: "Luego, puedes:",
    ol1: "Escanear el código QR para una instalación automática",
    ol2: "Instalar tu eSIM manualmente",
    note: "Instalar con un código QR es la forma más fácil."
  },
  ios: {
    qr: {
      title: "Instala tu eSIM usando el código QR (iOS)",
      s1: "1. Ve a Configuración > Datos móviles",
      s2: "2. Toca “Agregar eSIM” y selecciona Usar código QR",
      s3: "3. Escanea el código QR e ingresa el código de confirmación de 4 dígitos si se solicita",
      s4: "4. Etiqueta tu eSIM y selecciona “Solo datos celulares” en Línea predeterminada",
      s5: "5. Ahora deberías ver tu eSIM en “Datos móviles”"
    },
    manual: {
      title: "Cómo instalar tu eSIM manualmente (iOS)",
      s1: "1. Configuración > Datos móviles > Agregar eSIM",
      s2: "2. Toca “Agregar eSIM” y selecciona Usar código QR",
      s3: "3. En lugar de escanear, toca Ingresar detalles manualmente",
      s4: "4. Ingresa la dirección SM-DP+, el código de activación y el código de confirmación opcional desde tu app Airvoy",
      s5: "5. Etiqueta tu eSIM y selecciona “Solo datos celulares” en Línea predeterminada",
      s6: "6. Ahora deberías ver tu eSIM en Datos móviles"
    }
  },
  android: {
    qr: {
      title: "Instala tu eSIM usando el código QR (Android)",
      s1: "1. Ve a Configuración > Red e Internet > SIMs",
      s2: "2. Toca el ícono “+” a la derecha de “SIMs”",
      s3: "3. Toca “¿Descargar una SIM en su lugar?” en la parte inferior",
      s4: "4. En “Descargar tu SIM”, toca “Siguiente” — verás “Comprobando información de red...”",
      s5: "5. Después de la comprobación, aparece un visor para escanear tu código QR",
      s6: "6. Apunta a un QR impreso o a otro dispositivo que muestre el código",
      s7: "7. Después de escanear, tu dispositivo vuelve a comprobar la información",
      s8: "8. Toca Descargar para confirmar — los datos de la eSIM se descargarán",
      s9: "9. Al finalizar, verás “Descarga terminada”",
      s10: "10. Configura la eSIM para acceso a internet cuando estés listo."
    }
  },
  notes: {
    title: "Notas importantes",
    n1: "Asegúrate de que tu dispositivo sea compatible con eSIM y esté desbloqueado para redes",
    n2: "Necesitarás una conexión Wi-Fi estable durante la instalación",
    n3: "La eSIM solo puede instalarse una vez — comienza cuando estés listo",
    n4: "Mantén tu SIM principal activa para llamadas y mensajes desde tu número de casa",
    n5: "Tu eSIM se activará cuando llegues a tu país de destino"
  },
  support: {
    title: "¿Necesitas ayuda?",
    body: "Si tienes problemas para instalar tu eSIM, ¡nuestro equipo de soporte está aquí para ayudarte!",
    emailLabel: "Correo electrónico:",
    websiteLabel: "Sitio web:"
  }
},

installGuide: {
  header: {
    title: "Guía completa de instalación de eSIM",
    subtitle: "Todo lo que necesitas saber para instalar, activar y usar tu eSIM para una conectividad global sin interrupciones. Sigue nuestras instrucciones específicas para tu dispositivo y disfruta de una configuración sencilla.",
    link: "Consulta la guía detallada para instalar también en Android",
    iOS: "Guía detallada para iOS", 
    Android: "Guía detallada para Android"
  },
  iphoneHero: "Instala y activa tu eSIM en iPhone",
  cards: {
    c1: {
      alt: "iPhone con interruptor y ícono de reloj",
      install: "Instala",
      activate: "actívala",
      textA: "solo unas horas antes de tu viaje y",
      textB: "durante tu vuelo o al llegar a tu destino."
    },
    c2: {
      alt: "iPhone con interfaz de escáner de código QR",
      line1: "Selecciona “Instalar con código QR”",
      line2: "si tienes el código en otro dispositivo",
      line3: "para escanearlo."
    },
    c3: {
      alt: "iPhone con interfaz de instalación manual",
      line1: "Selecciona “Instalación manual”",
      line2: "si no puedes escanear el código QR."
    }
  },
  learn: {
    title: "Aprende paso a paso",
    subtitle: "Selecciona el tipo de instalación que deseas realizar",
    btnQr: "Instalación con código QR",
    btnManual: "Instalación manual"
  },
  prep: {
    alt: "Ícono de advertencia en teléfono",
    qr: {
      title: "Antes de comenzar la instalación con código QR, hay algunos puntos importantes que debes tener en cuenta:",
      i1: "Debes tener el código QR en otra pantalla o dispositivo para escanearlo con la cámara de tu teléfono.",
      i2: "Asegúrate de tener una conexión a internet estable durante todo el proceso.",
      i3: "Ten en cuenta que el código QR solo puede escanearse una vez.",
      i4: "No elimines la eSIM de tu dispositivo ya que no podrás volver a usarla."
    },
    manual: {
      title: "Antes de comenzar la instalación manual, hay algunos puntos importantes que debes tener en cuenta:",
      i1: "Los códigos de instalación manual solo pueden usarse una vez."
    },
    shared: {
      i2: "Asegúrate de tener una conexión a internet estable durante todo el proceso.",
      i3: "No elimines la eSIM de tu dispositivo ya que no podrás volver a usarla."
    }
  },
  start: {
    title: "Comencemos juntos",
    c1: {
      title: "Abre tu correo electrónico",
      qr: { p1: "Abre tu correo electrónico en un dispositivo diferente del que usarás para la instalación y busca el correo que te enviamos con el código QR." },
      manual: { p1: "Revisa el correo que te enviamos con la “dirección SM-DP+” y el “Código de activación” y tenlos a mano para iniciar la instalación. También te los enviamos por SMS." },
      shared: { missing: "Si no has recibido tu(s) código(s), por favor", contact: "contáctanos" }
    },
    c2: {
      qr: { title: "Escanea el código QR", p1: "Abre la cámara del iPhone donde instalarás la eSIM y escanea el código. También puedes ir a Configuración → Datos móviles y seleccionar “Agregar plan de datos” para escanear desde allí." },
      manual: { title: "Abre “Configuración” en tu iPhone", p1: "Luego, ve a Datos móviles, toca “Agregar eSIM” o “Agregar plan de datos” y selecciona “Usar código QR”. Luego elige “Ingresar detalles manualmente” cuando se te indique." }
    },
    c3: {
      title: "Sigue los pasos de instalación en tu iPhone",
      qr: { p1: "Al escanear el código comenzará el proceso de instalación. Usa nuestra guía a continuación para una configuración paso a paso." },
      manual: { p1: "Cuando llegues a “Escanear código QR”, selecciona “Ingresar detalles manualmente” y sigue los pasos que aparecen en tu iPhone." }
    }
  },
  compat: {
    title: "Comprobador de compatibilidad de dispositivos",
    subtitle: "Verifica si tu dispositivo es compatible con la tecnología eSIM. Usa la función de búsqueda para encontrar rápidamente tu modelo específico.",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "Buscar modelos de iPhone/iPad...",
    searchAndroid: "Buscar modelos de Android...",
    iphones: "iPhones compatibles",
    ipads: "iPads compatibles (solo 4G)",
    androids: "Dispositivos Android compatibles",
    noMatch: "No se encontraron dispositivos que coincidan con tu búsqueda.",
    iosNotesTitle: "Notas importantes:",
    iosNotes: {
      i1: "Los modelos de iPhone 13 y 14 pueden tener dos eSIM activadas simultáneamente",
      i2: "Los iPhones de China continental y Hong Kong no cuentan con capacidad eSIM (excepto algunos modelos)",
      i3: "Los modelos iPhone 14+ vendidos en EE. UU. no admiten tarjetas SIM físicas"
    },
    androidNotesTitle: "Restricciones importantes:",
    androidNotes: {
      i1: "Los dispositivos Samsung de EE. UU. y Hong Kong pueden no ser compatibles con eSIM",
      i2: "Los dispositivos Google Pixel de Australia, Japón y Taiwán no son compatibles con eSIM",
      i3: "Los teléfonos vendidos en Hong Kong generalmente no admiten eSIM",
      i4: "El dispositivo debe estar desbloqueado para usar eSIM"
    },
    empty: "Empieza a escribir el modelo de tu dispositivo para comprobar la compatibilidad"
  },
  tips: {
    title: "Consejos pro: activa antes de viajar",
    body: "Para una experiencia de viaje sin problemas, instala tu eSIM antes de salir y actívala al llegar. Así estarás conectado tan pronto aterrices, sin buscar Wi-Fi ni tarjetas SIM locales.",
    before: {
      title: "Antes de salir",
      i1: "Instala el perfil de eSIM en casa",
      i2: "Prueba el proceso de instalación",
      i3: "Guarda una captura de pantalla de tu código QR como respaldo",
      i4: "Asegúrate de que tu dispositivo esté desbloqueado"
    },
    after: {
      title: "Al llegar",
      i1: "Enciende los datos móviles para tu eSIM",
      i2: "Espera 2–3 minutos para el registro en la red",
      i3: "Prueba la conexión buscando en la web",
      i4: "Configura el roaming de datos si es necesario"
    }
  },
  support: {
    title: "¿Necesitas soporte adicional?",
    body: "Nuestro equipo de soporte experto está aquí para ayudarte en cada paso del camino. Desde dudas sobre compatibilidad de dispositivos hasta asistencia para la instalación, estamos contigo.",
    btnEmail: "Soporte por correo electrónico",
    btnCenter: "Visitar centro de soporte"
  },
  steps: {
    ios: {
      s1: { title: "Abre Configuración", desc: "Ve a Configuración → Celular (o Datos móviles en algunas regiones)", detail: "Busca la opción “Celular” en el menú principal de Configuración. En algunos países puede aparecer como “Datos móviles”." },
      s2: { title: "Agregar plan celular", desc: "Toca “Agregar plan celular” o “Agregar eSIM”", detail: "Esta opción aparece al final de la página de Configuración celular. Si no la ves, es posible que tu dispositivo no sea compatible con eSIM." },
      s3: { title: "Escanear código QR", desc: "Elige “Usar código QR” y escanea el código de tu correo electrónico", detail: "Apunta tu cámara al código QR. Asegúrate de buena iluminación y mantén el teléfono estable hasta que lo reconozca." },
      s4: { title: "Agregar plan celular", desc: "Toca “Agregar plan celular” cuando aparezcan los detalles del plan", detail: "Revisa la información del operador y los detalles del plan antes de confirmar. Este paso descarga tu perfil eSIM." },
      s5: { title: "Etiqueta tus planes", desc: "Elige etiquetas para tus planes (por ejemplo, “Principal”, “Viaje”, “Secundario”)", detail: "Esto te ayudará a identificar qué plan usar para datos, llamadas y mensajes. La mayoría de los viajeros usa la eSIM solo para datos." },
      s6: { title: "Configura la línea predeterminada", desc: "Selecciona qué línea usar para datos móviles", detail: "Puedes elegir tu eSIM para datos mientras mantienes tu SIM original para llamadas y mensajes." }
    },
    android: {
      s1: { title: "Abre Configuración", desc: "Ve a Configuración → Red e Internet → SIMs", detail: "La ruta exacta puede variar según el fabricante. En dispositivos Samsung podría ser Configuración → Conexiones → Administrador de tarjetas SIM." },
      s2: { title: "Agregar plan móvil", desc: "Toca el botón “+” o “Agregar plan móvil”", detail: "Busca opciones como “Agregar plan móvil”, “¿Descargar una SIM en su lugar?” o “Agregar operador” según tu dispositivo." },
      s3: { title: "Descargar SIM", desc: "Selecciona “¿No tienes una tarjeta SIM?” o “Descargar una SIM en su lugar”", detail: "Esta opción le indica a tu teléfono que deseas instalar una eSIM en lugar de insertar una SIM física." },
      s4: { title: "Escanear código QR", desc: "Elige “Escanear código QR” y apunta tu cámara al código", detail: "Asegúrate de buena iluminación y mantén firme el teléfono. La cámara detectará y escaneará el código QR de tu correo." },
      s5: { title: "Descargar perfil", desc: "Toca “Descargar” cuando aparezca el perfil del operador", detail: "Tu dispositivo se conectará a internet para descargar el perfil eSIM. Esto puede tardar unos momentos." },
      s6: { title: "Activar eSIM", desc: "Habilita la eSIM y configúrala como tu conexión de datos preferida", detail: "Puedes elegir qué SIM usar para datos, llamadas y SMS. La mayoría de los viajeros usa la eSIM solo para datos." }
    }
  }
},

profile: {
  loading: "Cargando tu perfil…",
  errors: {
    load: "No se pudieron cargar tus eSIM",
    delete: "No se pudo eliminar la eSIM. Por favor, inténtalo de nuevo.",
    bundle: "No se pudo obtener el estado del paquete",
    network: "Error de red al obtener el estado del paquete",
    invoice: "No se pudo descargar la factura"
  },
  auth: {
    title: "Autenticación requerida",
    subtitle: "Inicia sesión para ver tu perfil e historial de eSIM.",
    cta: "Iniciar sesión"
  },
  header: {
    fallback: "Perfil de usuario",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} compradas"
  },
  list: {
    title: "Tus eSIM",
    subtitle: "Administra tus perfiles comprados y accede a códigos QR y facturas.",
    total: "{{count}} en total"
  },
  empty: {
    title: "Aún no tienes eSIM",
    subtitle: "Explora nuestros planes para conectarte en segundos — sin SIM física requerida.",
    cta: "Explorar planes",
    tip: "Consejo: Puedes instalar una eSIM antes de tu viaje y activarla al llegar."
  },
  item: {
    country: "País",
    statusTitle: "Estado actual",
    pricePaid: "Precio pagado",
    purchaseDate: "Fecha de compra"
  },
  actions: {
    details: "Ver detalles",
    showQr: "Mostrar QR",
    invoice: "Factura"
  },
  hint: "¿Necesitas ayuda para instalar una eSIM? En iOS: Ajustes → Celular → Agregar eSIM. En Android: Ajustes → Red e Internet → SIMs → Agregar eSIM.",
  delete: {
    title: "Eliminar eSIM",
    confirm: "¿Estás seguro de que quieres eliminar esta eSIM de tu historial? Esta acción no se puede deshacer.",
    deleting: "Eliminando…",
    cta: "Eliminar eSIM"
  },
  details: {
    title: "Detalles de eSIM y estado en vivo",
    refresh: "Actualizar estado del paquete",
    live: "Estado en vivo del paquete",
    updated: "Actualizado:",
    fetching: "Obteniendo estado en tiempo real...",
    ref: "Ref:",
    discount: "Descuento aplicado",
    usage: {
      title: "Uso de datos",
      used: "Usado",
      remaining: "Restante",
      total: "Total"
    },
    assigned: "Paquete asignado",
    plan: {
      title: "Información del plan",
      destination: "Destino",
      name: "Nombre del plan",
      allowance: "Cantidad de datos",
      validity: "Validez"
    },
    tech: {
      title: "Detalles técnicos",
      activation: "Código de activación",
      copyActivation: "Copiar código de activación",
      iccid: "ICCID",
      copyIccid: "Copiar ICCID",
      orderRef: "Referencia de pedido GOeSIM"
    },
    install: {
      title: "Instrucciones de instalación",
      iosTitle: "Para iOS:",
      androidTitle: "Para Android:",
      ios: "Ajustes → Celular → Agregar eSIM → Usar código QR",
      android: "Ajustes → Red e Internet → SIMs → Agregar eSIM → Escanear código QR",
      important: "Importante:",
      once: "Solo puedes instalar esta eSIM una vez. Asegúrate de que tu dispositivo esté desbloqueado y sea compatible con eSIM antes de continuar."
    },
    purchase: {
      title: "Información de compra",
      date: "Fecha de compra",
      amount: "Monto pagado",
      method: "Método de pago",
      txn: "ID de transacción"
    },
    referral: {
      title: "Descuento por referido aplicado",
      code: "Código de referido",
      original: "Precio original",
      saved: "Ahorraste"
    },
    billing: {
      title: "Información de facturación",
      name: "Nombre completo",
      email: "Correo electrónico",
      country: "País",
      zip: "Código postal"
    }
  },
  qr: {
    title: "Código QR de eSIM",
    alt: "Código QR de eSIM",
    copy: "Copiar código de activación",
    tip: "Consejo: Abre la cámara de tu teléfono y escanea el QR. Solo puedes instalar una eSIM una vez."
  },
  common: {
    usd: "USD",
    days: "días",
    na: "N/D",
    invalidDate: "Fecha no válida",
    cancel: "Cancelar",
    close: "Cerrar",
    copied: "copiado"
  }
},

countryDetails: {
  loading: "Cargando detalles del país...",
  errors: {
    notFound: "País no encontrado",
    loadFail: "No se pudieron cargar los datos del país"
  },
  notFound: {
    title: "País no encontrado",
    subtitle: "El país que buscas no existe o no tiene planes disponibles.",
    cta: "Explorar todos los países"
  },
  back: "Volver a países",
  blurb: "Explora {{country}} con flexibilidad usando nuestros planes de datos eSIM. Ya sea que visites por una estadía corta o un viaje prolongado, nuestros planes te mantienen conectado sin complicaciones.",
  noPlans: "No hay planes disponibles para los filtros seleccionados.",
  plan: {
    details: "Detalles del plan",
    detailsShort: "Detalles",
    networkBadge: "5G",
    unlimited: "Ilimitado",
    unlimitedData: "Datos ilimitados",
    gb: "GB",
    gbShort: "GB",
    data: "Datos",
    forDays: "Por {count, plural, one {# DÍA} other {# DÍAS}}"
  },
  currency: {
    usd: "USD"
  },
  duration: {
    days: "{count, plural, one {# día} other {# días}}"
  },
  more: {
    more: "Ver más planes",
    moreShort: "+{extra} más",
    less: "Mostrar menos planes",
    lessShort: "Mostrar menos"
  },
  modal: {
    title: "Detalles del plan",
    country: "País:",
    duration: "Duración:",
    network: "Red:",
    autostart: "Inicio automático:",
    enabled: "Activado",
    disabled: "Desactivado",
    planType: "Tipo de plan:",
    description: "Descripción",
    purchase: "Comprar este plan",
    signInToPurchase: "Inicia sesión para comprar"
  },
  bar: {
    title: "eSIM de {{country}}",
    total: "Total",
    buy: "Comprar ahora"
  }
},

checkout: {
  loading: "Cargando pago seguro...",
  invalidPlan: {
    title: "Datos del plan inválidos",
    subtitle: "No se pudo cargar la información del plan seleccionado.",
    cta: "Volver al panel de control"
  },
  success: {
    title: "¡Compra exitosa!",
    message: "¡eSIM comprada con éxito! ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "El código QR y las instrucciones de instalación se han enviado a {{a}} y {{b}}",
    sentOne: "El código QR y las instrucciones de instalación se han enviado a {{email}}",
    view: "Ver mis eSIMs"
  },
  common: {
    close: "Cerrar"
  },
  header: {
    title: "Pago seguro",
    subtitle: "Completa tu compra de eSIM de forma segura"
  },
  benefits: {
    title: "Inicia sesión para obtener beneficios",
    copy: "Crea una cuenta para guardar tu historial de compras, acceder a ofertas exclusivas y administrar tus eSIM.",
    cta: "Registrarse / Iniciar sesión"
  },
  billing: {
    title: "Información de facturación",
    subtitle: "Tu factura y la eSIM se enviarán a este correo electrónico"
  },
  form: {
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    referral: "Código de referido (opcional)"
  },
  placeholder: {
    firstName: "Ingresa tu nombre",
    lastName: "Ingresa tu apellido",
    email: "Ingresa tu correo electrónico",
    referral: "Ingresa el código de referido",
    altEmail: "Ingresa un correo alternativo"
  },
  referral: {
    validating: "Validando...",
    invalid: "Código de referido inválido",
    ownCode: "No puedes usar tu propio código de referido",
    inactive: "Este código de referido ya no está activo",
    used: "Este código de referido ya fue utilizado",
    valid: "¡Válido! Descuento de {{percent}}% aplicado",
    error: "Error al validar el código"
  },
  altEmail: {
    title: "Usar un correo electrónico diferente",
    copy: "La eSIM también se enviará a este correo diferente y se guardará en tu cuenta",
    input: "Correo electrónico alternativo"
  },
  createAccount: {
    title: "Crea una cuenta para guardar el historial de compras",
    copy: "Opcional - te ayuda a administrar eSIMs y acceder a soporte"
  },
  payment: {
    title: "Detalles de pago",
    secured: "Protegido por Stripe",
    method: "Método de pago",
    card: "Tarjeta de crédito o débito",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "Pagar con PayPal",
    cardInfo: "Información de la tarjeta",
    loadingSecure: "Cargando formulario de pago seguro...",
    cardComplete: "La información de la tarjeta está completa",
    processing: "Procesando pago...",
    complete: "Completar compra • ${{total}}"
  },
  legal: {
    agree: "Al completar el pedido, aceptas nuestros",
    terms: "Términos y condiciones",
    and: "y",
    privacy: "Políticas de privacidad y reembolsos"
  },
  summary: {
    title: "Resumen del pedido",
    planLabel: "Plan eSIM",
    digital: "Digital",
    data: "Datos incluidos:",
    validity: "Validez:",
    coverage: "Cobertura:",
    nationwide: "Nacional"
  },
  pricing: {
    planPrice: "Precio del plan",
    referralDiscount: "Descuento por referido ({{percent}}%)",
    stripeFee: "Tarifa de procesamiento Stripe",
    paypalFee: "Tarifa de procesamiento PayPal",
    taxes: "Impuestos y tarifa de servicio",
    included: "Incluido",
    total: "Total"
  },
  paypal: {
    description: "eSIM para {{country}} - {{data}} por {{days}} días"
  },
  duration: {
    days: "{count, plural, one {# día} other {# días}}"
  },
  alerts: {
    enterName: "Por favor, ingresa tu nombre completo",
    formNotReady: "El formulario de pago no está listo. Espera un momento y vuelve a intentarlo.",
    cardIncomplete: "Por favor, ingresa la información completa de la tarjeta",
    paypalFailed: "El pago con PayPal falló: {{msg}}",
    paypalGeneric: "El pago con PayPal falló. Inténtalo de nuevo.",
    purchaseFailed: "La compra falló: {{msg}}"
  }
},

privacy: {
  title: "Política de privacidad",
  subtitle:
    "Declaración sobre las prácticas de recopilación, uso y protección de la información personal por parte de Routed Labs, Inc.",
  lastUpdated: {
    label: "Última actualización:",
    date: "1 de agosto de 2025"
  },
  sections: {
    intro: {
      heading: "Introducción",
      p1:
        "Routed Labs, Inc. (“Routed Labs”, “nosotros” o “nuestro”) opera el sitio web y la aplicación móvil de Airvoy (el “Servicio”). Esta Política de Privacidad establece cómo recopilamos, usamos, divulgamos y protegemos la información personal. Al usar el Servicio, aceptas estas prácticas tal como se describen aquí.",
      p2:
        "Routed Labs se compromete a mantener la confidencialidad, integridad y seguridad de tu información personal. Nuestras prácticas de datos están diseñadas para ser transparentes, proporcionadas y cumplir con las leyes y regulaciones aplicables."
    },
    collect: {
      heading: "Información que recopilamos",
      p1:
        "Cumplimos con principios de minimización de datos y recopilamos únicamente la información necesaria para proporcionar servicios eSIM. Específicamente, recopilamos:",
      email: {
        title: "Dirección de correo electrónico",
        collectedWhen: "Recopilada cuando:",
        items: [
          "Creas una cuenta",
          "Compras un plan eSIM",
          "Te suscribes a un boletín",
          "Contactas al soporte"
        ],
        purposeLabel: "Propósito:",
        purpose:
          "Gestionar cuentas, entregar eSIMs, proporcionar confirmaciones y habilitar soporte al cliente."
      },
      notCollect: {
        title: "No recopilamos:",
        items: [
          "Números de teléfono o identificadores de dispositivo",
          "Ubicación o datos de geolocalización",
          "Historial de navegación o cookies de comportamiento",
          "Perfiles de redes sociales o fotografías personales",
          "Datos financieros (los pagos son procesados por proveedores externos)"
        ]
      }
    },
    use: {
      heading: "Cómo usamos la información",
      p1: "La información recopilada se utiliza exclusivamente para fines definidos:",
      items: [
        "Entrega de credenciales eSIM, confirmaciones de compra y recibos",
        "Provisión de soporte técnico y de atención al cliente",
        "Transmisión de actualizaciones esenciales del servicio y avisos de seguridad",
        "Distribución opcional de material de marketing (sujeto a consentimiento)"
      ],
      optOut: "Puedes darte de baja de las comunicaciones de marketing en cualquier momento."
    },
    share: {
      heading: "Compartir y divulgar datos",
      p1:
        "La información personal no se vende, alquila ni intercambia. Puede compartirse únicamente en las siguientes circunstancias:",
      items: [
        { title: "Proveedores de servicios:", body: "Para funciones como procesamiento de pagos o envío de correos electrónicos" },
        { title: "Requisitos legales:", body: "Cuando lo exija la ley, regulación o procesos legales" },
        { title: "Transacciones comerciales:", body: "En relación con fusiones, adquisiciones o reorganizaciones" },
        { title: "Seguridad:", body: "Para proteger los derechos, la propiedad y la seguridad de Routed Labs y sus usuarios" }
      ]
    },
    retain: {
      heading: "Retención y eliminación de datos",
      p1: "La información se conserva solo durante el tiempo necesario para los fines aquí descritos:",
      items: [
        "Cuentas activas: Los datos se conservan mientras la cuenta esté activa y hasta dos años después de la última interacción.",
        "Compras como invitado: Conservadas hasta un año para garantizar soporte y cumplimiento.",
        "Tras la eliminación de la cuenta: Toda la información personal se borra permanentemente de los sistemas activos."
      ]
    },
    rights: {
      heading: "Derechos del usuario",
      p1: "Puedes ejercer los siguientes derechos:",
      items: [
        "Acceder y obtener una copia de la información personal",
        "Solicitar la corrección de datos inexactos",
        "Solicitar la eliminación de registros",
        "Retirar el consentimiento para comunicaciones de marketing en cualquier momento"
      ],
      contactPreamble: "Las solicitudes pueden enviarse a"
    },
    security: {
      heading: "Seguridad de los datos",
      p1:
        "Routed Labs aplica medidas técnicas y organizativas adecuadas para proteger la información personal, incluyendo:",
      items: [
        "Cifrado en tránsito y en reposo",
        "Auditorías y evaluaciones de vulnerabilidad regulares",
        "Controles de acceso estrictos y protocolos de autenticación",
        "Infraestructura y centros de datos seguros"
      ]
    },
    contact: {
      heading: "Información de contacto",
      p1:
        "Las preguntas o inquietudes sobre esta Política de Privacidad pueden dirigirse a:",
      company: "Routed Labs, Inc.",
      emailLabel: "Correo electrónico:",
      addressLabel: "Dirección:",
      address: "451 Niantic Avenue, Daly City, CA 94014, Estados Unidos",
      subjectLabel: "Asunto para la correspondencia:",
      subject: "“Consulta sobre la política de privacidad”"
    },
    updates: {
      heading: "Actualizaciones de esta política",
      p1:
        "Esta Política de Privacidad puede revisarse periódicamente para reflejar cambios operativos, legales o regulatorios. Las modificaciones importantes se publicarán en esta página con una fecha de “Última actualización” actualizada.",
      p2:
        "Se recomienda a los usuarios revisar este documento regularmente para mantenerse informados sobre cómo Routed Labs gestiona la información personal."
    }
  }
},

tos: {
  title: "Términos de servicio",
  subtitle:
    "Términos y condiciones legales que rigen el uso de la plataforma Airvoy y los servicios proporcionados por Routed Labs, Inc.",
  lastUpdated: { label: "Última actualización:", date: "1 de agosto de 2025" },
  sections: {
    agreement: {
      heading: "Aceptación de los términos",
      p1:
        "Estos Términos de servicio (“Términos”) constituyen un acuerdo legalmente vinculante entre el usuario (“tú”) y Routed Labs, Inc. (“Routed Labs”, “nosotros” o “nuestro”) con respecto al uso del sitio web, la aplicación móvil y los servicios eSIM relacionados de Airvoy (colectivamente, el “Servicio”).",
      p2:
        "Al acceder o utilizar el Servicio, reconoces que has leído, comprendido y aceptas estar sujeto a estos Términos. Si no estás de acuerdo, debes abstenerte de acceder o utilizar el Servicio."
    },
    service: {
      heading: "Descripción del servicio",
      p1:
        "El Servicio proporciona funcionalidad eSIM (SIM integrada) que permite a los usuarios acceder a redes de datos móviles a nivel internacional. Las ofertas incluyen:",
      items: [
        "Perfiles eSIM digitales para conectividad global",
        "Múltiples opciones de planes de datos con diferentes duraciones",
        "Entrega de códigos QR para activación e instalación",
        "Soporte al cliente para consultas técnicas",
        "Herramientas de gestión de cuenta para usuarios registrados"
      ],
      notice:
        "Importante: El Servicio requiere un dispositivo compatible y desbloqueado. No garantizamos compatibilidad con todos los dispositivos ni cobertura en todas las áreas geográficas."
    },
    eligibility: {
      heading: "Elegibilidad",
      p1: "Para usar el Servicio, declaras y garantizas que:",
      items: [
        "Tienes al menos 18 años de edad o cuentas con el consentimiento de tus padres",
        "Tienes la capacidad legal para celebrar un contrato vinculante",
        "Proporcionas información de registro precisa y completa",
        "Posees o estás autorizado para usar un dispositivo compatible",
        "Cumplirás con las leyes y regulaciones aplicables"
      ]
    },
    account: {
      heading: "Registro de cuenta",
      p1:
        "Los usuarios pueden comprar eSIM ya sea como titulares de cuentas registradas o como invitados. El registro proporciona funciones adicionales, incluido el historial de compras y soporte ampliado.",
      registered: {
        title: "Cuentas registradas",
        items: [
          "Se requiere una dirección de correo electrónico válida",
          "Responsabilidad de mantener la seguridad de la cuenta",
          "Obligación de mantener la información precisa",
          "Notificación inmediata en caso de acceso no autorizado"
        ]
      },
      guest: {
        title: "Compras como invitado",
        items: [
          "Solo requiere una dirección de correo electrónico",
          "La eSIM se entrega electrónicamente",
          "El soporte se limita a asuntos específicos de la compra",
          "No se conserva un historial de compras continuo"
        ]
      }
    },
    payment: {
      heading: "Términos de pago",
      p1:
        "Al completar una compra, autorizas a Routed Labs y a sus procesadores de pago a cobrar el método de pago que proporciones. Los términos clave incluyen:",
      items: [
        "Todos los precios se expresan en dólares estadounidenses e incluyen los impuestos aplicables",
        "El pago se debe realizar al momento de la compra",
        "El procesamiento de pagos es gestionado por proveedores externos",
        "La falta de pago puede resultar en la suspensión del servicio"
      ]
    },
    refunds: {
      heading: "Política de reembolsos",
      p1: "Las solicitudes de reembolso se consideran sujetas a las siguientes condiciones:",
      items: [
        "Elegible si se solicita dentro de las 24 horas posteriores a la compra",
        "No elegible una vez que la eSIM ha sido activada o utilizada",
        "Los problemas técnicos serán revisados caso por caso",
        "La compatibilidad del dispositivo es responsabilidad del usuario"
      ],
      p2: {
        prefix: "Las solicitudes de reembolso deben enviarse a ",
        suffix: ", proporcionando los detalles del pedido y el motivo."
      }
    },
    limitations: {
      heading: "Limitaciones del servicio",
      p1: "El Servicio está sujeto a limitaciones, incluyendo:",
      items: [
        "El dispositivo debe ser compatible con eSIM y estar desbloqueado",
        "La cobertura depende de las redes asociadas locales",
        "La velocidad y disponibilidad varían según la ubicación",
        "Los datos no utilizados expiran y no se acumulan",
        "Los planes no pueden transferirse entre dispositivos"
      ]
    },
    prohibited: {
      heading: "Usos prohibidos",
      p1:
        "Aceptas no utilizar el Servicio para ningún propósito ilegal o prohibido, incluyendo, pero no limitado a:",
      items: [
        "Actividad ilegal o violaciones regulatorias",
        "Acoso, abuso o actividad fraudulenta",
        "Acceso o interferencia no autorizada a la red",
        "Reventa o compartición de credenciales sin consentimiento",
        "Uso excesivo que afecte el rendimiento de la red"
      ]
    },
    liability: {
      heading: "Limitación de responsabilidad",
      p1:
        "En la máxima medida permitida por la ley, Routed Labs no será responsable por daños indirectos, incidentales o consecuentes derivados de tu uso del Servicio. La responsabilidad total no excederá el monto pagado por ti por el Servicio que dio lugar a la reclamación durante los doce (12) meses anteriores a la misma."
    },
    indemnity: {
      heading: "Indemnización",
      p1:
        "Aceptas indemnizar y eximir de responsabilidad a Routed Labs y sus afiliados frente a reclamaciones, daños o gastos que surjan de tu mal uso del Servicio o de la violación de estos Términos."
    },
    termination: {
      heading: "Terminación",
      p1:
        "Podemos suspender o terminar el acceso al Servicio de inmediato si incumples estos Términos, participas en conductas ilegales o actúas de manera perjudicial para Routed Labs o sus usuarios. Al terminar, tus derechos de uso del Servicio cesan inmediatamente."
    },
    law: {
      heading: "Ley aplicable",
      p1:
        "Estos Términos se rigen por las leyes del estado de Delaware, Estados Unidos. Aceptas someterte a la jurisdicción exclusiva de los tribunales ubicados en Delaware para la resolución de disputas."
    },
    amend: {
      heading: "Modificaciones",
      p1:
        "Routed Labs se reserva el derecho de modificar estos Términos a su discreción. Las actualizaciones se publicarán en el sitio web y entrarán en vigor inmediatamente, salvo que se indique lo contrario. El uso continuo del Servicio después de las modificaciones implica la aceptación de los Términos revisados."
    },
    contact: {
      heading: "Información de contacto",
      p1: "Para preguntas sobre estos Términos, por favor contacta a:"
    }
  }
},

about: {
  title: "Acerca de Airvoy",
  sections: {
    overview: {
      heading: "Descripción general",
      body:
        "Airvoy es una plataforma eSIM desarrollada por Routed Labs, Inc. La plataforma ofrece a los viajeros internacionales conectividad móvil accesible, asequible y confiable. Al eliminar la necesidad de tarjetas SIM físicas, el servicio permite la activación fluida de planes de datos en más de 200 destinos."
    },
    mission: {
      heading: "Misión",
      body:
        "Routed Labs, Inc. opera con una única misión: simplificar la conectividad móvil. La empresa busca eliminar la incertidumbre, los costos ocultos y los obstáculos logísticos asociados con el roaming internacional y la adquisición de SIM, asegurando así que los viajeros puedan mantenerse conectados con facilidad."
    },
    background: {
      heading: "Antecedentes",
      p1:
        "Routed Labs, Inc. tiene su sede en Daly City, California. La creación de nuestra empresa surgió de experiencias directas con las dificultades de mantenerse conectado internacionalmente, incluidos los altos costos de roaming y la disponibilidad limitada de SIM.",
      p2:
        "Al observar estos desafíos, el fundador identificó una oportunidad para aprovechar la tecnología eSIM y mejorar la conectividad global.",
      p3:
        "Hoy en día, la empresa respalda a miles de usuarios en todo el mundo, con énfasis en confiabilidad, transparencia y accesibilidad."
    },
    operations: {
      heading: "Operaciones",
      items: [
        { title: "Cobertura global:", desc: "Acceso a redes de alta velocidad en más de 200 países y territorios." },
        { title: "Provisionamiento de eSIM:", desc: "Instalación digital de planes en minutos, sin tarjetas SIM físicas." },
        { title: "Orientación al cliente:", desc: "Servicio y soporte diseñados para priorizar la claridad y las necesidades del usuario." }
      ]
    },
    corporate: {
      heading: "Información corporativa",
      company: {
        title: "Detalles de la empresa",
        nameLabel: "Nombre de la empresa:",
        name: "Routed Labs, Inc.",
        repLabel: "Representante:",
        rep: "Hector Diaz",
        addrLabel: "Dirección de la sede:",
        addr: "451 Niantic Avenue, Daly City, CA 94014, Estados Unidos",
        contactLabel: "Contacto:"
      },
      agent: {
        title: "Información del agente registrado",
        nameLabel: "Nombre del agente registrado:",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "Dirección del agente registrado:",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, Estados Unidos"
      }
    },
    comms: {
      heading: "Comunicaciones",
      p1: {
        prefix: "Para consultas oficiales o correspondencia, por favor escribe a",
        suffix:
          ". La correspondencia corporativa y legal también puede dirigirse al agente registrado de la empresa, Legalinc Corporate Services Inc., en su dirección de Newark, Delaware."
      }
    }
  }
},

auth: {
  titles: {
    signin: 'Bienvenido de nuevo',
    signup: 'Crear cuenta',
    forgot: 'Restablecer contraseña',
  },
  subtitles: {
    signin: 'Inicia sesión para comprar planes eSIM',
    signup: 'Únete a Airvoy hoy',
    forgot: 'Ingresa tu correo electrónico para restablecer tu contraseña',
  },
  fields: {
    email: 'Dirección de correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
  },
  placeholders: {
    email: 'Ingresa tu correo electrónico',
    password: 'Ingresa tu contraseña',
    confirmPassword: 'Confirma tu contraseña',
  },
  actions: {
    close: 'Cerrar',
    continueWithGoogle: 'Continuar con Google',
    signingIn: 'Iniciando sesión...',
    pleaseWait: 'Por favor espera...',
    signIn: 'Iniciar sesión',
    createAccount: 'Crear cuenta',
    sendReset: 'Enviar correo de restablecimiento',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
  },
  labels: {
    orEmail: 'O continúa con tu correo electrónico',
  },
  links: {
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate',
    forgot: '¿Olvidaste tu contraseña?',
    haveAccount: '¿Ya tienes una cuenta?',
    signIn: 'Inicia sesión',
    remembered: '¿Recordaste tu contraseña?',
    backToSignIn: 'Volver a iniciar sesión',
  },
  messages: {
    resetSent: '¡Correo de restablecimiento de contraseña enviado! Revisa tu bandeja de entrada.',
  },
  errors: {
    fillAll: 'Por favor completa todos los campos',
    userNotFound: 'No se encontró una cuenta con este correo electrónico',
    wrongPassword: 'Correo electrónico o contraseña incorrectos',
    emailInUse: 'Ya existe una cuenta con este correo electrónico',
    weakPassword: 'La contraseña es demasiado débil',
    invalidEmail: 'Dirección de correo electrónico inválida',
    tooManyRequests: 'Demasiados intentos fallidos. Por favor inténtalo más tarde',
    popupClosed: 'La ventana de inicio de sesión se cerró antes de completar',
    popupCancelled: 'El inicio de sesión fue cancelado',
    popupBlocked: 'La ventana de inicio de sesión fue bloqueada por tu navegador',
    passwordMismatch: 'Las contraseñas no coinciden',
    passwordMin: 'La contraseña debe tener al menos 6 caracteres',
    enterEmail: 'Por favor ingresa tu correo electrónico',
    generic: 'Ocurrió un error. Por favor inténtalo de nuevo',
  },
  legal: {
    prefix: 'Al crear una cuenta, aceptas nuestros',
    terms: 'Términos de servicio',
    and: 'y',
    privacy: 'Política de privacidad',
  },
},

support: {
  title: "Soporte",
  contactInfo: "Información de contacto",
  channels: {
    email: {
      title: "Soporte por correo electrónico",
      description: "Para consultas, reportes de incidentes y solicitudes de asistencia.",
      contact: "support@routedlabs.com",
      action: "Redactar correo"
    },
    chat: {
      title: "Chat en vivo",
      description: "Asistencia en tiempo real para asuntos urgentes, sujeta a disponibilidad.",
      contact: "Disponible 09:00–18:00 hora del Pacífico",
      action: "Abrir chat"
    }
  },
  faqTitle: "Preguntas frecuentes",
  noResults: "No hay resultados que coincidan con la búsqueda.",
  categoryLabel: "Categoría:",
  show: "Mostrar",
  hide: "Ocultar",
  noticesTitle: "Avisos y correspondencia",
  noticesLine1: {
    before: "Las consultas y la correspondencia oficial deben dirigirse a",
    after: "."
  },
  noticesLine2:
    "Esta página tiene como objetivo describir los procesos de soporte y materiales de referencia. No modifica ni reemplaza los términos de servicio o políticas aplicables, que prevalecen en todos los casos.",
  categories: {
    overview: "Descripción general de eSIM",
    compatibility: "Compatibilidad de dispositivos",
    installation: "Instalación",
    dualSim: "Dual SIM",
    dataUsage: "Uso de datos",
    planMgmt: "Gestión de planes",
    deviceReqs: "Requisitos del dispositivo",
    troubleshooting: "Solución de problemas",
    refunds: "Reembolsos",
    supportHours: "Disponibilidad de soporte"
  },
  faqs: {
    1: {
      q: "¿Qué es una eSIM y cómo funciona?",
      a: "Una eSIM (SIM integrada) es una SIM programable, incorporada en el dispositivo, que permite activar el servicio celular sin tarjeta física. Los usuarios pueden aprovisionar un perfil digitalmente y obtener conectividad escaneando un código o siguiendo los pasos de configuración en Airvoy."
    },
    2: {
      q: "¿Qué dispositivos son compatibles con la funcionalidad eSIM?",
      a: "Muchos teléfonos inteligentes modernos incluyen compatibilidad con eSIM, incluidos modelos recientes de los principales fabricantes. Revisa la configuración del dispositivo (a menudo en “Celular” o “Datos móviles”) para ver si aparece la opción “Agregar plan de datos”."
    },
    3: {
      q: "¿Cómo se instala una eSIM?",
      a: "Después de la compra, recibirás instrucciones de instalación y un código QR por correo electrónico. En tu dispositivo, ve a Configuración → Celular/Datos móviles → Agregar plan de datos y escanea el código. La activación se completa automáticamente siguiendo las indicaciones."
    },
    4: {
      q: "¿Se puede usar una SIM física y una eSIM al mismo tiempo en el mismo dispositivo?",
      a: "La mayoría de los dispositivos compatibles con eSIM admiten doble SIM. Puedes mantener tu número principal para llamadas y mensajes mientras usas la eSIM para datos. La selección se controla en la configuración del dispositivo."
    },
    5: {
      q: "¿Qué pasa si no consumo todos los datos asignados?",
      a: "Los datos no utilizados no se acumulan ni son reembolsables. Los planes expiran al final de su periodo de validez. Elige un plan que se ajuste a tu consumo estimado durante el viaje."
    },
    6: {
      q: "¿Es posible añadir datos o extender un plan activo?",
      a: "Sí. Puedes obtener datos adicionales o extender el servicio comprando otro plan a través del sitio web o el portal de tu cuenta, sujeto a disponibilidad para el destino."
    },
    7: {
      q: "¿El dispositivo debe estar desbloqueado?",
      a: "Sí. Para usar una eSIM de un proveedor diferente al operador original, tu dispositivo debe estar desbloqueado. Si está bloqueado, contacta a tu operador para solicitar el desbloqueo antes de la activación."
    },
    8: {
      q: "¿Qué hacer si la eSIM no funciona como se espera?",
      a: "Verifica que el dispositivo esté desbloqueado y sea compatible con eSIM. Asegúrate de que la itinerancia de datos esté habilitada, selecciona el plan de datos correcto e intenta reiniciar el dispositivo. Si los problemas persisten, contacta al soporte."
    },
    9: {
      q: "¿Se pueden solicitar reembolsos?",
      a: "Los reembolsos pueden estar disponibles dentro de las 24 horas posteriores a la compra si la eSIM no ha sido activada ni utilizada. Una vez activada, la venta es final. Para problemas técnicos, el soporte intentará resolverlos o emitir crédito en la cuenta si corresponde."
    },
    10: {
      q: "¿Cuáles son los horarios de soporte y tiempos de respuesta?",
      a: "El soporte por correo electrónico está disponible de forma continua. Los tiempos de respuesta típicos son de varias horas. Los problemas urgentes reportados durante el viaje reciben prioridad elevada."
    }
  }
}

  },
  fr: {
    // Navigation
nav: {
  installEsim: "Installer l’eSIM",
  admin: "Admin",
  faqs: "FAQ",
  browsePlans: "Parcourir les forfaits",
  partnerships: "Partenariats",
  dashboard: "Tableau de bord",
  signOut: "Se déconnecter",
  signIn: "Se connecter",
  getTheApp: "Télécharger l’application"
},

    // Hero Section
hero: {
  badge: "Rejoignez plus de 30 000 voyageurs utilisant Airvoy eSIM.",
  title: "Le Global",
  titleHighlight: "eSIM",
  subtitle: "Restez connecté comme à la maison — configuration instantanée, données flexibles et couverture mondiale dans plus de 200 pays.",
  searchPlaceholder: "Où voyagez-vous ?",
  appStore: "App Store",
  googlePlay: "Google Play"
},

    // Popular Countries
popularCountries: {
  title: "Destinations populaires",
  subtitle: "Connectez-vous instantanément dans ces destinations de voyage prisées",
  fromPrice: "À partir de",
  perDay: "/jour",
  unlimited: "Illimité",
  startingAt: "À partir de",
  getStarted: "Commencer",
  viewAllCountries: "Voir tous les pays",
  noPlansAvailable: "Aucun forfait illimité disponible"
},

    // How It Works
howItWorks: {
  title: "Comment fonctionne Airvoy eSIM",
  subtitle: "Connectez-vous en trois étapes simples",
  step1Title: "Choisissez votre destination",
  step1Desc: "Parcourez plus de 200 destinations avec des tarifs transparents. Aucun frais caché, aucune surprise — juste le forfait parfait pour votre aventure.",
  step2Title: "Installez en quelques secondes",
  step2Desc: "Recevez votre eSIM instantanément par e-mail. Un simple scan de code QR et vous êtes prêt — sans visite en magasin ni échange de carte SIM physique.",
  step3Title: "Connectez-vous automatiquement",
  step3Desc: "Atterrissez et connectez-vous instantanément. Votre eSIM s’active automatiquement à votre arrivée — oubliez la chasse au Wi-Fi de l’aéroport pour toujours.",
  learnMore: "En savoir plus"
},

    // Benefits
benefits: {
  whyAirvoy: "Pourquoi Airvoy ?",
  title: "Restez connecté où que vous alliez",
  item1Title: "Trouvez un forfait adapté à vous",
  item1Desc: "Des forfaits de données flexibles qui s’adaptent à votre budget. D’un forfait hebdomadaire de 1 Go à 100 Go de données valables six mois — trouvez-les tous dans une seule application.",
  item2Title: "Facile à utiliser",
  item2Desc: "Téléchargez simplement Airvoy, installez l’eSIM et obtenez un forfait de données — il s’activera automatiquement dès votre arrivée à destination.",
  item3Title: "Évitez les frais d’itinérance",
  item3Desc: "Les frais d’itinérance cachés appartiennent au passé. Sachez combien coûtera votre connexion internet avant même de partir en voyage !",
  item4Title: "Une seule eSIM pour tous vos voyages",
  item4Desc: "Ajoutez de nouvelles destinations à votre eSIM Airvoy existante — inutile d’installer une nouvelle eSIM à chaque fois. Rechargez simplement et connectez-vous !",
  item5Title: "Ne manquez jamais de données",
  item5Desc: "Ne risquez pas de manquer de données au pire moment — nous vous avertissons lorsque vous avez utilisé 80 % de votre forfait.",
  item6Title: "+200 pays",
  item6Desc: "Restez en ligne dans plus de 200 pays et territoires à travers le monde."
},

    // Videos
videos: {
  title: "Regardez et connectez-vous rapidement",
  subtitle: "Deux tutoriels rapides — un pour iPhone, un pour Samsung.",
  iPhoneTitle: "Configuration et activation eSIM — iPhone",
  iPhoneDesc: "Guide étape par étape pour installer et activer votre eSIM Airvoy sur iPhone. Scannez, installez et soyez en ligne en quelques minutes.",
  samsungTitle: "Configuration et activation eSIM — Samsung",
  samsungDesc: "Apprenez à ajouter votre eSIM Airvoy sur les appareils Samsung Galaxy. Un tutoriel rapide et clair de l’installation à la première connexion.",
  iOSGuide: "Guide iOS",
  samsungGuide: "Guide Samsung",
  installationGuide: "Ou lisez le guide d’installation complet"
},

    // Footer
footer: {
  description: "Rejoignez plus de 30 000 voyageurs utilisant Airvoy eSIM. Voyagez intelligemment, restez connecté — où que votre voyage vous mène.",
  company: "Entreprise",
  aboutUs: "À propos de nous",
  resources: "Ressources",
  documentation: "Documentation",
  support: "Assistance",
  legal: "Mentions légales",
  privacyPolicy: "Politique de confidentialité",
  termsOfService: "Conditions d’utilisation",
  followUs: "Suivez-nous",
  copyright: "Tous droits réservés.",
  madeWith: "Fait avec",
  forTravelers: "pour les voyageurs du monde entier"
},

    // Auth
aut: {
  authenticationRequired: "Authentification requise",
  signInPrompt: "Veuillez vous connecter pour accéder au tableau de bord et acheter des forfaits eSIM."
},

    // Common
common: {
  close: "Fermer",
  loading: "Chargement...",
  tryAgain: "Réessayer",
  noResults: "Aucun pays trouvé pour"
},

activate: {
  altText: "Activation globale d’Airvoy eSIM",
  activeInThailand: "Airvoy actif en Thaïlande",
  activeInSpain: "Airvoy actif en Espagne",
  activeWorldwide: "Airvoy actif dans le monde entier",
  activeInGreece: "Airvoy actif en Grèce",
  activeInMexico: "Airvoy actif au Mexique",
  title: "Conservez votre numéro WhatsApp",
  description: "Vous pouvez appeler et envoyer des messages à tous vos contacts sur WhatsApp, comme si vous étiez dans le même pays.\nNe perdez pas le contact avec votre famille et vos amis."
},

regionalPlans: {
  multiCountryCoverage: "Couverture multi-pays",
  title: "Forfaits régionaux",
  subtitle: "Choisissez une région, puis sélectionnez la durée et les données dont vous avez besoin.",
  noPlansAvailable: "Aucun forfait régional disponible.",
  from: "À partir de",
  seePlans: "Voir les forfaits",
  countries: "pays",
  plans: "forfaits",
  startingFrom: "À partir de",
  browseOptions: "Parcourir les options",
  viewPlans: "Voir les forfaits"
},

partnerships: {
  headerLabel: "PARTENARIATS",
  title: "Partenariats Airvoy",
  subtitle: "Collaborons et faisons de grandes choses ensemble.",
  join: "Rejoindre",
  airvoyAffiliate: "Programme\nd’affiliation Airvoy",
  affiliateDescription: "Gagnez jusqu’à 20 % de commission en promouvant Airvoy eSIM — rejoignez dès aujourd’hui notre réseau officiel d’affiliés !",
  joinNow: "Rejoindre maintenant !",
  learnMore: "En savoir plus",
  partnershipImageAlt: "Partenariat Airvoy",
  
  // Partnership types
  affiliateProgram: "Programme d’affiliation",
  eventPartnership: "Partenariat événementiel",
  travelPartnership: "Partenariat voyage",
  contentPartnership: "Partenariat contenu",
  sportsPartnership: "Partenariat sportif",
  musicCulturePartnership: "Partenariat musique & culture",
  athleteCollaboration: "Collaboration avec athlètes",
  other: "Autre",
  
  // Partnership descriptions
  eventPartnerships: "Partenariats événementiels",
  eventDescription1: "Vous organisez un événement international et souhaitez offrir à vos participants un avantage très utile : des données mobiles gratuites ?",
  eventDescription2: "Nous pouvons concevoir la solution idéale pour vous et vos invités afin qu’ils restent connectés facilement avant, pendant et après l’événement.",
  
  travelPartnerships: "Partenariats voyage",
  travelDescription1: "Souhaitez-vous proposer des données mobiles et des appels internationaux plus abordables à vos employés et clients voyageant à l’étranger ?",
  travelDescription2: "Grâce à notre suite de connectivité mobile intégrée, nous pouvons vous aider à offrir des solutions de voyage à forte valeur ajoutée avec un minimum d’effort et un maximum d’utilité.",
  
  contentPartnerships: "Partenariats contenu",
  contentDescription1: "Vous êtes créateur de contenu sur les réseaux sociaux, avec des idées créatives, une audience engagée et un œil avisé pour les #TravelHacks et #LifeHacks ?",
  contentDescription2: "Ou vous aimez simplement Airvoy et souhaitez en parler pour que d’autres puissent profiter d’une connectivité mobile sans faille à travers le monde ?",
  
  sportsPartnerships: "Partenariats sportifs",
  sportsDescription1: "Vous gérez une compétition sportive et souhaitez offrir aux athlètes, équipes et fans un moyen fiable de rester connectés tout au long de l’événement ?",
  sportsDescription2: "Associez-vous à Airvoy pour fournir des solutions de données mobiles fluides qui gardent tout le monde connecté, de la cérémonie d’ouverture au coup de sifflet final.",
  
  musicCulturePartnerships: "Partenariats musique & culture",
  musicDescription1: "Vous organisez un festival de musique, un événement culturel ou un spectacle en direct et cherchez des moyens d’améliorer l’expérience des participants ?",
  musicDescription2: "Airvoy peut fournir à votre public des services de données mobiles fiables, leur permettant de partager, diffuser et rester connectés tout en profitant de l’événement.",
  
  athleteCollaborations: "Collaborations avec athlètes",
  athleteDescription1: "Vous êtes un athlète qui parcourt le monde de compétition en compétition et n’avez plus de place dans votre armoire à trophées ?",
  athleteDescription2: "Collaborez avec Airvoy pour rester connecté où que votre sport vous mène et partagez votre parcours avec vos fans, où que vous soyez.",
  
  letsTalk: "Discutons-en",
  
  // Contact form
  getInTouch: "Prenez contact",
  successMessage: "Merci de nous avoir contactés ! Nous vous répondrons bientôt.",
  errorMessage: "Une erreur s’est produite. Veuillez réessayer.",
  emailPlaceholder: "Entrez votre e-mail",
  fullNamePlaceholder: "Nom complet",
  partnerTypePlaceholder: "Sur quoi souhaitez-vous collaborer ?",
  messagePlaceholder: "Décrivez brièvement votre idée",
  privacyConsent: "Vous acceptez notre",
  privacyPolicy: "politique de confidentialité",
  sending: "Envoi en cours…",
  send: "Envoyer"
},

faq: {
  headerLabel: "FAQ",
  title: "Trouvez les réponses aux questions les plus fréquemment posées",
  learnMore: "En savoir plus",
  
  whatIsEsim: {
    question: "Qu’est-ce qu’une eSIM ?",
    answer: "Une eSIM est une carte SIM numérique standardisée qui vous permet d’activer un forfait mobile auprès de votre opérateur sans avoir besoin d’une carte SIM physique. Vous pouvez installer huit eSIM ou plus sur un iPhone et utiliser deux numéros de téléphone en même temps."
  },
  
  howToSetup: {
    question: "Comment configurer votre eSIM ?",
    answer: "La technologie eSIM est très pratique. La configuration peut cependant être légèrement agaçante, surtout si c’est votre première fois. Mais ne vous inquiétez pas, nous avons des guides étape par étape pour vous permettre de profiter d’Airvoy en un rien de temps."
  },
  
  whatIsAirvoy: {
    question: "Qu’est-ce qu’Airvoy ?",
    answer: "Airvoy est une application mobile qui fournit des solutions de connectivité mobile mondiale. Elle offre un moyen simple et fluide de rester connecté lorsque vous voyagez, sans avoir besoin de cartes SIM physiques ni de frais d’itinérance élevés."
  },
  
  howSaveRoaming: {
    question: "Comment Airvoy m’aide-t-il à économiser sur les frais d’itinérance ?",
    answer: "Airvoy propose des données mobiles à des tarifs jusqu’à 90 % moins chers que les frais d’itinérance classiques. Ainsi, vous évitez les coûts élevés des services d’itinérance traditionnels."
  },
  
  needNewSim: {
    question: "Dois-je obtenir une nouvelle carte SIM chaque fois que je voyage avec Airvoy ?",
    answer: "Non, Airvoy utilise la technologie eSIM, ce qui signifie qu’aucune carte SIM physique n’est nécessaire. L’eSIM Airvoy est mondiale : une fois téléchargée et activée, vous pouvez l’utiliser pour voyager partout ou acheter de nouvelles eSIM pour des pays spécifiques."
  },
  
  constantConnectivity: {
    question: "Comment Airvoy garantit-il une connectivité constante lorsque je voyage ?",
    answer: "Airvoy propose des données mobiles à des tarifs jusqu’à 90 % moins chers que les frais d’itinérance classiques. Ainsi, vous évitez les coûts élevés des services d’itinérance traditionnels."
  },
  
  freeCallsTexts: {
    question: "Airvoy propose-t-il des appels et SMS gratuits ?",
    answer: "Pas encore. Mais Airvoy proposera bientôt des appels et SMS gratuits entre utilisateurs Airvoy. Cela signifie que vous pourrez rester connecté avec d’autres utilisateurs Airvoy sans frais supplémentaires."
  },
  
  whyChooseAirvoy: {
    question: "Pourquoi devrais-je choisir Airvoy plutôt que d’autres alternatives d’itinérance ?",
    answer: "Vous devriez choisir Airvoy plutôt que d’autres alternatives d’itinérance car Airvoy offre une connectivité mondiale fluide avec une seule eSIM, un modèle économique avantageux et des fonctionnalités supplémentaires comme la messagerie (bientôt) et les numéros locaux (bientôt), le tout dans une application conviviale. C’est abordable, simple et vous gardez le contrôle total sur votre façon de vous connecter, où que vous soyez."
  }
},

browse: {
  main: {
    title: "Parcourir les forfaits eSIM",
    subtitle: "Découvrez des forfaits eSIM pour des destinations du monde entier avec des prix en temps réel"
  },
  search: {
    placeholder: "Rechercher des pays (ex. : États-Unis, Espagne, Japon)…",
    clearSearch: "Effacer la recherche",
    noCountriesFound: "Aucun pays ne correspond à votre recherche.",
    noCountriesAvailable: "Aucun pays disponible.",
    clearSearchButton: "Effacer la recherche",
    searching: "Recherche de pays…",
    country: "pays",
    countries: "pays",
    foundFor: "trouvés pour"
  },
  loading: {
    loadingText: "Chargement…",
    allCountriesLoaded: "Tous les pays ont été chargés",
    total: "total"
  },
  buttons: {
    showMoreCountries: "Afficher plus de pays",
    showLessPlans: "Afficher moins de forfaits",
    showLess: "Afficher moins",
    seeMorePlans: "Voir plus de forfaits",
    more: "plus",
    buyNow: "Acheter maintenant"
  },
  navigation: {
    backToCountries: "Retour aux pays"
  }, 
  countryDetails: {
    description: "Explorez {{country}} en toute flexibilité avec nos forfaits de données eSIM. Que vous soyez en visite pour un court séjour ou un voyage prolongé, nos forfaits vous gardent connecté sans tracas."
  },
  plans: {
    noPlansAvailable: "Aucun forfait disponible pour les filtres sélectionnés.",
    planDetails: "Détails du forfait",
    details: "Détails",
    unlimited: "Illimité",
    for: "Pour",
    day: "jour",
    days: "jours"
  },
  checkout: {
    total: "Total"
  },
  planDetails: {
    title: "Détails du forfait",
    unlimitedData: "Données illimitées",
    data: "Données",
    country: "Pays",
    duration: "Durée",
    day: "jour",
    days: "jours",
    network: "Réseau",
    autoStart: "Démarrage automatique",
    enabled: "Activé",
    disabled: "Désactivé",
    planType: "Type de forfait",
    description: "Description",
    purchaseThisPlan: "Acheter ce forfait",
    signInToPurchase: "Connectez-vous pour acheter"
  }
},

installation: {
  title: "Comment installer et configurer mon eSIM ?",
  metaUpdated: "Il y a 2 mois • Mis à jour",
  intro: {
    p1: "Que vous soyez sur Android ou Apple, vérifiez d’abord que votre téléphone est compatible eSIM et désimlocké. Vous aurez également besoin d’une connexion Internet stable (de préférence Wi-Fi).",
    p2: "Ensuite, vous pouvez soit :",
    ol1: "Scanner le code QR pour une installation automatique",
    ol2: "Installer votre eSIM manuellement",
    note: "L’installation avec un code QR est la méthode la plus simple."
  },
  ios: {
    qr: {
      title: "Installer votre eSIM avec le code QR (iOS)",
      s1: "1. Allez dans Réglages > Données cellulaires",
      s2: "2. Touchez « Ajouter un eSIM » et sélectionnez Utiliser un code QR",
      s3: "3. Scannez le code QR et entrez le code de confirmation à 4 chiffres si demandé",
      s4: "4. Nommez votre eSIM et sélectionnez « Données cellulaires uniquement » sous Ligne par défaut",
      s5: "5. Vous devriez maintenant voir votre eSIM dans « Données cellulaires »"
    },
    manual: {
      title: "Comment installer votre eSIM manuellement (iOS)",
      s1: "1. Réglages > Données cellulaires > Ajouter un eSIM",
      s2: "2. Touchez « Ajouter un eSIM » et sélectionnez Utiliser un code QR",
      s3: "3. Au lieu de scanner, touchez Saisir les informations manuellement",
      s4: "4. Saisissez l’adresse SM-DP+, le code d’activation et, si nécessaire, le code de confirmation depuis votre application Airvoy",
      s5: "5. Nommez votre eSIM et sélectionnez « Données cellulaires uniquement » sous Ligne par défaut",
      s6: "6. Vous devriez maintenant voir votre eSIM dans Données cellulaires"
    }
  },
  android: {
    qr: {
      title: "Installer votre eSIM avec le code QR (Android)",
      s1: "1. Allez dans Paramètres > Réseau et Internet > Cartes SIM",
      s2: "2. Touchez l’icône « + » à droite de « Cartes SIM »",
      s3: "3. Touchez « Télécharger une SIM à la place ? » en bas",
      s4: "4. Dans « Téléchargez votre SIM », touchez « Suivant » — vous verrez « Vérification des informations réseau... »",
      s5: "5. Après la vérification, un viseur s’affiche pour scanner votre code QR",
      s6: "6. Pointez-le vers un QR imprimé ou affiché sur un autre appareil",
      s7: "7. Après le scan, votre appareil vérifie à nouveau les informations",
      s8: "8. Touchez Télécharger pour confirmer — les données eSIM seront téléchargées",
      s9: "9. Une fois terminé, vous verrez « Téléchargement terminé »",
      s10: "10. Configurez l’eSIM pour l’accès Internet lorsque vous êtes prêt."
    }
  },
  notes: {
    title: "Notes importantes",
    n1: "Assurez-vous que votre appareil est compatible eSIM et désimlocké",
    n2: "Vous aurez besoin d’une connexion Wi-Fi stable pendant l’installation",
    n3: "La eSIM ne peut être installée qu’une seule fois — commencez lorsque vous êtes prêt",
    n4: "Gardez votre carte SIM principale active pour les appels et SMS depuis votre numéro d’origine",
    n5: "Votre eSIM s’activera lorsque vous arriverez dans votre pays de destination"
  },
  support: {
    title: "Besoin d’aide ?",
    body: "Si vous avez des difficultés à installer votre eSIM, notre équipe support est là pour vous aider !",
    emailLabel: "E-mail :",
    websiteLabel: "Site web :"
  }
},

installGuide: {
  header: {
    title: "Guide complet d’installation d’eSIM",
    subtitle: "Tout ce que vous devez savoir pour installer, activer et utiliser votre eSIM pour une connectivité mondiale fluide. Suivez nos instructions spécifiques à votre appareil pour une configuration sans problème.",
    link: "Consultez également le guide détaillé pour l’installation sur Android",
    iOS: "Guide détaillé pour iOS",
    Android: "Guide détaillé pour Android"
  },
  iphoneHero: "Installez et activez votre eSIM sur iPhone",
  cards: {
    c1: {
      alt: "iPhone avec interrupteur et icône d’horloge",
      install: "Installez",
      activate: "activez",
      textA: "quelques heures avant votre voyage et",
      textB: "pendant votre vol ou à votre arrivée à destination."
    },
    c2: {
      alt: "iPhone avec interface de scanner de code QR",
      line1: "Sélectionnez « Installer avec un code QR »",
      line2: "si vous avez le code sur un autre appareil",
      line3: "à scanner."
    },
    c3: {
      alt: "iPhone avec interface d’installation manuelle",
      line1: "Sélectionnez « Installer manuellement »",
      line2: "si vous ne pouvez pas scanner le code QR."
    }
  },
  learn: {
    title: "Apprenez étape par étape",
    subtitle: "Sélectionnez le type d’installation que vous souhaitez effectuer",
    btnQr: "Installation avec code QR",
    btnManual: "Installation manuelle"
  },
  prep: {
    alt: "Icône d’avertissement sur téléphone",
    qr: {
      title: "Avant de commencer l’installation avec un code QR, voici quelques points importants à connaître :",
      i1: "Vous devez avoir le code QR sur un autre écran ou appareil pour le scanner avec la caméra de votre téléphone.",
      i2: "Assurez-vous de disposer d’une connexion Internet stable tout au long du processus.",
      i3: "Veuillez noter que le code QR ne peut être scanné qu’une seule fois.",
      i4: "Ne supprimez pas l’eSIM de votre appareil car vous ne pourrez plus l’utiliser."
    },
    manual: {
      title: "Avant de commencer l’installation manuelle, voici quelques points importants à connaître :",
      i1: "Les codes d’installation manuelle ne peuvent être utilisés qu’une seule fois."
    },
    shared: {
      i2: "Assurez-vous de disposer d’une connexion Internet stable tout au long du processus.",
      i3: "Ne supprimez pas l’eSIM de votre appareil car vous ne pourrez plus l’utiliser."
    }
  },
  start: {
    title: "Commençons ensemble",
    c1: {
      title: "Ouvrez votre e-mail",
      qr: { p1: "Ouvrez votre e-mail sur un autre appareil que celui que vous utiliserez pour l’installation et trouvez l’e-mail que nous vous avons envoyé avec le code QR." },
      manual: { p1: "Vérifiez l’e-mail que nous vous avons envoyé contenant l’« adresse SM-DP+ » et le « code d’activation » et gardez-les à portée de main pour commencer l’installation. Nous vous les envoyons également par SMS." },
      shared: { missing: "Si vous n’avez pas reçu vos codes, veuillez", contact: "nous contacter" }
    },
    c2: {
      qr: { title: "Scannez le code QR", p1: "Ouvrez l’appareil photo de l’iPhone où vous souhaitez installer l’eSIM et scannez le code. Vous pouvez aussi aller dans Réglages → Données cellulaires et sélectionner « Ajouter un forfait cellulaire » pour scanner depuis cet écran." },
      manual: { title: "Ouvrez « Réglages » sur votre iPhone", p1: "Ensuite, allez dans Données cellulaires, appuyez sur « Ajouter une eSIM » ou « Ajouter un forfait cellulaire » et sélectionnez « Utiliser un code QR ». Puis choisissez « Saisir les détails manuellement » lorsque cela est proposé." }
    },
    c3: {
      title: "Suivez les étapes d’installation sur votre iPhone",
      qr: { p1: "Le scan du code lancera le processus d’installation. Utilisez notre guide ci-dessous pour une configuration étape par étape." },
      manual: { p1: "Une fois arrivé à « Scanner le code QR », sélectionnez « Saisir les détails manuellement » et suivez les étapes affichées sur votre iPhone." }
    }
  },
  compat: {
    title: "Vérificateur de compatibilité des appareils",
    subtitle: "Vérifiez si votre appareil prend en charge la technologie eSIM. Utilisez la fonction de recherche pour trouver rapidement votre modèle précis.",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "Rechercher des modèles iPhone/iPad...",
    searchAndroid: "Rechercher des modèles Android...",
    iphones: "iPhones compatibles",
    ipads: "iPads compatibles (4G uniquement)",
    androids: "Appareils Android compatibles",
    noMatch: "Aucun appareil correspondant à votre recherche.",
    iosNotesTitle: "Remarques importantes :",
    iosNotes: {
      i1: "Les modèles iPhone 13 et 14 peuvent avoir deux eSIM activées simultanément",
      i2: "Les iPhones de Chine continentale et de Hong Kong n’ont pas la capacité eSIM (sauf certains modèles)",
      i3: "Les modèles iPhone 14+ vendus aux États-Unis ne prennent pas en charge les cartes SIM physiques"
    },
    androidNotesTitle: "Restrictions importantes :",
    androidNotes: {
      i1: "Les appareils Samsung des États-Unis et de Hong Kong peuvent ne pas prendre en charge l’eSIM",
      i2: "Les Google Pixel d’Australie, du Japon et de Taïwan n’ont pas de support eSIM",
      i3: "Les téléphones vendus à Hong Kong ne prennent généralement pas en charge l’eSIM",
      i4: "L’appareil doit être désimlocké pour utiliser l’eSIM"
    },
    empty: "Commencez à taper le modèle de votre appareil pour vérifier la compatibilité"
  },
  tips: {
    title: "Astuces Pro : Activez avant de voyager",
    body: "Pour un voyage sans tracas, installez votre eSIM avant le départ et activez-la à votre arrivée. Vous serez connecté dès l’atterrissage, sans chercher de Wi-Fi ou de cartes SIM locales.",
    before: {
      title: "Avant le départ",
      i1: "Installez le profil eSIM chez vous",
      i2: "Testez le processus d’installation",
      i3: "Gardez une capture d’écran de votre code QR en sauvegarde",
      i4: "Assurez-vous que votre appareil est désimlocké"
    },
    after: {
      title: "À l’arrivée",
      i1: "Activez les données cellulaires pour votre eSIM",
      i2: "Attendez 2 à 3 minutes pour l’enregistrement sur le réseau",
      i3: "Testez la connexion avec une recherche web",
      i4: "Configurez l’itinérance des données si nécessaire"
    }
  },
  support: {
    title: "Besoin d’une assistance supplémentaire ?",
    body: "Notre équipe d’assistance experte est là pour vous aider à chaque étape. Des questions sur la compatibilité des appareils à l’aide à l’installation, nous sommes à vos côtés.",
    btnEmail: "Assistance par e-mail",
    btnCenter: "Visiter le centre de support"
  },
  steps: {
    ios: {
      s1: { title: "Ouvrez Réglages", desc: "Allez dans Réglages → Cellulaire (ou Données mobiles selon les régions)", detail: "Cherchez l’option « Cellulaire » dans le menu principal des réglages. Dans certains pays, elle peut être appelée « Données mobiles »." },
      s2: { title: "Ajouter un forfait cellulaire", desc: "Appuyez sur « Ajouter un forfait cellulaire » ou « Ajouter une eSIM »", detail: "Cette option apparaît en bas de la page Cellulaire. Si vous ne la voyez pas, votre appareil peut ne pas prendre en charge l’eSIM." },
      s3: { title: "Scanner le code QR", desc: "Choisissez « Utiliser un code QR » et scannez le code depuis votre e-mail", detail: "Pointez votre appareil photo vers le code QR. Assurez un bon éclairage et maintenez le téléphone stable jusqu’à ce qu’il reconnaisse le code." },
      s4: { title: "Ajouter un forfait cellulaire", desc: "Appuyez sur « Ajouter un forfait cellulaire » lorsque les détails apparaissent", detail: "Vérifiez les informations de l’opérateur et les détails du forfait avant de confirmer. Cette étape télécharge votre profil eSIM." },
      s5: { title: "Étiquetez vos forfaits", desc: "Choisissez des étiquettes pour vos forfaits (ex. « Principal », « Voyage », « Secondaire »)", detail: "Cela vous aide à identifier quel forfait utiliser pour les données, appels et messages. La plupart des voyageurs utilisent l’eSIM uniquement pour les données." },
      s6: { title: "Configurer la ligne par défaut", desc: "Sélectionnez la ligne à utiliser pour les données cellulaires", detail: "Vous pouvez choisir votre eSIM pour les données tout en gardant votre SIM d’origine pour les appels et SMS." }
    },
    android: {
      s1: { title: "Ouvrez Paramètres", desc: "Allez dans Paramètres → Réseau et Internet → SIM", detail: "Le chemin exact peut varier selon le fabricant. Sur Samsung, cela peut être Paramètres → Connexions → Gestionnaire de carte SIM." },
      s2: { title: "Ajouter un forfait mobile", desc: "Appuyez sur le bouton « + » ou « Ajouter un forfait mobile »", detail: "Cherchez des options comme « Ajouter un forfait mobile », « Télécharger une SIM à la place » ou « Ajouter un opérateur » selon votre appareil." },
      s3: { title: "Télécharger la SIM", desc: "Sélectionnez « Pas de carte SIM ? » ou « Télécharger une SIM à la place »", detail: "Cette option indique à votre téléphone que vous souhaitez installer une eSIM au lieu d’insérer une carte SIM physique." },
      s4: { title: "Scanner le code QR", desc: "Choisissez « Scanner le code QR » et pointez votre caméra vers le code", detail: "Assurez un bon éclairage et gardez vos mains stables. La caméra détectera automatiquement le code QR de votre e-mail." },
      s5: { title: "Télécharger le profil", desc: "Appuyez sur « Télécharger » lorsque le profil de l’opérateur apparaît", detail: "Votre appareil se connectera à Internet pour télécharger le profil eSIM. Cela peut prendre quelques instants." },
      s6: { title: "Activer l’eSIM", desc: "Activez l’eSIM et définissez-la comme votre connexion de données préférée", detail: "Vous pouvez choisir quelle SIM utiliser pour les données, appels et SMS. La plupart des voyageurs utilisent l’eSIM uniquement pour les données." }
    }
  }
},

profile: {
  loading: "Chargement de votre profil…",
  errors: {
    load: "Échec du chargement de vos eSIM",
    delete: "Échec de la suppression de l’eSIM. Veuillez réessayer.",
    bundle: "Échec de la récupération de l’état du forfait",
    network: "Erreur réseau lors de la récupération de l’état du forfait",
    invoice: "Échec du téléchargement de la facture"
  },
  auth: {
    title: "Authentification requise",
    subtitle: "Veuillez vous connecter pour voir votre profil et l’historique de vos eSIM.",
    cta: "Se connecter"
  },
  header: {
    fallback: "Profil utilisateur",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} achetée(s)"
  },
  list: {
    title: "Vos eSIM",
    subtitle: "Gérez vos profils achetés et accédez aux codes QR & factures.",
    total: "{{count}} au total"
  },
  empty: {
    title: "Aucune eSIM pour l’instant",
    subtitle: "Parcourez nos forfaits pour vous connecter en quelques secondes — aucune carte SIM physique requise.",
    cta: "Parcourir les forfaits",
    tip: "Astuce : vous pouvez installer une eSIM avant votre voyage et l’activer à votre arrivée."
  },
  item: {
    country: "Pays",
    statusTitle: "Statut actuel",
    pricePaid: "Prix payé",
    purchaseDate: "Date d’achat"
  },
  actions: {
    details: "Voir les détails",
    showQr: "Afficher le QR",
    invoice: "Facture"
  },
  hint: "Besoin d’aide pour installer une eSIM ? Sur iOS : Réglages → Cellulaire → Ajouter une eSIM. Sur Android : Paramètres → Réseau et Internet → Cartes SIM → Ajouter une eSIM.",
  delete: {
    title: "Supprimer l’eSIM",
    confirm: "Êtes-vous sûr de vouloir supprimer cette eSIM de votre historique ? Cette action est irréversible.",
    deleting: "Suppression…",
    cta: "Supprimer l’eSIM"
  },
  details: {
    title: "Détails de l’eSIM & État en direct",
    refresh: "Actualiser l’état du forfait",
    live: "État en direct du forfait",
    updated: "Mis à jour :",
    fetching: "Récupération de l’état en temps réel...",
    ref: "Réf :",
    discount: "Réduction appliquée",
    usage: {
      title: "Utilisation des données",
      used: "Utilisé",
      remaining: "Restant",
      total: "Total"
    },
    assigned: "Forfait attribué",
    plan: {
      title: "Informations sur le forfait",
      destination: "Destination",
      name: "Nom du forfait",
      allowance: "Volume de données",
      validity: "Validité"
    },
    tech: {
      title: "Détails techniques",
      activation: "Code d’activation",
      copyActivation: "Copier le code d’activation",
      iccid: "ICCID",
      copyIccid: "Copier l’ICCID",
      orderRef: "Référence de commande GOeSIM"
    },
    install: {
      title: "Instructions d’installation",
      iosTitle: "Pour iOS :",
      androidTitle: "Pour Android :",
      ios: "Réglages → Cellulaire → Ajouter une eSIM → Utiliser le code QR",
      android: "Paramètres → Réseau et Internet → Cartes SIM → Ajouter une eSIM → Scanner le code QR",
      important: "Important :",
      once: "Vous ne pouvez installer cette eSIM qu’une seule fois. Assurez-vous que votre appareil est débloqué et compatible eSIM avant de continuer."
    },
    purchase: {
      title: "Informations d’achat",
      date: "Date d’achat",
      amount: "Montant payé",
      method: "Méthode de paiement",
      txn: "ID de transaction"
    },
    referral: {
      title: "Réduction de parrainage appliquée",
      code: "Code de parrainage",
      original: "Prix initial",
      saved: "Vous avez économisé"
    },
    billing: {
      title: "Informations de facturation",
      name: "Nom complet",
      email: "E-mail",
      country: "Pays",
      zip: "Code postal"
    }
  },
  qr: {
    title: "Code QR de l’eSIM",
    alt: "Code QR de l’eSIM",
    copy: "Copier le code d’activation",
    tip: "Astuce : ouvrez l’appareil photo de votre téléphone et scannez le QR. Vous ne pouvez installer une eSIM qu’une seule fois."
  },
  common: {
    usd: "USD",
    days: "jours",
    na: "N/D",
    invalidDate: "Date invalide",
    cancel: "Annuler",
    close: "Fermer",
    copied: "copié"
  }
},

countryDetails: {
  loading: "Chargement des détails du pays...",
  errors: {
    notFound: "Pays introuvable",
    loadFail: "Échec du chargement des données du pays"
  },
  notFound: {
    title: "Pays introuvable",
    subtitle: "Le pays que vous recherchez n’existe pas ou n’a aucun forfait disponible.",
    cta: "Parcourir tous les pays"
  },
  back: "Retour aux pays",
  blurb: "Explorez {{country}} en toute flexibilité grâce à nos forfaits de données eSIM. Que vous soyez en visite pour un court séjour ou un voyage prolongé, nos forfaits vous gardent connecté sans tracas.",
  noPlans: "Aucun forfait disponible pour les filtres sélectionnés.",
  plan: {
    details: "Détails du forfait",
    detailsShort: "Détails",
    networkBadge: "5G",
    unlimited: "Illimité",
    unlimitedData: "Données illimitées",
    gb: "Go",
    gbShort: "Go",
    data: "Données",
    forDays: "Pour {count, plural, one {# JOUR} other {# JOURS}}"
  },
  currency: {
    usd: "USD" 
  },
  duration: {
    days: "{count, plural, one {# jour} other {# jours}}"
  },
  more: {
    more: "Voir plus de forfaits",
    moreShort: "+{extra} de plus",
    less: "Voir moins de forfaits",
    lessShort: "Voir moins"
  },
  modal: {
    title: "Détails du forfait",
    country: "Pays :",
    duration: "Durée :",
    network: "Réseau :",
    autostart: "Démarrage automatique :",
    enabled: "Activé",
    disabled: "Désactivé",
    planType: "Type de forfait :",
    description: "Description",
    purchase: "Acheter ce forfait",
    signInToPurchase: "Connectez-vous pour acheter"
  },
  bar: {
    title: "eSIM {{country}}",
    total: "Total",
    buy: "Acheter maintenant"
  }
},

checkout: {
  loading: "Chargement du paiement sécurisé...",
  invalidPlan: {
    title: "Données du forfait invalides",
    subtitle: "Les informations du forfait sélectionné n’ont pas pu être chargées.",
    cta: "Retour au tableau de bord"
  },
  success: {
    title: "Achat réussi !",
    message: "eSIM achetée avec succès ! ICCID : {{iccid}}. {{targetEmail}}",
    sentBoth: "Le code QR et les instructions d’installation ont été envoyés à {{a}} et {{b}}",
    sentOne: "Le code QR et les instructions d’installation ont été envoyés à {{email}}",
    view: "Voir mes eSIM"
  },
  common: {
    close: "Fermer"
  },
  header: {
    title: "Paiement sécurisé",
    subtitle: "Finalisez votre achat eSIM en toute sécurité"
  },
  benefits: {
    title: "Connectez-vous pour plus d’avantages",
    copy: "Créez un compte pour sauvegarder votre historique d’achats, accéder à des offres exclusives et gérer vos eSIM.",
    cta: "S’inscrire / Se connecter"
  },
  billing: {
    title: "Informations de facturation",
    subtitle: "Votre facture et votre eSIM seront envoyées à cette adresse e-mail"
  },
  form: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "Adresse e-mail",
    referral: "Code de parrainage (optionnel)"
  },
  placeholder: {
    firstName: "Entrez le prénom",
    lastName: "Entrez le nom",
    email: "Entrez l’adresse e-mail",
    referral: "Entrez le code de parrainage",
    altEmail: "Entrez une autre adresse e-mail"
  },
  referral: {
    validating: "Validation en cours...",
    invalid: "Code de parrainage invalide",
    ownCode: "Impossible d’utiliser votre propre code de parrainage",
    inactive: "Ce code de parrainage n’est plus actif",
    used: "Ce code de parrainage a déjà été utilisé",
    valid: "Valide ! Réduction de {{percent}}% appliquée",
    error: "Erreur lors de la validation du code"
  },
  altEmail: {
    title: "Utiliser une autre adresse e-mail",
    copy: "La eSIM sera également envoyée à cette autre adresse et enregistrée sur votre compte",
    input: "Autre adresse e-mail"
  },
  createAccount: {
    title: "Créer un compte pour sauvegarder l’historique d’achats",
    copy: "Optionnel — vous aide à gérer vos eSIM et à accéder au support"
  },
  payment: {
    title: "Détails du paiement",
    secured: "Sécurisé par Stripe",
    method: "Méthode de paiement",
    card: "Carte de crédit ou de débit",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "Payer avec PayPal",
    cardInfo: "Informations de la carte",
    loadingSecure: "Chargement du formulaire de paiement sécurisé...",
    cardComplete: "Les informations de la carte sont complètes",
    processing: "Traitement du paiement...",
    complete: "Finaliser l’achat • ${{total}}"
  },
  legal: {
    agree: "En finalisant la commande, vous acceptez nos",
    terms: "Conditions générales",
    and: "et",
    privacy: "Politiques de confidentialité et de remboursement"
  },
  summary: {
    title: "Récapitulatif de la commande",
    planLabel: "Forfait eSIM",
    digital: "Numérique",
    data: "Données incluses :",
    validity: "Validité :",
    coverage: "Couverture :",
    nationwide: "National"
  },
  pricing: {
    planPrice: "Prix du forfait",
    referralDiscount: "Réduction parrainage ({{percent}}%)",
    stripeFee: "Frais de traitement Stripe",
    paypalFee: "Frais de traitement PayPal",
    taxes: "Taxes et frais de service",
    included: "Inclus",
    total: "Total"
  },
  paypal: {
    description: "eSIM pour {{country}} - {{data}} pour {{days}} jours"
  },
  duration: {
    days: "{count, plural, one {# jour} other {# jours}}"
  },
  alerts: {
    enterName: "Veuillez entrer votre nom complet",
    formNotReady: "Le formulaire de paiement n’est pas prêt. Veuillez patienter un instant et réessayer.",
    cardIncomplete: "Veuillez saisir les informations complètes de la carte",
    paypalFailed: "Échec du paiement PayPal : {{msg}}",
    paypalGeneric: "Échec du paiement PayPal. Veuillez réessayer.",
    purchaseFailed: "Échec de l’achat : {{msg}}"
  }
},

privacy: {
  title: "Politique de confidentialité",
  subtitle:
    "Déclaration des pratiques concernant la collecte, l’utilisation et la protection des informations personnelles par Routed Labs, Inc.",
  lastUpdated: {
    label: "Dernière mise à jour :",
    date: "1 août 2025"
  },
  sections: {
    intro: {
      heading: "Introduction",
      p1:
        "Routed Labs, Inc. (« Routed Labs », « nous », « notre » ou « nos ») exploite le site web et l’application mobile Airvoy (le « Service »). La présente politique de confidentialité décrit comment nous collectons, utilisons, divulguons et protégeons les informations personnelles. En utilisant le Service, vous consentez aux pratiques décrites dans ce document.",
      p2:
        "Routed Labs s’engage à maintenir la confidentialité, l’intégrité et la sécurité de vos informations personnelles. Nos pratiques en matière de données sont conçues pour être transparentes, proportionnées et conformes aux lois et réglementations applicables."
    },
    collect: {
      heading: "Informations que nous collectons",
      p1:
        "Nous respectons les principes de minimisation des données et ne collectons que les informations nécessaires pour fournir les services eSIM. Plus précisément, nous collectons :",
      email: {
        title: "Adresse e-mail",
        collectedWhen: "Collectée lorsque vous :",
        items: [
          "Créez un compte",
          "Achetez un forfait eSIM",
          "Vous abonnez à une newsletter",
          "Contactez l’assistance"
        ],
        purposeLabel: "Objectif :",
        purpose:
          "Gérer les comptes, livrer les eSIM, fournir des confirmations et permettre le support client."
      },
      notCollect: {
        title: "Nous ne collectons pas :",
        items: [
          "Numéros de téléphone ou identifiants d’appareils",
          "Données de localisation ou de géotracking",
          "Historique de navigation ou cookies comportementaux",
          "Profils de réseaux sociaux ou photos personnelles",
          "Données financières (les paiements sont gérés par des prestataires tiers)"
        ]
      }
    },
    use: {
      heading: "Comment nous utilisons les informations",
      p1: "Les informations collectées sont utilisées exclusivement à des fins définies :",
      items: [
        "Livraison des identifiants eSIM, confirmations d’achat et reçus",
        "Fourniture de support technique et client",
        "Envoi de mises à jour essentielles du service et d’avis de sécurité",
        "Diffusion facultative de contenus marketing (sous réserve de votre consentement)"
      ],
      optOut: "Vous pouvez vous désabonner des communications marketing à tout moment."
    },
    share: {
      heading: "Partage et divulgation des données",
      p1:
        "Les informations personnelles ne sont ni vendues, ni louées, ni échangées. Elles peuvent être partagées uniquement dans les circonstances suivantes :",
      items: [
        { title: "Fournisseurs de services :", body: "Pour des fonctions telles que le traitement des paiements ou l’envoi d’e-mails" },
        { title: "Obligations légales :", body: "Lorsque la loi, la réglementation ou une procédure judiciaire l’exige" },
        { title: "Opérations commerciales :", body: "Dans le cadre de fusions, d’acquisitions ou de réorganisations" },
        { title: "Sécurité :", body: "Pour protéger les droits, les biens et la sécurité de Routed Labs et de ses utilisateurs" }
      ]
    },
    retain: {
      heading: "Conservation et suppression des données",
      p1: "Les informations sont conservées uniquement aussi longtemps que nécessaire aux fins décrites dans ce document :",
      items: [
        "Comptes actifs : les données sont conservées tant que le compte reste actif et jusqu’à deux ans après la dernière interaction.",
        "Achats invités : conservés jusqu’à un an pour garantir le support client et l’exécution.",
        "Après suppression du compte : toutes les informations personnelles sont définitivement effacées des systèmes actifs."
      ]
    },
    rights: {
      heading: "Droits individuels",
      p1: "Vous pouvez exercer les droits suivants :",
      items: [
        "Accéder et obtenir une copie des informations personnelles",
        "Demander la correction de données inexactes",
        "Demander la suppression des enregistrements",
        "Retirer votre consentement aux communications marketing à tout moment"
      ],
      contactPreamble: "Les demandes peuvent être envoyées à"
    },
    security: {
      heading: "Sécurité des données",
      p1:
        "Routed Labs applique des mesures techniques et organisationnelles appropriées pour protéger les informations personnelles, notamment :",
      items: [
        "Chiffrement en transit et au repos",
        "Audits réguliers et évaluations de vulnérabilités",
        "Contrôles stricts d’accès et protocoles d’authentification",
        "Infrastructure et centres de données sécurisés"
      ]
    },
    contact: {
      heading: "Coordonnées",
      p1:
        "Les questions ou préoccupations concernant cette politique de confidentialité peuvent être adressées à :",
      company: "Routed Labs, Inc.",
      emailLabel: "E-mail :",
      addressLabel: "Adresse :",
      address: "451 Niantic Avenue, Daly City, CA 94014, États-Unis",
      subjectLabel: "Objet de la correspondance :",
      subject: "« Demande concernant la politique de confidentialité »"
    },
    updates: {
      heading: "Mises à jour de cette politique",
      p1:
        "Cette politique de confidentialité peut être révisée périodiquement pour refléter des changements opérationnels, légaux ou réglementaires. Les modifications importantes seront publiées sur cette page avec une date de « Dernière mise à jour » actualisée.",
      p2:
        "Les utilisateurs sont encouragés à consulter ce document régulièrement afin de rester informés sur la manière dont Routed Labs gère les informations personnelles."
    }
  }
},

tos: {
  title: "Conditions d’utilisation",
  subtitle:
    "Conditions juridiques régissant l’utilisation de la plateforme Airvoy et des services fournis par Routed Labs, Inc.",
  lastUpdated: { label: "Dernière mise à jour :", date: "1er août 2025" },
  sections: {
    agreement: {
      heading: "Acceptation des conditions",
      p1:
        "Ces Conditions d’utilisation (« Conditions ») constituent un accord juridiquement contraignant entre l’utilisateur (« vous ») et Routed Labs, Inc. (« Routed Labs », « nous », « notre » ou « nos ») concernant l’utilisation du site web, de l’application mobile Airvoy et des services eSIM associés (collectivement, le « Service »).",
      p2:
        "En accédant au Service ou en l’utilisant, vous reconnaissez avoir lu, compris et accepté d’être lié par ces Conditions. Si vous n’êtes pas d’accord, vous devez vous abstenir d’accéder ou d’utiliser le Service."
    },
    service: {
      heading: "Description du service",
      p1:
        "Le Service fournit une fonctionnalité eSIM (SIM intégrée) permettant aux utilisateurs d’accéder aux réseaux de données cellulaires à l’international. Les offres comprennent :",
      items: [
        "Profils eSIM numériques pour la connectivité mondiale",
        "Différentes options de forfaits de données avec diverses durées",
        "Livraison de codes QR pour l’activation et l’installation",
        "Assistance client pour les questions techniques",
        "Outils de gestion de compte pour les utilisateurs enregistrés"
      ],
      notice:
        "Important : Le Service nécessite un appareil compatible et déverrouillé. Nous ne garantissons pas la compatibilité avec tous les appareils ni la couverture dans toutes les zones géographiques."
    },
    eligibility: {
      heading: "Éligibilité",
      p1: "Pour utiliser le Service, vous déclarez et garantissez que vous :",
      items: [
        "Avez au moins 18 ans ou disposez du consentement parental",
        "Avez la capacité juridique de conclure un contrat contraignant",
        "Fournissez des informations d’inscription exactes et complètes",
        "Possédez ou êtes autorisé à utiliser un appareil compatible",
        "Respecterez les lois et réglementations applicables"
      ]
    },
    account: {
      heading: "Création de compte",
      p1:
        "Les utilisateurs peuvent acheter des eSIMs en tant que titulaires de compte enregistrés ou en tant qu’invités. L’inscription offre des fonctionnalités supplémentaires, notamment l’historique des achats et une assistance élargie.",
      registered: {
        title: "Comptes enregistrés",
        items: [
          "Adresse e-mail valide requise",
          "Responsabilité de maintenir la sécurité du compte",
          "Obligation de tenir les informations à jour",
          "Notification immédiate en cas d’accès non autorisé"
        ]
      },
      guest: {
        title: "Achats en tant qu’invité",
        items: [
          "Nécessite uniquement une adresse e-mail",
          "eSIM livrée par voie électronique",
          "Assistance limitée aux questions liées à l’achat",
          "Aucun historique d’achat conservé"
        ]
      }
    },
    payment: {
      heading: "Conditions de paiement",
      p1:
        "En finalisant un achat, vous autorisez Routed Labs et ses prestataires de paiement à débiter le moyen de paiement que vous fournissez. Les principales conditions incluent :",
      items: [
        "Tous les prix sont indiqués en dollars américains et incluent les taxes applicables",
        "Le paiement est exigible au moment de l’achat",
        "Le traitement des paiements est assuré par des prestataires tiers",
        "Le non-paiement peut entraîner la suspension du service"
      ]
    },
    refunds: {
      heading: "Politique de remboursement",
      p1: "Les demandes de remboursement sont examinées selon les conditions suivantes :",
      items: [
        "Éligible si demandé dans les 24 heures suivant l’achat",
        "Non éligible une fois que l’eSIM a été activée ou utilisée",
        "Les problèmes techniques seront examinés au cas par cas",
        "La compatibilité de l’appareil relève de la responsabilité de l’utilisateur"
      ],
      p2: {
        prefix: "Les demandes de remboursement doivent être envoyées à ",
        suffix: ", avec les détails de la commande et la raison fournie."
      }
    },
    limitations: {
      heading: "Limitations du service",
      p1: "Le Service est soumis à certaines limitations, notamment :",
      items: [
        "L’appareil doit être compatible eSIM et déverrouillé",
        "La couverture dépend des réseaux partenaires locaux",
        "La vitesse et la disponibilité varient selon l’emplacement",
        "Les données non utilisées expirent et ne sont pas reportées",
        "Les forfaits ne peuvent pas être transférés entre appareils"
      ]
    },
    prohibited: {
      heading: "Utilisations interdites",
      p1:
        "Vous acceptez de ne pas utiliser le Service à des fins illégales ou interdites, notamment mais sans s’y limiter :",
      items: [
        "Activité illégale ou violations réglementaires",
        "Harcèlement, abus ou activités frauduleuses",
        "Accès non autorisé au réseau ou interférences",
        "Revente ou partage d’identifiants sans consentement",
        "Utilisation excessive nuisant aux performances du réseau"
      ]
    },
    liability: {
      heading: "Limitation de responsabilité",
      p1:
        "Dans la mesure maximale permise par la loi, Routed Labs ne pourra être tenue responsable des dommages indirects, accessoires ou consécutifs résultant de votre utilisation du Service. La responsabilité totale ne dépassera pas le montant que vous avez payé pour le Service à l’origine de la réclamation au cours des douze (12) mois précédant celle-ci."
    },
    indemnity: {
      heading: "Indemnisation",
      p1:
        "Vous acceptez d’indemniser et de dégager de toute responsabilité Routed Labs et ses affiliés pour toute réclamation, dommage ou dépense résultant de votre mauvaise utilisation du Service ou de la violation de ces Conditions."
    },
    termination: {
      heading: "Résiliation",
      p1:
        "Nous pouvons suspendre ou résilier l’accès au Service immédiatement si vous enfreignez ces Conditions, adoptez un comportement illégal ou agissez d’une manière préjudiciable à Routed Labs ou à ses utilisateurs. En cas de résiliation, vos droits d’utilisation du Service cessent immédiatement."
    },
    law: {
      heading: "Droit applicable",
      p1:
        "Ces Conditions sont régies par les lois de l’État du Delaware, États-Unis. Vous acceptez de vous soumettre à la juridiction exclusive des tribunaux situés dans le Delaware pour la résolution des litiges."
    },
    amend: {
      heading: "Modifications",
      p1:
        "Routed Labs se réserve le droit de modifier ces Conditions à sa discrétion. Les mises à jour seront publiées sur le site web et prendront effet immédiatement, sauf indication contraire. La poursuite de l’utilisation du Service après les modifications vaut acceptation des Conditions révisées."
    },
    contact: {
      heading: "Coordonnées",
      p1: "Pour toute question concernant ces Conditions, veuillez contacter :"
    }
  }
},

about: {
  title: "À propos d’Airvoy",
  sections: {
    overview: {
      heading: "Aperçu",
      body:
        "Airvoy est une plateforme eSIM développée par Routed Labs, Inc. Elle offre aux voyageurs internationaux une connectivité mobile accessible, abordable et fiable. En éliminant le besoin de cartes SIM physiques, le service permet l’activation transparente de forfaits de données dans plus de 200 destinations."
    },
    mission: {
      heading: "Mission",
      body:
        "Routed Labs, Inc. poursuit une mission unique : simplifier la connectivité mobile. L’entreprise vise à supprimer l’incertitude, les coûts cachés et les obstacles logistiques liés à l’itinérance internationale et à l’achat de SIM, permettant ainsi aux voyageurs de rester connectés facilement."
    },
    background: {
      heading: "Contexte",
      p1:
        "Routed Labs, Inc. est basée à Daly City, Californie. La création de l’entreprise est née d’expériences directes des difficultés liées à la connectivité internationale, notamment les frais d’itinérance élevés et la disponibilité limitée des cartes SIM.",
      p2:
        "Face à ces défis, le fondateur a identifié l’opportunité de tirer parti de la technologie eSIM pour améliorer la connectivité mondiale.",
      p3:
        "Aujourd’hui, l’entreprise soutient des milliers d’utilisateurs dans le monde entier, avec un accent sur la fiabilité, la transparence et l’accessibilité."
    },
    operations: {
      heading: "Opérations",
      items: [
        { title: "Couverture mondiale :", desc: "Accès à des réseaux haut débit dans plus de 200 pays et territoires." },
        { title: "Provisionnement eSIM :", desc: "Installation numérique de forfaits en quelques minutes, sans carte SIM physique." },
        { title: "Orientation client :", desc: "Service et assistance conçus pour privilégier la clarté et répondre aux besoins des utilisateurs." }
      ]
    },
    corporate: {
      heading: "Informations légales",
      company: {
        title: "Détails de l’entreprise",
        nameLabel: "Nom de l’entreprise :",
        name: "Routed Labs, Inc.",
        repLabel: "Représentant :",
        rep: "Hector Diaz",
        addrLabel: "Adresse du siège :",
        addr: "451 Niantic Avenue, Daly City, CA 94014, États-Unis",
        contactLabel: "Contact :"
      },
      agent: {
        title: "Informations sur l’agent enregistré",
        nameLabel: "Nom de l’agent enregistré :",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "Adresse de l’agent enregistré :",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, États-Unis"
      }
    },
    comms: {
      heading: "Communications",
      p1: {
        prefix: "Pour les demandes officielles ou la correspondance, veuillez écrire à",
        suffix:
          ". Les correspondances légales et d’entreprise peuvent également être adressées à l’agent enregistré de la société, Legalinc Corporate Services Inc., à son adresse de Newark, Delaware."
      }
    }
  }
},

auth: {
  titles: {
    signin: 'Bon retour',
    signup: 'Créer un compte',
    forgot: 'Réinitialiser le mot de passe',
  },
  subtitles: {
    signin: 'Connectez-vous pour acheter des forfaits eSIM',
    signup: 'Rejoignez Airvoy dès aujourd’hui',
    forgot: 'Entrez votre e-mail pour réinitialiser votre mot de passe',
  },
  fields: {
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmez le mot de passe',
  },
  placeholders: {
    email: 'Entrez votre e-mail',
    password: 'Entrez votre mot de passe',
    confirmPassword: 'Confirmez votre mot de passe',
  },
  actions: {
    close: 'Fermer',
    continueWithGoogle: 'Continuer avec Google',
    signingIn: 'Connexion en cours...',
    pleaseWait: 'Veuillez patienter...',
    signIn: 'Se connecter',
    createAccount: 'Créer un compte',
    sendReset: 'Envoyer l’e-mail de réinitialisation',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
  },
  labels: {
    orEmail: 'Ou continuer avec un e-mail',
  },
  links: {
    noAccount: "Vous n’avez pas de compte ?",
    signUp: 'Inscrivez-vous',
    forgot: 'Mot de passe oublié ?',
    haveAccount: 'Vous avez déjà un compte ?',
    signIn: 'Se connecter',
    remembered: 'Vous vous souvenez de votre mot de passe ?',
    backToSignIn: 'Retour à la connexion',
  },
  messages: {
    resetSent: 'E-mail de réinitialisation du mot de passe envoyé ! Vérifiez votre boîte de réception.',
  },
  errors: {
    fillAll: 'Veuillez remplir tous les champs',
    userNotFound: 'Aucun compte trouvé avec cette adresse e-mail',
    wrongPassword: 'Adresse e-mail ou mot de passe incorrect',
    emailInUse: 'Un compte avec cet e-mail existe déjà',
    weakPassword: 'Le mot de passe est trop faible',
    invalidEmail: 'Adresse e-mail invalide',
    tooManyRequests: 'Trop de tentatives échouées. Veuillez réessayer plus tard',
    popupClosed: 'La fenêtre de connexion a été fermée avant la fin',
    popupCancelled: 'La connexion a été annulée',
    popupBlocked: 'La fenêtre de connexion a été bloquée par votre navigateur',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordMin: 'Le mot de passe doit contenir au moins 6 caractères',
    enterEmail: 'Veuillez entrer votre adresse e-mail',
    generic: 'Une erreur s’est produite. Veuillez réessayer',
  },
  legal: {
    prefix: 'En créant un compte, vous acceptez nos',
    terms: 'Conditions d’utilisation',
    and: 'et',
    privacy: 'Politique de confidentialité',
  },
},

support: {
  title: "Assistance",
  contactInfo: "Informations de contact",
  channels: {
    email: {
      title: "Assistance par e-mail",
      description: "Pour les demandes, signalements d’incidents et demandes d’assistance.",
      contact: "support@routedlabs.com",
      action: "Rédiger un e-mail"
    },
    chat: {
      title: "Chat en direct",
      description: "Assistance en temps réel pour les questions urgentes, selon disponibilité.",
      contact: "Disponible de 09h00 à 18h00, heure du Pacifique",
      action: "Ouvrir le chat"
    }
  },
  faqTitle: "Foire aux questions",
  noResults: "Aucune entrée ne correspond à la recherche actuelle.",
  categoryLabel: "Catégorie :",
  show: "Afficher",
  hide: "Masquer",
  noticesTitle: "Avis et correspondance",
  noticesLine1: {
    before: "Les demandes officielles et la correspondance doivent être adressées à",
    after: "."
  },
  noticesLine2:
    "Cette page a pour but de décrire les processus d’assistance et de fournir des documents de référence. Elle ne modifie ni ne remplace aucune condition d’utilisation ou politique applicable, qui prévalent dans tous les cas.",
  categories: {
    overview: "Aperçu de l’eSIM",
    compatibility: "Compatibilité des appareils",
    installation: "Installation",
    dualSim: "Double SIM",
    dataUsage: "Utilisation des données",
    planMgmt: "Gestion des forfaits",
    deviceReqs: "Exigences des appareils",
    troubleshooting: "Dépannage",
    refunds: "Remboursements",
    supportHours: "Disponibilité du support"
  },
  faqs: {
    1: {
      q: "Qu’est-ce qu’une eSIM et comment fonctionne-t-elle ?",
      a: "Une eSIM (SIM intégrée) est une carte SIM programmable intégrée à l’appareil qui permet d’activer un service cellulaire sans carte physique. Les utilisateurs configurent un profil numériquement et peuvent obtenir une connexion en scannant un code ou en suivant les étapes de configuration dans Airvoy."
    },
    2: {
      q: "Quels appareils prennent en charge la fonctionnalité eSIM ?",
      a: "De nombreux smartphones modernes intègrent la fonctionnalité eSIM, y compris les modèles récents des principaux fabricants. Vérifiez les paramètres de votre appareil (souvent sous « Données cellulaires » ou « Réseau mobile ») pour voir si l’option « Ajouter un forfait cellulaire » est disponible."
    },
    3: {
      q: "Comment une eSIM est-elle installée ?",
      a: "Après l’achat, vous recevez les instructions d’installation et un code QR par e-mail. Sur votre appareil, accédez à Réglages → Données cellulaires/Réseau mobile → Ajouter un forfait cellulaire et scannez le code. L’activation se termine automatiquement après les invites."
    },
    4: {
      q: "Peut-on utiliser une carte SIM physique et une eSIM simultanément sur le même appareil ?",
      a: "La plupart des appareils compatibles eSIM prennent en charge la double SIM. Vous pouvez conserver votre numéro principal pour les appels et messages tout en utilisant l’eSIM pour les données. Le choix se fait dans les paramètres de l’appareil."
    },
    5: {
      q: "Que se passe-t-il si les données allouées ne sont pas entièrement utilisées ?",
      a: "Les données non utilisées ne sont ni reportées ni remboursables. Les forfaits expirent à la fin de leur période de validité. Choisissez un forfait adapté à votre consommation prévue lors de votre voyage."
    },
    6: {
      q: "Est-il possible d’ajouter des données ou de prolonger un forfait actif ?",
      a: "Oui. Vous pouvez acheter des données supplémentaires ou prolonger le service en achetant un autre forfait sur le site web ou via votre compte, sous réserve de disponibilité pour la destination."
    },
    7: {
      q: "L’appareil doit-il être désimlocké ?",
      a: "Oui. Pour utiliser une eSIM d’un autre fournisseur que l’opérateur d’origine, votre appareil doit être désimlocké. S’il est verrouillé, contactez votre opérateur pour demander un déverrouillage avant l’activation."
    },
    8: {
      q: "Que faire si l’eSIM ne fonctionne pas comme prévu ?",
      a: "Vérifiez que l’appareil est désimlocké et compatible eSIM. Assurez-vous que l’itinérance des données est activée, que le bon forfait est sélectionné et essayez de redémarrer l’appareil. Si le problème persiste, contactez l’assistance."
    },
    9: {
      q: "Les remboursements sont-ils possibles ?",
      a: "Des remboursements peuvent être accordés dans les 24 heures suivant l’achat si l’eSIM n’a pas été activée ou utilisée. Une fois activée, la vente est définitive. Pour les problèmes techniques, le support tentera une résolution ou accordera un crédit sur le compte si nécessaire."
    },
    10: {
      q: "Quelles sont les heures d’assistance et les délais de réponse attendus ?",
      a: "L’assistance par e-mail est disponible en continu. Les délais de réponse typiques sont de quelques heures. Les problèmes urgents signalés lors de vos déplacements reçoivent une priorité accrue."
    }
  }
}

  },
  de: {
    // Navigation
nav: {
  installEsim: "eSIM installieren",
  admin: "Geschäftskunden",
  faqs: "FAQs",
  browsePlans: "Tarife durchsuchen",
  partnerships: "Partnerschaften",
  dashboard: "Dashboard",
  signOut: "Abmelden",
  signIn: "Anmelden",
  getTheApp: "App herunterladen"
},

    // Hero Section
hero: {
  badge: "Schließe dich über 30.000 Reisenden an, die Airvoy eSIM nutzen.",
  title: "Das globale",
  titleHighlight: "eSIM",
  subtitle: "Bleib verbunden, als wärst du zu Hause – sofortige Einrichtung, flexible Daten und weltweite Abdeckung in über 200 Ländern.",
  searchPlaceholder: "Wohin reist du?",
  appStore: "App Store",
  googlePlay: "Google Play"
},

    // Popular Countries
popularCountries: {
  title: "Beliebte Reiseziele",
  subtitle: "Sofort verbunden an diesen Top-Reisezielen",
  fromPrice: "Ab",
  perDay: "/Tag",
  unlimited: "Unbegrenzt",
  startingAt: "Ab",
  getStarted: "Loslegen",
  viewAllCountries: "Alle Länder anzeigen",
  noPlansAvailable: "Keine unbegrenzten Tarife verfügbar"
},

    // How It Works
howItWorks: {
  title: "So funktioniert Airvoy eSIM",
  subtitle: "In drei einfachen Schritten verbunden sein",
  step1Title: "Wähle dein Reiseziel",
  step1Desc: "Durchsuche über 200 Reiseziele mit transparenten Preisen. Keine versteckten Gebühren, keine Überraschungen – nur der perfekte Tarif für dein Abenteuer.",
  step2Title: "In Sekunden installieren",
  step2Desc: "Erhalte deine eSIM sofort per E-Mail. Einfach den QR-Code scannen und loslegen – kein Ladenbesuch oder SIM-Kartentausch nötig.",
  step3Title: "Automatisch verbinden",
  step3Desc: "Landen und sofort verbunden sein. Deine eSIM aktiviert sich automatisch bei Ankunft – Schluss mit der Suche nach Flughafen-WLAN.",
  learnMore: "Mehr erfahren"
},

    // Benefits
benefits: {
  whyAirvoy: "Warum Airvoy?",
  title: "Bleib überall verbunden, wo du hingehst",
  item1Title: "Finde den passenden Tarif",
  item1Desc: "Flexible Datentarife, die zu deinem Budget passen. Von einem wöchentlichen 1-GB-Tarif bis zu 100 GB für ein halbes Jahr – alles in einer App.",
  item2Title: "Einfach zu benutzen",
  item2Desc: "Lade einfach Airvoy herunter, installiere die eSIM und wähle einen Datentarif – sie wird automatisch aktiviert, sobald du dein Ziel erreichst.",
  item3Title: "Roaming-Kosten vermeiden",
  item3Desc: "Versteckte Roaming-Gebühren gehören der Vergangenheit an. Wisse genau, wie viel deine Internetverbindung kostet, bevor du reist!",
  item4Title: "Eine eSIM für alle Reisen",
  item4Desc: "Füge neue Reiseziele zu deiner bestehenden Airvoy eSIM hinzu – keine neuen eSIMs bei jeder Reise nötig. Einfach aufladen und verbinden!",
  item5Title: "Nie ohne Daten",
  item5Desc: "Geh kein Risiko ein, ohne Daten dazustehen – wir benachrichtigen dich, wenn du 80 % deines Tarifs verbraucht hast.",
  item6Title: "+200 Länder",
  item6Desc: "Bleib online in über 200 Ländern und Regionen weltweit."
},

    // Videos
videos: {
  title: "Ansehen & schnell verbunden sein",
  subtitle: "Zwei kurze Anleitungen – eine für iPhone, eine für Samsung.",
  iPhoneTitle: "eSIM-Einrichtung & Aktivierung — iPhone",
  iPhoneDesc: "Schritt-für-Schritt-Anleitung zur Installation und Aktivierung deiner Airvoy eSIM auf dem iPhone. Scannen, installieren und in Minuten online sein.",
  samsungTitle: "eSIM-Einrichtung & Aktivierung — Samsung",
  samsungDesc: "Erfahre, wie du deine Airvoy eSIM auf Samsung Galaxy-Geräten hinzufügst. Eine schnelle, klare Anleitung von der Installation bis zur ersten Verbindung.",
  iOSGuide: "iOS-Anleitung",
  samsungGuide: "Samsung-Anleitung",
  installationGuide: "Oder lies die vollständige Installationsanleitung"
},

    // Footer
footer: {
  description: "Schließe dich über 30.000 Reisenden an, die Airvoy eSIM nutzen. Reise smart, bleib verbunden – egal wohin deine Reise geht.",
  company: "Unternehmen",
  aboutUs: "Über uns",
  resources: "Ressourcen",
  documentation: "Dokumentation",
  support: "Support",
  legal: "Rechtliches",
  privacyPolicy: "Datenschutzerklärung",
  termsOfService: "Nutzungsbedingungen",
  followUs: "Folge uns",
  copyright: "Alle Rechte vorbehalten.",
  madeWith: "Gemacht mit",
  forTravelers: "für Reisende weltweit"
},

    // Auth
aut: {
  authenticationRequired: "Authentifizierung erforderlich",
  signInPrompt: "Bitte melde dich an, um auf das Dashboard zuzugreifen und eSIM-Tarife zu kaufen."
},

    // Common
common: {
  close: "Schließen",
  loading: "Lädt...",
  tryAgain: "Erneut versuchen",
  noResults: "Keine Länder gefunden für"
},

activate: {
  altText: "Airvoy eSIM globale Aktivierung",
  activeInThailand: "Airvoy aktiv in Thailand",
  activeInSpain: "Airvoy aktiv in Spanien", 
  activeWorldwide: "Airvoy weltweit aktiv",
  activeInGreece: "Airvoy aktiv in Griechenland",
  activeInMexico: "Airvoy aktiv in Mexiko",
  title: "Behalte deine WhatsApp-Nummer",
  description: "Du kannst alle deine Kontakte auf WhatsApp anrufen und ihnen schreiben, als wärst du im selben Land.\nVerliere nicht den Kontakt zu Familie und Freunden."
},

regionalPlans: {
  multiCountryCoverage: "Abdeckung in mehreren Ländern",
  title: "Regionale Tarife", 
  subtitle: "Wähle eine Region und dann die gewünschte Laufzeit/Datenmenge.",
  noPlansAvailable: "Keine regionalen Tarife verfügbar.",
  from: "Ab",
  seePlans: "Tarife ansehen",
  countries: "Länder",
  plans: "Tarife", 
  startingFrom: "Ab",
  browseOptions: "Optionen durchsuchen",
  viewPlans: "Tarife anzeigen"
},

partnerships: {
  headerLabel: "PARTNERSCHAFTEN",
  title: "Airvoy Partnerschaften",
  subtitle: "Lass uns zusammenarbeiten und Großes erreichen.",
  join: "Beitreten",
  airvoyAffiliate: "Airvoy\nAffiliate-Programm", 
  affiliateDescription: "Verdiene bis zu 20 % Provision, indem du Airvoy eSIM bewirbst – tritt noch heute unserem offiziellen Affiliate-Netzwerk bei!",
  joinNow: "Jetzt beitreten!",
  learnMore: "Mehr erfahren",
  partnershipImageAlt: "Airvoy Partnerschaft",
  
  // Partnership types
  affiliateProgram: "Affiliate-Programm",
  eventPartnership: "Event-Partnerschaft", 
  travelPartnership: "Reisepartnerschaft",
  contentPartnership: "Content-Partnerschaft",
  sportsPartnership: "Sport-Partnerschaft",
  musicCulturePartnership: "Musik- & Kulturpartnerschaft",
  athleteCollaboration: "Athleten-Kooperation",
  other: "Andere",
  
  // Partnership descriptions
  eventPartnerships: "Event-Partnerschaften",
  eventDescription1: "Organisierst du ein internationales Event und möchtest deinen Gästen einen super nützlichen Vorteil bieten: kostenloses mobiles Internet?",
  eventDescription2: "Wir können die perfekte Lösung für dich und deine Gäste maßschneidern, damit sie vor, während und nach dem Event nahtlos verbunden bleiben.",
  
  travelPartnerships: "Reisepartnerschaften",
  travelDescription1: "Möchtest du deinen Kunden und Mitarbeitern günstiges und nahtloses mobiles Internet und Sprachdienste für Auslandsreisen anbieten?",
  travelDescription2: "Mit unserer integrierten Konnektivitätslösung kannst du deinen Kunden mühelos Mehrwert-Reiselösungen mit maximalem Nutzen bieten.",
  
  contentPartnerships: "Content-Partnerschaften", 
  contentDescription1: "Bist du Content Creator in den sozialen Medien mit kreativen Ideen, einem engagierten Publikum und einem Blick für nützliche #TravelHacks und #LifeHacks?",
  contentDescription2: "Oder liebst du einfach Airvoy und möchtest anderen helfen, nahtlose mobile Konnektivität weltweit zu genießen?",
  
  sportsPartnerships: "Sport-Partnerschaften",
  sportsDescription1: "Organisierst du einen Sportwettbewerb und möchtest Athleten, Teams und Fans eine zuverlässige Verbindung während des gesamten Events bieten?",
  sportsDescription2: "Kooperiere mit Airvoy, um nahtlose mobile Datenlösungen bereitzustellen, die alle von der Eröffnungsfeier bis zum Schlusspfiff verbinden.",
  
  musicCulturePartnerships: "Musik- & Kulturpartnerschaften",
  musicDescription1: "Organisierst du ein Musikfestival, eine kulturelle Veranstaltung oder eine Live-Performance und möchtest das Erlebnis für die Besucher verbessern?",
  musicDescription2: "Airvoy kann deinem Publikum zuverlässige mobile Datendienste bieten, damit sie teilen, streamen und verbunden bleiben, während sie das Event genießen.",
  
  athleteCollaborations: "Athleten-Kooperationen",
  athleteDescription1: "Bist du ein Athlet, der von Wettbewerb zu Wettbewerb um die Welt reist und keinen Platz mehr in der Trophäensammlung hat?",
  athleteDescription2: "Kooperiere mit Airvoy, um überall verbunden zu bleiben und deine Reise mit deinen Fans zu teilen, egal wo du bist.",
  
  letsTalk: "Lass uns reden",
  
  // Contact form
  getInTouch: "Kontaktiere uns",
  successMessage: "Danke für deine Nachricht! Wir melden uns bald bei dir.",
  errorMessage: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  emailPlaceholder: "E-Mail-Adresse eingeben",
  fullNamePlaceholder: "Vollständiger Name",
  partnerTypePlaceholder: "Woran möchtest du mit uns zusammenarbeiten?",
  messagePlaceholder: "Erzähle uns kurz, was du im Sinn hast",
  privacyConsent: "Du stimmst unserer freundlichen",
  privacyPolicy: "Datenschutzrichtlinie",
  sending: "Wird gesendet...",
  send: "Senden"
},

faq: {
  headerLabel: "FAQ",
  title: "Finde Antworten auf einige der am häufigsten gestellten Fragen",
  learnMore: "Mehr erfahren",
  
  whatIsEsim: {
    question: "Was ist eine eSIM?",
    answer: "Eine eSIM ist eine standardisierte digitale SIM, mit der du einen Mobilfunktarif von deinem Anbieter aktivieren kannst, ohne eine physische SIM-Karte zu benötigen. Auf einem iPhone kannst du acht oder mehr eSIMs installieren und zwei Telefonnummern gleichzeitig nutzen."
  },
  
  howToSetup: {
    question: "Wie richte ich meine eSIM ein?",
    answer: "Die eSIM-Technologie ist sehr praktisch. Die Einrichtung kann jedoch etwas mühsam sein, besonders wenn du es zum ersten Mal machst. Aber keine Sorge – wir haben hier Schritt-für-Schritt-Anleitungen, damit du im Handumdrehen mit Airvoy startest."
  },
  
  whatIsAirvoy: {
    question: "Was ist Airvoy?",
    answer: "Airvoy ist eine mobile App, die globale mobile Konnektivitätslösungen bietet. Sie ermöglicht dir, nahtlos verbunden zu bleiben, wenn du reist – ganz ohne physische SIM-Karten oder teure Roaming-Gebühren."
  },
  
  howSaveRoaming: {
    question: "Wie hilft mir Airvoy, Roaming-Gebühren zu sparen?",
    answer: "Airvoy bietet mobile Daten zu Preisen an, die bis zu 90 % günstiger sind als typische Roaming-Gebühren. So kannst du die hohen Kosten traditioneller Roaming-Dienste vermeiden."
  },
  
  needNewSim: {
    question: "Muss ich mit Airvoy jedes Mal eine neue SIM-Karte kaufen, wenn ich reise?",
    answer: "Nein, Airvoy nutzt eSIM-Technologie, das heißt, es ist keine physische SIM-Karte erforderlich. Die Airvoy eSIM ist global, was bedeutet, dass du sie nach der Installation und Aktivierung weltweit nutzen kannst – oder du kaufst bei Bedarf neue Pläne für bestimmte Länder."
  },
  
  constantConnectivity: {
    question: "Wie stellt Airvoy eine konstante Verbindung sicher, wenn ich reise?",
    answer: "Airvoy bietet mobile Daten zu Preisen, die bis zu 90 % günstiger sind als typische Roaming-Gebühren. So kannst du die hohen Kosten traditioneller Roaming-Dienste vermeiden."
  },
  
  freeCallsTexts: {
    question: "Bietet Airvoy kostenlose Anrufe und SMS an?",
    answer: "Noch nicht. Aber Airvoy wird bald kostenlose Anrufe und Nachrichten zwischen Airvoy-Nutzern anbieten. So kannst du mit anderen Airvoy-Nutzern ohne zusätzliche Kosten in Kontakt bleiben."
  },
  
  whyChooseAirvoy: {
    question: "Warum sollte ich Airvoy anderen Roaming-Alternativen vorziehen?",
    answer: "Du solltest Airvoy wählen, weil es nahtlose globale Konnektivität mit nur einer eSIM, ein kosteneffizientes Modell und zusätzliche Funktionen wie Messaging (bald) und lokale Nummern (bald) in einer benutzerfreundlichen App bietet. Es ist günstig, einfach und gibt dir volle Kontrolle darüber, wie du dich verbinden möchtest – egal wohin du reist."
  }
},

browse: {
  main: {
    title: "eSIM-Tarife durchsuchen",
    subtitle: "Entdecke eSIM-Tarife für Reiseziele weltweit mit aktuellen Preisen"
  },
  search: {
    placeholder: "Länder suchen (z. B. Vereinigte Staaten, Spanien, Japan)...",
    clearSearch: "Suche löschen",
    noCountriesFound: "Keine Länder gefunden, die deiner Suche entsprechen.",
    noCountriesAvailable: "Keine Länder verfügbar.",
    clearSearchButton: "Suche löschen",
    searching: "Länder werden gesucht...",
    country: "Land",
    countries: "Länder",
    foundFor: "gefunden für"
  },
  loading: {
    loadingText: "Wird geladen...",
    allCountriesLoaded: "Alle Länder geladen",
    total: "Gesamt"
  },
  buttons: {
    showMoreCountries: "Mehr Länder anzeigen",
    showLessPlans: "Weniger Tarife anzeigen",
    showLess: "Weniger anzeigen",
    seeMorePlans: "Mehr Tarife ansehen",
    more: "mehr",
    buyNow: "Jetzt kaufen"
  },
  navigation: {
    backToCountries: "Zurück zu den Ländern"
  },
  countryDetails: {
    description: "Entdecke {{country}} flexibel mit unseren eSIM-Datentarifen. Egal, ob du für einen kurzen Aufenthalt oder eine längere Reise unterwegs bist – unsere Tarife halten dich mühelos verbunden."
  },
  plans: {
    noPlansAvailable: "Keine Tarife für die ausgewählten Filter verfügbar.",
    planDetails: "Tarifdetails",
    details: "Details",
    unlimited: "Unbegrenzt",
    for: "Für",
    day: "Tag",
    days: "Tage"
  },
  checkout: {
    total: "Gesamt"
  },
  planDetails: {
    title: "Tarifdetails",
    unlimitedData: "Unbegrenzte Daten",
    data: "Daten",
    country: "Land",
    duration: "Dauer",
    day: "Tag",
    days: "Tage",
    network: "Netzwerk",
    autoStart: "Automatischer Start",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    planType: "Tariftyp",
    description: "Beschreibung",
    purchaseThisPlan: "Diesen Tarif kaufen",
    signInToPurchase: "Zum Kauf anmelden"
  }
},

installation: {
  title: "Wie installiere und richte ich meine eSIM ein?",
  metaUpdated: "Vor 2 Monaten • Aktualisiert",
  intro: {
    p1: "Egal, ob du Android oder Apple nutzt, überprüfe zuerst, ob dein Telefon eSIM-kompatibel und netzwerkentsperrt ist. Du benötigst außerdem eine stabile Internetverbindung (vorzugsweise WLAN).",
    p2: "Dann kannst du entweder:",
    ol1: "Den QR-Code für die automatische Installation scannen",
    ol2: "Deine eSIM manuell installieren",
    note: "Die Installation mit einem QR-Code ist der einfachste Weg."
  },
  ios: {
    qr: {
      title: "Installiere deine eSIM mit dem QR-Code (iOS)",
      s1: "1. Gehe zu Einstellungen > Mobile Daten",
      s2: "2. Tippe auf „eSIM hinzufügen“ und wähle QR-Code verwenden",
      s3: "3. Scanne den QR-Code und gib bei Aufforderung den 4-stelligen Bestätigungscode ein",
      s4: "4. Benenne deine eSIM und wähle „Nur mobile Daten“ unter Standardleitung",
      s5: "5. Du solltest deine eSIM jetzt unter „Mobile Daten“ sehen"
    },
    manual: {
      title: "So installierst du deine eSIM manuell (iOS)",
      s1: "1. Einstellungen > Mobile Daten > eSIM hinzufügen",
      s2: "2. Tippe auf „eSIM hinzufügen“ und wähle QR-Code verwenden",
      s3: "3. Tippe statt Scannen auf Details manuell eingeben",
      s4: "4. Gib die SM-DP+ Adresse, den Aktivierungscode und den optionalen Bestätigungscode aus deiner Airvoy-App ein",
      s5: "5. Benenne deine eSIM und wähle „Nur mobile Daten“ unter Standardleitung",
      s6: "6. Du solltest deine eSIM jetzt unter Mobile Daten sehen"
    }
  },
  android: {
    qr: {
      title: "Installiere deine eSIM mit dem QR-Code (Android)",
      s1: "1. Gehe zu Einstellungen > Netzwerk & Internet > SIMs",
      s2: "2. Tippe auf das „+“-Symbol rechts neben „SIMs“",
      s3: "3. Tippe unten auf „Stattdessen eine SIM herunterladen?“",
      s4: "4. Tippe bei „Lade deine SIM herunter“ auf „Weiter“ — es wird „Netzwerkinfo wird überprüft...“ angezeigt",
      s5: "5. Nach der Prüfung erscheint ein Sucher, um deinen QR-Code zu scannen",
      s6: "6. Richte ihn auf einen gedruckten QR-Code oder ein anderes Gerät, das den Code anzeigt",
      s7: "7. Nach dem Scannen prüft dein Gerät die Informationen erneut",
      s8: "8. Tippe auf „Herunterladen“, um zu bestätigen — die eSIM-Daten werden heruntergeladen",
      s9: "9. Nach Abschluss siehst du „Download abgeschlossen“",
      s10: "10. Richte die eSIM für den Internetzugang ein, wenn du bereit bist."
    }
  },
  notes: {
    title: "Wichtige Hinweise",
    n1: "Stelle sicher, dass dein Gerät eSIM-kompatibel und netzwerkentsperrt ist",
    n2: "Während der Installation wird eine stabile WLAN-Verbindung benötigt",
    n3: "Die eSIM kann nur einmal installiert werden — starte, wenn du bereit bist",
    n4: "Lass deine primäre SIM aktiv für Anrufe und SMS von deiner Heimatnummer",
    n5: "Deine eSIM wird aktiviert, sobald du im Zielland ankommst"
  },
  support: {
    title: "Brauchst du Hilfe?",
    body: "Wenn du Probleme bei der Installation deiner eSIM hast, ist unser Support-Team für dich da!",
    emailLabel: "E-Mail:",
    websiteLabel: "Webseite:"
  }
},

installGuide: {
  header: {
    title: "Vollständige eSIM-Installationsanleitung",
    subtitle: "Alles, was du wissen musst, um deine eSIM zu installieren, zu aktivieren und für nahtlose globale Konnektivität zu nutzen. Folge unseren gerätespezifischen Anweisungen für die reibungsloseste Einrichtung.",
    link: "Sieh dir die detaillierte Anleitung zur Installation auf Android an",
    ios: "Detaillierte Anleitung für iOS",
        android: "Detaillierte Anleitung für Android"
  },
  iphoneHero: "Installiere und aktiviere deine eSIM auf dem iPhone",
  cards: {
    c1: {
      alt: "iPhone mit Kippschalter und Uhrsymbol",
      install: "Installieren",
      activate: "aktivieren",
      textA: "einige Stunden vor deiner Reise und",
      textB: "während des Flugs oder nach Ankunft am Zielort."
    },
    c2: {
      alt: "iPhone mit QR-Code-Scanner-Oberfläche",
      line1: "Wähle „Mit QR-Code installieren“",
      line2: "wenn du den Code auf einem anderen Gerät hast,",
      line3: "um ihn zu scannen."
    },
    c3: {
      alt: "iPhone mit manueller Installationsoberfläche",
      line1: "Wähle „Manuell installieren“",
      line2: "wenn du den QR-Code nicht scannen kannst."
    }
  },
  learn: {
    title: "Schritt für Schritt lernen",
    subtitle: "Wähle die Art der Installation, die du durchführen möchtest",
    btnQr: "Installation mit QR-Code",
    btnManual: "Manuelle Installation"
  },
  prep: {
    alt: "Handy-Warnsymbol",
    qr: {
      title: "Bevor du die Installation mit einem QR-Code beginnst, gibt es einige wichtige Punkte zu beachten:",
      i1: "Du musst den QR-Code auf einem anderen Bildschirm oder Gerät haben, um ihn mit der Kamera deines Telefons zu scannen.",
      i2: "Stelle sicher, dass du während des gesamten Prozesses eine stabile Internetverbindung hast.",
      i3: "Bitte beachte, dass der QR-Code nur einmal gescannt werden kann.",
      i4: "Entferne die eSIM nicht von deinem Gerät, da du sie dann nicht erneut verwenden kannst."
    },
    manual: {
      title: "Bevor du die manuelle Installation beginnst, gibt es einige wichtige Punkte zu beachten:",
      i1: "Manuelle Installationscodes können nur einmal verwendet werden."
    },
    shared: {
      i2: "Stelle sicher, dass du während des gesamten Prozesses eine stabile Internetverbindung hast.",
      i3: "Entferne die eSIM nicht von deinem Gerät, da du sie dann nicht erneut verwenden kannst."
    }
  },
  start: {
    title: "Lass uns gemeinsam starten",
    c1: {
      title: "Öffne deine E-Mail",
      qr: { p1: "Öffne deine E-Mail auf einem anderen Gerät als dem, das du für die Installation verwenden wirst, und suche die E-Mail mit dem QR-Code, die wir dir geschickt haben." },
      manual: { p1: "Überprüfe die E-Mail, die wir dir mit der „SM-DP+ Adresse“ und dem „Aktivierungscode“ geschickt haben, und halte sie bereit, um die Installation zu starten. Wir senden sie dir auch als SMS." },
      shared: { missing: "Wenn du deine Codes nicht erhalten hast, bitte", contact: "kontaktiere uns" }
    },
    c2: {
      qr: { title: "Scanne den QR-Code", p1: "Öffne die Kamera auf dem iPhone, auf dem du die eSIM installieren möchtest, und scanne den Code. Du kannst auch zu Einstellungen → Mobile Daten gehen und „Mobilfunktarif hinzufügen“ auswählen, um von dort zu scannen." },
      manual: { title: "Öffne „Einstellungen“ auf deinem iPhone", p1: "Gehe zu Mobile Daten, tippe auf „eSIM hinzufügen“ oder „Mobilfunktarif hinzufügen“ und wähle „QR-Code verwenden“. Wähle dann „Details manuell eingeben“, wenn du dazu aufgefordert wirst." }
    },
    c3: {
      title: "Folge den Installationsschritten auf deinem iPhone",
      qr: { p1: "Das Scannen des Codes startet den Installationsprozess. Verwende unsere Anleitung unten für die schrittweise Konfiguration." },
      manual: { p1: "Wenn du zu „QR-Code scannen“ kommst, wähle „Details manuell eingeben“ und folge den Anweisungen auf deinem iPhone." }
    }
  },
  compat: {
    title: "Gerätekompatibilitäts-Checker",
    subtitle: "Prüfe, ob dein Gerät eSIM-Technologie unterstützt. Verwende die Suchfunktion, um schnell dein spezifisches Modell zu finden.",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "iPhone/iPad-Modelle suchen...",
    searchAndroid: "Android-Modelle suchen...",
    iphones: "Kompatible iPhones",
    ipads: "Kompatible iPads (nur 4G)",
    androids: "Kompatible Android-Geräte",
    noMatch: "Keine Geräte gefunden, die deiner Suche entsprechen.",
    iosNotesTitle: "Wichtige Hinweise:",
    iosNotes: {
      i1: "iPhone 13 und 14 Modelle können zwei eSIMs gleichzeitig aktivieren",
      i2: "iPhones aus Festlandchina und Hongkong unterstützen keine eSIM (außer einige Modelle)",
      i3: "iPhone 14+ Modelle, die in den USA verkauft werden, unterstützen keine physischen SIM-Karten"
    },
    androidNotesTitle: "Wichtige Einschränkungen:",
    androidNotes: {
      i1: "Samsung-Geräte aus den USA und Hongkong unterstützen möglicherweise keine eSIM",
      i2: "Google Pixel-Geräte aus Australien, Japan und Taiwan unterstützen keine eSIM",
      i3: "In Hongkong verkaufte Telefone unterstützen in der Regel keine eSIM",
      i4: "Das Gerät muss entsperrt sein, um eSIM nutzen zu können"
    },
    empty: "Beginne mit der Eingabe deines Gerätemodells, um die Kompatibilität zu prüfen"
  },
  tips: {
    title: "Profi-Tipps: Vor der Reise aktivieren",
    body: "Für ein reibungsloses Reiseerlebnis installiere deine eSIM vor der Abreise und aktiviere sie bei Ankunft. So bist du sofort verbunden, ohne nach WLAN oder lokalen SIM-Karten suchen zu müssen.",
    before: {
      title: "Vor der Abreise",
      i1: "Installiere das eSIM-Profil zu Hause",
      i2: "Teste den Installationsprozess",
      i3: "Bewahre einen Screenshot deines QR-Codes als Backup auf",
      i4: "Stelle sicher, dass dein Gerät entsperrt ist"
    },
    after: {
      title: "Nach der Ankunft",
      i1: "Aktiviere die mobilen Daten für deine eSIM",
      i2: "Warte 2–3 Minuten auf die Netzregistrierung",
      i3: "Teste die Verbindung mit einer Websuche",
      i4: "Aktiviere Datenroaming, falls erforderlich"
    }
  },
  support: {
    title: "Benötigst du zusätzliche Unterstützung?",
    body: "Unser Expertenteam unterstützt dich bei jedem Schritt. Von Fragen zur Gerätekompatibilität bis hin zur Installationshilfe – wir sind für dich da.",
    btnEmail: "E-Mail-Support",
    btnCenter: "Support-Center besuchen"
  },
  steps: {
    ios: {
      s1: { title: "Einstellungen öffnen", desc: "Gehe zu Einstellungen → Mobilfunk (oder Mobile Daten in manchen Regionen)", detail: "Suche die Option „Mobilfunk“ im Hauptmenü der Einstellungen. In manchen Ländern heißt sie „Mobile Daten“." },
      s2: { title: "Mobilfunktarif hinzufügen", desc: "Tippe auf „Mobilfunktarif hinzufügen“ oder „eSIM hinzufügen“", detail: "Diese Option erscheint unten auf der Mobilfunk-Seite. Wenn du sie nicht siehst, unterstützt dein Gerät möglicherweise keine eSIM." },
      s3: { title: "QR-Code scannen", desc: "Wähle „QR-Code verwenden“ und scanne den Code aus deiner E-Mail", detail: "Halte die Kamera ruhig und achte auf gute Beleuchtung, bis der Code erkannt wird." },
      s4: { title: "Mobilfunktarif hinzufügen", desc: "Tippe auf „Mobilfunktarif hinzufügen“, wenn die Tarifdetails angezeigt werden", detail: "Überprüfe die Anbieterinformationen und Tarifdetails, bevor du bestätigst. Dieser Schritt lädt dein eSIM-Profil herunter." },
      s5: { title: "Pläne beschriften", desc: "Wähle Bezeichnungen für deine Pläne (z. B. „Primär“, „Reise“, „Sekundär“)", detail: "Dies hilft dir, zu erkennen, welchen Plan du für Daten, Anrufe und Nachrichten verwenden möchtest. Die meisten Reisenden nutzen eSIM nur für Daten." },
      s6: { title: "Standardleitung konfigurieren", desc: "Wähle, welche Leitung du für mobile Daten verwenden möchtest", detail: "Du kannst deine eSIM für Daten verwenden und deine ursprüngliche SIM für Anrufe und SMS behalten." }
    },
    android: {
      s1: { title: "Einstellungen öffnen", desc: "Gehe zu Einstellungen → Netzwerk & Internet → SIMs", detail: "Der genaue Pfad kann je nach Hersteller variieren. Auf Samsung-Geräten z. B. Einstellungen → Verbindungen → SIM-Kartenverwaltung." },
      s2: { title: "Mobilfunktarif hinzufügen", desc: "Tippe auf die „+“-Taste oder „Mobilfunktarif hinzufügen“", detail: "Suche nach Optionen wie „Mobilfunktarif hinzufügen“, „Stattdessen SIM herunterladen“ oder „Anbieter hinzufügen“, je nach Gerät." },
      s3: { title: "SIM herunterladen", desc: "Wähle „Keine SIM-Karte?“ oder „Stattdessen SIM herunterladen“", detail: "Damit teilst du deinem Telefon mit, dass du eine eSIM installieren möchtest, anstatt eine physische SIM einzusetzen." },
      s4: { title: "QR-Code scannen", desc: "Wähle „QR-Code scannen“ und richte deine Kamera auf den Code", detail: "Achte auf gute Beleuchtung und halte die Kamera ruhig, bis der QR-Code erkannt wird." },
      s5: { title: "Profil herunterladen", desc: "Tippe auf „Herunterladen“, wenn das Anbieterprofil erscheint", detail: "Dein Gerät verbindet sich mit dem Internet, um das eSIM-Profil herunterzuladen. Dies kann einige Minuten dauern." },
      s6: { title: "eSIM aktivieren", desc: "Aktiviere die eSIM und wähle sie als bevorzugte Datenverbindung aus", detail: "Du kannst auswählen, welche SIM für Daten, Anrufe und SMS verwendet wird. Die meisten Reisenden nutzen eSIM nur für Daten." }
    }
  }
},

profile: {
  loading: "Dein Profil wird geladen…",
  errors: {
    load: "Deine eSIMs konnten nicht geladen werden",
    delete: "eSIM konnte nicht gelöscht werden. Bitte versuche es erneut.",
    bundle: "Bundle-Status konnte nicht abgerufen werden",
    network: "Netzwerkfehler beim Abrufen des Bundle-Status",
    invoice: "Rechnung konnte nicht heruntergeladen werden"
  },
  auth: {
    title: "Authentifizierung erforderlich",
    subtitle: "Bitte melde dich an, um dein Profil und deine eSIM-Historie zu sehen.",
    cta: "Anmelden"
  },
  header: {
    fallback: "Benutzerprofil",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} gekauft"
  },
  list: {
    title: "Deine eSIMs",
    subtitle: "Verwalte deine gekauften Profile und greife auf QR-Codes & Rechnungen zu.",
    total: "{{count}} insgesamt"
  },
  empty: {
    title: "Noch keine eSIMs",
    subtitle: "Durchsuche unsere Tarife, um in Sekunden verbunden zu sein – keine physische SIM erforderlich.",
    cta: "Tarife durchsuchen",
    tip: "Tipp: Du kannst eine eSIM vor deiner Reise installieren und sie bei Ankunft aktivieren."
  },
  item: {
    country: "Land",
    statusTitle: "Aktueller Status",
    pricePaid: "Bezahlter Preis",
    purchaseDate: "Kaufdatum"
  },
  actions: {
    details: "Details anzeigen",
    showQr: "QR anzeigen",
    invoice: "Rechnung"
  },
  hint: "Brauchst du Hilfe bei der Installation einer eSIM? Auf iOS: Einstellungen → Mobilfunk → eSIM hinzufügen. Auf Android: Einstellungen → Netzwerk & Internet → SIMs → eSIM hinzufügen.",
  delete: {
    title: "eSIM löschen",
    confirm: "Möchtest du diese eSIM wirklich aus deiner Historie entfernen? Diese Aktion kann nicht rückgängig gemacht werden.",
    deleting: "Wird gelöscht…",
    cta: "eSIM löschen"
  },
  details: {
    title: "eSIM-Details & Live-Status",
    refresh: "Bundle-Status aktualisieren",
    live: "Live-Bundle-Status",
    updated: "Aktualisiert:",
    fetching: "Echtzeitstatus wird abgerufen...",
    ref: "Ref:",
    discount: "Rabatt angewendet",
    usage: {
      title: "Datennutzung",
      used: "Verbraucht",
      remaining: "Verbleibend",
      total: "Gesamt"
    },
    assigned: "Bundle zugewiesen",
    plan: {
      title: "Tarifinformationen",
      destination: "Reiseziel",
      name: "Tarifname",
      allowance: "Datenvolumen",
      validity: "Gültigkeit"
    },
    tech: {
      title: "Technische Details",
      activation: "Aktivierungscode",
      copyActivation: "Aktivierungscode kopieren",
      iccid: "ICCID",
      copyIccid: "ICCID kopieren",
      orderRef: "GOeSIM-Bestellreferenz"
    },
    install: {
      title: "Installationsanweisungen",
      iosTitle: "Für iOS:",
      androidTitle: "Für Android:",
      ios: "Einstellungen → Mobilfunk → eSIM hinzufügen → QR-Code verwenden",
      android: "Einstellungen → Netzwerk & Internet → SIMs → eSIM hinzufügen → QR-Code scannen",
      important: "Wichtig:",
      once: "Diese eSIM kann nur einmal installiert werden. Stelle sicher, dass dein Gerät entsperrt und eSIM-kompatibel ist, bevor du fortfährst."
    },
    purchase: {
      title: "Kaufinformationen",
      date: "Kaufdatum",
      amount: "Bezahlter Betrag",
      method: "Zahlungsmethode",
      txn: "Transaktions-ID"
    },
    referral: {
      title: "Empfehlungsrabatt angewendet",
      code: "Empfehlungscode",
      original: "Originalpreis",
      saved: "Gespart"
    },
    billing: {
      title: "Rechnungsinformationen",
      name: "Vollständiger Name",
      email: "E-Mail",
      country: "Land",
      zip: "PLZ"
    }
  },
  qr: {
    title: "eSIM-QR-Code",
    alt: "eSIM-QR-Code",
    copy: "Aktivierungscode kopieren",
    tip: "Tipp: Öffne die Kamera deines Handys und scanne den QR-Code. Eine eSIM kann nur einmal installiert werden."
  },
  common: {
    usd: "USD",
    days: "Tage",
    na: "N/V",
    invalidDate: "Ungültiges Datum",
    cancel: "Abbrechen",
    close: "Schließen",
    copied: "kopiert"
  }
},

countryDetails: {
  loading: "Länderdetails werden geladen...",
  errors: {
    notFound: "Land nicht gefunden",
    loadFail: "Fehler beim Laden der Länderdaten"
  },
  notFound: {
    title: "Land nicht gefunden",
    subtitle: "Das gesuchte Land existiert nicht oder hat keine verfügbaren Tarife.",
    cta: "Alle Länder durchsuchen"
  },
  back: "Zurück zu den Ländern",
  blurb: "Erkunde {{country}} flexibel mit unseren eSIM-Datentarifen. Egal ob für einen kurzen Aufenthalt oder eine längere Reise – unsere Tarife halten dich mühelos verbunden.",
  noPlans: "Keine Tarife für die ausgewählten Filter verfügbar.",
  plan: {
    details: "Tarifdetails",
    detailsShort: "Details",
    networkBadge: "5G",
    unlimited: "Unbegrenzt",
    unlimitedData: "Unbegrenzte Daten",
    gb: "GB",
    gbShort: "GB",
    data: "Daten",
    forDays: "Für {count, plural, one {# TAG} other {# TAGE}}"
  },
  currency: {
    usd: "USD"
  },
  duration: {
    days: "{count, plural, one {# Tag} other {# Tage}}"
  },
  more: {
    more: "Weitere Tarife anzeigen",
    moreShort: "+{extra} Mehr",
    less: "Weniger Tarife anzeigen",
    lessShort: "Weniger anzeigen"
  },
  modal: {
    title: "Tarifdetails",
    country: "Land:",
    duration: "Dauer:",
    network: "Netzwerk:",
    autostart: "Automatischer Start:",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    planType: "Tariftyp:",
    description: "Beschreibung",
    purchase: "Diesen Tarif kaufen",
    signInToPurchase: "Zum Kauf anmelden"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "Gesamt",
    buy: "Jetzt kaufen"
  }
},

checkout: {
  loading: "Sicherer Checkout wird geladen...",
  invalidPlan: {
    title: "Ungültige Tarifdaten",
    subtitle: "Die Informationen zum ausgewählten Tarif konnten nicht geladen werden.",
    cta: "Zurück zum Dashboard"
  },
  success: {
    title: "Kauf erfolgreich!",
    message: "eSIM erfolgreich gekauft! ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "QR-Code und Installationsanweisungen wurden an {{a}} und {{b}} gesendet",
    sentOne: "QR-Code und Installationsanweisungen wurden an {{email}} gesendet",
    view: "Meine eSIMs anzeigen"
  },
  common: {
    close: "Schließen"
  },
  header: {
    title: "Sicherer Checkout",
    subtitle: "Schließe deinen eSIM-Kauf sicher ab"
  },
  benefits: {
    title: "Melde dich an für Vorteile",
    copy: "Erstelle ein Konto, um deine Kaufhistorie zu speichern, exklusive Angebote zu erhalten und deine eSIMs zu verwalten.",
    cta: "Registrieren / Anmelden"
  },
  billing: {
    title: "Rechnungsinformationen",
    subtitle: "Deine Rechnung und eSIM werden an diese E-Mail-Adresse gesendet"
  },
  form: {
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail-Adresse",
    referral: "Empfehlungscode (optional)"
  },
  placeholder: {
    firstName: "Vorname eingeben",
    lastName: "Nachname eingeben",
    email: "E-Mail-Adresse eingeben",
    referral: "Empfehlungscode eingeben",
    altEmail: "Alternative E-Mail eingeben"
  },
  referral: {
    validating: "Wird überprüft...",
    invalid: "Ungültiger Empfehlungscode",
    ownCode: "Eigener Empfehlungscode kann nicht verwendet werden",
    inactive: "Dieser Empfehlungscode ist nicht mehr aktiv",
    used: "Dieser Empfehlungscode wurde bereits verwendet",
    valid: "Gültig! {{percent}}% Rabatt angewendet",
    error: "Fehler bei der Code-Überprüfung"
  },
  altEmail: {
    title: "Andere E-Mail-Adresse verwenden",
    copy: "Die eSIM wird auch an diese E-Mail gesendet und in deinem Konto gespeichert",
    input: "Alternative E-Mail-Adresse"
  },
  createAccount: {
    title: "Konto erstellen, um Kaufhistorie zu speichern",
    copy: "Optional – hilft dir, eSIMs zu verwalten und Support zu erhalten"
  },
  payment: {
    title: "Zahlungsdetails",
    secured: "Gesichert durch Stripe",
    method: "Zahlungsmethode",
    card: "Kredit- oder Debitkarte",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "Mit PayPal bezahlen",
    cardInfo: "Karteninformationen",
    loadingSecure: "Sicheres Zahlungsformular wird geladen...",
    cardComplete: "Kartendaten sind vollständig",
    processing: "Zahlung wird verarbeitet...",
    complete: "Kauf abschließen • ${{total}}"
  },
  legal: {
    agree: "Mit Abschluss der Bestellung stimmst du unseren",
    terms: "Allgemeinen Geschäftsbedingungen",
    and: "und",
    privacy: "Datenschutz- & Rückerstattungsrichtlinien"
  },
  summary: {
    title: "Bestellübersicht",
    planLabel: "eSIM-Tarif",
    digital: "Digital",
    data: "Datenvolumen:",
    validity: "Gültigkeit:",
    coverage: "Abdeckung:",
    nationwide: "Landesweit"
  },
  pricing: {
    planPrice: "Tarifpreis",
    referralDiscount: "Empfehlungsrabatt ({{percent}}%)",
    stripeFee: "Stripe-Bearbeitungsgebühr",
    paypalFee: "PayPal-Bearbeitungsgebühr",
    taxes: "Steuern & Servicegebühr",
    included: "Inklusive",
    total: "Gesamt"
  },
  paypal: {
    description: "eSIM für {{country}} – {{data}} für {{days}} Tage"
  },
  duration: {
    days: "{count, plural, one {# Tag} other {# Tage}}"
  },
  alerts: {
    enterName: "Bitte gib deinen vollständigen Namen ein",
    formNotReady: "Das Zahlungsformular ist noch nicht bereit. Bitte warte einen Moment und versuche es erneut.",
    cardIncomplete: "Bitte vollständige Kartendaten eingeben",
    paypalFailed: "PayPal-Zahlung fehlgeschlagen: {{msg}}",
    paypalGeneric: "PayPal-Zahlung fehlgeschlagen. Bitte versuche es erneut.",
    purchaseFailed: "Kauf fehlgeschlagen: {{msg}}"
  }
},

privacy: {
  title: "Datenschutzerklärung",
  subtitle:
    "Erklärung zu den Praktiken von Routed Labs, Inc. bezüglich Erhebung, Nutzung und Schutz personenbezogener Daten.",
  lastUpdated: {
    label: "Zuletzt aktualisiert:",
    date: "1. August 2025"
  },
  sections: {
    intro: {
      heading: "Einleitung",
      p1:
        "Routed Labs, Inc. („Routed Labs“, „wir“, „uns“ oder „unser“) betreibt die Airvoy-Website und die mobile Anwendung (der „Service“). Diese Datenschutzerklärung erläutert, wie wir personenbezogene Daten erheben, verwenden, offenlegen und schützen. Durch die Nutzung des Service stimmen Sie den hierin beschriebenen Praktiken zu.",
      p2:
        "Routed Labs verpflichtet sich, die Vertraulichkeit, Integrität und Sicherheit Ihrer personenbezogenen Daten zu wahren. Unsere Datenpraktiken sind darauf ausgelegt, transparent, verhältnismäßig und rechtskonform zu sein."
    },
    collect: {
      heading: "Welche Daten wir erheben",
      p1:
        "Wir befolgen das Prinzip der Datensparsamkeit und erheben nur die Informationen, die zur Bereitstellung von eSIM-Diensten erforderlich sind. Konkret erfassen wir:",
      email: {
        title: "E-Mail-Adresse",
        collectedWhen: "Erhoben, wenn Sie:",
        items: [
          "Ein Konto erstellen",
          "Einen eSIM-Tarif kaufen",
          "Einen Newsletter abonnieren",
          "Den Support kontaktieren"
        ],
        purposeLabel: "Zweck:",
        purpose:
          "Verwaltung von Konten, Bereitstellung von eSIMs, Versand von Bestätigungen und Unterstützung durch den Kundenservice."
      },
      notCollect: {
        title: "Wir erheben NICHT:",
        items: [
          "Telefonnummern oder Gerätekennungen",
          "Standort- oder Geotracking-Daten",
          "Browserverlauf oder verhaltensbasierte Cookies",
          "Social-Media-Profile oder persönliche Fotos",
          "Finanzdaten (Zahlungen werden von Drittanbietern abgewickelt)"
        ]
      }
    },
    use: {
      heading: "Wie wir Informationen verwenden",
      p1: "Die erhobenen Daten werden ausschließlich für folgende Zwecke genutzt:",
      items: [
        "Bereitstellung von eSIM-Zugangsdaten, Kaufbestätigungen und Quittungen",
        "Technischer Support und Kundendienst",
        "Versand wichtiger Service-Updates und Sicherheitsmitteilungen",
        "Optionale Zusendung von Marketingmaterialien (nur mit Zustimmung)"
      ],
      optOut: "Sie können Marketingmitteilungen jederzeit abbestellen."
    },
    share: {
      heading: "Datenweitergabe und Offenlegung",
      p1:
        "Personenbezogene Daten werden nicht verkauft, vermietet oder gehandelt. Sie werden nur in den folgenden Fällen weitergegeben:",
      items: [
        { title: "Dienstleister:", body: "Für Funktionen wie Zahlungsabwicklung oder E-Mail-Versand" },
        { title: "Gesetzliche Anforderungen:", body: "Wenn dies durch Gesetze, Vorschriften oder Gerichtsverfahren vorgeschrieben ist" },
        { title: "Geschäftstransaktionen:", body: "Im Zusammenhang mit Fusionen, Übernahmen oder Umstrukturierungen" },
        { title: "Sicherheit:", body: "Zum Schutz der Rechte, des Eigentums und der Sicherheit von Routed Labs und seiner Nutzer" }
      ]
    },
    retain: {
      heading: "Datenspeicherung und -löschung",
      p1: "Daten werden nur so lange gespeichert, wie es für die hier beschriebenen Zwecke notwendig ist:",
      items: [
        "Aktive Konten: Daten werden während der aktiven Nutzung und bis zu zwei Jahre nach der letzten Interaktion aufbewahrt.",
        "Gastkäufe: Speicherung bis zu einem Jahr, um Kundensupport und Erfüllung zu gewährleisten.",
        "Nach Konto­löschung: Alle personenbezogenen Daten werden dauerhaft aus aktiven Systemen entfernt."
      ]
    },
    rights: {
      heading: "Rechte der betroffenen Personen",
      p1: "Sie können die folgenden Rechte ausüben:",
      items: [
        "Zugang und Kopie Ihrer personenbezogenen Daten anfordern",
        "Berichtigung unrichtiger Daten verlangen",
        "Löschung Ihrer Daten beantragen",
        "Ihre Zustimmung zu Marketingmitteilungen jederzeit widerrufen"
      ],
      contactPreamble: "Anfragen können gesendet werden an"
    },
    security: {
      heading: "Datensicherheit",
      p1:
        "Routed Labs setzt geeignete technische und organisatorische Maßnahmen ein, um personenbezogene Daten zu schützen, darunter:",
      items: [
        "Verschlüsselung während der Übertragung und Speicherung",
        "Regelmäßige Audits und Schwachstellenbewertungen",
        "Strenge Zugriffskontrollen und Authentifizierungsverfahren",
        "Sichere Infrastruktur und Rechenzentren"
      ]
    },
    contact: {
      heading: "Kontaktinformationen",
      p1:
        "Fragen oder Bedenken zu dieser Datenschutzerklärung können gerichtet werden an:",
      company: "Routed Labs, Inc.",
      emailLabel: "E-Mail:",
      addressLabel: "Adresse:",
      address: "451 Niantic Avenue, Daly City, CA 94014, Vereinigte Staaten",
      subjectLabel: "Betreffzeile für die Korrespondenz:",
      subject: "„Anfrage zur Datenschutzerklärung“"
    },
    updates: {
      heading: "Aktualisierungen dieser Richtlinie",
      p1:
        "Diese Datenschutzerklärung kann regelmäßig überarbeitet werden, um betriebliche, rechtliche oder regulatorische Änderungen widerzuspiegeln. Wesentliche Änderungen werden auf dieser Seite mit einem aktualisierten „Zuletzt aktualisiert“-Datum veröffentlicht.",
      p2:
        "Nutzer werden ermutigt, dieses Dokument regelmäßig zu überprüfen, um informiert zu bleiben, wie Routed Labs personenbezogene Daten verarbeitet."
    }
  }
},

tos: {
  title: "Nutzungsbedingungen",
  subtitle:
    "Rechtliche Bedingungen und Konditionen für die Nutzung der Airvoy-Plattform und der von Routed Labs, Inc. bereitgestellten Dienste.",
  lastUpdated: { label: "Zuletzt aktualisiert:", date: "1. August 2025" },
  sections: {
    agreement: {
      heading: "Zustimmung zu den Bedingungen",
      p1:
        "Diese Nutzungsbedingungen („Bedingungen“) stellen eine rechtsverbindliche Vereinbarung zwischen dem Benutzer („Sie“) und Routed Labs, Inc. („Routed Labs“, „wir“, „uns“ oder „unser“) über die Nutzung der Airvoy-Website, der mobilen Anwendung und der zugehörigen eSIM-Dienste (zusammen der „Dienst“) dar.",
      p2:
        "Durch den Zugriff auf oder die Nutzung des Dienstes bestätigen Sie, dass Sie diese Bedingungen gelesen, verstanden und akzeptiert haben. Wenn Sie nicht einverstanden sind, dürfen Sie den Dienst nicht nutzen."
    },
    service: {
      heading: "Beschreibung des Dienstes",
      p1:
        "Der Dienst bietet eSIM-Funktionalität (eingebettete SIM), die es Benutzern ermöglicht, international auf mobile Datennetze zuzugreifen. Das Angebot umfasst:",
      items: [
        "Digitale eSIM-Profile für globale Konnektivität",
        "Mehrere Datentarifoptionen mit unterschiedlichen Laufzeiten",
        "QR-Code-Zustellung zur Aktivierung und Installation",
        "Kundensupport für technische Anfragen",
        "Kontoverwaltungstools für registrierte Benutzer"
      ],
      notice:
        "Wichtig: Der Dienst erfordert ein kompatibles, entsperrtes Gerät. Wir garantieren keine Kompatibilität mit allen Geräten oder Abdeckung in allen geografischen Regionen."
    },
    eligibility: {
      heading: "Berechtigung",
      p1: "Um den Dienst zu nutzen, erklären und garantieren Sie, dass Sie:",
      items: [
        "Mindestens 18 Jahre alt sind oder elterliche Zustimmung haben",
        "Die rechtliche Fähigkeit besitzen, einen verbindlichen Vertrag abzuschließen",
        "Genaue und vollständige Registrierungsinformationen angeben",
        "Ein kompatibles Gerät besitzen oder berechtigt sind, es zu verwenden",
        "Die geltenden Gesetze und Vorschriften einhalten werden"
      ]
    },
    account: {
      heading: "Kontoregistrierung",
      p1:
        "Benutzer können eSIMs entweder als registrierte Kontoinhaber oder als Gäste erwerben. Die Registrierung bietet zusätzliche Funktionen wie Kaufhistorie und erweiterten Support.",
      registered: {
        title: "Registrierte Konten",
        items: [
          "Gültige E-Mail-Adresse erforderlich",
          "Verantwortung für die Sicherheit des Kontos",
          "Pflicht zur Aktualisierung korrekter Informationen",
          "Unverzügliche Meldung unbefugten Zugriffs"
        ]
      },
      guest: {
        title: "Gastkäufe",
        items: [
          "Erfordert nur eine E-Mail-Adresse",
          "eSIM wird elektronisch geliefert",
          "Support beschränkt sich auf kaufbezogene Anliegen",
          "Keine fortlaufende Kaufhistorie gespeichert"
        ]
      }
    },
    payment: {
      heading: "Zahlungsbedingungen",
      p1:
        "Durch Abschluss eines Kaufs ermächtigen Sie Routed Labs und seine Zahlungsabwickler, die von Ihnen bereitgestellte Zahlungsmethode zu belasten. Wichtige Bedingungen umfassen:",
      items: [
        "Alle Preise werden in US-Dollar angegeben und enthalten anfallende Steuern",
        "Die Zahlung ist zum Zeitpunkt des Kaufs fällig",
        "Die Zahlungsabwicklung erfolgt über Drittanbieter",
        "Nicht abgeschlossene Zahlungen können zur Sperrung des Dienstes führen"
      ]
    },
    refunds: {
      heading: "Rückerstattungsrichtlinie",
      p1: "Rückerstattungsanfragen werden unter folgenden Bedingungen geprüft:",
      items: [
        "Anspruch, wenn innerhalb von 24 Stunden nach dem Kauf beantragt",
        "Nicht möglich, sobald die eSIM aktiviert oder genutzt wurde",
        "Technische Probleme werden von Fall zu Fall geprüft",
        "Die Gerätekompatibilität liegt in der Verantwortung des Benutzers"
      ],
      p2: {
        prefix: "Rückerstattungsanfragen müssen an ",
        suffix: " gesendet werden, mit Angabe der Bestelldetails und des Grundes."
      }
    },
    limitations: {
      heading: "Einschränkungen des Dienstes",
      p1: "Der Dienst unterliegt Einschränkungen, darunter:",
      items: [
        "Gerät muss eSIM-kompatibel und entsperrt sein",
        "Abdeckung hängt von lokalen Partnernetzen ab",
        "Geschwindigkeit und Verfügbarkeit variieren je nach Standort",
        "Ungenutzte Daten verfallen und werden nicht übertragen",
        "Tarife können nicht zwischen Geräten übertragen werden"
      ]
    },
    prohibited: {
      heading: "Verbotene Nutzungen",
      p1:
        "Sie verpflichten sich, den Dienst nicht für rechtswidrige oder verbotene Zwecke zu nutzen, einschließlich, aber nicht beschränkt auf:",
      items: [
        "Gesetzeswidrige Aktivitäten oder regulatorische Verstöße",
        "Belästigung, Missbrauch oder betrügerische Aktivitäten",
        "Unbefugter Netzwerkzugriff oder -störung",
        "Weiterverkauf oder Teilen von Zugangsdaten ohne Zustimmung",
        "Übermäßige Nutzung, die die Netzwerkleistung beeinträchtigt"
      ]
    },
    liability: {
      heading: "Haftungsbeschränkung",
      p1:
        "Soweit gesetzlich zulässig, haftet Routed Labs nicht für indirekte, beiläufige oder Folgeschäden, die aus der Nutzung des Dienstes entstehen. Die Gesamthaftung übersteigt nicht den Betrag, den Sie für den Dienst in den zwölf (12) Monaten vor der Anspruchserhebung bezahlt haben."
    },
    indemnity: {
      heading: "Freistellung",
      p1:
        "Sie erklären sich damit einverstanden, Routed Labs und seine verbundenen Unternehmen von Ansprüchen, Schäden oder Kosten freizustellen, die sich aus Ihrer missbräuchlichen Nutzung des Dienstes oder der Verletzung dieser Bedingungen ergeben."
    },
    termination: {
      heading: "Kündigung",
      p1:
        "Wir können den Zugang zum Dienst sofort sperren oder beenden, wenn Sie diese Bedingungen verletzen, rechtswidrig handeln oder in einer Weise agieren, die Routed Labs oder seinen Benutzern schadet. Nach der Kündigung erlischt Ihr Nutzungsrecht sofort."
    },
    law: {
      heading: "Geltendes Recht",
      p1:
        "Diese Bedingungen unterliegen dem Recht des Bundesstaates Delaware, USA. Sie stimmen zu, sich der ausschließlichen Gerichtsbarkeit der Gerichte in Delaware zur Beilegung von Streitigkeiten zu unterwerfen."
    },
    amend: {
      heading: "Änderungen",
      p1:
        "Routed Labs behält sich das Recht vor, diese Bedingungen nach eigenem Ermessen zu ändern. Aktualisierungen werden auf der Website veröffentlicht und treten sofort in Kraft, sofern nicht anders angegeben. Die fortgesetzte Nutzung des Dienstes nach Änderungen gilt als Zustimmung zu den geänderten Bedingungen."
    },
    contact: {
      heading: "Kontaktinformationen",
      p1: "Bei Fragen zu diesen Bedingungen kontaktieren Sie bitte:"
    }
  }
},

about: {
  title: "Über Airvoy",
  sections: {
    overview: {
      heading: "Überblick",
      body:
        "Airvoy ist eine eSIM-Plattform, die von Routed Labs, Inc. entwickelt wurde. Die Plattform bietet internationalen Reisenden zugängliche, erschwingliche und zuverlässige mobile Konnektivität. Durch den Verzicht auf physische SIM-Karten ermöglicht der Service die nahtlose Aktivierung von Datentarifen in mehr als 200 Reisezielen."
    },
    mission: {
      heading: "Mission",
      body:
        "Routed Labs, Inc. verfolgt eine klare Mission: die Vereinfachung mobiler Konnektivität. Das Unternehmen möchte Unsicherheiten, versteckte Kosten und logistische Hürden im Zusammenhang mit internationalem Roaming und SIM-Beschaffung beseitigen, damit Reisende mühelos verbunden bleiben können."
    },
    background: {
      heading: "Hintergrund",
      p1:
        "Routed Labs, Inc. hat seinen Hauptsitz in Daly City, Kalifornien. Die Gründung unseres Unternehmens entstand aus den direkten Erfahrungen mit den Schwierigkeiten, international verbunden zu bleiben, darunter hohe Roaming-Gebühren und begrenzte SIM-Verfügbarkeit.",
      p2:
        "Angesichts dieser Herausforderungen erkannte der Gründer die Chance, eSIM-Technologie zu nutzen, um die globale Konnektivität zu verbessern.",
      p3:
        "Heute unterstützt das Unternehmen Tausende von Nutzern weltweit und legt dabei besonderen Wert auf Zuverlässigkeit, Transparenz und Zugänglichkeit."
    },
    operations: {
      heading: "Betrieb",
      items: [
        { title: "Globale Abdeckung:", desc: "Zugang zu Hochgeschwindigkeitsnetzen in über 200 Ländern und Regionen." },
        { title: "eSIM-Bereitstellung:", desc: "Digitale Tarifinstallation innerhalb weniger Minuten, ohne physische SIM-Karten." },
        { title: "Kundenorientierung:", desc: "Service und Support, die auf Klarheit und die Bedürfnisse der Nutzer ausgerichtet sind." }
      ]
    },
    corporate: {
      heading: "Unternehmensinformationen",
      company: {
        title: "Firmendetails",
        nameLabel: "Firmenname:",
        name: "Routed Labs, Inc.",
        repLabel: "Vertreter:",
        rep: "Hector Diaz",
        addrLabel: "Hauptsitzadresse:",
        addr: "451 Niantic Avenue, Daly City, CA 94014, Vereinigte Staaten",
        contactLabel: "Kontakt:"
      },
      agent: {
        title: "Informationen zum eingetragenen Vertreter",
        nameLabel: "Name des eingetragenen Vertreters:",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "Adresse des eingetragenen Vertreters:",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, Vereinigte Staaten"
      }
    },
    comms: {
      heading: "Kommunikation",
      p1: {
        prefix: "Für offizielle Anfragen oder Korrespondenz schreiben Sie bitte an",
        suffix:
          ". Unternehmens- und juristische Korrespondenz kann auch an den eingetragenen Vertreter des Unternehmens, Legalinc Corporate Services Inc., an dessen Adresse in Newark, Delaware, gerichtet werden."
      }
    }
  }
},

auth: {
  titles: {
    signin: 'Willkommen zurück',
    signup: 'Konto erstellen',
    forgot: 'Passwort zurücksetzen',
  },
  subtitles: {
    signin: 'Melde dich an, um eSIM-Tarife zu kaufen',
    signup: 'Werde noch heute Teil von Airvoy',
    forgot: 'Gib deine E-Mail ein, um dein Passwort zurückzusetzen',
  },
  fields: {
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
  },
  placeholders: {
    email: 'Gib deine E-Mail ein',
    password: 'Gib dein Passwort ein',
    confirmPassword: 'Bestätige dein Passwort',
  },
  actions: {
    close: 'Schließen',
    continueWithGoogle: 'Mit Google fortfahren',
    signingIn: 'Anmeldung läuft...',
    pleaseWait: 'Bitte warten...',
    signIn: 'Anmelden',
    createAccount: 'Konto erstellen',
    sendReset: 'Zurücksetzungs-E-Mail senden',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
  },
  labels: {
    orEmail: 'Oder mit E-Mail fortfahren',
  },
  links: {
    noAccount: 'Noch kein Konto?',
    signUp: 'Registrieren',
    forgot: 'Passwort vergessen?',
    haveAccount: 'Bereits ein Konto?',
    signIn: 'Anmelden',
    remembered: 'Passwort wieder eingefallen?',
    backToSignIn: 'Zurück zur Anmeldung',
  },
  messages: {
    resetSent: 'E-Mail zum Zurücksetzen des Passworts gesendet! Überprüfe dein Postfach.',
  },
  errors: {
    fillAll: 'Bitte alle Felder ausfüllen',
    userNotFound: 'Kein Konto mit dieser E-Mail-Adresse gefunden',
    wrongPassword: 'Falsche E-Mail oder falsches Passwort',
    emailInUse: 'Ein Konto mit dieser E-Mail existiert bereits',
    weakPassword: 'Das Passwort ist zu schwach',
    invalidEmail: 'Ungültige E-Mail-Adresse',
    tooManyRequests: 'Zu viele fehlgeschlagene Versuche. Bitte später erneut versuchen',
    popupClosed: 'Das Anmeldefenster wurde vor Abschluss geschlossen',
    popupCancelled: 'Die Anmeldung wurde abgebrochen',
    popupBlocked: 'Das Anmeldefenster wurde von deinem Browser blockiert',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordMin: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    enterEmail: 'Bitte gib deine E-Mail-Adresse ein',
    generic: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut',
  },
  legal: {
    prefix: 'Durch das Erstellen eines Kontos stimmst du unseren',
    terms: 'Nutzungsbedingungen',
    and: 'und',
    privacy: 'Datenschutzrichtlinien',
  },
},

support: {
  title: "Support",
  contactInfo: "Kontaktinformationen",
  channels: {
    email: {
      title: "E-Mail-Support",
      description: "Für Anfragen, Vorfallmeldungen und Hilfsersuchen.",
      contact: "support@routedlabs.com",
      action: "E-Mail verfassen"
    },
    chat: {
      title: "Live-Chat",
      description: "Echtzeitunterstützung für zeitkritische Anliegen, je nach Verfügbarkeit.",
      contact: "Verfügbar 09:00–18:00 Pazifische Zeit",
      action: "Chat öffnen"
    }
  },
  faqTitle: "Häufig gestellte Fragen",
  noResults: "Keine Einträge entsprechen der aktuellen Suche.",
  categoryLabel: "Kategorie:",
  show: "Anzeigen",
  hide: "Ausblenden",
  noticesTitle: "Hinweise und Korrespondenz",
  noticesLine1: {
    before: "Offizielle Anfragen und Korrespondenz sollten gerichtet werden an",
    after: "."
  },
  noticesLine2:
    "Diese Seite dient der Beschreibung von Supportprozessen und Referenzmaterialien. Sie ersetzt oder ändert nicht die geltenden Nutzungsbedingungen oder Richtlinien, die in allen Fällen maßgeblich sind.",
  categories: {
    overview: "eSIM-Übersicht",
    compatibility: "Gerätekompatibilität",
    installation: "Installation",
    dualSim: "Dual-SIM",
    dataUsage: "Datennutzung",
    planMgmt: "Tarifverwaltung",
    deviceReqs: "Geräteanforderungen",
    troubleshooting: "Fehlerbehebung",
    refunds: "Rückerstattungen",
    supportHours: "Support-Verfügbarkeit"
  },
  faqs: {
    1: {
      q: "Was ist eine eSIM und wie funktioniert sie?",
      a: "Eine eSIM (eingebettete SIM) ist eine programmierbare, geräteinterne SIM, die die Aktivierung von Mobilfunkdiensten ohne physische Karte ermöglicht. Nutzer können ein Profil digital einrichten und durch Scannen eines Codes oder das Befolgen von Konfigurationsschritten in Airvoy Konnektivität erhalten."
    },
    2: {
      q: "Welche Geräte unterstützen eSIM-Funktionalität?",
      a: "Viele moderne Smartphones unterstützen eSIM-Funktionalität, darunter aktuelle Modelle großer Hersteller. Überprüfen Sie die Geräteeinstellungen (oft unter „Mobilfunk“ oder „Mobile Daten“), um zu sehen, ob die Option „Datenplan hinzufügen“ verfügbar ist."
    },
    3: {
      q: "Wie wird eine eSIM installiert?",
      a: "Nach dem Kauf erhalten Sie Installationsanweisungen und einen QR-Code per E-Mail. Gehen Sie auf Ihrem Gerät zu Einstellungen → Mobilfunk/Mobile Daten → Datenplan hinzufügen und scannen Sie den Code. Die Aktivierung erfolgt automatisch nach den Anweisungen."
    },
    4: {
      q: "Kann eine physische SIM und eine eSIM gleichzeitig auf demselben Gerät verwendet werden?",
      a: "Die meisten eSIM-fähigen Geräte unterstützen Dual-SIM. Sie können Ihre primäre Nummer für Anrufe und Nachrichten behalten, während Sie die eSIM für Daten verwenden. Die Auswahl erfolgt in den Geräteeinstellungen."
    },
    5: {
      q: "Was passiert, wenn das bereitgestellte Datenvolumen nicht vollständig genutzt wird?",
      a: "Nicht genutzte Daten werden nicht übertragen und sind nicht erstattungsfähig. Tarife laufen am Ende ihrer Gültigkeitsdauer ab. Wählen Sie einen Tarif, der zu Ihrem voraussichtlichen Reisebedarf passt."
    },
    6: {
      q: "Kann man Daten hinzufügen oder einen aktiven Tarif verlängern?",
      a: "Ja. Sie können zusätzliches Datenvolumen erwerben oder den Service verlängern, indem Sie einen weiteren Tarif über die Website oder Ihr Benutzerkonto kaufen, sofern für das Reiseziel verfügbar."
    },
    7: {
      q: "Muss das Gerät entsperrt sein?",
      a: "Ja. Um eine eSIM von einem anderen Anbieter als dem ursprünglichen Mobilfunkanbieter zu nutzen, muss Ihr Gerät entsperrt sein. Wenn es gesperrt ist, wenden Sie sich an Ihren Anbieter, um eine Entsperrung anzufordern."
    },
    8: {
      q: "Welche Schritte sollten unternommen werden, wenn die eSIM nicht wie erwartet funktioniert?",
      a: "Stellen Sie sicher, dass das Gerät entsperrt und eSIM-fähig ist. Aktivieren Sie Datenroaming, wählen Sie den richtigen Datenplan aus und starten Sie das Gerät neu. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support."
    },
    9: {
      q: "Sind Rückerstattungen verfügbar?",
      a: "Rückerstattungen können innerhalb von 24 Stunden nach dem Kauf möglich sein, sofern die eSIM nicht aktiviert oder genutzt wurde. Nach der Aktivierung sind Käufe endgültig. Bei technischen Problemen wird der Support versuchen, Abhilfe zu schaffen oder gegebenenfalls Guthaben zu gewähren."
    },
    10: {
      q: "Wie sind die Supportzeiten und welche Antwortzeiten kann man erwarten?",
      a: "E-Mail-Support ist durchgehend verfügbar. Die typischen Antwortzeiten liegen bei einigen Stunden. Zeitkritische Anliegen während der Reise erhalten bevorzugte Bearbeitung."
    }
  }
}

  },
  it: {
    // Navigation
nav: {
  installEsim: "Installa eSIM",
  admin: "Per aziende",
  faqs: "FAQ",
  browsePlans: "Sfoglia piani",
  partnerships: "Partnership",
  dashboard: "Dashboard",
  signOut: "Esci",
  signIn: "Accedi",
  getTheApp: "Scarica l'app"
},

    // Hero Section
hero: {
  badge: "Unisciti a oltre 30.000 viaggiatori che usano Airvoy eSIM.",
  title: "Il Globale",
  titleHighlight: "eSIM",
  subtitle: "Rimani connesso come a casa — configurazione istantanea, dati flessibili e copertura globale in oltre 200 paesi.",
  searchPlaceholder: "Dove stai viaggiando?",
  appStore: "App Store",
  googlePlay: "Google Play"
},

// Popular Countries
popularCountries: {
  title: "Destinazioni popolari",
  subtitle: "Rimani connesso all'istante in queste principali destinazioni di viaggio",
  fromPrice: "Da",
  perDay: "/giorno",
  unlimited: "Illimitato",
  startingAt: "A partire da",
  getStarted: "Inizia ora",
  viewAllCountries: "Vedi tutti i paesi",
  noPlansAvailable: "Nessun piano illimitato disponibile"
},
// How It Works
howItWorks: {
  title: "Come funziona Airvoy eSIM",
  subtitle: "Connettiti in tre semplici passaggi",
  step1Title: "Scegli la tua destinazione",
  step1Desc: "Sfoglia oltre 200 destinazioni con prezzi trasparenti. Nessun costo nascosto, nessuna sorpresa — solo il piano perfetto per la tua avventura.",
  step2Title: "Installa in pochi secondi", 
  step2Desc: "Ricevi la tua eSIM all'istante via email. Basta scansionare un codice QR e sei pronto a partire — senza visite in negozio o cambio fisico di SIM.",
  step3Title: "Connettiti automaticamente",
  step3Desc: "Atterra e connettiti subito. La tua eSIM si attiva automaticamente al tuo arrivo — dimentica per sempre la caccia al WiFi in aeroporto.",
  learnMore: "Scopri di più"
},
// Benefits
benefits: {
  whyAirvoy: "Perché Airvoy?",
  title: "Rimani connesso ovunque tu vada",
  item1Title: "Trova un piano su misura per te",
  item1Desc: "Piani dati flessibili per ogni budget. Da 1 GB settimanale fino a 100 GB validi per sei mesi — tutto in un'unica app.",
  item2Title: "Facile da usare",
  item2Desc: "Scarica Airvoy, installa l’eSIM e scegli un piano dati — si attiverà automaticamente non appena raggiungi la tua destinazione.",
  item3Title: "Evita i costi di roaming",
  item3Desc: "Addio alle tariffe di roaming nascoste. Saprai quanto costerà la tua connessione internet prima di partire!",
  item4Title: "Un'unica eSIM per tutti i tuoi viaggi",
  item4Desc: "Aggiungi nuove destinazioni alla tua eSIM Airvoy esistente — non serve installare nuove eSIM ogni volta. Ricarica e connettiti!",
  item5Title: "Non rimanere mai senza dati",
  item5Desc: "Non rischiare di restare senza dati nel momento peggiore — ti avviseremo quando avrai usato l'80% del tuo piano.",
  item6Title: "+200 paesi",
  item6Desc: "Rimani online in oltre 200 paesi e territori in tutto il mondo."
},
// Videos
videos: {
  title: "Guarda e connettiti velocemente",
  subtitle: "Due rapide guide — una per iPhone e una per Samsung.",
  iPhoneTitle: "Configurazione e attivazione eSIM — iPhone",
  iPhoneDesc: "Guida passo passo per installare e attivare la tua Airvoy eSIM su iPhone. Scansiona, installa e sei online in pochi minuti.",
  samsungTitle: "Configurazione e attivazione eSIM — Samsung",
  samsungDesc: "Scopri come aggiungere la tua Airvoy eSIM su dispositivi Samsung Galaxy. Una guida semplice e chiara, dall’installazione alla prima connessione.",
  iOSGuide: "Guida iOS",
  samsungGuide: "Guida Samsung",
  installationGuide: "Oppure leggi la guida completa all'installazione"
},
// Footer
footer: {
  description: "Unisciti a oltre 30.000 viaggiatori che usano Airvoy eSIM. Viaggia in modo intelligente, resta connesso — ovunque ti porti il tuo viaggio.",
  company: "Azienda",
  aboutUs: "Chi siamo",
  resources: "Risorse",
  documentation: "Documentazione",
  support: "Supporto",
  legal: "Legale",
  privacyPolicy: "Informativa sulla privacy",
  termsOfService: "Termini di servizio",
  followUs: "Seguici",
  copyright: "Tutti i diritti riservati.",
  madeWith: "Creato con",
  forTravelers: "per viaggiatori di tutto il mondo"
},

// Auth
aut: {
  authenticationRequired: "Autenticazione richiesta",
  signInPrompt: "Accedi per visualizzare la dashboard e acquistare piani eSIM."
},
// Common
common: {
  close: "Chiudi",
  loading: "Caricamento...",
  tryAgain: "Riprova",
  noResults: "Nessun paese trovato per"
},
activate: {
  altText: "Attivazione globale Airvoy eSIM",
  activeInThailand: "Airvoy attivo in Thailandia",
  activeInSpain: "Airvoy attivo in Spagna", 
  activeWorldwide: "Airvoy attivo in tutto il mondo",
  activeInGreece: "Airvoy attivo in Grecia",
  activeInMexico: "Airvoy attivo in Messico",
  title: "Mantieni il tuo numero WhatsApp",
  description: "Puoi chiamare e inviare messaggi a tutti i tuoi contatti su WhatsApp, come se fossi nello stesso paese.\nNon perdere i contatti con familiari e amici."
},

regionalPlans: {
  multiCountryCoverage: "Copertura multi-paese",
  title: "Piani regionali",
  subtitle: "Scegli una regione, poi seleziona la durata/dati di cui hai bisogno.",
  noPlansAvailable: "Nessun piano regionale disponibile.",
  from: "Da",
  seePlans: "Vedi piani",
  countries: "paesi",
  plans: "piani",
  startingFrom: "A partire da",
  browseOptions: "Sfoglia opzioni",
  viewPlans: "Vedi piani"
},
partnerships: {
  headerLabel: "PARTNERSHIP",
  title: "Partnership Airvoy",
  subtitle: "Facciamo squadra e realizziamo grandi cose insieme.",
  join: "Unisciti",
  airvoyAffiliate: "Airvoy\nProgramma Affiliazione",
  affiliateDescription: "Guadagna fino al 20% di commissione promuovendo Airvoy eSIM — unisciti oggi alla nostra rete di affiliati ufficiale!",
  joinNow: "Iscriviti ora!",
  learnMore: "Scopri di più",
  partnershipImageAlt: "Partnership Airvoy",

  // Partnership types
  affiliateProgram: "Programma di affiliazione",
  eventPartnership: "Partnership per eventi",
  travelPartnership: "Partnership di viaggio",
  contentPartnership: "Partnership di contenuti",
  sportsPartnership: "Partnership sportiva",
  musicCulturePartnership: "Partnership musica e cultura",
  athleteCollaboration: "Collaborazione con atleti",
  other: "Altro",

  // Partnership descriptions
  eventPartnerships: "Partnership per eventi",
  eventDescription1: "Stai organizzando un evento internazionale e vuoi offrire ai tuoi partecipanti un vantaggio super utile: dati mobili gratuiti?",
  eventDescription2: "Possiamo personalizzare la soluzione giusta per te e per i tuoi ospiti in modo che possano restare connessi senza problemi prima, durante e dopo l’evento.",

  travelPartnerships: "Partnership di viaggio",
  travelDescription1: "Vuoi offrire ai clienti dei tuoi dipendenti e ai viaggiatori all'estero dati mobili e chiamate vocali più economiche e senza interruzioni?",
  travelDescription2: "Con la nostra suite di connettività mobile integrata, possiamo aiutarti a offrire soluzioni di viaggio a valore aggiunto con il minimo sforzo e la massima utilità.",

  contentPartnerships: "Partnership di contenuti",
  contentDescription1: "Sei un creatore di contenuti sui social media con idee creative, un pubblico coinvolto e un occhio attento ai #TravelHacks e #LifeHacks?",
  contentDescription2: "Oppure semplicemente ti piace Airvoy e vuoi farlo conoscere affinché altri possano godere di una connettività mobile senza interruzioni in tutto il mondo?",

  sportsPartnerships: "Partnership sportive",
  sportsDescription1: "Gestisci una competizione sportiva e vuoi offrire ad atleti, squadre e fan un modo affidabile per restare connessi durante l’evento?",
  sportsDescription2: "Collabora con Airvoy per fornire soluzioni di dati mobili senza interruzioni che mantengano tutti connessi, dalla cerimonia di apertura al fischio finale.",

  musicCulturePartnerships: "Partnership musica e cultura",
  musicDescription1: "Stai organizzando un festival musicale, un evento culturale o una performance dal vivo e vuoi migliorare l’esperienza dei partecipanti?",
  musicDescription2: "Airvoy può fornire al tuo pubblico servizi dati mobili affidabili, assicurando che possano condividere, trasmettere e restare connessi mentre si godono l’evento.",

  athleteCollaborations: "Collaborazioni con atleti",
  athleteDescription1: "Sei un atleta che viaggia per il mondo da una competizione all’altra, con la bacheca dei trofei ormai piena?",
  athleteDescription2: "Collabora con Airvoy per restare connesso ovunque il tuo sport ti porti e condividi il tuo percorso con i tuoi fan, ovunque tu sia.",

  letsTalk: "Parliamone",

  // Contact form
  getInTouch: "Mettiti in contatto",
  successMessage: "Grazie per averci contattato! Ti risponderemo presto.",
  errorMessage: "Qualcosa è andato storto. Riprova.",
  emailPlaceholder: "Inserisci la tua email",
  fullNamePlaceholder: "Nome completo",
  partnerTypePlaceholder: "Su cosa vuoi collaborare?",
  messagePlaceholder: "Descrivi brevemente cosa hai in mente",
  privacyConsent: "Accetti la nostra",
  privacyPolicy: "informativa sulla privacy",
  sending: "Invio in corso...",
  send: "Invia"
},

faq: {
  headerLabel: "FAQ",
  title: "Trova le risposte alle domande più frequenti",
  learnMore: "Scopri di più",

  whatIsEsim: {
    question: "Che cos’è una eSIM?",
    answer: "Una eSIM è una SIM digitale standard del settore che ti consente di attivare un piano cellulare dal tuo operatore senza dover utilizzare una SIM fisica. Puoi installare otto o più eSIM su un iPhone e usare due numeri di telefono contemporaneamente."
  },

  howToSetup: {
    question: "Come configurare la tua eSIM?",
    answer: "La tecnologia eSIM è molto comoda. Tuttavia, configurare la tua eSIM può essere un po’ fastidioso, soprattutto se è la prima volta. Ma niente paura, abbiamo guide passo passo qui per farti partire con Airvoy in pochissimo tempo."
  },

  whatIsAirvoy: {
    question: "Che cos’è Airvoy?",
    answer: "Airvoy è un’app mobile che offre soluzioni di connettività mobile globale. Ti consente di rimanere connesso durante i tuoi viaggi senza la necessità di SIM fisiche o costosi costi di roaming."
  },

  howSaveRoaming: {
    question: "Come mi aiuta Airvoy a risparmiare sui costi di roaming?",
    answer: "Offre dati mobili a tariffe fino al 90% più economiche rispetto ai tradizionali costi di roaming. In questo modo puoi evitare le elevate spese associate ai servizi di roaming tradizionali."
  },

  needNewSim: {
    question: "Devo ottenere una nuova SIM ogni volta che viaggio con Airvoy?",
    answer: "No, Airvoy utilizza la tecnologia eSIM, quindi non c’è alcuna SIM fisica coinvolta. La eSIM di Airvoy è globale: una volta scaricata e attivata, puoi usarla per connetterti ovunque, oppure acquistare nuove eSIM per paesi specifici."
  },

  constantConnectivity: {
    question: "Come garantisce Airvoy una connessione costante quando viaggio?",
    answer: "Offre dati mobili a tariffe fino al 90% più economiche rispetto ai tradizionali costi di roaming. In questo modo puoi evitare le elevate spese associate ai servizi di roaming tradizionali."
  },

  freeCallsTexts: {
    question: "Airvoy offre chiamate e messaggi gratuiti?",
    answer: "Non ancora. Ma presto Airvoy offrirà chiamate e messaggi gratuiti tra utenti Airvoy. Ciò significa che potrai restare in contatto con altri utenti Airvoy senza costi aggiuntivi."
  },

  whyChooseAirvoy: {
    question: "Perché dovrei scegliere Airvoy rispetto ad altre alternative di roaming?",
    answer: "Dovresti scegliere Airvoy perché offre una connettività globale senza interruzioni con una sola eSIM, un modello conveniente e funzioni aggiuntive come messaggistica (presto) e numeri locali (presto), tutto in un’app intuitiva. È economico, semplice e ti offre il pieno controllo su come connetterti ovunque tu vada."
  }
},
browse: {
  main: {
    title: "Sfoglia piani eSIM",
    subtitle: "Scopri piani eSIM per destinazioni in tutto il mondo con prezzi in tempo reale"
  },
  search: {
    placeholder: "Cerca paesi (es. Stati Uniti, Spagna, Giappone)...",
    clearSearch: "Cancella ricerca",
    noCountriesFound: "Nessun paese trovato che corrisponda alla tua ricerca.",
    noCountriesAvailable: "Nessun paese disponibile.",
    clearSearchButton: "Cancella ricerca",
    searching: "Ricerca paesi in corso...",
    country: "paese",
    countries: "paesi",
    foundFor: "trovati per"
  },
  loading: {
    loadingText: "Caricamento...",
    allCountriesLoaded: "Tutti i paesi caricati",
    total: "totale"
  },
  buttons: {
    showMoreCountries: "Mostra più paesi",
    showLessPlans: "Mostra meno piani",
    showLess: "Mostra meno",
    seeMorePlans: "Vedi più piani",
    more: "altro",
    buyNow: "Acquista ora"
  },
  navigation: {
    backToCountries: "Torna ai paesi"
  },
  countryDetails: {
    description: "Esplora {{country}} con flessibilità grazie ai nostri piani dati eSIM. Che tu sia in visita per un breve soggiorno o per un viaggio lungo, i nostri piani ti mantengono connesso senza complicazioni."
  },
  plans: {
    noPlansAvailable: "Nessun piano disponibile per i filtri selezionati.",
    planDetails: "Dettagli piano",
    details: "Dettagli",
    unlimited: "Illimitato",
    for: "Per",
    day: "giorno",
    days: "giorni"
  },
  checkout: {
    total: "Totale"
  },
  planDetails: {
    title: "Dettagli piano",
    unlimitedData: "Dati illimitati",
    data: "Dati",
    country: "Paese",
    duration: "Durata",
    day: "giorno",
    days: "giorni",
    network: "Rete",
    autoStart: "Avvio automatico",
    enabled: "Abilitato",
    disabled: "Disabilitato",
    planType: "Tipo di piano",
    description: "Descrizione",
    purchaseThisPlan: "Acquista questo piano",
    signInToPurchase: "Accedi per acquistare"
  }
},

installation: {
  title: "Come installare e configurare la mia eSIM?",
  metaUpdated: "2 mesi fa • Aggiornato",
  intro: {
    p1: "Che tu sia su Android o Apple, verifica prima che il tuo telefono sia compatibile con eSIM e sbloccato dalla rete. Avrai anche bisogno di una connessione Internet stabile (preferibilmente Wi-Fi).",
    p2: "Poi puoi:",
    ol1: "Scansionare il codice QR per l’installazione automatica",
    ol2: "Installare manualmente la tua eSIM",
    note: "L’installazione con codice QR è il metodo più semplice."
  },
  ios: {
    qr: {
      title: "Installa la tua eSIM usando il codice QR (iOS)",
      s1: "1. Vai su Impostazioni > Cellulare",
      s2: "2. Tocca “Aggiungi eSIM” e seleziona Usa codice QR",
      s3: "3. Scansiona il codice QR e inserisci il codice di conferma a 4 cifre se richiesto",
      s4: "4. Assegna un’etichetta alla tua eSIM e seleziona “Solo dati cellulare” sotto Linea predefinita",
      s5: "5. Ora dovresti vedere la tua eSIM in “Cellulare”"
    },
    manual: {
      title: "Come installare manualmente la tua eSIM (iOS)",
      s1: "1. Impostazioni > Cellulare > Aggiungi eSIM",
      s2: "2. Tocca “Aggiungi eSIM” e seleziona Usa codice QR",
      s3: "3. Invece di scansionare, tocca Inserisci dettagli manualmente",
      s4: "4. Inserisci l’indirizzo SM-DP+, il codice di attivazione e l’eventuale codice di conferma dall’app Airvoy",
      s5: "5. Assegna un’etichetta alla tua eSIM e seleziona “Solo dati cellulare” sotto Linea predefinita",
      s6: "6. Ora dovresti vedere la tua eSIM in Cellulare"
    }
  },
  android: {
    qr: {
      title: "Installa la tua eSIM usando il codice QR (Android)",
      s1: "1. Vai su Impostazioni > Rete e Internet > SIM",
      s2: "2. Tocca l’icona “+” a destra di “SIM”",
      s3: "3. Tocca “Scaricare una SIM invece?” in basso",
      s4: "4. Su “Scarica la tua SIM”, tocca “Avanti” — vedrai “Verifica info di rete...”",
      s5: "5. Dopo la verifica, apparirà il mirino per scansionare il codice QR",
      s6: "6. Puntalo su un QR stampato o mostrato su un altro dispositivo",
      s7: "7. Dopo la scansione, il dispositivo controllerà di nuovo le informazioni",
      s8: "8. Tocca Scarica per confermare — i dati della eSIM verranno scaricati",
      s9: "9. Al termine, vedrai “Download completato”",
      s10: "10. Configura la eSIM per l’accesso a Internet quando sei pronto."
    }
  },
  notes: {
    title: "Note importanti",
    n1: "Assicurati che il tuo dispositivo sia compatibile con eSIM e sbloccato",
    n2: "Avrai bisogno di una connessione Wi-Fi stabile durante l’installazione",
    n3: "La eSIM può essere installata solo una volta — inizia quando sei pronto",
    n4: "Mantieni attiva la SIM principale per chiamate e messaggi dal tuo numero di casa",
    n5: "La tua eSIM si attiverà quando raggiungerai il Paese di destinazione"
  },
  support: {
    title: "Hai bisogno di aiuto?",
    body: "Se hai problemi a installare la tua eSIM, il nostro team di supporto è qui per aiutarti!",
    emailLabel: "Email:",
    websiteLabel: "Sito web:"
  }
},
installGuide: {
  header: {
    title: "Guida completa all’installazione della eSIM",
    subtitle: "Tutto ciò che devi sapere per installare, attivare e usare la tua eSIM per una connettività globale senza interruzioni. Segui le nostre istruzioni specifiche per dispositivo per un’installazione semplice.",
    link: "Consulta la guida dettagliata anche per l’installazione su Android",
    ios: "Guida dettagliata per iOS",
        android: "Guida dettagliata per Android"
  },
  iphoneHero: "Installa e attiva la tua eSIM su iPhone",
  cards: {
    c1: {
      alt: "iPhone con interruttore e icona orologio",
      install: "Installa",
      activate: "attiva",
      textA: "poche ore prima del tuo viaggio e",
      textB: "durante il volo o quando arrivi a destinazione."
    },
    c2: {
      alt: "iPhone con interfaccia scanner codice QR",
      line1: "Seleziona “Installa con codice QR”",
      line2: "se hai il codice su un altro dispositivo",
      line3: "da scansionare."
    },
    c3: {
      alt: "iPhone con interfaccia di installazione manuale",
      line1: "Seleziona “Installa manualmente”",
      line2: "se non puoi scansionare il codice QR."
    }
  },
  learn: {
    title: "Impara passo dopo passo",
    subtitle: "Seleziona il tipo di installazione che vuoi eseguire",
    btnQr: "Installazione con codice QR",
    btnManual: "Installazione manuale"
  },
  prep: {
    alt: "Icona avviso telefono",
    qr: {
      title: "Prima di iniziare l’installazione con un codice QR, ecco alcuni punti importanti:",
      i1: "Devi avere il codice QR su un altro schermo o dispositivo per scansionarlo con la fotocamera del telefono.",
      i2: "Assicurati di avere una connessione Internet stabile per tutta la durata del processo.",
      i3: "Tieni presente che il codice QR può essere scansionato una sola volta.",
      i4: "Non rimuovere la eSIM dal tuo dispositivo perché non potrai più usarla."
    },
    manual: {
      title: "Prima di iniziare l’installazione manuale, ecco alcuni punti importanti:",
      i1: "I codici di installazione manuale possono essere utilizzati una sola volta."
    },
    shared: {
      i2: "Assicurati di avere una connessione Internet stabile per tutta la durata del processo.",
      i3: "Non rimuovere la eSIM dal tuo dispositivo perché non potrai più usarla."
    }
  },
  start: {
    title: "Iniziamo insieme",
    c1: {
      title: "Apri la tua email",
      qr: { p1: "Apri la tua email su un altro dispositivo rispetto a quello che userai per l’installazione e trova il messaggio che ti abbiamo inviato con il codice QR." },
      manual: { p1: "Controlla l’email che ti abbiamo inviato con l’“indirizzo SM-DP+” e il “Codice di attivazione” e tienili a portata di mano per iniziare l’installazione. Li abbiamo anche inviati via SMS." },
      shared: { missing: "Se non hai ricevuto il/i tuo/i codice/i, per favore", contact: "contattaci" }
    },
    c2: {
      qr: { title: "Scansiona il codice QR", p1: "Apri la fotocamera sull’iPhone dove installerai la eSIM e scansiona il codice. Puoi anche andare su Impostazioni → Cellulare e selezionare “Aggiungi piano dati” per scansionare da lì." },
      manual: { title: "Apri “Impostazioni” sul tuo iPhone", p1: "Poi vai su Cellulare, tocca “Aggiungi eSIM” o “Aggiungi piano dati” e seleziona “Usa codice QR”. Quindi scegli “Inserisci dettagli manualmente” quando richiesto." }
    },
    c3: {
      title: "Segui i passaggi di installazione sul tuo iPhone",
      qr: { p1: "La scansione del codice avvierà il processo di installazione. Usa la nostra guida qui sotto per una configurazione passo passo." },
      manual: { p1: "Quando arrivi a “Scansiona codice QR”, seleziona “Inserisci dettagli manualmente” e segui i passaggi mostrati sul tuo iPhone." }
    }
  },
  compat: {
    title: "Verificatore compatibilità dispositivi",
    subtitle: "Verifica se il tuo dispositivo supporta la tecnologia eSIM. Usa la funzione di ricerca per trovare rapidamente il tuo modello specifico.",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "Cerca modelli iPhone/iPad...",
    searchAndroid: "Cerca modelli Android...",
    iphones: "iPhone compatibili",
    ipads: "iPad compatibili (solo 4G)",
    androids: "Dispositivi Android compatibili",
    noMatch: "Nessun dispositivo trovato corrispondente alla tua ricerca.",
    iosNotesTitle: "Note importanti:",
    iosNotes: {
      i1: "I modelli iPhone 13 e 14 possono avere due eSIM attive contemporaneamente",
      i2: "Gli iPhone venduti in Cina continentale e Hong Kong non hanno funzionalità eSIM (tranne alcuni modelli)",
      i3: "I modelli iPhone 14+ venduti negli USA non supportano schede SIM fisiche"
    },
    androidNotesTitle: "Restrizioni importanti:",
    androidNotes: {
      i1: "I dispositivi Samsung dagli USA e Hong Kong potrebbero non supportare la eSIM",
      i2: "I Google Pixel venduti in Australia, Giappone e Taiwan non hanno supporto eSIM",
      i3: "I telefoni venduti a Hong Kong generalmente non supportano eSIM",
      i4: "Il dispositivo deve essere sbloccato dall’operatore per usare la eSIM"
    },
    empty: "Inizia a digitare il modello del tuo dispositivo per verificare la compatibilità"
  },
  tips: {
    title: "Consiglio Pro: Attiva prima di viaggiare",
    body: "Per un’esperienza di viaggio senza problemi, installa la tua eSIM prima della partenza e attivala all’arrivo. Così sarai connesso non appena atterri, senza cercare Wi-Fi o SIM locali.",
    before: {
      title: "Prima della partenza",
      i1: "Installa il profilo eSIM da casa",
      i2: "Prova il processo di installazione",
      i3: "Conserva uno screenshot del tuo codice QR come backup",
      i4: "Assicurati che il tuo dispositivo sia sbloccato dall’operatore"
    },
    after: {
      title: "All’arrivo",
      i1: "Attiva i dati cellulari per la tua eSIM",
      i2: "Attendi 2–3 minuti per la registrazione alla rete",
      i3: "Testa la connessione con una ricerca web",
      i4: "Configura il roaming dati se necessario"
    }
  },
  support: {
    title: "Hai bisogno di ulteriore supporto?",
    body: "Il nostro team di supporto esperto è qui per aiutarti in ogni fase. Dalle domande sulla compatibilità del dispositivo all’assistenza per l’installazione, ci siamo noi.",
    btnEmail: "Supporto via Email",
    btnCenter: "Visita il Centro Assistenza"
  },
  steps: {
    ios: {
      s1: { title: "Apri Impostazioni", desc: "Vai su Impostazioni → Cellulare (o Dati mobili in alcune regioni)", detail: "Cerca l’opzione “Cellulare” nel menu principale di Impostazioni. In alcuni Paesi potrebbe essere indicata come “Dati mobili”." },
      s2: { title: "Aggiungi piano cellulare", desc: "Tocca “Aggiungi piano cellulare” o “Aggiungi eSIM”", detail: "Questa opzione appare in fondo alla pagina Cellulare. Se non la vedi, il tuo dispositivo potrebbe non supportare eSIM." },
      s3: { title: "Scansiona codice QR", desc: "Scegli “Usa codice QR” e scansiona il codice dalla tua email", detail: "Punta la fotocamera sul codice QR. Assicurati di avere una buona illuminazione e mantieni il telefono fermo finché non lo riconosce." },
      s4: { title: "Aggiungi piano cellulare", desc: "Tocca “Aggiungi piano cellulare” quando compaiono i dettagli", detail: "Controlla le informazioni dell’operatore e i dettagli del piano prima di confermare. Questo passo scarica il profilo eSIM." },
      s5: { title: "Etichetta i tuoi piani", desc: "Scegli etichette per i tuoi piani (es. “Primario”, “Viaggio”, “Secondario”)", detail: "Questo ti aiuta a identificare quale piano usare per dati, chiamate e messaggi. La maggior parte dei viaggiatori usa la eSIM solo per i dati." },
      s6: { title: "Configura linea predefinita", desc: "Seleziona quale linea usare per i dati cellulari", detail: "Puoi scegliere la eSIM per i dati mantenendo la tua SIM originale per chiamate e messaggi." }
    },
    android: {
      s1: { title: "Apri Impostazioni", desc: "Vai su Impostazioni → Rete e Internet → SIM", detail: "Il percorso esatto può variare a seconda del produttore. Su Samsung potrebbe essere Impostazioni → Connessioni → Gestore schede SIM." },
      s2: { title: "Aggiungi piano dati", desc: "Tocca il pulsante “+” o “Aggiungi piano dati”", detail: "Cerca opzioni come “Aggiungi piano dati”, “Scaricare una SIM invece” o “Aggiungi operatore” a seconda del tuo dispositivo." },
      s3: { title: "Scarica SIM", desc: "Seleziona “Non hai una SIM?” o “Scaricare una SIM invece”", detail: "Questa opzione indica al telefono che vuoi installare una eSIM invece di inserire una SIM fisica." },
      s4: { title: "Scansiona codice QR", desc: "Scegli “Scansiona codice QR” e punta la fotocamera sul codice", detail: "Assicurati di avere una buona illuminazione e una mano ferma. La fotocamera rileverà automaticamente il codice QR dalla tua email." },
      s5: { title: "Scarica profilo", desc: "Tocca “Scarica” quando appare il profilo dell’operatore", detail: "Il dispositivo si connetterà a Internet per scaricare il profilo eSIM. Questo potrebbe richiedere qualche istante." },
      s6: { title: "Attiva eSIM", desc: "Abilita la eSIM e impostala come connessione dati preferita", detail: "Puoi scegliere quale SIM usare per dati, chiamate e SMS. La maggior parte dei viaggiatori usa la eSIM solo per i dati." }
    }
  }
},

profile: {
  loading: "Caricamento del tuo profilo…",
  errors: {
    load: "Impossibile caricare le tue eSIM",
    delete: "Impossibile eliminare la eSIM. Riprova.",
    bundle: "Impossibile recuperare lo stato del pacchetto",
    network: "Errore di rete durante il recupero dello stato del pacchetto",
    invoice: "Impossibile scaricare la fattura"
  },
  auth: {
    title: "Autenticazione richiesta",
    subtitle: "Accedi per visualizzare il tuo profilo e la cronologia delle eSIM.",
    cta: "Accedi"
  },
  header: {
    fallback: "Profilo utente",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} acquistate"
  },
  list: {
    title: "Le tue eSIM",
    subtitle: "Gestisci i profili acquistati e accedi ai codici QR e alle fatture.",
    total: "{{count}} totale"
  },
  empty: {
    title: "Nessuna eSIM",
    subtitle: "Sfoglia i nostri piani per connetterti in pochi secondi — senza SIM fisica.",
    cta: "Sfoglia piani",
    tip: "Suggerimento: puoi installare una eSIM prima del viaggio e attivarla all’arrivo."
  },
  item: {
    country: "Paese",
    statusTitle: "Stato attuale",
    pricePaid: "Prezzo pagato",
    purchaseDate: "Data di acquisto"
  },
  actions: {
    details: "Vedi dettagli",
    showQr: "Mostra QR",
    invoice: "Fattura"
  },
  hint: "Hai bisogno di aiuto per installare una eSIM? Su iOS: Impostazioni → Cellulare → Aggiungi eSIM. Su Android: Impostazioni → Rete e Internet → SIM → Aggiungi eSIM.",
  delete: {
    title: "Elimina eSIM",
    confirm: "Sei sicuro di voler rimuovere questa eSIM dalla cronologia? Questa azione non può essere annullata.",
    deleting: "Eliminazione…",
    cta: "Elimina eSIM"
  },
  details: {
    title: "Dettagli eSIM e stato live",
    refresh: "Aggiorna stato pacchetto",
    live: "Stato pacchetto live",
    updated: "Aggiornato:",
    fetching: "Recupero stato in tempo reale...",
    ref: "Rif:",
    discount: "Sconto applicato",
    usage: {
      title: "Utilizzo dati",
      used: "Usati",
      remaining: "Rimanenti",
      total: "Totale"
    },
    assigned: "Pacchetto assegnato",
    plan: {
      title: "Informazioni piano",
      destination: "Destinazione",
      name: "Nome piano",
      allowance: "Traffico dati",
      validity: "Validità"
    },
    tech: {
      title: "Dettagli tecnici",
      activation: "Codice di attivazione",
      copyActivation: "Copia codice di attivazione",
      iccid: "ICCID",
      copyIccid: "Copia ICCID",
      orderRef: "Riferimento ordine GOeSIM"
    },
    install: {
      title: "Istruzioni di installazione",
      iosTitle: "Per iOS:",
      androidTitle: "Per Android:",
      ios: "Impostazioni → Cellulare → Aggiungi eSIM → Usa codice QR",
      android: "Impostazioni → Rete e Internet → SIM → Aggiungi eSIM → Scansiona codice QR",
      important: "Importante:",
      once: "Puoi installare questa eSIM una sola volta. Assicurati che il tuo dispositivo sia sbloccato e compatibile con eSIM prima di procedere."
    },
    purchase: {
      title: "Informazioni d’acquisto",
      date: "Data di acquisto",
      amount: "Importo pagato",
      method: "Metodo di pagamento",
      txn: "ID transazione"
    },
    referral: {
      title: "Sconto referral applicato",
      code: "Codice referral",
      original: "Prezzo originale",
      saved: "Hai risparmiato"
    },
    billing: {
      title: "Informazioni di fatturazione",
      name: "Nome completo",
      email: "Email",
      country: "Paese",
      zip: "CAP"
    }
  },
  qr: {
    title: "Codice QR eSIM",
    alt: "Codice QR eSIM",
    copy: "Copia codice di attivazione",
    tip: "Suggerimento: apri la fotocamera del telefono e scansiona il QR. Puoi installare una eSIM solo una volta."
  },
  common: {
    usd: "USD",
    days: "giorni",
    na: "N/D",
    invalidDate: "Data non valida",
    cancel: "Annulla",
    close: "Chiudi",
    copied: "copiato"
  }
},
countryDetails: {
  loading: "Caricamento dettagli paese...",
  errors: {
    notFound: "Paese non trovato",
    loadFail: "Impossibile caricare i dati del paese"
  },
  notFound: {
    title: "Paese non trovato",
    subtitle: "Il paese che stai cercando non esiste o non ha piani disponibili.",
    cta: "Sfoglia tutti i paesi"
  },
  back: "Torna ai paesi",
  blurb: "Esplora {{country}} con flessibilità usando i nostri piani dati eSIM. Che tu sia in visita per un breve soggiorno o un viaggio lungo, i nostri piani ti mantengono connesso senza problemi.",
  noPlans: "Nessun piano disponibile per i filtri selezionati.",
  plan: {
    details: "Dettagli piano",
    detailsShort: "Dettagli",
    networkBadge: "5G",
    unlimited: "Illimitato",
    unlimitedData: "Dati illimitati",
    gb: "GB",
    gbShort: "GB",
    data: "Dati",
    forDays: "Per {count, plural, one {# GIORNO} other {# GIORNI}}"
  },
  currency: {
    usd: "USD" 
  },
  duration: {
    days: "{count, plural, one {# giorno} other {# giorni}}"
  },
  more: {
    more: "Vedi altri piani",
    moreShort: "+{extra} Altri",
    less: "Mostra meno piani",
    lessShort: "Mostra meno"
  },
  modal: {
    title: "Dettagli piano",
    country: "Paese:",
    duration: "Durata:",
    network: "Rete:",
    autostart: "Avvio automatico:",
    enabled: "Abilitato",
    disabled: "Disabilitato",
    planType: "Tipo di piano:",
    description: "Descrizione",
    purchase: "Acquista questo piano",
    signInToPurchase: "Accedi per acquistare"
  },
  bar: {
    title: "eSIM {{country}}",
    total: "Totale",
    buy: "Acquista ora"
  }
},

checkout: {
  loading: "Caricamento del checkout sicuro...",
  invalidPlan: {
    title: "Dati del piano non validi",
    subtitle: "Le informazioni sul piano selezionato non possono essere caricate.",
    cta: "Torna alla Dashboard"
  },
  success: {
    title: "Acquisto completato!",
    message: "eSIM acquistata con successo! ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "Il codice QR e le istruzioni di installazione sono stati inviati sia a {{a}} che a {{b}}",
    sentOne: "Il codice QR e le istruzioni di installazione sono stati inviati a {{email}}",
    view: "Visualizza le mie eSIM"
  },
  common: {
    close: "Chiudi"
  },
  header: {
    title: "Checkout sicuro",
    subtitle: "Completa l'acquisto della tua eSIM in modo sicuro"
  },
  benefits: {
    title: "Accedi per i vantaggi",
    copy: "Crea un account per salvare la cronologia degli acquisti, accedere a offerte esclusive e gestire le tue eSIM.",
    cta: "Registrati / Accedi"
  },
  billing: {
    title: "Informazioni di fatturazione",
    subtitle: "La tua fattura e la tua eSIM saranno inviate a questo indirizzo email"
  },
  form: {
    firstName: "Nome",
    lastName: "Cognome",
    email: "Indirizzo email",
    referral: "Codice di riferimento (opzionale)"
  },
  placeholder: {
    firstName: "Inserisci il nome",
    lastName: "Inserisci il cognome",
    email: "Inserisci l'indirizzo email",
    referral: "Inserisci il codice di riferimento",
    altEmail: "Inserisci un'email alternativa"
  },
  referral: {
    validating: "Convalida in corso...",
    invalid: "Codice di riferimento non valido",
    ownCode: "Non puoi usare il tuo stesso codice di riferimento",
    inactive: "Questo codice di riferimento non è più attivo",
    used: "Questo codice di riferimento è già stato utilizzato",
    valid: "Valido! Sconto del {{percent}}% applicato",
    error: "Errore nella convalida del codice"
  },
  altEmail: {
    title: "Usa un indirizzo email diverso",
    copy: "La eSIM sarà inviata anche alla diversa email e salvata nel tuo account",
    input: "Indirizzo email alternativo"
  },
  createAccount: {
    title: "Crea un account per salvare la cronologia degli acquisti",
    copy: "Opzionale - ti aiuta a gestire le eSIM e ad accedere al supporto"
  },
  payment: {
    title: "Dettagli di pagamento",
    secured: "Protetto da Stripe",
    method: "Metodo di pagamento",
    card: "Carta di credito o debito",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "Paga con PayPal",
    cardInfo: "Informazioni carta",
    loadingSecure: "Caricamento del modulo di pagamento sicuro...",
    cardComplete: "Informazioni carta completate",
    processing: "Elaborazione del pagamento...",
    complete: "Completa acquisto • ${{total}}"
  },
  legal: {
    agree: "Completando l'ordine, accetti i nostri",
    terms: "Termini e Condizioni",
    and: "e",
    privacy: "Informativa sulla privacy e sui rimborsi"
  },
  summary: {
    title: "Riepilogo ordine",
    planLabel: "Piano eSIM",
    digital: "Digitale",
    data: "Dati inclusi:",
    validity: "Validità:",
    coverage: "Copertura:",
    nationwide: "Nazionale"
  },
  pricing: {
    planPrice: "Prezzo del piano",
    referralDiscount: "Sconto referral ({{percent}}%)",
    stripeFee: "Commissione di elaborazione Stripe",
    paypalFee: "Commissione di elaborazione PayPal",
    taxes: "Tasse e commissioni di servizio",
    included: "Incluso",
    total: "Totale"
  },
  paypal: {
    description: "eSIM per {{country}} - {{data}} per {{days}} giorni"
  },
  duration: {
    days: "{count, plural, one {# giorno} other {# giorni}}"
  },
  alerts: {
    enterName: "Inserisci il tuo nome completo",
    formNotReady: "Il modulo di pagamento non è pronto. Attendi un momento e riprova.",
    cardIncomplete: "Inserisci tutte le informazioni della carta",
    paypalFailed: "Pagamento PayPal non riuscito: {{msg}}",
    paypalGeneric: "Pagamento PayPal non riuscito. Riprova.",
    purchaseFailed: "Acquisto non riuscito: {{msg}}"
  }
},
privacy: {
  title: "Informativa sulla privacy",
  subtitle:
    "Dichiarazione delle pratiche relative alla raccolta, all'uso e alla protezione delle informazioni personali da parte di Routed Labs, Inc.",
  lastUpdated: {
    label: "Ultimo aggiornamento:",
    date: "1 agosto 2025"
  },
  sections: {
    intro: {
      heading: "Introduzione",
      p1:
        "Routed Labs, Inc. (“Routed Labs”, “noi”, “nostro” o “ci”) gestisce il sito web e l'applicazione mobile Airvoy (il “Servizio”). Questa Informativa sulla privacy descrive come raccogliamo, utilizziamo, divulghiamo e proteggiamo le informazioni personali. Utilizzando il Servizio, acconsenti a queste pratiche come descritto nel presente documento.",
      p2:
        "Routed Labs si impegna a mantenere la riservatezza, l'integrità e la sicurezza delle tue informazioni personali. Le nostre pratiche sui dati sono progettate per essere trasparenti, proporzionate e conformi alle leggi e ai regolamenti applicabili."
    },
    collect: {
      heading: "Informazioni che raccogliamo",
      p1:
        "Adottiamo principi di minimizzazione dei dati e raccogliamo solo le informazioni necessarie per fornire i servizi eSIM. In particolare, raccogliamo:",
      email: {
        title: "Indirizzo email",
        collectedWhen: "Raccolto quando:",
        items: [
          "Crei un account",
          "Acquisti un piano eSIM",
          "Ti iscrivi a una newsletter",
          "Contatti il supporto"
        ],
        purposeLabel: "Scopo:",
        purpose:
          "Gestire account, consegnare eSIM, fornire conferme e consentire l'assistenza clienti."
      },
      notCollect: {
        title: "Non raccogliamo:",
        items: [
          "Numeri di telefono o identificatori del dispositivo",
          "Dati di posizione o geotracciamento",
          "Cronologia di navigazione o cookie comportamentali",
          "Profili social media o fotografie personali",
          "Dati finanziari (i pagamenti sono gestiti da fornitori terzi)"
        ]
      }
    },
    use: {
      heading: "Come utilizziamo le informazioni",
      p1: "Le informazioni raccolte vengono utilizzate esclusivamente per scopi definiti:",
      items: [
        "Consegna delle credenziali eSIM, conferme di acquisto e ricevute",
        "Fornitura di supporto tecnico e assistenza clienti",
        "Invio di aggiornamenti essenziali del servizio e avvisi di sicurezza",
        "Distribuzione facoltativa di materiale di marketing (previo consenso)"
      ],
      optOut: "Puoi annullare l'iscrizione alle comunicazioni di marketing in qualsiasi momento."
    },
    share: {
      heading: "Condivisione e divulgazione dei dati",
      p1:
        "Le informazioni personali non vengono vendute, affittate o scambiate. Possono essere condivise solo nelle seguenti circostanze:",
      items: [
        { title: "Fornitori di servizi:", body: "Per funzioni come l'elaborazione dei pagamenti o la consegna di email" },
        { title: "Requisiti legali:", body: "Quando richiesto dalla legge, da regolamenti o procedimenti legali" },
        { title: "Operazioni aziendali:", body: "In caso di fusioni, acquisizioni o riorganizzazione" },
        { title: "Sicurezza:", body: "Per proteggere i diritti, la proprietà e la sicurezza di Routed Labs e dei suoi utenti" }
      ]
    },
    retain: {
      heading: "Conservazione e cancellazione dei dati",
      p1: "Le informazioni vengono conservate solo per il tempo necessario agli scopi descritti in questo documento:",
      items: [
        "Account attivi: i dati vengono conservati finché l'account rimane attivo e fino a due anni dopo l'ultima interazione.",
        "Acquisti come ospite: conservati fino a un anno per garantire supporto e completamento del servizio.",
        "Alla cancellazione dell'account: tutte le informazioni personali vengono eliminate in modo permanente dai sistemi attivi."
      ]
    },
    rights: {
      heading: "Diritti dell'utente",
      p1: "Puoi esercitare i seguenti diritti:",
      items: [
        "Accedere e ottenere una copia delle informazioni personali",
        "Richiedere la correzione di dati inesatti",
        "Richiedere la cancellazione dei dati",
        "Revocare il consenso alle comunicazioni di marketing in qualsiasi momento"
      ],
      contactPreamble: "Le richieste possono essere inviate a"
    },
    security: {
      heading: "Sicurezza dei dati",
      p1:
        "Routed Labs applica misure tecniche e organizzative adeguate per proteggere le informazioni personali, tra cui:",
      items: [
        "Crittografia in transito e a riposo",
        "Audit regolari e valutazioni di vulnerabilità",
        "Controlli di accesso rigorosi e protocolli di autenticazione",
        "Infrastruttura e data center sicuri"
      ]
    },
    contact: {
      heading: "Informazioni di contatto",
      p1:
        "Domande o dubbi su questa Informativa sulla privacy possono essere indirizzati a:",
      company: "Routed Labs, Inc.",
      emailLabel: "Email:",
      addressLabel: "Indirizzo:",
      address: "451 Niantic Avenue, Daly City, CA 94014, Stati Uniti",
      subjectLabel: "Oggetto della corrispondenza:",
      subject: "“Richiesta Informativa sulla privacy”"
    },
    updates: {
      heading: "Aggiornamenti di questa informativa",
      p1:
        "La presente Informativa sulla privacy può essere aggiornata periodicamente per riflettere modifiche operative, legali o normative. Le modifiche rilevanti saranno pubblicate su questa pagina con la data di “Ultimo aggiornamento” aggiornata.",
      p2:
        "Gli utenti sono invitati a consultare questo documento regolarmente per rimanere informati su come Routed Labs gestisce le informazioni personali."
    }
  }
},

tos: {
  title: "Termini di Servizio",
  subtitle:
    "Termini e condizioni legali che regolano l'uso della piattaforma Airvoy e dei servizi forniti da Routed Labs, Inc.",
  lastUpdated: { label: "Ultimo aggiornamento:", date: "1 agosto 2025" },
  sections: {
    agreement: {
      heading: "Accordo sui Termini",
      p1:
        "Questi Termini di Servizio (“Termini”) costituiscono un accordo legalmente vincolante tra l'utente (“tu”) e Routed Labs, Inc. (“Routed Labs,” “noi,” “nostro” o “ci”) riguardante l'uso del sito web Airvoy, dell'applicazione mobile e dei relativi servizi eSIM (collettivamente, il “Servizio”).",
      p2:
        "Accedendo o utilizzando il Servizio, dichiari di aver letto, compreso e di accettare di essere vincolato da questi Termini. Se non sei d'accordo, devi astenerti dall'accedere o utilizzare il Servizio."
    },
    service: {
      heading: "Descrizione del Servizio",
      p1:
        "Il Servizio fornisce funzionalità eSIM (SIM incorporata) che consentono agli utenti di accedere alle reti dati cellulari a livello internazionale. Le offerte includono:",
      items: [
        "Profili eSIM digitali per connettività globale",
        "Varie opzioni di piani dati con diverse durate",
        "Consegna del codice QR per attivazione e installazione",
        "Supporto clienti per richieste tecniche",
        "Strumenti di gestione account per utenti registrati"
      ],
      notice:
        "Importante: Il Servizio richiede un dispositivo compatibile e sbloccato. Non garantiamo la compatibilità con tutti i dispositivi o la copertura in tutte le aree geografiche."
    },
    eligibility: {
      heading: "Idoneità",
      p1: "Per utilizzare il Servizio, dichiari e garantisci di:",
      items: [
        "Avere almeno 18 anni o il consenso dei genitori",
        "Avere la capacità legale di stipulare un contratto vincolante",
        "Fornire informazioni di registrazione accurate e complete",
        "Possedere o essere autorizzato a utilizzare un dispositivo compatibile",
        "Rispettare le leggi e i regolamenti applicabili"
      ]
    },
    account: {
      heading: "Registrazione dell'Account",
      p1:
        "Gli utenti possono acquistare eSIM come titolari di account registrati o come ospiti. La registrazione offre funzionalità aggiuntive, tra cui cronologia degli acquisti e supporto esteso.",
      registered: {
        title: "Account Registrati",
        items: [
          "È richiesto un indirizzo email valido",
          "Responsabilità di mantenere la sicurezza dell'account",
          "Obbligo di mantenere informazioni accurate",
          "Notifica immediata in caso di accesso non autorizzato"
        ]
      },
      guest: {
        title: "Acquisti come Ospite",
        items: [
          "Richiede solo un indirizzo email",
          "eSIM consegnata elettronicamente",
          "Supporto limitato a questioni relative all'acquisto",
          "Nessuna cronologia acquisti mantenuta"
        ]
      }
    },
    payment: {
      heading: "Condizioni di Pagamento",
      p1:
        "Completando un acquisto, autorizzi Routed Labs e i suoi processori di pagamento a addebitare il metodo di pagamento fornito. Termini principali includono:",
      items: [
        "Tutti i prezzi sono indicati in dollari statunitensi e includono le tasse applicabili",
        "Il pagamento è dovuto al momento dell'acquisto",
        "L'elaborazione del pagamento è gestita da fornitori terzi",
        "Il mancato pagamento può comportare la sospensione del servizio"
      ]
    },
    refunds: {
      heading: "Politica di Rimborso",
      p1: "Le richieste di rimborso vengono valutate in base alle seguenti condizioni:",
      items: [
        "Ammissibili se richieste entro 24 ore dall'acquisto",
        "Non ammissibili una volta che l'eSIM è stata attivata o utilizzata",
        "Problemi tecnici verranno valutati caso per caso",
        "La compatibilità del dispositivo è responsabilità dell'utente"
      ],
      p2: {
        prefix: "Le richieste di rimborso devono essere inviate a ",
        suffix: ", fornendo i dettagli dell'ordine e la motivazione."
      }
    },
    limitations: {
      heading: "Limitazioni del Servizio",
      p1: "Il Servizio è soggetto a limitazioni, tra cui:",
      items: [
        "Il dispositivo deve essere compatibile con eSIM e sbloccato",
        "La copertura dipende dalle reti partner locali",
        "Velocità e disponibilità variano in base alla posizione",
        "I dati non utilizzati scadono e non vengono trasferiti",
        "I piani non possono essere trasferiti tra dispositivi"
      ]
    },
    prohibited: {
      heading: "Usi Vietati",
      p1:
        "Accetti di non utilizzare il Servizio per scopi illeciti o vietati, inclusi ma non limitati a:",
      items: [
        "Attività illegali o violazioni normative",
        "Molestie, abusi o attività fraudolente",
        "Accesso o interferenza non autorizzata alla rete",
        "Rivendita o condivisione delle credenziali senza consenso",
        "Uso eccessivo che compromette le prestazioni della rete"
      ]
    },
    liability: {
      heading: "Limitazione di Responsabilità",
      p1:
        "Nella misura massima consentita dalla legge, Routed Labs non sarà responsabile per danni indiretti, incidentali o consequenziali derivanti dall'uso del Servizio. La responsabilità totale non supererà l'importo pagato da te per il Servizio che ha dato origine al reclamo nei dodici (12) mesi precedenti."
    },
    indemnity: {
      heading: "Manleva",
      p1:
        "Accetti di indennizzare e tenere indenne Routed Labs e le sue affiliate da reclami, danni o spese derivanti dal tuo uso improprio del Servizio o dalla violazione di questi Termini."
    },
    termination: {
      heading: "Risoluzione",
      p1:
        "Possiamo sospendere o terminare l'accesso al Servizio immediatamente se violi questi Termini, intraprendi condotte illecite o agisci in modo dannoso per Routed Labs o i suoi utenti. Alla risoluzione, i tuoi diritti di utilizzo del Servizio cessano immediatamente."
    },
    law: {
      heading: "Legge Applicabile",
      p1:
        "Questi Termini sono regolati dalle leggi dello Stato del Delaware, Stati Uniti. Accetti di sottoporre eventuali controversie alla giurisdizione esclusiva dei tribunali situati nel Delaware."
    },
    amend: {
      heading: "Modifiche",
      p1:
        "Routed Labs si riserva il diritto di modificare questi Termini a propria discrezione. Gli aggiornamenti saranno pubblicati sul sito web e avranno effetto immediato salvo diversa indicazione. L'uso continuato del Servizio dopo le modifiche implica l'accettazione dei Termini aggiornati."
    },
    contact: {
      heading: "Informazioni di Contatto",
      p1: "Per domande relative a questi Termini, contatta:"
    }
  }
},
about: {
  title: "Informazioni su Airvoy",
  sections: {
    overview: {
      heading: "Panoramica",
      body:
        "Airvoy è una piattaforma eSIM sviluppata da Routed Labs, Inc. La piattaforma offre ai viaggiatori internazionali una connettività mobile accessibile, conveniente e affidabile. Eliminando la necessità di SIM fisiche, il servizio consente l'attivazione immediata di piani dati in oltre 200 destinazioni."
    },
    mission: {
      heading: "Missione",
      body:
        "Routed Labs, Inc. opera con una missione chiara: semplificare la connettività mobile. L'azienda mira a eliminare incertezze, costi nascosti e ostacoli logistici legati al roaming internazionale e all'acquisto di SIM, garantendo che i viaggiatori possano rimanere connessi con facilità."
    },
    background: {
      heading: "Contesto",
      p1:
        "Routed Labs, Inc. ha sede a Daly City, California. La nascita della nostra azienda deriva da esperienze dirette delle difficoltà legate alla connettività internazionale, come tariffe di roaming elevate e disponibilità limitata di SIM.",
      p2:
        "Osservando queste sfide, il fondatore ha individuato l'opportunità di sfruttare la tecnologia eSIM per migliorare la connettività globale.",
      p3:
        "Oggi l'azienda supporta migliaia di utenti in tutto il mondo, con un'enfasi su affidabilità, trasparenza e accessibilità."
    },
    operations: {
      heading: "Operazioni",
      items: [
        { title: "Copertura Globale:", desc: "Accesso a reti ad alta velocità in oltre 200 paesi e territori." },
        { title: "Provisioning eSIM:", desc: "Installazione digitale del piano in pochi minuti, senza schede SIM fisiche." },
        { title: "Orientamento al Cliente:", desc: "Servizi e supporto progettati per privilegiare chiarezza ed esigenze dell'utente." }
      ]
    },
    corporate: {
      heading: "Informazioni Aziendali",
      company: {
        title: "Dettagli Aziendali",
        nameLabel: "Nome dell'Azienda:",
        name: "Routed Labs, Inc.",
        repLabel: "Rappresentante:",
        rep: "Hector Diaz",
        addrLabel: "Indirizzo della Sede Centrale:",
        addr: "451 Niantic Avenue, Daly City, CA 94014, Stati Uniti",
        contactLabel: "Contatto:"
      },
      agent: {
        title: "Informazioni sull'Agente Registrato",
        nameLabel: "Nome dell'Agente Registrato:",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "Indirizzo dell'Agente Registrato:",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, Stati Uniti"
      }
    },
    comms: {
      heading: "Comunicazioni",
      p1: {
        prefix: "Per richieste ufficiali o corrispondenza, scrivi a",
        suffix:
          ". La corrispondenza aziendale e legale può essere indirizzata anche all'agente registrato della società, Legalinc Corporate Services Inc., presso il suo indirizzo a Newark, Delaware."
      }
    }
  }
},

auth: {
  titles: {
    signin: 'Bentornato',
    signup: 'Crea account',
    forgot: 'Reimposta password',
  },
  subtitles: {
    signin: 'Accedi per acquistare piani eSIM',
    signup: 'Unisciti ad Airvoy oggi',
    forgot: 'Inserisci la tua email per reimpostare la password',
  },
  fields: {
    email: 'Indirizzo email',
    password: 'Password',
    confirmPassword: 'Conferma password',
  },
  placeholders: {
    email: 'Inserisci la tua email',
    password: 'Inserisci la tua password',
    confirmPassword: 'Conferma la tua password',
  },
  actions: {
    close: 'Chiudi',
    continueWithGoogle: 'Continua con Google',
    signingIn: 'Accesso in corso...',
    pleaseWait: 'Attendere...',
    signIn: 'Accedi',
    createAccount: 'Crea account',
    sendReset: 'Invia email di reimpostazione',
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
  },
  labels: {
    orEmail: 'Oppure continua con l’email',
  },
  links: {
    noAccount: "Non hai un account?",
    signUp: 'Registrati',
    forgot: 'Hai dimenticato la password?',
    haveAccount: 'Hai già un account?',
    signIn: 'Accedi',
    remembered: 'Ricordi la password?',
    backToSignIn: 'Torna al login',
  },
  messages: {
    resetSent: 'Email per reimpostare la password inviata! Controlla la tua casella di posta.',
  },
  errors: {
    fillAll: 'Compila tutti i campi',
    userNotFound: 'Nessun account trovato con questo indirizzo email',
    wrongPassword: 'Email o password errata',
    emailInUse: 'Esiste già un account con questa email',
    weakPassword: 'La password è troppo debole',
    invalidEmail: 'Indirizzo email non valido',
    tooManyRequests: 'Troppi tentativi falliti. Riprova più tardi',
    popupClosed: 'La finestra di accesso è stata chiusa prima del completamento',
    popupCancelled: 'Accesso annullato',
    popupBlocked: 'La finestra di accesso è stata bloccata dal browser',
    passwordMismatch: 'Le password non corrispondono',
    passwordMin: 'La password deve contenere almeno 6 caratteri',
    enterEmail: 'Inserisci il tuo indirizzo email',
    generic: 'Si è verificato un errore. Riprova',
  },
  legal: {
    prefix: 'Creando un account accetti i nostri',
    terms: 'Termini di servizio',
    and: 'e',
    privacy: 'Informativa sulla privacy',
  },
},
support: {
  title: "Supporto",
  contactInfo: "Informazioni di contatto",
  channels: {
    email: {
      title: "Supporto email",
      description: "Per richieste, segnalazioni e assistenza.",
      contact: "support@routedlabs.com",
      action: "Scrivi email"
    },
    chat: {
      title: "Chat dal vivo",
      description: "Assistenza in tempo reale per questioni urgenti, soggetta a disponibilità.",
      contact: "Disponibile 09:00–18:00 Ora del Pacifico",
      action: "Apri chat"
    }
  },
  faqTitle: "Domande frequenti",
  noResults: "Nessun risultato corrisponde alla ricerca corrente.",
  categoryLabel: "Categoria:",
  show: "Mostra",
  hide: "Nascondi",
  noticesTitle: "Avvisi e comunicazioni",
  noticesLine1: {
    before: "Le richieste ufficiali e la corrispondenza devono essere indirizzate a",
    after: "."
  },
  noticesLine2:
    "Questa pagina descrive i processi di supporto e fornisce riferimenti. Non modifica né sostituisce i termini di servizio o le politiche applicabili, che restano vincolanti in ogni caso.",
  categories: {
    overview: "Panoramica eSIM",
    compatibility: "Compatibilità dispositivi",
    installation: "Installazione",
    dualSim: "Dual SIM",
    dataUsage: "Uso dei dati",
    planMgmt: "Gestione piani",
    deviceReqs: "Requisiti del dispositivo",
    troubleshooting: "Risoluzione problemi",
    refunds: "Rimborsi",
    supportHours: "Orari di supporto"
  },
  faqs: {
    1: {
      q: "Cos’è un’eSIM e come funziona?",
      a: "Un’eSIM (embedded SIM) è una SIM programmabile integrata nel dispositivo che consente l’attivazione del servizio cellulare senza scheda fisica. Gli utenti attivano un profilo digitalmente e possono connettersi scansionando un codice o seguendo i passaggi di configurazione su Airvoy."
    },
    2: {
      q: "Quali dispositivi supportano la funzionalità eSIM?",
      a: "Molti smartphone moderni supportano la tecnologia eSIM, inclusi i modelli recenti dei principali produttori. Controlla le impostazioni del dispositivo (spesso in “Cellulare” o “Dati mobili”) per verificare la presenza dell’opzione “Aggiungi piano dati”."
    },
    3: {
      q: "Come si installa un’eSIM?",
      a: "Dopo l’acquisto, riceverai via email le istruzioni di installazione e un codice QR. Sul tuo dispositivo vai su Impostazioni → Cellulare/Dati mobili → Aggiungi piano dati e scansiona il codice. L’attivazione si completerà automaticamente dopo le istruzioni a schermo."
    },
    4: {
      q: "È possibile usare una SIM fisica e un’eSIM insieme sullo stesso dispositivo?",
      a: "La maggior parte dei dispositivi compatibili con eSIM supporta la modalità dual SIM. Puoi mantenere il tuo numero principale per chiamate e messaggi mentre usi l’eSIM per i dati. La selezione avviene nelle impostazioni del dispositivo."
    },
    5: {
      q: "Cosa succede se non consumo tutti i dati inclusi?",
      a: "I dati non utilizzati non vengono trasferiti né rimborsati. I piani scadono al termine del periodo di validità. Scegli un piano adeguato alle tue esigenze di viaggio."
    },
    6: {
      q: "È possibile aggiungere dati o estendere un piano attivo?",
      a: "Sì. Puoi acquistare dati aggiuntivi o estendere il servizio comprando un altro piano sul sito web o dal tuo account, se disponibile per la destinazione scelta."
    },
    7: {
      q: "Il dispositivo deve essere sbloccato?",
      a: "Sì. Per usare un’eSIM di un altro operatore, il dispositivo deve essere sbloccato. Se è bloccato, contatta il tuo operatore per richiederne lo sblocco prima dell’attivazione."
    },
    8: {
      q: "Cosa fare se l’eSIM non funziona come previsto?",
      a: "Verifica che il dispositivo sia sbloccato e compatibile con eSIM. Assicurati che il roaming dati sia attivo, che il piano dati corretto sia selezionato e prova a riavviare il dispositivo. Se i problemi persistono, contatta l’assistenza."
    },
    9: {
      q: "Sono previsti rimborsi?",
      a: "I rimborsi possono essere richiesti entro 24 ore dall’acquisto se l’eSIM non è stata attivata o utilizzata. Una volta attivata, la vendita è definitiva. Per problemi tecnici, il supporto tenterà la risoluzione o potrà fornire credito sull’account se appropriato."
    },
    10: {
      q: "Quali sono gli orari di supporto e i tempi di risposta?",
      a: "Il supporto via email è sempre disponibile. I tempi di risposta tipici sono di poche ore. Le problematiche urgenti segnalate durante il viaggio ricevono priorità elevata."
    }
  }
}

  },
  ja: {
    // Navigation
nav: {
  installEsim: "eSIMをインストール",
  business: "管理",
  faqs: "よくある質問",
  browsePlans: "プランを探す",
  partnerships: "パートナーシップ",
  dashboard: "ダッシュボード",
  signOut: "サインアウト",
  signIn: "サインイン",
  getTheApp: "アプリを入手"
},

    // Hero Section
hero: {
  badge: "Airvoy eSIMを利用する30,000人以上の旅行者に参加しよう。",
  title: "世界中で使える",
  titleHighlight: "eSIM",
  subtitle: "まるで自宅にいるように接続を維持—即時セットアップ、柔軟なデータ、200以上の国と地域をカバー。",
  searchPlaceholder: "どこへ旅行しますか？",
  appStore: "App Store",
  googlePlay: "Google Play"
},

// Popular Countries
popularCountries: {
  title: "人気の渡航先",
  subtitle: "人気の旅行先で即座に接続しましょう",
  fromPrice: "〜から",
  perDay: "/日",
  unlimited: "無制限",
  startingAt: "開始価格",
  getStarted: "始める",
  viewAllCountries: "すべての国を見る",
  noPlansAvailable: "無制限プランは利用できません"
},
// How It Works
howItWorks: {
  title: "Airvoy eSIMの仕組み",
  subtitle: "3つの簡単なステップで接続完了",
  step1Title: "渡航先を選ぶ",
  step1Desc: "200以上の渡航先を透明な価格で検索。隠れた手数料もサプライズもなく、冒険に最適なプランを見つけましょう。",
  step2Title: "数秒でインストール",
  step2Desc: "eSIMはメールですぐに届きます。QRコードを一度スキャンするだけで準備完了—店舗訪問や物理SIMの差し替えは不要です。",
  step3Title: "自動で接続",
  step3Desc: "到着したらすぐに接続。eSIMは到着時に自動的に有効化され、空港のWiFi探しから解放されます。",
  learnMore: "もっと詳しく"
},
// Benefits
benefits: {
  whyAirvoy: "なぜAirvoy？",
  title: "どこにいてもつながり続ける",
  item1Title: "自分に合ったプランを見つける",
  item1Desc: "予算に合わせた柔軟なデータプラン。週1GBから半年持つ100GBまで—すべて1つのアプリで簡単に。",
  item2Title: "使いやすい",
  item2Desc: "Airvoyをダウンロードし、eSIMをインストール、データプランを購入するだけ—目的地に着いた瞬間に自動で有効化されます。",
  item3Title: "ローミング料金を回避",
  item3Desc: "思わぬローミング料金とはもうお別れ。旅行前に通信費を把握して安心して出発できます！",
  item4Title: "1つのeSIMで全ての旅をカバー",
  item4Desc: "既存のAirvoy eSIMに新しい渡航先を追加可能—毎回新しいeSIMをインストールする必要はありません。チャージするだけで接続！",
  item5Title: "データ切れの心配なし",
  item5Desc: "最悪のタイミングでデータが尽きる心配は不要—プランの80%を使った時点で通知します。",
  item6Title: "200以上の国と地域",
  item6Desc: "世界200以上の国と地域でオンラインを維持しましょう。"
},
// Videos
videos: {
  title: "動画を見てすぐ接続",
  subtitle: "iPhoneとSamsung向けの2つの簡単ガイド",
  iPhoneTitle: "eSIM設定と有効化 — iPhone",
  iPhoneDesc: "Airvoy eSIMをiPhoneでインストール・有効化する手順ガイド。スキャンして数分でオンラインに。",
  samsungTitle: "eSIM設定と有効化 — Samsung",
  samsungDesc: "Samsung Galaxy端末でAirvoy eSIMを追加する方法。インストールから接続までをわかりやすく解説。",
  iOSGuide: "iOSガイド",
  samsungGuide: "Samsungガイド",
  installationGuide: "または完全なインストールガイドを読む"
},
// Footer
footer: {
  description: "Airvoy eSIMを利用する30,000人以上の旅行者に参加しよう。スマートに旅をして、どこでもつながろう。",
  company: "会社情報",
  aboutUs: "私たちについて",
  resources: "リソース",
  documentation: "ドキュメント",
  support: "サポート",
  legal: "法的情報",
  privacyPolicy: "プライバシーポリシー",
  termsOfService: "利用規約",
  followUs: "フォローする",
  copyright: "全著作権所有。",
  madeWith: "作成：",
  forTravelers: "世界中の旅行者のために"
},
// Auth
aut: {
  authenticationRequired: "認証が必要です",
  signInPrompt: "ダッシュボードにアクセスしてeSIMプランを購入するにはサインインしてください。"
},

// Common
common: {
  close: "閉じる",
  loading: "読み込み中...",
  tryAgain: "再試行",
  noResults: "該当する国が見つかりません："
},
activate: {
  altText: "Airvoy eSIM グローバル有効化",
  activeInThailand: "Airvoy タイで利用可能",
  activeInSpain: "Airvoy スペインで利用可能", 
  activeWorldwide: "Airvoy 世界中で利用可能",
  activeInGreece: "Airvoy ギリシャで利用可能",
  activeInMexico: "Airvoy メキシコで利用可能",
  title: "WhatsApp番号を保持",
  description: "同じ国にいるかのように、WhatsAppで全ての連絡先に通話やメッセージができます。\n家族や友人とのつながりを失わないでください。"
},
regionalPlans: {
  multiCountryCoverage: "複数国をカバー",
  title: "地域プラン", 
  subtitle: "地域を選び、必要な期間・データ量のプランを選びましょう。",
  noPlansAvailable: "利用可能な地域プランはありません。",
  from: "〜から",
  seePlans: "プランを見る",
  countries: "国",
  plans: "プラン", 
  startingFrom: "開始価格",
  browseOptions: "オプションを見る",
  viewPlans: "プランを表示"
},

partnerships: {
  headerLabel: "パートナーシップ",
  title: "Airvoy パートナーシップ",
  subtitle: "一緒に素晴らしいことを成し遂げましょう。",
  join: "参加する",
  airvoyAffiliate: "Airvoy\nアフィリエイトプログラム", 
  affiliateDescription: "Airvoy eSIMを紹介して最大20％のコミッションを獲得—公式アフィリエイトネットワークに今すぐ参加しよう！",
  joinNow: "今すぐ参加！",
  learnMore: "詳細を見る",
  partnershipImageAlt: "Airvoy パートナーシップ",

  // Partnership types
  affiliateProgram: "アフィリエイトプログラム",
  eventPartnership: "イベントパートナーシップ", 
  travelPartnership: "旅行パートナーシップ",
  contentPartnership: "コンテンツパートナーシップ",
  sportsPartnership: "スポーツパートナーシップ",
  musicCulturePartnership: "音楽 & 文化パートナーシップ",
  athleteCollaboration: "アスリートコラボレーション",
  other: "その他",

  // Partnership descriptions
  eventPartnerships: "イベントパートナーシップ",
  eventDescription1: "国際的なイベントを開催していて、参加者に無料モバイルデータという便利な特典を提供したいですか？",
  eventDescription2: "イベントの前、最中、そして終了後もシームレスに接続できるよう、あなたとゲストに最適なソリューションをカスタマイズします。",

  travelPartnerships: "旅行パートナーシップ",
  travelDescription1: "海外旅行する社員や顧客に、シームレスで低価格なモバイルデータや音声通話を提供したいと考えていますか？",
  travelDescription2: "当社の統合型モバイル接続ソリューションを使えば、最小限の手間で最大限の付加価値を持つ旅行サービスをクライアントに提供できます。",

  contentPartnerships: "コンテンツパートナーシップ", 
  contentDescription1: "ソーシャルメディアでクリエイティブなアイデアを持ち、熱心なフォロワーがいて、#TravelHacks や #LifeHacks に興味がありますか？",
  contentDescription2: "それとも、ただAirvoyが好きで、世界中でシームレスなモバイル接続を広めたいですか？",

  sportsPartnerships: "スポーツパートナーシップ",
  sportsDescription1: "スポーツ大会を運営していて、アスリート、チーム、ファンがイベント中ずっと信頼できる接続を利用できるようにしたいですか？",
  sportsDescription2: "Airvoyと提携して、開会式から閉会の瞬間まで全員をつなぐシームレスなモバイルデータソリューションを提供しましょう。",

  musicCulturePartnerships: "音楽 & 文化パートナーシップ",
  musicDescription1: "音楽フェスや文化イベント、ライブ公演を企画していて、来場者の体験を向上させたいですか？",
  musicDescription2: "Airvoyは、参加者が共有・配信しながらイベントを楽しめるよう、信頼できるモバイルデータサービスを提供します。",

  athleteCollaborations: "アスリートコラボレーション",
  athleteDescription1: "世界中を転戦するアスリートで、トロフィーキャビネットがいっぱいになっていませんか？",
  athleteDescription2: "Airvoyと提携して、どこにいても接続を維持し、ファンに旅を共有しましょう。",

  letsTalk: "話しましょう",

  // Contact form
  getInTouch: "お問い合わせ",
  successMessage: "ご連絡ありがとうございます！まもなく返信いたします。",
  errorMessage: "問題が発生しました。もう一度お試しください。",
  emailPlaceholder: "メールアドレスを入力",
  fullNamePlaceholder: "氏名",
  partnerTypePlaceholder: "どのような提携をお考えですか？",
  messagePlaceholder: "ご希望の内容を簡単にお知らせください",
  privacyConsent: "次の内容に同意します：",
  privacyPolicy: "プライバシーポリシー",
  sending: "送信中...",
  send: "送信"
},

faq: {
  headerLabel: "FAQ",
  title: "よくある質問とその答え",
  learnMore: "詳細を見る",

  whatIsEsim: {
    question: "eSIMとは何ですか？",
    answer: "eSIMは業界標準のデジタルSIMで、物理SIMを使わずに通信キャリアのモバイルプランを有効化できます。iPhoneでは8枚以上のeSIMをインストールし、同時に2つの電話番号を使用できます。"
  },

  howToSetup: {
    question: "eSIMの設定方法は？",
    answer: "eSIMは非常に便利な技術です。ただし、初めて設定する場合は少し手間がかかるかもしれません。でも安心してください。ステップごとのガイドを用意しているので、すぐにAirvoyを使い始められます。"
  },

  whatIsAirvoy: {
    question: "Airvoyとは何ですか？",
    answer: "Airvoyはグローバルなモバイル接続ソリューションを提供するモバイルアプリです。物理SIMカードや高額なローミング料金なしで、旅行中もシームレスに接続できます。"
  },

  howSaveRoaming: {
    question: "Airvoyはどのようにローミング料金を節約しますか？",
    answer: "Airvoyは一般的なローミング料金より最大90％安いモバイルデータを提供します。これにより、従来のローミングサービスに伴う高額な費用を避けることができます。"
  },

  needNewSim: {
    question: "Airvoyを使うたびに新しいSIMカードを買う必要がありますか？",
    answer: "いいえ。AirvoyはeSIM技術を使用しているため、物理SIMカードは不要です。Airvoy eSIMはグローバル対応で、一度ダウンロードして有効化すれば、世界中で利用できます。特定の国用に新しいeSIMを購入することも可能です。"
  },

  constantConnectivity: {
    question: "Airvoyは旅行中にどのようにして接続を維持しますか？",
    answer: "Airvoyは一般的なローミング料金より最大90％安いモバイルデータを提供します。これにより、高額な従来型ローミングを避けることができます。"
  },

  freeCallsTexts: {
    question: "Airvoyは無料通話やメッセージを提供しますか？",
    answer: "まだ対応していませんが、Airvoyユーザー同士で無料通話やメッセージができる機能を近日中に提供予定です。"
  },

  whyChooseAirvoy: {
    question: "他のローミング代替手段よりAirvoyを選ぶ理由は？",
    answer: "Airvoyは1つのeSIMでシームレスなグローバル接続を提供し、コスト効率が高く、近々メッセージングやローカル番号の機能も追加予定です。手頃で使いやすく、どこにいても自由に接続方法をコントロールできます。"
  }
},

browse: {
  main: {
    title: "eSIMプランを閲覧",
    subtitle: "世界中の目的地向けeSIMプランをリアルタイム価格で見つける"
  },
  search: {
    placeholder: "国を検索（例：アメリカ、スペイン、日本）...",
    clearSearch: "検索をクリア",
    noCountriesFound: "検索に一致する国が見つかりませんでした。",
    noCountriesAvailable: "利用可能な国がありません。",
    clearSearchButton: "検索をクリア",
    searching: "国を検索中...",
    country: "国",
    countries: "国",
    foundFor: "件見つかりました"
  },
  loading: {
    loadingText: "読み込み中...",
    allCountriesLoaded: "すべての国を読み込みました",
    total: "合計"
  },
  buttons: {
    showMoreCountries: "さらに国を表示",
    showLessPlans: "プランを少なく表示",
    showLess: "表示を減らす",
    seeMorePlans: "さらにプランを見る",
    more: "もっと見る",
    buyNow: "今すぐ購入"
  },
  navigation: {
    backToCountries: "国一覧に戻る"
  },
  countryDetails: {
    description: "{{country}}を柔軟に探索するために、当社のeSIMデータプランをご利用ください。短期滞在でも長期旅行でも、手間なく接続を維持できます。"
  },
  plans: {
    noPlansAvailable: "選択したフィルターに該当するプランはありません。",
    planDetails: "プラン詳細",
    details: "詳細",
    unlimited: "無制限",
    for: "期間",
    day: "日",
    days: "日間"
  },
  checkout: {
    total: "合計"
  },
  planDetails: {
    title: "プラン詳細",
    unlimitedData: "データ無制限",
    data: "データ",
    country: "国",
    duration: "期間",
    day: "日",
    days: "日間",
    network: "ネットワーク",
    autoStart: "自動開始",
    enabled: "有効",
    disabled: "無効",
    planType: "プランタイプ",
    description: "説明",
    purchaseThisPlan: "このプランを購入",
    signInToPurchase: "購入するにはサインイン"
  }
},
installation: {
  title: "eSIMのインストールと設定方法",
  metaUpdated: "2か月前 • 更新済み",
  intro: {
    p1: "AndroidまたはAppleのどちらをお使いでも、まず端末がeSIM対応かつネットワークロック解除済みであることを確認してください。安定したインターネット接続（Wi-Fi推奨）も必要です。",
    p2: "その後、以下のいずれかの方法で設定できます：",
    ol1: "QRコードをスキャンして自動インストール",
    ol2: "手動でeSIMをインストール",
    note: "QRコードを使ったインストールが最も簡単な方法です。"
  },
  ios: {
    qr: {
      title: "QRコードを使ってeSIMをインストールする（iOS）",
      s1: "1. 設定 > モバイル通信 に移動",
      s2: "2. 「eSIMを追加」をタップし「QRコードを使用」を選択",
      s3: "3. QRコードをスキャンし、求められたら4桁の確認コードを入力",
      s4: "4. eSIMにラベルを付け、デフォルト回線で「モバイルデータのみ」を選択",
      s5: "5. 「モバイル通信」にeSIMが表示されます"
    },
    manual: {
      title: "手動でeSIMをインストールする方法（iOS）",
      s1: "1. 設定 > モバイル通信 > eSIMを追加",
      s2: "2. 「eSIMを追加」をタップし「QRコードを使用」を選択",
      s3: "3. スキャンの代わりに「詳細を手動で入力」を選択",
      s4: "4. Airvoyアプリに表示されるSM-DP+アドレス、アクティベーションコード、必要に応じて確認コードを入力",
      s5: "5. eSIMにラベルを付け、デフォルト回線で「モバイルデータのみ」を選択",
      s6: "6. 「モバイル通信」にeSIMが表示されます"
    }
  },
  android: {
    qr: {
      title: "QRコードを使ってeSIMをインストールする（Android）",
      s1: "1. 設定 > ネットワークとインターネット > SIM に移動",
      s2: "2. 「SIM」の右側にある「＋」アイコンをタップ",
      s3: "3. 下部の「代わりにSIMをダウンロードしますか？」をタップ",
      s4: "4. 「SIMをダウンロード」画面で「次へ」をタップ — 「ネットワーク情報を確認中...」が表示されます",
      s5: "5. 確認が終わるとQRコードをスキャンするビューファインダーが表示されます",
      s6: "6. 印刷されたQRコードまたは別のデバイスに表示されたコードをスキャンします",
      s7: "7. スキャン後、デバイスが情報を再確認します",
      s8: "8. 「ダウンロード」をタップして確認 — eSIMデータがダウンロードされます",
      s9: "9. 完了すると「ダウンロードが完了しました」と表示されます",
      s10: "10. 準備ができたらeSIMをインターネット接続用に設定します"
    }
  },
  notes: {
    title: "重要な注意点",
    n1: "端末がeSIM対応かつネットワークロック解除済みであることを確認してください",
    n2: "インストール中は安定したWi-Fi接続が必要です",
    n3: "eSIMは一度しかインストールできません — 準備ができたときに開始してください",
    n4: "自宅の電話番号からの通話やSMSのためにメインSIMを有効にしておいてください",
    n5: "eSIMは目的地の国に到着したときにアクティブになります"
  },
  support: {
    title: "サポートが必要ですか？",
    body: "eSIMのインストールで問題がある場合、当社のサポートチームがサポートします！",
    emailLabel: "メール：",
    websiteLabel: "ウェブサイト："
  }
},

installGuide: {
  header: {
    title: "eSIMインストール完全ガイド",
    subtitle: "eSIMをインストール、アクティベート、利用するために必要なすべての情報をまとめました。デバイスごとの手順に従って、スムーズな設定を体験してください。",
    link: "Androidでのインストール方法も詳しく見る",
    ios: "iOSの詳細ガイド",
        android: "Androidの詳細ガイド"
  },
  iphoneHero: "iPhoneでeSIMをインストールして有効化する",
  cards: {
    c1: {
      alt: "トグルスイッチと時計アイコンのあるiPhone",
      install: "インストール",
      activate: "有効化",
      textA: "旅行の数時間前に、または",
      textB: "フライト中や到着時に実行してください。"
    },
    c2: {
      alt: "QRコードスキャナー画面のiPhone",
      line1: "「QRコードでインストール」を選択",
      line2: "コードが他のデバイスに表示されている場合、",
      line3: "カメラでスキャンします。"
    },
    c3: {
      alt: "手動インストール画面のiPhone",
      line1: "「手動でインストール」を選択",
      line2: "QRコードがスキャンできない場合はこちらを使用します。"
    }
  },
  learn: {
    title: "ステップごとに学ぶ",
    subtitle: "希望するインストール方法を選んでください",
    btnQr: "QRコードでインストール",
    btnManual: "手動インストール"
  },
  prep: {
    alt: "スマホ警告アイコン",
    qr: {
      title: "QRコードでのインストールを始める前に、注意すべき重要なポイントがあります：",
      i1: "QRコードは別の画面やデバイスに表示し、インストールする端末のカメラで読み取る必要があります。",
      i2: "手順中は安定したインターネット接続を確保してください。",
      i3: "QRコードは1回しかスキャンできません。",
      i4: "一度インストールしたeSIMを削除すると再利用できません。"
    },
    manual: {
      title: "手動インストールを始める前に、注意すべき重要なポイントがあります：",
      i1: "手動インストールコードは1回しか使用できません。"
    },
    shared: {
      i2: "手順中は安定したインターネット接続を確保してください。",
      i3: "一度インストールしたeSIMを削除すると再利用できません。"
    }
  },
  start: {
    title: "一緒に始めましょう",
    c1: {
      title: "メールを開く",
      qr: { p1: "インストールに使用するデバイスとは別の端末でメールを開き、QRコードが記載されたメールを探してください。" },
      manual: { p1: "「SM-DP+アドレス」と「アクティベーションコード」が記載されたメールを確認し、手元に用意してください。SMSでもお送りします。" },
      shared: { missing: "コードを受け取っていない場合は", contact: "こちらにご連絡ください" }
    },
    c2: {
      qr: { title: "QRコードをスキャンする", p1: "eSIMをインストールするiPhoneのカメラを開き、コードをスキャンします。設定 → モバイル通信 → 「モバイル通信プランを追加」からもスキャンできます。" },
      manual: { title: "iPhoneの「設定」を開く", p1: "次にモバイル通信を開き、「eSIMを追加」または「モバイル通信プランを追加」をタップし、「QRコードを使用」を選んでから「詳細を手動で入力」を選択します。" }
    },
    c3: {
      title: "iPhone上でインストール手順を進める",
      qr: { p1: "コードをスキャンするとインストールが開始されます。以下のガイドを参考にステップごとの設定を行ってください。" },
      manual: { p1: "「QRコードをスキャン」画面に到達したら「詳細を手動で入力」を選択し、表示される手順に従ってください。" }
    }
  },
  compat: {
    title: "デバイス対応状況チェッカー",
    subtitle: "お使いのデバイスがeSIMに対応しているか確認しましょう。検索機能を使えばモデル名で素早く見つけられます。",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "iPhone/iPadモデルを検索…",
    searchAndroid: "Androidモデルを検索…",
    iphones: "対応しているiPhone",
    ipads: "対応しているiPad（4Gモデルのみ）",
    androids: "対応しているAndroid端末",
    noMatch: "検索条件に一致するデバイスが見つかりません。",
    iosNotesTitle: "重要な注意点：",
    iosNotes: {
      i1: "iPhone 13および14モデルは同時に2つのeSIMを有効化可能",
      i2: "中国本土および香港向けのiPhoneはeSIM非対応（いくつかのモデルを除く）",
      i3: "米国で販売されたiPhone 14以降のモデルは物理SIMカード非対応"
    },
    androidNotesTitle: "重要な制限事項：",
    androidNotes: {
      i1: "米国および香港版のSamsung端末はeSIMに対応しない場合があります",
      i2: "オーストラリア、日本、台湾向けのGoogle Pixel端末はeSIM非対応",
      i3: "香港で販売されている多くのスマートフォンはeSIMに対応していません",
      i4: "eSIMを使用するにはデバイスがSIMロック解除されている必要があります"
    },
    empty: "対応状況を確認するにはデバイスモデルを入力してください"
  },
  tips: {
    title: "プロのコツ：旅行前に有効化しておく",
    body: "快適な旅行をするために、出発前にeSIMをインストールし、到着時に有効化しましょう。空港でWi-Fiや現地SIMを探す手間を省き、すぐに接続できます。",
    before: {
      title: "出発前にすること",
      i1: "自宅でeSIMプロファイルをインストールする",
      i2: "インストール手順を事前にテストする",
      i3: "QRコードのスクリーンショットをバックアップとして保存する",
      i4: "デバイスがSIMロック解除されていることを確認する"
    },
    after: {
      title: "到着後にすること",
      i1: "eSIMのモバイルデータをオンにする",
      i2: "ネットワーク登録が完了するまで2〜3分待つ",
      i3: "Web検索などで接続を確認する",
      i4: "必要に応じてデータローミングを設定する"
    }
  },
  support: {
    title: "さらにサポートが必要ですか？",
    body: "専門のサポートチームがあらゆるステップでお手伝いします。デバイス対応の確認からインストール支援まで、安心してお任せください。",
    btnEmail: "メールサポート",
    btnCenter: "サポートセンターを訪問"
  },
  steps: {
    ios: {
      s1: { title: "設定を開く", desc: "設定 → モバイル通信（地域によっては「モバイルデータ」）へ進む", detail: "設定メニューから「モバイル通信」を探してください。一部の国では「モバイルデータ」と表示されます。" },
      s2: { title: "モバイル通信プランを追加", desc: "「モバイル通信プランを追加」または「eSIMを追加」をタップ", detail: "このオプションはモバイル通信設定ページの下部にあります。表示されない場合は、デバイスがeSIM非対応の可能性があります。" },
      s3: { title: "QRコードをスキャン", desc: "「QRコードを使用」を選択し、メールのコードをスキャン", detail: "カメラをQRコードに向けてください。明るい場所で安定させるとスキャンしやすくなります。" },
      s4: { title: "モバイル通信プランを追加", desc: "プラン情報が表示されたら「モバイル通信プランを追加」をタップ", detail: "キャリア情報とプラン内容を確認してから確定します。この操作でeSIMプロファイルがダウンロードされます。" },
      s5: { title: "プランにラベルを付ける", desc: "例：「メイン」「旅行用」「サブ」などを選択", detail: "どのプランをデータや通話に使うか識別しやすくなります。多くの旅行者はデータ専用でeSIMを使用します。" },
      s6: { title: "デフォルト回線を設定", desc: "どの回線をモバイルデータに使うか選択", detail: "通話やSMSは元のSIMを維持しつつ、データだけをeSIMに設定することが可能です。" }
    },
    android: {
      s1: { title: "設定を開く", desc: "設定 → ネットワークとインターネット → SIM へ進む", detail: "メーカーによって表示が異なる場合があります。Samsungでは「設定 → 接続 → SIMカード管理」などになります。" },
      s2: { title: "モバイルプランを追加", desc: "「+」ボタンまたは「モバイルプランを追加」をタップ", detail: "「モバイルプランを追加」「SIMを挿入しないでダウンロード」「キャリアを追加」などが表示されることがあります。" },
      s3: { title: "SIMをダウンロード", desc: "「SIMカードがありません」または「代わりにSIMをダウンロード」を選択", detail: "物理SIMを挿入する代わりにeSIMをインストールすることを端末に伝えます。" },
      s4: { title: "QRコードをスキャン", desc: "「QRコードをスキャン」を選択し、カメラをコードに向ける", detail: "明るい場所で手を安定させてください。カメラが自動でメールのQRコードを認識します。" },
      s5: { title: "プロファイルをダウンロード", desc: "キャリアプロファイルが表示されたら「ダウンロード」をタップ", detail: "端末がインターネットを通じてeSIMプロファイルをダウンロードします。数秒かかる場合があります。" },
      s6: { title: "eSIMを有効化", desc: "eSIMを有効化し、データ接続用に設定する", detail: "データ、通話、SMSで使用するSIMを選択できます。多くの旅行者はデータ専用でeSIMを使用します。" }
    }
  }
},

countryDetails: {
  loading: "国情報を読み込み中...",
  errors: {
    notFound: "国が見つかりません",
    loadFail: "国データの読み込みに失敗しました"
  },
  notFound: {
    title: "国が見つかりません",
    subtitle: "お探しの国は存在しないか、利用可能なプランがありません。",
    cta: "すべての国を表示"
  },
  back: "国一覧に戻る",
  blurb: "Airvoy eSIMのデータプランで{{country}}を柔軟に楽しみましょう。短期滞在でも長期旅行でも、面倒なく接続を維持できます。",
  noPlans: "選択したフィルターでは利用可能なプランがありません。",
  plan: {
    details: "プラン詳細",
    detailsShort: "詳細",
    networkBadge: "5G",
    unlimited: "無制限",
    unlimitedData: "無制限データ",
    gb: "GB",
    gbShort: "GB",
    data: "データ",
    forDays: "{count, plural, one {# 日間} other {# 日間}}"
  },
  currency: {
    usd: "米ドル"
  },
  duration: {
    days: "{count, plural, one {# 日} other {# 日}}"
  },
  more: {
    more: "さらにプランを表示",
    moreShort: "+{extra} 件",
    less: "プランを少なく表示",
    lessShort: "少なく表示"
  },
  modal: {
    title: "プラン詳細",
    country: "国：",
    duration: "期間：",
    network: "ネットワーク：",
    autostart: "自動開始：",
    enabled: "有効",
    disabled: "無効",
    planType: "プランタイプ：",
    description: "説明",
    purchase: "このプランを購入",
    signInToPurchase: "購入するにはサインインしてください"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "合計",
    buy: "今すぐ購入"
  }
},
checkout: {
  loading: "安全なチェックアウトを読み込み中...",
  invalidPlan: {
    title: "無効なプランデータ",
    subtitle: "選択されたプラン情報を読み込めませんでした。",
    cta: "ダッシュボードに戻る"
  },
  success: {
    title: "購入が成功しました！",
    message: "eSIMの購入が完了しました！ ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "QRコードとインストール手順は{{a}}と{{b}}の両方に送信されました",
    sentOne: "QRコードとインストール手順は{{email}}に送信されました",
    view: "マイeSIMを見る"
  },
  common: {
    close: "閉じる"
  },
  header: {
    title: "安全なチェックアウト",
    subtitle: "安全にeSIMを購入してください"
  },
  benefits: {
    title: "サインインして特典を利用",
    copy: "アカウントを作成すると購入履歴の保存、限定オファーの利用、eSIMの管理ができます。",
    cta: "サインアップ / サインイン"
  },
  billing: {
    title: "請求情報",
    subtitle: "請求書とeSIMはこのメールアドレスに送信されます"
  },
  form: {
    firstName: "名",
    lastName: "姓",
    email: "メールアドレス",
    referral: "紹介コード（任意）"
  },
  placeholder: {
    firstName: "名を入力",
    lastName: "姓を入力",
    email: "メールアドレスを入力",
    referral: "紹介コードを入力",
    altEmail: "別のメールアドレスを入力"
  },
  referral: {
    validating: "確認中...",
    invalid: "無効な紹介コードです",
    ownCode: "自分の紹介コードは使用できません",
    inactive: "この紹介コードはすでに無効です",
    used: "この紹介コードはすでに使用されています",
    valid: "有効です！ {{percent}}%割引が適用されました",
    error: "コードの確認中にエラーが発生しました"
  },
  altEmail: {
    title: "別のメールアドレスを使用",
    copy: "eSIMはこの別のメールにも送信され、アカウントにも保存されます",
    input: "別のメールアドレス"
  },
  createAccount: {
    title: "アカウントを作成して購入履歴を保存",
    copy: "任意 - eSIMの管理やサポートの利用に便利です"
  },
  payment: {
    title: "支払い情報",
    secured: "Stripeによって保護されています",
    method: "支払い方法",
    card: "クレジットまたはデビットカード",
    cardTypes: "Visa、Mastercard、American Express",
    paypalCopy: "PayPalで支払う",
    cardInfo: "カード情報",
    loadingSecure: "安全な決済フォームを読み込み中...",
    cardComplete: "カード情報が入力済みです",
    processing: "支払いを処理中...",
    complete: "購入を完了 • ${{total}}"
  },
  legal: {
    agree: "注文を完了すると、以下に同意したものとみなされます：",
    terms: "利用規約",
    and: "および",
    privacy: "プライバシー・返金ポリシー"
  },
  summary: {
    title: "注文概要",
    planLabel: "eSIMプラン",
    digital: "デジタル",
    data: "データ容量：",
    validity: "有効期間：",
    coverage: "対応エリア：",
    nationwide: "全国"
  },
  pricing: {
    planPrice: "プラン価格",
    referralDiscount: "紹介割引（{{percent}}%）",
    stripeFee: "Stripe決済手数料",
    paypalFee: "PayPal決済手数料",
    taxes: "税金・サービス料",
    included: "含まれる",
    total: "合計"
  },
  paypal: {
    description: "{{country}}向けeSIM - {{days}}日間で{{data}}"
  },
  duration: {
    days: "{count, plural, one {# 日} other {# 日}}"
  },
  alerts: {
    enterName: "フルネームを入力してください",
    formNotReady: "支払いフォームの準備ができていません。少し待ってから再試行してください。",
    cardIncomplete: "カード情報を完全に入力してください",
    paypalFailed: "PayPal決済に失敗しました: {{msg}}",
    paypalGeneric: "PayPal決済に失敗しました。もう一度お試しください。",
    purchaseFailed: "購入に失敗しました: {{msg}}"
  }
},

privacy: {
  title: "プライバシーポリシー",
  subtitle:
    "Routed Labs, Inc. による個人情報の収集、利用、および保護に関する取り扱いについての声明。",
  lastUpdated: {
    label: "最終更新日：",
    date: "2025年8月1日"
  },
  sections: {
    intro: {
      heading: "はじめに",
      p1:
        "Routed Labs, Inc.（以下「Routed Labs」「当社」「私たち」）は、Airvoy のウェブサイトおよびモバイルアプリケーション（以下「サービス」）を運営しています。本プライバシーポリシーは、当社が個人情報を収集、利用、開示、保護する方法を定めています。サービスを利用することにより、ここに記載された取り扱いに同意したものとみなされます。",
      p2:
        "Routed Labs は、あなたの個人情報の機密性、完全性、および安全性を維持することに努めています。当社のデータ管理は、透明性、適正性、および関連法規への準拠を基本としています。"
    },
    collect: {
      heading: "収集する情報",
      p1:
        "当社はデータ最小化の原則を遵守し、eSIM サービスの提供に必要な情報のみを収集します。具体的には以下の情報を収集します：",
      email: {
        title: "メールアドレス",
        collectedWhen: "以下の場合に収集されます：",
        items: [
          "アカウントを作成したとき",
          "eSIM プランを購入したとき",
          "ニュースレターを購読したとき",
          "サポートに連絡したとき"
        ],
        purposeLabel: "利用目的：",
        purpose:
          "アカウント管理、eSIM の提供、購入確認、およびカスタマーサポートのため。"
      },
      notCollect: {
        title: "収集しない情報：",
        items: [
          "電話番号やデバイス識別子",
          "位置情報や位置追跡データ",
          "閲覧履歴や行動追跡用のクッキー",
          "SNS プロフィールや個人の写真",
          "金融データ（支払いは第三者決済サービスを通じて処理）"
        ]
      }
    },
    use: {
      heading: "情報の利用方法",
      p1: "収集した情報は、以下の明確な目的のためだけに使用されます：",
      items: [
        "eSIM 資格情報、購入確認、領収書の送付",
        "技術的およびカスタマーサポートの提供",
        "重要なサービス更新やセキュリティ通知の送信",
        "マーケティング資料の配信（同意した場合のみ）"
      ],
      optOut: "マーケティング通信はいつでも配信停止できます。"
    },
    share: {
      heading: "データの共有と開示",
      p1:
        "当社は個人情報を販売、貸与、取引しません。以下の場合にのみ共有されることがあります：",
      items: [
        { title: "サービス提供者：", body: "支払い処理やメール配信などの機能を提供する場合" },
        { title: "法的要件：", body: "法律、規制、または法的手続きにより義務付けられる場合" },
        { title: "事業取引：", body: "合併、買収、または事業再編に関連する場合" },
        { title: "セキュリティ：", body: "Routed Labs およびユーザーの権利、財産、安全を保護するため" }
      ]
    },
    retain: {
      heading: "データの保存と削除",
      p1: "情報は以下に示す目的のため必要な期間のみ保持されます：",
      items: [
        "アクティブなアカウント：アカウントが有効な間および最後の利用から最大2年間保持。",
        "ゲスト購入：サポートと提供を保証するため最大1年間保持。",
        "アカウント削除後：すべての個人情報はアクティブなシステムから完全に消去されます。"
      ]
    },
    rights: {
      heading: "個人の権利",
      p1: "あなたは次の権利を行使できます：",
      items: [
        "個人情報へのアクセスおよびコピーの取得",
        "不正確なデータの修正を要求",
        "記録の削除を要求",
        "マーケティング通信の同意をいつでも撤回"
      ],
      contactPreamble: "これらの要求は以下に送付してください："
    },
    security: {
      heading: "データセキュリティ",
      p1:
        "Routed Labs は個人情報を保護するために適切な技術的および組織的措置を適用しています。例：",
      items: [
        "通信および保存時の暗号化",
        "定期的な監査と脆弱性評価",
        "厳格なアクセス制御と認証プロトコル",
        "安全なインフラとデータセンター"
      ]
    },
    contact: {
      heading: "お問い合わせ先",
      p1:
        "このプライバシーポリシーに関する質問や懸念は以下にご連絡ください：",
      company: "Routed Labs, Inc.",
      emailLabel: "メール：",
      addressLabel: "住所：",
      address: "451 Niantic Avenue, Daly City, CA 94014, United States",
      subjectLabel: "件名：",
      subject: "「プライバシーポリシーに関する問い合わせ」"
    },
    updates: {
      heading: "本ポリシーの更新",
      p1:
        "本プライバシーポリシーは、運営上、法的、または規制上の変更を反映するために随時改訂される場合があります。重要な変更があった場合は、本ページ上で更新日とともに公表されます。",
      p2:
        "ユーザーは、Routed Labs による個人情報の取り扱いを把握するため、定期的に本書を確認することを推奨します。"
    }
  }
},
tos: {
  title: "利用規約",
  subtitle:
    "Routed Labs, Inc. が提供する Airvoy プラットフォームおよびサービスの利用に関する法的条件。",
  lastUpdated: { label: "最終更新日：", date: "2025年8月1日" },
  sections: {
    agreement: {
      heading: "利用規約への同意",
      p1:
        "本利用規約（以下「規約」）は、ユーザー（以下「あなた」）と Routed Labs, Inc.（以下「Routed Labs」「当社」）との間の法的拘束力を有する契約です。Airvoy のウェブサイト、モバイルアプリ、および関連する eSIM サービス（以下「サービス」）の利用に関するものです。",
      p2:
        "サービスへアクセスまたは利用することにより、あなたは本規約を読み理解し、同意したものとみなされます。もし同意しない場合は、サービスの利用を控えてください。"
    },
    service: {
      heading: "サービスの説明",
      p1:
        "本サービスは、国際的に携帯データネットワークへ接続できる eSIM（埋め込み型SIM）機能を提供します。提供内容は以下を含みます：",
      items: [
        "グローバル接続用のデジタル eSIM プロファイル",
        "期間が異なる複数のデータプランオプション",
        "アクティベーションとインストールのための QR コード配信",
        "技術的な問い合わせに対応するカスタマーサポート",
        "登録ユーザー向けのアカウント管理ツール"
      ],
      notice:
        "重要：本サービスには、対応かつ SIM ロック解除されたデバイスが必要です。すべてのデバイスや地域での互換性や通信を保証するものではありません。"
    },
    eligibility: {
      heading: "利用資格",
      p1: "本サービスを利用するにあたり、あなたは以下を表明および保証します：",
      items: [
        "18歳以上である、または保護者の同意を得ている",
        "法的に契約を締結する能力がある",
        "正確かつ完全な登録情報を提供する",
        "対応デバイスを所持または使用権限がある",
        "関連する法律および規制を遵守する"
      ]
    },
    account: {
      heading: "アカウント登録",
      p1:
        "ユーザーは、登録ユーザーとしてまたはゲストとして eSIM を購入できます。登録することで、購入履歴や拡張サポートなどの追加機能が利用可能です。",
      registered: {
        title: "登録アカウント",
        items: [
          "有効なメールアドレスが必要",
          "アカウントの安全性を維持する責任",
          "情報を正確に保つ義務",
          "不正アクセスを速やかに通知する義務"
        ]
      },
      guest: {
        title: "ゲスト購入",
        items: [
          "メールアドレスのみが必要",
          "eSIM は電子的に配信される",
          "サポートは購入に関する内容に限定",
          "購入履歴は保持されない"
        ]
      }
    },
    payment: {
      heading: "支払い条件",
      p1:
        "購入を完了することにより、あなたは Routed Labs およびその決済処理業者が提供した支払い方法へ請求することを許可するものとします。主な条件は以下のとおりです：",
      items: [
        "すべての価格は米ドルで表示され、適用される税金を含む",
        "支払いは購入時に完了する必要がある",
        "支払い処理は第三者の決済サービスを通じて行われる",
        "支払いが完了しない場合、サービスが停止される可能性がある"
      ]
    },
    refunds: {
      heading: "返金ポリシー",
      p1: "返金リクエストは以下の条件に基づき検討されます：",
      items: [
        "購入から24時間以内のリクエストは対象",
        "eSIM が有効化または使用された場合は対象外",
        "技術的な問題は個別に審査される",
        "デバイスの互換性はユーザーの責任となる"
      ],
      p2: {
        prefix: "返金リクエストは次の宛先まで送付してください：",
        suffix: "（注文詳細と理由を記載してください）"
      }
    },
    limitations: {
      heading: "サービスの制限",
      p1: "本サービスには以下の制限があります：",
      items: [
        "デバイスは eSIM 対応かつ SIM ロック解除済みである必要がある",
        "通信は現地パートナーネットワークに依存する",
        "速度と利用可能範囲は地域によって異なる",
        "未使用データは繰越されず失効する",
        "プランはデバイス間で移行できない"
      ]
    },
    prohibited: {
      heading: "禁止される使用",
      p1:
        "あなたは以下のような不法または禁止された目的で本サービスを使用しないことに同意します：",
      items: [
        "違法行為や規制違反",
        "嫌がらせ、虐待、詐欺的行為",
        "不正なネットワークアクセスや干渉",
        "同意なしの資格情報の再販または共有",
        "過度な使用によるネットワーク性能の低下"
      ]
    },
    liability: {
      heading: "責任の制限",
      p1:
        "法律で許容される最大限の範囲において、Routed Labs はあなたによる本サービス利用から生じる間接的、付随的、または結果的損害について責任を負いません。総責任額は、請求の発生前12か月間に当該サービスのために支払われた金額を超えないものとします。"
    },
    indemnity: {
      heading: "補償",
      p1:
        "あなたは、本サービスの不正利用や本規約違反に起因する請求、損害、または費用から Routed Labs およびその関連会社を免責し、保護することに同意します。"
    },
    termination: {
      heading: "利用停止および解約",
      p1:
        "あなたが本規約に違反した場合、不法行為を行った場合、または当社や他のユーザーに不利益を与える行為をした場合、当社は即時にサービスへのアクセスを停止または解約することができます。解約後、サービス利用の権利は直ちに失われます。"
    },
    law: {
      heading: "準拠法",
      p1:
        "本規約は米国デラウェア州の法律に準拠します。あなたは、紛争の解決のためにデラウェア州所在の裁判所の専属的管轄権に従うことに同意します。"
    },
    amend: {
      heading: "規約の改定",
      p1:
        "Routed Labs は独自の裁量で本規約を改定する権利を有します。更新はウェブサイト上に公表され、特別な記載がない限り直ちに効力を発します。改定後もサービスを継続して利用する場合、改定後の規約に同意したものとみなされます。"
    },
    contact: {
      heading: "お問い合わせ先",
      p1: "本規約に関する質問は以下にご連絡ください："
    }
  }
},

about: {
  title: "Airvoyについて",
  sections: {
    overview: {
      heading: "概要",
      body:
        "AirvoyはRouted Labs, Inc.によって開発されたeSIMプラットフォームです。国際的な旅行者に、手頃な価格で信頼できるモバイル接続を提供します。物理SIMカードを必要としないため、200以上の目的地でデータプランをシームレスに有効化できます。"
    },
    mission: {
      heading: "使命",
      body:
        "Routed Labs, Inc.は、モバイル接続を簡素化するという唯一の使命を掲げています。国際ローミングやSIM調達に伴う不確実性、隠れたコスト、物流上の障害を取り除き、旅行者が安心して接続を維持できるよう目指しています。"
    },
    background: {
      heading: "背景",
      p1:
        "Routed Labs, Inc.はカリフォルニア州デイリーシティに本社を構えています。当社は国際的な接続の維持に伴う課題、例えば高額なローミング料金やSIMカードの入手困難といった実体験から誕生しました。",
      p2:
        "これらの課題を観察した創業者は、eSIM技術を活用して世界的な接続性を改善する機会を見出しました。",
      p3:
        "現在、当社は信頼性・透明性・利便性を重視し、世界中の数千人のユーザーを支援しています。"
    },
    operations: {
      heading: "事業内容",
      items: [
        { title: "グローバルカバレッジ:", desc: "200以上の国と地域で高速ネットワークにアクセス可能。" },
        { title: "eSIMプロビジョニング:", desc: "物理SIM不要で数分以内にデジタルプランをインストール。" },
        { title: "顧客志向:", desc: "明確さとユーザーのニーズを最優先に設計されたサービスとサポート。" }
      ]
    },
    corporate: {
      heading: "法人情報",
      company: {
        title: "会社概要",
        nameLabel: "会社名:",
        name: "Routed Labs, Inc.",
        repLabel: "代表者:",
        rep: "Hector Diaz",
        addrLabel: "本社所在地:",
        addr: "451 Niantic Avenue, Daly City, CA 94014, United States",
        contactLabel: "連絡先:"
      },
      agent: {
        title: "登録代理人情報",
        nameLabel: "登録代理人名:",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "登録代理人住所:",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, United States"
      }
    },
    comms: {
      heading: "連絡先",
      p1: {
        prefix: "公式な問い合わせや書面による連絡は",
        suffix:
          "までお送りください。企業や法的な書簡は、デラウェア州ニューアークに所在するLegalinc Corporate Services Inc.にも送付可能です。"
      }
    }
  }
},
auth: {
  titles: {
    signin: 'おかえりなさい',
    signup: 'アカウント作成',
    forgot: 'パスワードをリセット',
  },
  subtitles: {
    signin: 'eSIMプランを購入するにはサインインしてください',
    signup: '今すぐAirvoyに登録',
    forgot: 'パスワードをリセットするにはメールアドレスを入力してください',
  },
  fields: {
    email: 'メールアドレス',
    password: 'パスワード',
    confirmPassword: 'パスワードを確認',
  },
  placeholders: {
    email: 'メールアドレスを入力',
    password: 'パスワードを入力',
    confirmPassword: 'パスワードを再入力',
  },
  actions: {
    close: '閉じる',
    continueWithGoogle: 'Googleで続行',
    signingIn: 'サインイン中...',
    pleaseWait: 'お待ちください...',
    signIn: 'サインイン',
    createAccount: 'アカウント作成',
    sendReset: 'リセットメールを送信',
    showPassword: 'パスワードを表示',
    hidePassword: 'パスワードを非表示',
  },
  labels: {
    orEmail: 'またはメールアドレスで続行',
  },
  links: {
    noAccount: "アカウントをお持ちでない方はこちら",
    signUp: '登録する',
    forgot: 'パスワードをお忘れですか？',
    haveAccount: 'すでにアカウントをお持ちですか？',
    signIn: 'サインイン',
    remembered: 'パスワードを思い出しましたか？',
    backToSignIn: 'サインインに戻る',
  },
  messages: {
    resetSent: 'パスワードリセット用のメールを送信しました。受信箱を確認してください。',
  },
  errors: {
    fillAll: 'すべての項目を入力してください',
    userNotFound: 'このメールアドレスのアカウントは見つかりません',
    wrongPassword: 'メールアドレスまたはパスワードが正しくありません',
    emailInUse: 'このメールアドレスのアカウントはすでに存在します',
    weakPassword: 'パスワードが弱すぎます',
    invalidEmail: '無効なメールアドレスです',
    tooManyRequests: '試行回数が多すぎます。しばらくしてからお試しください',
    popupClosed: 'サインインのポップアップが完了前に閉じられました',
    popupCancelled: 'サインインがキャンセルされました',
    popupBlocked: 'サインインのポップアップがブラウザにブロックされました',
    passwordMismatch: 'パスワードが一致しません',
    passwordMin: 'パスワードは6文字以上である必要があります',
    enterEmail: 'メールアドレスを入力してください',
    generic: 'エラーが発生しました。もう一度お試しください',
  },
  legal: {
    prefix: 'アカウントを作成することで、次に同意したものとみなされます：',
    terms: '利用規約',
    and: 'および',
    privacy: 'プライバシーポリシー',
  },
},
support: {
  title: "サポート",
  contactInfo: "連絡先情報",
  channels: {
    email: {
      title: "メールサポート",
      description: "お問い合わせ、インシデント報告、サポート依頼はこちらから。",
      contact: "support@routedlabs.com",
      action: "メールを作成"
    },
    chat: {
      title: "ライブチャット",
      description: "リアルタイムでのサポート（営業時間内のみ対応）。",
      contact: "営業時間：太平洋時間09:00–18:00",
      action: "チャットを開く"
    }
  },
  faqTitle: "よくある質問",
  noResults: "現在の検索条件に一致する項目はありません。",
  categoryLabel: "カテゴリ：",
  show: "表示",
  hide: "非表示",
  noticesTitle: "お知らせ・連絡先",
  noticesLine1: {
    before: "公式な問い合わせおよび書面による連絡は",
    after: "へお送りください。"
  },
  noticesLine2:
    "このページはサポートプロセスと参考資料を説明するものであり、適用される利用規約やポリシーを変更または置き換えるものではありません。",
  categories: {
    overview: "eSIMの概要",
    compatibility: "デバイスの互換性",
    installation: "インストール",
    dualSim: "デュアルSIM",
    dataUsage: "データ利用",
    planMgmt: "プラン管理",
    deviceReqs: "デバイス要件",
    troubleshooting: "トラブルシューティング",
    refunds: "払い戻し",
    supportHours: "サポート受付時間"
  },
  faqs: {
    1: {
      q: "eSIMとは何ですか？どのように動作しますか？",
      a: "eSIM（組み込み型SIM）は、物理カードを使わずにモバイル通信を有効化できるデバイス内蔵のプログラム可能なSIMです。ユーザーはコードをスキャンしたり、Airvoyの設定手順に従うことで接続を取得できます。"
    },
    2: {
      q: "どのデバイスがeSIMに対応していますか？",
      a: "多くの最新スマートフォンがeSIMに対応しています。設定（「モバイル通信」または「モバイルデータ」）内に「データプランを追加」オプションがあるか確認してください。"
    },
    3: {
      q: "eSIMはどのようにインストールしますか？",
      a: "購入後、インストール手順とQRコードがメールで届きます。デバイスの設定→モバイル通信→データプランを追加からコードをスキャンすると、自動的に有効化が完了します。"
    },
    4: {
      q: "物理SIMとeSIMを同時に利用できますか？",
      a: "ほとんどのeSIM対応デバイスはデュアルSIMに対応しています。通話やメッセージにはメイン番号を使い、データ通信にはeSIMを利用できます。設定で選択可能です。"
    },
    5: {
      q: "未使用のデータはどうなりますか？",
      a: "未使用のデータは翌月に繰り越されず、払い戻しもできません。プランは有効期限で失効します。旅行中の使用量を見積もってプランを選択してください。"
    },
    6: {
      q: "データの追加やプランの延長はできますか？",
      a: "はい。利用可能な国の場合、ウェブサイトやアカウントから追加のデータ購入や延長が可能です。"
    },
    7: {
      q: "デバイスはSIMロック解除が必要ですか？",
      a: "はい。他のキャリアのeSIMを利用するにはデバイスがSIMロック解除されている必要があります。ロックされている場合は事前にキャリアに解除を依頼してください。"
    },
    8: {
      q: "eSIMがうまく動作しない場合はどうすればよいですか？",
      a: "デバイスがアンロックされているか、eSIM対応かを確認してください。データローミングを有効にし、正しいデータプランが選択されているか確認し、再起動を試みてください。解決しない場合はサポートへ連絡してください。"
    },
    9: {
      q: "払い戻しはできますか？",
      a: "eSIMがアクティベートまたは使用されていない場合、購入から24時間以内であれば返金可能です。一度有効化された後の返金はできません。技術的な問題がある場合、サポートが解決を試みるか、必要に応じてアカウントにクレジットを付与します。"
    },
    10: {
      q: "サポートの受付時間と応答時間は？",
      a: "メールサポートは常時受け付けています。通常、数時間以内に返信します。旅行中の緊急の問題には優先的に対応します。"
    }
  }
}

  },
  ru: {
    // Navigation
nav: {
  installEsim: "Установить eSIM",
  admin: "Для бизнеса",
  faqs: "Часто задаваемые вопросы",
  browsePlans: "Просмотреть тарифы",
  partnerships: "Партнёрства",
  dashboard: "Панель управления",
  signOut: "Выйти",
  signIn: "Войти",
  getTheApp: "Скачать приложение"
},

    // Hero Section
hero: {
  badge: "Присоединяйтесь к более чем 30 000 путешественников, использующих Airvoy eSIM.",
  title: "Глобальная",
  titleHighlight: "eSIM",
  subtitle: "Оставайтесь на связи, как дома — мгновенная настройка, гибкие тарифы и покрытие в более чем 200 странах.",
  searchPlaceholder: "Куда вы путешествуете?",
  appStore: "App Store",
  googlePlay: "Google Play"
},

// Popular Countries
popularCountries: {
  title: "Популярные направления",
  subtitle: "Подключайтесь мгновенно в этих лучших туристических направлениях",
  fromPrice: "От",
  perDay: "/день",
  unlimited: "Безлимит",
  startingAt: "Начиная с",
  getStarted: "Начать",
  viewAllCountries: "Посмотреть все страны",
  noPlansAvailable: "Нет доступных безлимитных тарифов"
},
// How It Works
howItWorks: {
  title: "Как работает Airvoy eSIM",
  subtitle: "Подключитесь в три простых шага",
  step1Title: "Выберите направление",
  step1Desc: "Просматривайте более 200 направлений с прозрачными ценами. Без скрытых комиссий и сюрпризов — найдите идеальный тариф для вашего путешествия.",
  step2Title: "Установите за секунды",
  step2Desc: "Получите eSIM мгновенно на email. Один быстрый скан QR-кода — и вы готовы к поездке, без посещения магазинов и замены SIM-карт.",
  step3Title: "Подключитесь автоматически",
  step3Desc: "Приземляйтесь и подключайтесь мгновенно. Ваша eSIM активируется автоматически по прибытии — забудьте про поиски Wi-Fi в аэропорту.",
  learnMore: "Узнать больше"
},
// Benefits
benefits: {
  whyAirvoy: "Почему Airvoy?",
  title: "Оставайтесь на связи, где бы вы ни были",
  item1Title: "Найдите подходящий тариф",
  item1Desc: "Гибкие тарифные планы под любой бюджет. От недельного плана на 1 ГБ до 100 ГБ на полгода — всё в одном приложении.",
  item2Title: "Просто в использовании",
  item2Desc: "Скачайте Airvoy, установите eSIM и подключите тариф — он активируется автоматически, как только вы достигнете пункта назначения.",
  item3Title: "Без роуминга",
  item3Desc: "Скрытые роуминговые платежи остались в прошлом. Знайте стоимость интернета до поездки!",
  item4Title: "Одна eSIM для всех поездок",
  item4Desc: "Добавляйте новые направления в существующую Airvoy eSIM — больше не нужно устанавливать новые eSIM каждый раз. Просто пополняйте и подключайтесь!",
  item5Title: "Никогда не останетесь без интернета",
  item5Desc: "Не рискуйте остаться без данных в самый неподходящий момент — мы предупредим, когда вы израсходуете 80% тарифа.",
  item6Title: "+200 стран",
  item6Desc: "Будьте онлайн в более чем 200 странах и территориях по всему миру."
},
// Videos
videos: {
  title: "Смотрите и подключайтесь быстро",
  subtitle: "Два быстрых руководства — для iPhone и Samsung.",
  iPhoneTitle: "Установка и активация eSIM — iPhone",
  iPhoneDesc: "Пошаговое руководство по установке и активации Airvoy eSIM на iPhone. Сканируйте, устанавливайте и выходите в сеть за минуты.",
  samsungTitle: "Установка и активация eSIM — Samsung",
  samsungDesc: "Узнайте, как добавить Airvoy eSIM на устройства Samsung Galaxy. Быстрое и понятное руководство от установки до первого подключения.",
  iOSGuide: "Гид для iOS",
  samsungGuide: "Гид для Samsung",
  installationGuide: "Или прочитайте полное руководство по установке"
},
// Footer
footer: {
  description: "Присоединяйтесь к более чем 30 000 путешественников, использующих Airvoy eSIM. Путешествуйте умно, оставайтесь на связи — где бы вы ни были.",
  company: "Компания",
  aboutUs: "О нас",
  resources: "Ресурсы",
  documentation: "Документация",
  support: "Поддержка",
  legal: "Правовая информация",
  privacyPolicy: "Политика конфиденциальности",
  termsOfService: "Условия использования",
  followUs: "Подписывайтесь на нас",
  copyright: "Все права защищены.",
  madeWith: "Сделано с",
  forTravelers: "для путешественников по всему миру"
},
// Auth
aut: {
  authenticationRequired: "Требуется аутентификация",
  signInPrompt: "Пожалуйста, войдите, чтобы получить доступ к панели управления и приобрести eSIM-планы."
},

// Common
common: {
  close: "Закрыть",
  loading: "Загрузка...",
  tryAgain: "Попробовать снова",
  noResults: "Страны не найдены для"
},
activate: {
  altText: "Глобальная активация Airvoy eSIM",
  activeInThailand: "Airvoy активен в Таиланде",
  activeInSpain: "Airvoy активен в Испании",
  activeWorldwide: "Airvoy активен по всему миру",
  activeInGreece: "Airvoy активен в Греции",
  activeInMexico: "Airvoy активен в Мексике",
  title: "Сохраняйте свой номер WhatsApp",
  description: "Вы можете звонить и писать всем своим контактам в WhatsApp, как будто находитесь в той же стране.\nНе теряйте связь с семьёй и друзьями."
},
regionalPlans: {
  multiCountryCoverage: "Покрытие в нескольких странах",
  title: "Региональные планы",
  subtitle: "Выберите регион, затем выберите нужную продолжительность и объём данных.",
  noPlansAvailable: "Региональные планы недоступны.",
  from: "От",
  seePlans: "Смотреть планы",
  countries: "страны",
  plans: "планы",
  startingFrom: "Начиная с",
  browseOptions: "Просмотреть варианты",
  viewPlans: "Посмотреть планы"
},

partnerships: {
  headerLabel: "ПАРТНЁРСТВА",
  title: "Партнёрства Airvoy",
  subtitle: "Давайте сотрудничать и создавать что-то великое вместе.",
  join: "Присоединиться",
  airvoyAffiliate: "Партнёрская\nпрограмма Airvoy",
  affiliateDescription: "Зарабатывайте до 20% комиссии, продвигая Airvoy eSIM — присоединяйтесь к нашей официальной партнёрской сети уже сегодня!",
  joinNow: "Присоединиться сейчас!",
  learnMore: "Узнать больше",
  partnershipImageAlt: "Партнёрство Airvoy",

  // Partnership types
  affiliateProgram: "Партнёрская программа",
  eventPartnership: "Партнёрство для мероприятий",
  travelPartnership: "Партнёрство в сфере путешествий",
  contentPartnership: "Контент-партнёрство",
  sportsPartnership: "Спортивное партнёрство",
  musicCulturePartnership: "Музыкальное и культурное партнёрство",
  athleteCollaboration: "Сотрудничество с атлетами",
  other: "Другое",

  // Partnership descriptions
  eventPartnerships: "Партнёрства для мероприятий",
  eventDescription1: "Организуете международное мероприятие и хотите подарить участникам полезный бонус — бесплатный мобильный интернет?",
  eventDescription2: "Мы можем адаптировать решение под ваши нужды и ваших гостей, чтобы они оставались на связи до, во время и после события.",

  travelPartnerships: "Путешественнические партнёрства",
  travelDescription1: "Хотите предложить своим клиентам и сотрудникам удобный и недорогой мобильный интернет и звонки за границей?",
  travelDescription2: "С нашим интегрированным пакетом мобильной связи вы сможете легко предоставить клиентам полезные travel-решения с минимальными усилиями.",

  contentPartnerships: "Контент-партнёрства",
  contentDescription1: "Вы создаёте контент в соцсетях, имеете креативные идеи, вовлечённую аудиторию и чувствуете тренды #TravelHacks и #LifeHacks?",
  contentDescription2: "Или просто любите Airvoy и хотите рассказать другим о нашем удобном подключении по всему миру?",

  sportsPartnerships: "Спортивные партнёрства",
  sportsDescription1: "Организуете спортивное соревнование и хотите дать спортсменам, командам и фанатам надёжную связь на протяжении всего события?",
  sportsDescription2: "Сотрудничайте с Airvoy, чтобы предоставить бесперебойные мобильные решения для всех — от открытия до финального свистка.",

  musicCulturePartnerships: "Музыкальные и культурные партнёрства",
  musicDescription1: "Организуете музыкальный фестиваль, культурное событие или живое выступление и хотите улучшить опыт посетителей?",
  musicDescription2: "Airvoy может предоставить надёжный мобильный интернет, чтобы гости могли делиться впечатлениями, стримить и оставаться на связи.",

  athleteCollaborations: "Сотрудничество с атлетами",
  athleteDescription1: "Вы — спортсмен, который путешествует по миру с соревнования на соревнование, и у вас уже не хватает места для трофеев?",
  athleteDescription2: "Сотрудничайте с Airvoy, чтобы оставаться на связи в любой точке мира и делиться своим путешествием с фанатами, где бы вы ни были.",

  letsTalk: "Давайте обсудим",

  // Contact form
  getInTouch: "Свяжитесь с нами",
  successMessage: "Спасибо за обращение! Мы скоро с вами свяжемся.",
  errorMessage: "Что-то пошло не так. Пожалуйста, попробуйте снова.",
  emailPlaceholder: "Введите ваш email",
  fullNamePlaceholder: "Полное имя",
  partnerTypePlaceholder: "О чём вы хотите сотрудничать?",
  messagePlaceholder: "Кратко расскажите, что вы планируете",
  privacyConsent: "Вы соглашаетесь с нашей дружелюбной",
  privacyPolicy: "политикой конфиденциальности",
  sending: "Отправка...",
  send: "Отправить"
},
faq: {
  headerLabel: "FAQ",
  title: "Найдите ответы на часто задаваемые вопросы",
  learnMore: "Узнать больше",

  whatIsEsim: {
    question: "Что такое eSIM?",
    answer: "eSIM — это цифровая SIM-карта, соответствующая отраслевому стандарту, которая позволяет активировать сотовый тариф без физической SIM-карты. Вы можете установить восемь и более eSIM на iPhone и использовать два номера одновременно."
  },

  howToSetup: {
    question: "Как установить eSIM?",
    answer: "Технология eSIM очень удобна. Но установка может быть немного сложной, особенно если вы делаете это впервые. Не волнуйтесь — у нас есть пошаговые инструкции, чтобы вы подключились к Airvoy без проблем."
  },

  whatIsAirvoy: {
    question: "Что такое Airvoy?",
    answer: "Airvoy — это мобильное приложение, которое предоставляет глобальные решения для мобильной связи. Оно обеспечивает лёгкий способ оставаться на связи в путешествиях без физических SIM-карт и высоких роуминговых тарифов."
  },

  howSaveRoaming: {
    question: "Как Airvoy помогает экономить на роуминге?",
    answer: "Airvoy предлагает мобильный интернет по ценам до 90% ниже стандартных роуминговых тарифов. Так вы избегаете высоких расходов на традиционные услуги роуминга."
  },

  needNewSim: {
    question: "Нужно ли покупать новую SIM-карту при каждой поездке с Airvoy?",
    answer: "Нет. Airvoy использует технологию eSIM, то есть физическая SIM-карта не нужна. Airvoy eSIM глобальна — установив её один раз, вы можете использовать её для роуминга по всему миру или покупать новые планы для отдельных стран."
  },

  constantConnectivity: {
    question: "Как Airvoy обеспечивает стабильную связь в путешествиях?",
    answer: "Airvoy предлагает мобильный интернет по ценам до 90% ниже стандартных роуминговых тарифов. Так вы избегаете высоких расходов на традиционные услуги роуминга."
  },

  freeCallsTexts: {
    question: "Предлагает ли Airvoy бесплатные звонки и сообщения?",
    answer: "Пока нет. Но скоро Airvoy позволит бесплатно звонить и писать другим пользователям Airvoy. Вы сможете общаться без дополнительных затрат."
  },

  whyChooseAirvoy: {
    question: "Почему стоит выбрать Airvoy вместо других роуминговых решений?",
    answer: "Airvoy обеспечивает простое глобальное подключение с одной eSIM, выгодные тарифы и дополнительные функции (сообщения и локальные номера скоро появятся) — всё в удобном приложении. Это доступно, просто и даёт полный контроль над вашей связью в путешествиях."
  }
},
browse: {
  main: {
    title: "Просмотр eSIM-планов",
    subtitle: "Откройте eSIM-планы для направлений по всему миру с актуальными ценами"
  },
  search: {
    placeholder: "Поиск стран (например, США, Испания, Япония)...",
    clearSearch: "Очистить поиск",
    noCountriesFound: "Страны не найдены по вашему запросу.",
    noCountriesAvailable: "Нет доступных стран.",
    clearSearchButton: "Очистить поиск",
    searching: "Поиск стран...",
    country: "страна",
    countries: "страны",
    foundFor: "найдено для"
  },
  loading: {
    loadingText: "Загрузка...",
    allCountriesLoaded: "Все страны загружены",
    total: "всего"
  },
  buttons: {
    showMoreCountries: "Показать больше стран",
    showLessPlans: "Показать меньше планов",
    showLess: "Показать меньше",
    seeMorePlans: "Посмотреть больше планов",
    more: "ещё",
    buyNow: "Купить сейчас"
  },
  navigation: {
    backToCountries: "Назад к списку стран"
  },
  countryDetails: {
    description: "Исследуйте {{country}} с гибкостью с нашими eSIM-планами. Подходит как для коротких поездок, так и для длительных путешествий — оставайтесь на связи без лишних хлопот."
  },
  plans: {
    noPlansAvailable: "Нет доступных планов по выбранным фильтрам.",
    planDetails: "Детали плана",
    details: "Подробности",
    unlimited: "Безлимитный",
    for: "На",
    day: "день",
    days: "дней"
  },
  checkout: {
    total: "Итого"
  },
  planDetails: {
    title: "Детали плана",
    unlimitedData: "Безлимитный интернет",
    data: "Данные",
    country: "Страна",
    duration: "Продолжительность",
    day: "день",
    days: "дней",
    network: "Сеть",
    autoStart: "Автостарт",
    enabled: "Включено",
    disabled: "Отключено",
    planType: "Тип плана",
    description: "Описание",
    purchaseThisPlan: "Купить этот план",
    signInToPurchase: "Войдите, чтобы купить"
  }
},

installation: {
  title: "Как установить и настроить мой eSIM?",
  metaUpdated: "2 месяца назад • Обновлено",
  intro: {
    p1: "Независимо от того, используете ли вы Android или Apple, сначала убедитесь, что ваш телефон поддерживает eSIM и разблокирован для работы с любыми сетями. Также потребуется стабильное интернет-соединение (предпочтительно Wi-Fi).",
    p2: "Затем вы можете:",
    ol1: "Сканировать QR-код для автоматической установки",
    ol2: "Установить eSIM вручную",
    note: "Установка с помощью QR-кода — самый простой способ."
  },
  ios: {
    qr: {
      title: "Установите eSIM с помощью QR-кода (iOS)",
      s1: "1. Перейдите в Настройки > Сотовая связь",
      s2: "2. Нажмите «Добавить eSIM» и выберите «Использовать QR-код»",
      s3: "3. Отсканируйте QR-код и введите 4-значный код подтверждения, если потребуется",
      s4: "4. Назовите ваш eSIM и выберите «Только сотовые данные» в разделе Линия по умолчанию",
      s5: "5. Теперь вы должны увидеть свой eSIM в разделе «Сотовая связь»"
    },
    manual: {
      title: "Как установить eSIM вручную (iOS)",
      s1: "1. Настройки > Сотовая связь > Добавить eSIM",
      s2: "2. Нажмите «Добавить eSIM» и выберите «Использовать QR-код»",
      s3: "3. Вместо сканирования нажмите «Ввести данные вручную»",
      s4: "4. Введите SM-DP+ адрес, код активации и при необходимости код подтверждения из приложения Airvoy",
      s5: "5. Назовите ваш eSIM и выберите «Только сотовые данные» в разделе Линия по умолчанию",
      s6: "6. Теперь вы должны увидеть свой eSIM в разделе «Сотовая связь»"
    }
  },
  android: {
    qr: {
      title: "Установите eSIM с помощью QR-кода (Android)",
      s1: "1. Перейдите в Настройки > Сеть и Интернет > SIM-карты",
      s2: "2. Нажмите «+» справа от «SIM-карты»",
      s3: "3. Внизу выберите «Загрузить SIM вместо этого?»",
      s4: "4. На экране «Загрузить SIM» нажмите «Далее» — появится сообщение «Проверка сетевой информации...»",
      s5: "5. После проверки появится видоискатель для сканирования QR-кода",
      s6: "6. Наведите его на распечатанный QR-код или другой экран с кодом",
      s7: "7. После сканирования устройство снова проверит данные",
      s8: "8. Нажмите «Загрузить» для подтверждения — данные eSIM будут загружены",
      s9: "9. После завершения вы увидите «Загрузка завершена»",
      s10: "10. Настройте eSIM для доступа к интернету, когда будете готовы."
    }
  },
  notes: {
    title: "Важные заметки",
    n1: "Убедитесь, что ваше устройство поддерживает eSIM и разблокировано для любых операторов",
    n2: "Во время установки потребуется стабильное Wi-Fi-соединение",
    n3: "eSIM можно установить только один раз — начните, когда будете готовы",
    n4: "Сохраняйте основную SIM-карту активной для звонков и сообщений с вашего домашнего номера",
    n5: "Ваш eSIM активируется при достижении страны назначения"
  },
  support: {
    title: "Нужна помощь?",
    body: "Если у вас возникли трудности с установкой eSIM, наша служба поддержки готова помочь!",
    emailLabel: "Эл. почта:",
    websiteLabel: "Веб-сайт:"
  }
},
installGuide: {
  header: {
    title: "Полное руководство по установке eSIM",
    subtitle: "Всё, что нужно знать для установки, активации и использования eSIM для беспрепятственной глобальной связи. Следуйте инструкциям для вашего устройства для максимально простой настройки.",
    link: "Ознакомьтесь с подробным руководством по установке на Android",
    ios: "Подробное руководство для iOS",
        android: "Подробное руководство для Android"
  },
  iphoneHero: "Установите и активируйте eSIM на iPhone",
  cards: {
    c1: {
      alt: "iPhone с переключателем и значком часов",
      install: "Установите",
      activate: "активируйте",
      textA: "за несколько часов до поездки и",
      textB: "во время полёта или по прибытии в пункт назначения."
    },
    c2: {
      alt: "iPhone с интерфейсом сканера QR-кода",
      line1: "Выберите «Установить по QR-коду»",
      line2: "если у вас есть код на другом устройстве",
      line3: "для сканирования."
    },
    c3: {
      alt: "iPhone с интерфейсом ручной установки",
      line1: "Выберите «Установить вручную»",
      line2: "если не можете отсканировать QR-код."
    }
  },
  learn: {
    title: "Учитесь шаг за шагом",
    subtitle: "Выберите способ установки, который хотите использовать",
    btnQr: "Установка с QR-кодом",
    btnManual: "Ручная установка"
  },
  prep: {
    alt: "Иконка предупреждения на телефоне",
    qr: {
      title: "Перед установкой с помощью QR-кода важно учесть:",
      i1: "У вас должен быть QR-код на другом экране или устройстве для сканирования камерой телефона.",
      i2: "Убедитесь, что у вас стабильное интернет-соединение на протяжении всего процесса.",
      i3: "Учтите, что QR-код можно отсканировать только один раз.",
      i4: "Не удаляйте eSIM с устройства, так как повторно использовать его будет невозможно."
    },
    manual: {
      title: "Перед ручной установкой важно учесть:",
      i1: "Коды для ручной установки можно использовать только один раз."
    },
    shared: {
      i2: "Убедитесь, что у вас стабильное интернет-соединение на протяжении всего процесса.",
      i3: "Не удаляйте eSIM с устройства, так как повторно использовать его будет невозможно."
    }
  },
  start: {
    title: "Начнём вместе",
    c1: {
      title: "Откройте свою почту",
      qr: { p1: "Откройте свою почту на другом устройстве, отличном от того, на которое будете устанавливать eSIM, и найдите письмо с QR-кодом." },
      manual: { p1: "Проверьте письмо, которое мы вам отправили, с адресом «SM-DP+» и «Кодом активации» и держите их под рукой для установки. Мы также отправляем их вам по SMS." },
      shared: { missing: "Если вы не получили код(ы), пожалуйста", contact: "свяжитесь с нами" }
    },
    c2: {
      qr: { title: "Сканируйте QR-код", p1: "Откройте камеру на iPhone, куда будете устанавливать eSIM, и отсканируйте код. Также можно перейти в Настройки → Сотовая связь и выбрать «Добавить тарифный план», чтобы сканировать оттуда." },
      manual: { title: "Откройте «Настройки» на iPhone", p1: "Перейдите в Сотовая связь, нажмите «Добавить eSIM» или «Добавить тарифный план» и выберите «Использовать QR-код». Затем выберите «Ввести данные вручную», если будет предложено." }
    },
    c3: {
      title: "Следуйте шагам установки на iPhone",
      qr: { p1: "Сканирование кода запустит процесс установки. Используйте наше руководство ниже для пошаговой настройки." },
      manual: { p1: "Когда появится «Сканировать QR-код», выберите «Ввести данные вручную» и следуйте шагам на вашем iPhone." }
    }
  },
  compat: {
    title: "Проверка совместимости устройства",
    subtitle: "Проверьте, поддерживает ли ваше устройство технологию eSIM. Используйте поиск, чтобы быстро найти нужную модель.",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "Искать модели iPhone/iPad...",
    searchAndroid: "Искать модели Android...",
    iphones: "Совместимые iPhone",
    ipads: "Совместимые iPad (только с 4G)",
    androids: "Совместимые Android-устройства",
    noMatch: "Устройства по вашему запросу не найдены.",
    iosNotesTitle: "Важные замечания:",
    iosNotes: {
      i1: "Модели iPhone 13 и 14 могут иметь две активные eSIM одновременно",
      i2: "iPhone из материкового Китая и Гонконга не поддерживают eSIM (кроме некоторых моделей)",
      i3: "iPhone 14+ для США не поддерживают физические SIM-карты"
    },
    androidNotesTitle: "Важные ограничения:",
    androidNotes: {
      i1: "Устройства Samsung из США и Гонконга могут не поддерживать eSIM",
      i2: "Google Pixel из Австралии, Японии и Тайваня не поддерживают eSIM",
      i3: "Телефоны, продаваемые в Гонконге, обычно не поддерживают eSIM",
      i4: "Устройство должно быть разблокировано для использования eSIM"
    },
    empty: "Начните вводить модель устройства, чтобы проверить совместимость"
  },
  tips: {
    title: "Полезные советы: активируйте перед поездкой",
    body: "Для комфортного путешествия установите eSIM до вылета и активируйте по прибытии. Это обеспечит подключение сразу после приземления без поиска Wi-Fi или местных SIM-карт.",
    before: {
      title: "Перед вылетом",
      i1: "Установите профиль eSIM дома",
      i2: "Протестируйте процесс установки",
      i3: "Сделайте скриншот QR-кода на случай неполадок",
      i4: "Убедитесь, что устройство разблокировано для всех операторов"
    },
    after: {
      title: "По прибытии",
      i1: "Включите сотовые данные для eSIM",
      i2: "Подождите 2–3 минуты для регистрации в сети",
      i3: "Проверьте подключение, выполнив поиск в интернете",
      i4: "При необходимости настройте роуминг данных"
    }
  },
  support: {
    title: "Нужна дополнительная поддержка?",
    body: "Наша команда экспертов готова помочь вам на каждом этапе. От проверки совместимости устройства до помощи с установкой — мы всегда рядом.",
    btnEmail: "Поддержка по email",
    btnCenter: "Перейти в центр поддержки"
  },
  steps: {
    ios: {
      s1: { title: "Откройте Настройки", desc: "Перейдите в Настройки → Сотовая связь (или Mobile Data в некоторых регионах)", detail: "Найдите пункт «Сотовая связь» в главном меню Настроек. В некоторых странах это может называться «Mobile Data»." },
      s2: { title: "Добавьте тарифный план", desc: "Нажмите «Добавить тарифный план» или «Добавить eSIM»", detail: "Эта опция находится внизу страницы сотовой связи. Если её нет, возможно, устройство не поддерживает eSIM." },
      s3: { title: "Сканируйте QR-код", desc: "Выберите «Использовать QR-код» и отсканируйте код из письма", detail: "Наведите камеру на QR-код. Обеспечьте хорошее освещение и держите телефон неподвижно до распознавания." },
      s4: { title: "Добавьте тарифный план", desc: "Нажмите «Добавить тарифный план», когда появятся данные", detail: "Проверьте информацию об операторе и тариф перед подтверждением. Этот шаг загрузит профиль eSIM." },
      s5: { title: "Назовите ваши планы", desc: "Выберите названия для планов (например, «Основной», «Путешествие», «Второй»)", detail: "Это поможет определить, какой план использовать для данных, звонков и сообщений. Чаще всего eSIM используют только для данных." },
      s6: { title: "Настройте линию по умолчанию", desc: "Выберите, какая линия будет использоваться для сотовых данных", detail: "Можно использовать eSIM для данных, оставив свою SIM для звонков и SMS." }
    },
    android: {
      s1: { title: "Откройте Настройки", desc: "Перейдите в Настройки → Сеть и Интернет → SIM-карты", detail: "Путь может отличаться в зависимости от производителя. На Samsung это может быть Настройки → Подключения → Диспетчер SIM-карт." },
      s2: { title: "Добавьте мобильный план", desc: "Нажмите кнопку «+» или «Добавить мобильный план»", detail: "Ищите варианты вроде «Добавить мобильный план», «Загрузить SIM вместо этого» или «Добавить оператора» в зависимости от устройства." },
      s3: { title: "Загрузите SIM", desc: "Выберите «Нет SIM-карты?» или «Загрузить SIM вместо этого»", detail: "Эта опция сообщает телефону, что вы хотите установить eSIM, а не использовать физическую SIM-карту." },
      s4: { title: "Сканируйте QR-код", desc: "Выберите «Сканировать QR-код» и наведите камеру на код", detail: "Обеспечьте хорошее освещение и держите телефон неподвижно. Камера автоматически распознает QR-код из письма." },
      s5: { title: "Загрузите профиль", desc: "Нажмите «Загрузить», когда появятся данные оператора", detail: "Телефон подключится к интернету для загрузки профиля eSIM. Это может занять несколько минут." },
      s6: { title: "Активируйте eSIM", desc: "Включите eSIM и выберите её как основной источник данных", detail: "Вы можете выбрать, какая SIM будет использоваться для данных, звонков и SMS. Чаще всего eSIM используют только для данных." }
    }
  }
},

profile: {
  loading: "Загрузка вашего профиля…",
  errors: {
    load: "Не удалось загрузить ваши eSIM",
    delete: "Не удалось удалить eSIM. Пожалуйста, попробуйте снова.",
    bundle: "Не удалось получить статус пакета",
    network: "Ошибка сети при получении статуса пакета",
    invoice: "Не удалось скачать счет"
  },
  auth: {
    title: "Требуется аутентификация",
    subtitle: "Пожалуйста, войдите в систему, чтобы просмотреть свой профиль и историю eSIM.",
    cta: "Войти"
  },
  header: {
    fallback: "Профиль пользователя",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} приобретено"
  },
  list: {
    title: "Ваши eSIM",
    subtitle: "Управляйте купленными профилями и получайте доступ к QR-кодам и счетам.",
    total: "Всего: {{count}}"
  },
  empty: {
    title: "Пока нет eSIM",
    subtitle: "Просмотрите наши тарифы, чтобы подключиться за секунды — без физической SIM-карты.",
    cta: "Просмотреть тарифы",
    tip: "Совет: Вы можете установить eSIM до поездки и активировать её по прибытии."
  },
  item: {
    country: "Страна",
    statusTitle: "Текущий статус",
    pricePaid: "Оплачено",
    purchaseDate: "Дата покупки"
  },
  actions: {
    details: "Подробнее",
    showQr: "Показать QR",
    invoice: "Счет"
  },
  hint: "Нужна помощь с установкой eSIM? На iOS: Настройки → Сотовая связь → Добавить eSIM. На Android: Настройки → Сеть и Интернет → SIM-карты → Добавить eSIM.",
  delete: {
    title: "Удалить eSIM",
    confirm: "Вы уверены, что хотите удалить эту eSIM из истории? Это действие нельзя отменить.",
    deleting: "Удаление…",
    cta: "Удалить eSIM"
  },
  details: {
    title: "Детали eSIM и статус в реальном времени",
    refresh: "Обновить статус пакета",
    live: "Статус пакета в реальном времени",
    updated: "Обновлено:",
    fetching: "Получение статуса в реальном времени...",
    ref: "Справка:",
    discount: "Скидка применена",
    usage: {
      title: "Использование данных",
      used: "Использовано",
      remaining: "Осталось",
      total: "Всего"
    },
    assigned: "Пакет назначен",
    plan: {
      title: "Информация о плане",
      destination: "Направление",
      name: "Название плана",
      allowance: "Доступные данные",
      validity: "Срок действия"
    },
    tech: {
      title: "Технические данные",
      activation: "Код активации",
      copyActivation: "Скопировать код активации",
      iccid: "ICCID",
      copyIccid: "Скопировать ICCID",
      orderRef: "Справочный номер заказа GOeSIM"
    },
    install: {
      title: "Инструкция по установке",
      iosTitle: "Для iOS:",
      androidTitle: "Для Android:",
      ios: "Настройки → Сотовая связь → Добавить eSIM → Использовать QR-код",
      android: "Настройки → Сеть и Интернет → SIM-карты → Добавить eSIM → Сканировать QR-код",
      important: "Важно:",
      once: "Вы можете установить эту eSIM только один раз. Убедитесь, что ваше устройство разблокировано и поддерживает eSIM перед продолжением."
    },
    purchase: {
      title: "Информация о покупке",
      date: "Дата покупки",
      amount: "Сумма оплаты",
      method: "Способ оплаты",
      txn: "ID транзакции"
    },
    referral: {
      title: "Применена реферальная скидка",
      code: "Реферальный код",
      original: "Исходная цена",
      saved: "Вы сэкономили"
    },
    billing: {
      title: "Платежная информация",
      name: "Полное имя",
      email: "Электронная почта",
      country: "Страна",
      zip: "Почтовый индекс"
    }
  },
  qr: {
    title: "QR-код eSIM",
    alt: "QR-код eSIM",
    copy: "Скопировать код активации",
    tip: "Совет: откройте камеру телефона и сканируйте QR-код. Установить eSIM можно только один раз."
  },
  common: {
    usd: "USD",
    days: "дн.",
    na: "Н/Д",
    invalidDate: "Недействительная дата",
    cancel: "Отмена",
    close: "Закрыть",
    copied: "скопировано"
  }
},
countryDetails: {
  loading: "Загрузка данных о стране...",
  errors: {
    notFound: "Страна не найдена",
    loadFail: "Не удалось загрузить данные о стране"
  },
  notFound: {
    title: "Страна не найдена",
    subtitle: "Страна, которую вы ищете, не существует или для неё нет доступных тарифов.",
    cta: "Просмотреть все страны"
  },
  back: "Назад к странам",
  blurb: "Откройте {{country}} с гибкими eSIM-тарифами. Независимо от того, приезжаете ли вы на короткий срок или в длительную поездку, наши планы обеспечат вам связь без лишних хлопот.",
  noPlans: "Нет доступных тарифов для выбранных фильтров.",
  plan: {
    details: "Детали плана",
    detailsShort: "Детали",
    networkBadge: "5G",
    unlimited: "Безлимитный",
    unlimitedData: "Безлимитный интернет",
    gb: "ГБ",
    gbShort: "ГБ",
    data: "Данные",
    forDays: "На {count, plural, one {# ДЕНЬ} other {# ДНЕЙ}}"
  },
  currency: {
    usd: "USD"
  },
  duration: {
    days: "{count, plural, one {# день} other {# дней}}"
  },
  more: {
    more: "Смотреть больше тарифов",
    moreShort: "+{extra} ещё",
    less: "Показать меньше тарифов",
    lessShort: "Меньше"
  },
  modal: {
    title: "Детали плана",
    country: "Страна:",
    duration: "Длительность:",
    network: "Сеть:",
    autostart: "Автостарт:",
    enabled: "Включено",
    disabled: "Выключено",
    planType: "Тип плана:",
    description: "Описание",
    purchase: "Купить этот план",
    signInToPurchase: "Войдите, чтобы купить"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "Итого",
    buy: "Купить сейчас"
  }
},

checkout: {
  loading: "Загрузка защищённой оплаты...",
  invalidPlan: {
    title: "Недействительные данные плана",
    subtitle: "Не удалось загрузить информацию о выбранном плане.",
    cta: "Вернуться в панель управления"
  },
  success: {
    title: "Покупка успешна!",
    message: "eSIM успешно приобретён! ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "QR-код и инструкции по установке были отправлены на {{a}} и {{b}}",
    sentOne: "QR-код и инструкции по установке были отправлены на {{email}}",
    view: "Посмотреть мои eSIM"
  },
  common: {
    close: "Закрыть"
  },
  header: {
    title: "Защищённая оплата",
    subtitle: "Завершите покупку eSIM безопасно"
  },
  benefits: {
    title: "Войдите, чтобы получить преимущества",
    copy: "Создайте аккаунт, чтобы сохранить историю покупок, получить эксклюзивные предложения и управлять своими eSIM.",
    cta: "Зарегистрироваться / Войти"
  },
  billing: {
    title: "Платёжная информация",
    subtitle: "Счёт и eSIM будут отправлены на этот адрес электронной почты"
  },
  form: {
    firstName: "Имя",
    lastName: "Фамилия",
    email: "Адрес электронной почты",
    referral: "Реферальный код (необязательно)"
  },
  placeholder: {
    firstName: "Введите имя",
    lastName: "Введите фамилию",
    email: "Введите адрес электронной почты",
    referral: "Введите реферальный код",
    altEmail: "Введите альтернативный адрес электронной почты"
  },
  referral: {
    validating: "Проверка...",
    invalid: "Недействительный реферальный код",
    ownCode: "Нельзя использовать свой собственный реферальный код",
    inactive: "Этот реферальный код больше не активен",
    used: "Этот реферальный код уже был использован",
    valid: "Действительно! Применена скидка {{percent}}%",
    error: "Ошибка проверки кода"
  },
  altEmail: {
    title: "Использовать другой адрес электронной почты",
    copy: "eSIM также будет отправлен на другой адрес и сохранён в вашем аккаунте",
    input: "Альтернативный адрес электронной почты"
  },
  createAccount: {
    title: "Создайте аккаунт для сохранения истории покупок",
    copy: "Необязательно — помогает управлять eSIM и получать поддержку"
  },
  payment: {
    title: "Данные оплаты",
    secured: "Защищено Stripe",
    method: "Способ оплаты",
    card: "Кредитная или дебетовая карта",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "Оплатить через PayPal",
    cardInfo: "Информация о карте",
    loadingSecure: "Загрузка защищённой формы оплаты...",
    cardComplete: "Информация о карте заполнена",
    processing: "Обработка платежа...",
    complete: "Завершить покупку • ${{total}}"
  },
  legal: {
    agree: "Завершая заказ, вы соглашаетесь с нашими",
    terms: "Условиями использования",
    and: "и",
    privacy: "Политикой конфиденциальности и возвратов"
  },
  summary: {
    title: "Сводка заказа",
    planLabel: "План eSIM",
    digital: "Цифровой",
    data: "Объём данных:",
    validity: "Срок действия:",
    coverage: "Покрытие:",
    nationwide: "По всей стране"
  },
  pricing: {
    planPrice: "Стоимость плана",
    referralDiscount: "Реферальная скидка ({{percent}}%)",
    stripeFee: "Комиссия за обработку Stripe",
    paypalFee: "Комиссия за обработку PayPal",
    taxes: "Налоги и сервисный сбор",
    included: "Включено",
    total: "Итого"
  },
  paypal: {
    description: "eSIM для {{country}} — {{data}} на {{days}} дней"
  },
  duration: {
    days: "{count, plural, one {# день} few {# дня} many {# дней} other {# дней}}"
  },
  alerts: {
    enterName: "Пожалуйста, введите полное имя",
    formNotReady: "Форма оплаты ещё не готова. Подождите немного и попробуйте снова.",
    cardIncomplete: "Пожалуйста, введите полные данные карты",
    paypalFailed: "Ошибка оплаты через PayPal: {{msg}}",
    paypalGeneric: "Ошибка оплаты через PayPal. Пожалуйста, попробуйте снова.",
    purchaseFailed: "Ошибка покупки: {{msg}}"
  }
},
privacy: {
  title: "Политика конфиденциальности",
  subtitle:
    "Заявление о порядке сбора, использования и защиты персональной информации компанией Routed Labs, Inc.",
  lastUpdated: {
    label: "Последнее обновление:",
    date: "1 августа 2025"
  },
  sections: {
    intro: {
      heading: "Введение",
      p1:
        "Routed Labs, Inc. («Routed Labs», «мы», «наш» или «нас») управляет веб-сайтом и мобильным приложением Airvoy (далее — «Сервис»). Настоящая Политика конфиденциальности описывает, как мы собираем, используем, раскрываем и защищаем персональную информацию. Используя Сервис, вы даёте согласие на описанные здесь практики.",
      p2:
        "Routed Labs стремится поддерживать конфиденциальность, целостность и безопасность вашей персональной информации. Наши практики обработки данных разработаны так, чтобы быть прозрачными, пропорциональными и соответствовать применимым законам и нормативным актам."
    },
    collect: {
      heading: "Информация, которую мы собираем",
      p1:
        "Мы придерживаемся принципов минимизации данных и собираем только ту информацию, которая необходима для предоставления услуг eSIM. В частности, мы собираем:",
      email: {
        title: "Адрес электронной почты",
        collectedWhen: "Собирается, когда вы:",
        items: [
          "Создаёте аккаунт",
          "Приобретаете план eSIM",
          "Подписываетесь на рассылку",
          "Обращаетесь в службу поддержки"
        ],
        purposeLabel: "Цель:",
        purpose:
          "Для управления аккаунтами, доставки eSIM, отправки подтверждений и обеспечения поддержки клиентов."
      },
      notCollect: {
        title: "Мы не собираем:",
        items: [
          "Номера телефонов или идентификаторы устройств",
          "Данные о местоположении или геотрекинге",
          "Историю просмотров или поведенческие cookie",
          "Профили в соцсетях или личные фотографии",
          "Финансовые данные (платежи обрабатываются сторонними сервисами)"
        ]
      }
    },
    use: {
      heading: "Как мы используем информацию",
      p1: "Собранная информация используется исключительно для определённых целей:",
      items: [
        "Доставка данных eSIM, подтверждений покупок и квитанций",
        "Предоставление технической и клиентской поддержки",
        "Отправка важных обновлений сервиса и уведомлений о безопасности",
        "Необязательная рассылка маркетинговых материалов (по согласованию)"
      ],
      optOut: "Вы можете отказаться от маркетинговых сообщений в любое время."
    },
    share: {
      heading: "Обмен данными и раскрытие информации",
      p1:
        "Персональная информация не продаётся, не сдаётся в аренду и не передаётся в торговых целях. Она может быть передана только в следующих случаях:",
      items: [
        { title: "Поставщики услуг:", body: "Для функций, таких как обработка платежей или доставка писем" },
        { title: "Юридические требования:", body: "Когда этого требует закон, нормативный акт или судебное разбирательство" },
        { title: "Бизнес-транзакции:", body: "В связи со слияниями, поглощениями или реструктуризацией" },
        { title: "Безопасность:", body: "Для защиты прав, собственности и безопасности Routed Labs и его пользователей" }
      ]
    },
    retain: {
      heading: "Хранение и удаление данных",
      p1: "Информация хранится только столько времени, сколько необходимо для целей, описанных здесь:",
      items: [
        "Активные аккаунты: данные хранятся, пока аккаунт остаётся активным, и до двух лет после последнего взаимодействия.",
        "Гостевые покупки: хранятся до одного года для обеспечения поддержки и выполнения заказа.",
        "После удаления аккаунта: вся персональная информация безвозвратно удаляется из активных систем."
      ]
    },
    rights: {
      heading: "Права пользователей",
      p1: "Вы можете воспользоваться следующими правами:",
      items: [
        "Запросить доступ и копию персональных данных",
        "Запросить исправление неточной информации",
        "Запросить удаление данных",
        "Отозвать согласие на маркетинговые рассылки в любое время"
      ],
      contactPreamble: "Запросы могут быть направлены по адресу"
    },
    security: {
      heading: "Безопасность данных",
      p1:
        "Routed Labs применяет соответствующие технические и организационные меры для защиты персональной информации, включая:",
      items: [
        "Шифрование при передаче и хранении",
        "Регулярные аудиты и оценку уязвимостей",
        "Строгий контроль доступа и протоколы аутентификации",
        "Безопасную инфраструктуру и дата-центры"
      ]
    },
    contact: {
      heading: "Контактная информация",
      p1:
        "Вопросы или комментарии по поводу этой Политики конфиденциальности можно направлять по адресу:",
      company: "Routed Labs, Inc.",
      emailLabel: "Эл. почта:",
      addressLabel: "Адрес:",
      address: "451 Niantic Avenue, Daly City, CA 94014, США",
      subjectLabel: "Тема письма:",
      subject: "«Запрос по политике конфиденциальности»"
    },
    updates: {
      heading: "Обновления этой политики",
      p1:
        "Эта Политика конфиденциальности может периодически пересматриваться для отражения изменений в работе, законодательстве или регулировании. Существенные изменения будут опубликованы на этой странице с обновлённой датой «Последнее обновление».",
      p2:
        "Рекомендуем пользователям регулярно просматривать этот документ, чтобы быть в курсе того, как Routed Labs обрабатывает персональные данные."
    }
  }
},

tos: {
  title: "Условия обслуживания",
  subtitle:
    "Юридические условия и положения, регулирующие использование платформы Airvoy и услуг, предоставляемых Routed Labs, Inc.",
  lastUpdated: { label: "Последнее обновление:", date: "1 августа 2025 г." },
  sections: {
    agreement: {
      heading: "Согласие с условиями",
      p1:
        "Настоящие Условия обслуживания («Условия») являются юридически обязательным соглашением между пользователем («вы») и Routed Labs, Inc. («Routed Labs», «мы», «наш» или «нас»), регулирующим использование веб-сайта Airvoy, мобильного приложения и связанных услуг eSIM (далее — «Сервис»).",
      p2:
        "Получая доступ или используя Сервис, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать данные Условия. Если вы не согласны, вы должны воздержаться от доступа к Сервису или его использования."
    },
    service: {
      heading: "Описание сервиса",
      p1:
        "Сервис предоставляет функциональность eSIM (встроенной SIM-карты), позволяя пользователям подключаться к сотовым сетям по всему миру. Предлагаемые услуги включают:",
      items: [
        "Цифровые eSIM-профили для глобальной связи",
        "Различные варианты тарифных планов с разной продолжительностью",
        "Доставка QR-кода для активации и установки",
        "Поддержка клиентов по техническим вопросам",
        "Инструменты управления аккаунтом для зарегистрированных пользователей"
      ],
      notice:
        "Важно: Для работы Сервиса требуется совместимое и разблокированное устройство. Мы не гарантируем совместимость со всеми устройствами и покрытие во всех регионах."
    },
    eligibility: {
      heading: "Право на использование",
      p1: "Используя Сервис, вы подтверждаете и гарантируете, что вы:",
      items: [
        "Достигли 18 лет или имеете согласие родителей",
        "Обладаете правоспособностью для заключения юридически обязывающего договора",
        "Предоставляете точные и полные регистрационные данные",
        "Владеете совместимым устройством или имеете разрешение на его использование",
        "Будете соблюдать применимые законы и нормы"
      ]
    },
    account: {
      heading: "Регистрация аккаунта",
      p1:
        "Пользователи могут приобретать eSIM либо как зарегистрированные владельцы аккаунтов, либо как гости. Регистрация предоставляет дополнительные функции, включая историю покупок и расширенную поддержку.",
      registered: {
        title: "Зарегистрированные аккаунты",
        items: [
          "Требуется действующий адрес электронной почты",
          "Ответственность за безопасность аккаунта лежит на пользователе",
          "Обязанность поддерживать актуальность данных",
          "Немедленное уведомление о несанкционированном доступе"
        ]
      },
      guest: {
        title: "Покупки без регистрации",
        items: [
          "Требуется только адрес электронной почты",
          "eSIM доставляется в электронном виде",
          "Поддержка ограничена вопросами, связанными с покупкой",
          "История покупок не сохраняется"
        ]
      }
    },
    payment: {
      heading: "Условия оплаты",
      p1:
        "Совершая покупку, вы разрешаете Routed Labs и её платёжным провайдерам списывать средства с предоставленного вами способа оплаты. Основные условия:",
      items: [
        "Все цены указаны в долларах США и включают применимые налоги",
        "Оплата производится в момент покупки",
        "Обработка платежей осуществляется сторонними провайдерами",
        "Неудачная оплата может привести к приостановке обслуживания"
      ]
    },
    refunds: {
      heading: "Политика возвратов",
      p1: "Запросы на возврат средств рассматриваются при соблюдении следующих условий:",
      items: [
        "Допустимы, если запрошены в течение 24 часов после покупки",
        "Не допускаются, если eSIM была активирована или использована",
        "Технические проблемы рассматриваются индивидуально",
        "Совместимость устройства — ответственность пользователя"
      ],
      p2: {
        prefix: "Запросы на возврат должны быть отправлены на ",
        suffix: ", с указанием данных заказа и причины."
      }
    },
    limitations: {
      heading: "Ограничения сервиса",
      p1: "Использование Сервиса подвержено ряду ограничений, включая:",
      items: [
        "Устройство должно поддерживать eSIM и быть разблокированным",
        "Покрытие зависит от местных партнёрских сетей",
        "Скорость и доступность зависят от местоположения",
        "Неиспользованные данные не переносятся на следующий период",
        "Планы нельзя переносить между устройствами"
      ]
    },
    prohibited: {
      heading: "Запрещённое использование",
      p1:
        "Вы соглашаетесь не использовать Сервис для незаконных или запрещённых целей, включая, но не ограничиваясь:",
      items: [
        "Незаконная деятельность или нарушение регуляций",
        "Домогательства, злоупотребления или мошенничество",
        "Несанкционированный доступ к сети или вмешательство",
        "Перепродажа или передача учётных данных без разрешения",
        "Чрезмерное использование, ухудшающее работу сети"
      ]
    },
    liability: {
      heading: "Ограничение ответственности",
      p1:
        "В максимально допустимой законом степени Routed Labs не несёт ответственности за косвенные, случайные или последующие убытки, возникающие в результате использования вами Сервиса. Общая ответственность не может превышать сумму, уплаченную вами за Сервис, вызвавший претензию, за двенадцать (12) месяцев, предшествующих заявлению."
    },
    indemnity: {
      heading: "Возмещение убытков",
      p1:
        "Вы соглашаетесь возместить ущерб и защитить Routed Labs и её аффилированные лица от любых претензий, убытков или расходов, возникших в результате неправильного использования вами Сервиса или нарушения данных Условий."
    },
    termination: {
      heading: "Прекращение действия",
      p1:
        "Мы можем приостановить или прекратить доступ к Сервису немедленно, если вы нарушаете данные Условия, занимаетесь противоправной деятельностью или действуете во вред Routed Labs или его пользователям. После прекращения ваши права на использование Сервиса немедленно утрачиваются."
    },
    law: {
      heading: "Применимое право",
      p1:
        "Данные Условия регулируются законодательством штата Делавэр, США. Вы соглашаетесь подчиняться исключительной юрисдикции судов Делавэра для разрешения споров."
    },
    amend: {
      heading: "Изменения условий",
      p1:
        "Routed Labs оставляет за собой право изменять данные Условия по своему усмотрению. Обновления публикуются на сайте и вступают в силу немедленно, если не указано иное. Продолжая использовать Сервис после изменений, вы подтверждаете своё согласие с обновлёнными Условиями."
    },
    contact: {
      heading: "Контактная информация",
      p1: "По вопросам, касающимся данных Условий, свяжитесь с нами:"
    }
  }
},
about: {
  title: "О компании Airvoy",
  sections: {
    overview: {
      heading: "Обзор",
      body:
        "Airvoy — это платформа eSIM, разработанная компанией Routed Labs, Inc. Она обеспечивает международных путешественников доступной, надёжной и удобной мобильной связью. Отказ от физических SIM-карт позволяет легко активировать тарифные планы более чем в 200 странах."
    },
    mission: {
      heading: "Миссия",
      body:
        "Routed Labs, Inc. работает с единственной целью — упростить мобильную связь. Компания стремится устранить неопределённость, скрытые расходы и сложности, связанные с международным роумингом и покупкой SIM-карт, чтобы путешественники могли оставаться на связи без проблем."
    },
    background: {
      heading: "История",
      p1:
        "Routed Labs, Inc. базируется в Дейли-Сити, Калифорния. Идея компании возникла из личного опыта сложностей с международной связью, включая высокие тарифы роуминга и ограниченную доступность SIM-карт.",
      p2:
        "Наблюдая эти трудности, основатель увидел возможность использовать технологию eSIM для улучшения глобальной связи.",
      p3:
        "Сегодня компания поддерживает тысячи пользователей по всему миру, уделяя внимание надёжности, прозрачности и доступности."
    },
    operations: {
      heading: "Деятельность",
      items: [
        { title: "Глобальное покрытие:", desc: "Доступ к высокоскоростным сетям в более чем 200 странах и территориях." },
        { title: "Подключение eSIM:", desc: "Цифровая установка тарифных планов за считанные минуты без физических SIM-карт." },
        { title: "Ориентация на клиента:", desc: "Сервис и поддержка, созданные для простоты и удобства пользователей." }
      ]
    },
    corporate: {
      heading: "Корпоративная информация",
      company: {
        title: "Данные о компании",
        nameLabel: "Название компании:",
        name: "Routed Labs, Inc.",
        repLabel: "Представитель:",
        rep: "Hector Diaz",
        addrLabel: "Адрес штаб-квартиры:",
        addr: "451 Niantic Avenue, Daly City, CA 94014, США",
        contactLabel: "Контакт:"
      },
      agent: {
        title: "Информация о зарегистрированном агенте",
        nameLabel: "Имя зарегистрированного агента:",
        name: "Legalinc Corporate Services Inc.",
        addrLabel: "Адрес зарегистрированного агента:",
        addr: "131 Continental Dr, Suite 305, Newark, DE 19713, США"
      }
    },
    comms: {
      heading: "Связь",
      p1: {
        prefix: "По официальным запросам или для переписки пишите на",
        suffix:
          ". Корпоративная и юридическая корреспонденция также может направляться зарегистрированному агенту компании Legalinc Corporate Services Inc. по адресу в Ньюарке, Делавэр."
      }
    }
  }
},

auth: {
  titles: {
    signin: 'С возвращением',
    signup: 'Создать аккаунт',
    forgot: 'Сбросить пароль',
  },
  subtitles: {
    signin: 'Войдите, чтобы приобрести планы eSIM',
    signup: 'Присоединяйтесь к Airvoy уже сегодня',
    forgot: 'Введите свой email, чтобы сбросить пароль',
  },
  fields: {
    email: 'Адрес электронной почты',
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
  },
  placeholders: {
    email: 'Введите ваш email',
    password: 'Введите ваш пароль',
    confirmPassword: 'Подтвердите ваш пароль',
  },
  actions: {
    close: 'Закрыть',
    continueWithGoogle: 'Продолжить с Google',
    signingIn: 'Вход...',
    pleaseWait: 'Пожалуйста, подождите...',
    signIn: 'Войти',
    createAccount: 'Создать аккаунт',
    sendReset: 'Отправить письмо для сброса',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
  },
  labels: {
    orEmail: 'Или продолжить с помощью email',
  },
  links: {
    noAccount: "Нет аккаунта?",
    signUp: 'Зарегистрироваться',
    forgot: 'Забыли пароль?',
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
    remembered: 'Вспомнили пароль?',
    backToSignIn: 'Вернуться к входу',
  },
  messages: {
    resetSent: 'Письмо для сброса пароля отправлено! Проверьте почту.',
  },
  errors: {
    fillAll: 'Пожалуйста, заполните все поля',
    userNotFound: 'Аккаунт с этим email не найден',
    wrongPassword: 'Неверный email или пароль',
    emailInUse: 'Аккаунт с этим email уже существует',
    weakPassword: 'Пароль слишком слабый',
    invalidEmail: 'Некорректный email',
    tooManyRequests: 'Слишком много неудачных попыток. Попробуйте позже',
    popupClosed: 'Всплывающее окно входа было закрыто до завершения',
    popupCancelled: 'Вход был отменён',
    popupBlocked: 'Всплывающее окно входа было заблокировано браузером',
    passwordMismatch: 'Пароли не совпадают',
    passwordMin: 'Пароль должен содержать не менее 6 символов',
    enterEmail: 'Пожалуйста, введите ваш email',
    generic: 'Произошла ошибка. Попробуйте снова',
  },
  legal: {
    prefix: 'Создавая аккаунт, вы соглашаетесь с',
    terms: 'Условиями использования',
    and: 'и',
    privacy: 'Политикой конфиденциальности',
  },
},
support: {
  title: "Поддержка",
  contactInfo: "Контактная информация",
  channels: {
    email: {
      title: "Поддержка по email",
      description: "Для запросов, сообщений о проблемах и просьб о помощи.",
      contact: "support@routedlabs.com",
      action: "Написать письмо"
    },
    chat: {
      title: "Онлайн-чат",
      description: "Помощь в реальном времени для срочных вопросов, при наличии поддержки.",
      contact: "Доступно с 09:00 до 18:00 по тихоокеанскому времени",
      action: "Открыть чат"
    }
  },
  faqTitle: "Часто задаваемые вопросы",
  noResults: "Нет результатов по текущему запросу.",
  categoryLabel: "Категория:",
  show: "Показать",
  hide: "Скрыть",
  noticesTitle: "Уведомления и корреспонденция",
  noticesLine1: {
    before: "Официальные запросы и корреспонденцию следует направлять на",
    after: "."
  },
  noticesLine2:
    "Эта страница предназначена для описания процессов поддержки и справочных материалов. Она не изменяет и не заменяет действующие условия обслуживания или политики, которые имеют приоритет во всех случаях.",
  categories: {
    overview: "Обзор eSIM",
    compatibility: "Совместимость устройств",
    installation: "Установка",
    dualSim: "Dual SIM",
    dataUsage: "Использование данных",
    planMgmt: "Управление планами",
    deviceReqs: "Требования к устройствам",
    troubleshooting: "Устранение неполадок",
    refunds: "Возвраты",
    supportHours: "Доступность поддержки"
  },
  faqs: {
    1: {
      q: "Что такое eSIM и как она работает?",
      a: "eSIM (встроенная SIM) — это программируемая SIM-карта, встроенная в устройство, которая позволяет активировать сотовую связь без физической карты. Пользователи получают профиль цифровым способом и могут подключиться, отсканировав код или следуя шагам настройки в Airvoy."
    },
    2: {
      q: "Какие устройства поддерживают функцию eSIM?",
      a: "Многие современные смартфоны поддерживают eSIM, включая последние модели ведущих производителей. Проверьте настройки устройства (обычно в разделе «Сотовая связь» или «Мобильные данные»), чтобы увидеть, доступна ли опция «Добавить тарифный план»."
    },
    3: {
      q: "Как устанавливается eSIM?",
      a: "После покупки вы получите инструкции по установке и QR-код на email. На устройстве перейдите в Настройки → Сотовая связь/Мобильные данные → Добавить тарифный план и отсканируйте код. Активация завершится автоматически после выполнения подсказок."
    },
    4: {
      q: "Можно ли использовать физическую SIM и eSIM одновременно на одном устройстве?",
      a: "Большинство устройств с поддержкой eSIM позволяют использовать две SIM. Вы можете сохранить основной номер для звонков и сообщений, а eSIM использовать для передачи данных. Выбор регулируется в настройках устройства."
    },
    5: {
      q: "Что происходит, если выделенный трафик не израсходован полностью?",
      a: "Неиспользованные данные не переносятся и не возвращаются. Планы истекают по окончании срока действия. Выбирайте план, соответствующий вашему предполагаемому использованию во время поездки."
    },
    6: {
      q: "Можно ли добавить трафик или продлить действующий план?",
      a: "Да. Вы можете приобрести дополнительный трафик или продлить услугу, купив новый план через сайт или ваш аккаунт, если это доступно для выбранного направления."
    },
    7: {
      q: "Должно ли устройство быть разблокировано?",
      a: "Да. Чтобы использовать eSIM от другого оператора, устройство должно быть разблокировано. Если оно заблокировано, обратитесь к вашему оператору, чтобы запросить разблокировку перед активацией."
    },
    8: {
      q: "Что делать, если eSIM не работает как ожидается?",
      a: "Убедитесь, что устройство разблокировано и поддерживает eSIM. Проверьте, включен ли роуминг данных, выбран ли правильный тарифный план, и попробуйте перезагрузить устройство. Если проблема сохраняется, свяжитесь с поддержкой."
    },
    9: {
      q: "Доступен ли возврат средств?",
      a: "Возврат может быть возможен в течение 24 часов после покупки, если eSIM не была активирована или использована. После активации возвраты невозможны. В случае технических проблем поддержка попытается их решить или предоставит кредит на счёт."
    },
    10: {
      q: "Каковы часы работы поддержки и время ответа?",
      a: "Поддержка по email доступна круглосуточно. Обычно ответ приходит в течение нескольких часов. Срочные вопросы, сообщённые во время путешествий, получают повышенный приоритет."
    }
  }
}

  },
  hi: {
    // Navigation
nav: {
  installEsim: "eSIM स्थापित करें",
  business: "प्रशासन",
  faqs: "सामान्य प्रश्न",
  browsePlans: "प्लान देखें",
  partnerships: "साझेदारियाँ",
  dashboard: "डैशबोर्ड",
  signOut: "साइन आउट",
  signIn: "साइन इन",
  getTheApp: "ऐप प्राप्त करें"
},

    // Hero Section
hero: {
  badge: "Airvoy eSIM का उपयोग करने वाले +30,000 यात्रियों में शामिल हों।",
  title: "वैश्विक",
  titleHighlight: "eSIM",
  subtitle: "ऐसे जुड़े रहें जैसे आप घर पर हों — त्वरित सेटअप, लचीला डेटा और 200+ देशों में वैश्विक कवरेज।",
  searchPlaceholder: "आप कहाँ यात्रा कर रहे हैं?",
  appStore: "ऐप स्टोर",
  googlePlay: "गूगल प्ले"
},

    // Popular Countries
popularCountries: {
  title: "लोकप्रिय गंतव्य",
  subtitle: "इन शीर्ष यात्रा स्थलों पर तुरंत कनेक्ट हों",
  fromPrice: "से",
  perDay: "/दिन",
  unlimited: "अनलिमिटेड",
  startingAt: "की शुरुआत",
  getStarted: "शुरू करें",
  viewAllCountries: "सभी देशों को देखें",
  noPlansAvailable: "कोई अनलिमिटेड प्लान उपलब्ध नहीं"
},

// How It Works
howItWorks: {
  title: "Airvoy eSIM कैसे काम करता है",
  subtitle: "तीन आसान चरणों में कनेक्ट हो जाएं",
  step1Title: "अपना गंतव्य चुनें",
  step1Desc: "200+ गंतव्यों को पारदर्शी कीमतों के साथ ब्राउज़ करें। कोई छिपे शुल्क नहीं, कोई आश्चर्य नहीं — बस आपके सफ़र के लिए सही प्लान।",
  step2Title: "सेकंडों में इंस्टॉल करें", 
  step2Desc: "अपना eSIM तुरंत ईमेल के माध्यम से प्राप्त करें। एक त्वरित QR कोड स्कैन और आप तैयार हैं — न स्टोर विज़िट की ज़रूरत, न फिज़िकल सिम बदलने की।",
  step3Title: "स्वचालित रूप से कनेक्ट करें",
  step3Desc: "लैंड करें और तुरंत कनेक्ट हो जाएं। आपका eSIM आगमन पर स्वचालित रूप से सक्रिय हो जाता है — अब हवाई अड्डे पर वाईफाई ढूँढने की ज़रूरत नहीं।",
  learnMore: "और जानें"
},
// Benefits
benefits: {
  whyAirvoy: "क्यों चुनें Airvoy?",
  title: "जहाँ भी जाएँ, जुड़े रहें",
  item1Title: "अपने लिए सही प्लान खोजें",
  item1Desc: "लचीले डेटा प्लान जो आपके बजट में फिट हों। साप्ताहिक 1 GB प्लान से लेकर छह महीने तक चलने वाले 100 GB डेटा तक — सब कुछ एक ही ऐप में पाएं।",
  item2Title: "आसानी से उपयोग करें",
  item2Desc: "बस Airvoy डाउनलोड करें, eSIM इंस्टॉल करें, और डेटा प्लान लें — यह आपके गंतव्य पर पहुँचते ही स्वतः सक्रिय हो जाएगा।",
  item3Title: "रोमिंग लागत से बचें",
  item3Desc: "छिपे हुए रोमिंग शुल्क अब बीते समय की बात हैं। यात्रा से पहले जान लें कि आपका इंटरनेट कनेक्शन कितना खर्च करेगा!",
  item4Title: "आपकी सभी यात्राओं के लिए एक ही eSIM",
  item4Desc: "अपने मौजूदा Airvoy eSIM में नए गंतव्य जोड़ें — हर बार नया eSIM इंस्टॉल करने की ज़रूरत नहीं। बस टॉप अप करें और कनेक्ट हो जाएँ!",
  item5Title: "डेटा खत्म होने न दें",
  item5Desc: "सबसे बुरे समय पर डेटा खत्म होने का जोखिम न लें — हम आपको सूचित करेंगे जब आप अपने प्लान का 80% उपयोग कर चुके होंगे।",
  item6Title: "+200 देश",
  item6Desc: "दुनिया भर के 200+ देशों और क्षेत्रों में ऑनलाइन रहें।"
},
// Videos
videos: {
  title: "देखें और जल्दी कनेक्ट हों",
  subtitle: "दो त्वरित गाइड — एक iPhone के लिए, एक Samsung के लिए।",
  iPhoneTitle: "eSIM सेटअप और एक्टिवेशन — iPhone",
  iPhoneDesc: "अपने iPhone पर Airvoy eSIM इंस्टॉल और सक्रिय करने के लिए चरण-दर-चरण गाइड। स्कैन करें, इंस्टॉल करें और कुछ ही मिनटों में ऑनलाइन हो जाएँ।",
  samsungTitle: "eSIM सेटअप और एक्टिवेशन — Samsung",
  samsungDesc: "Samsung Galaxy डिवाइस पर Airvoy eSIM जोड़ना सीखें। इंस्टॉल से पहली कनेक्शन तक की तेज़, स्पष्ट गाइड।",
  iOSGuide: "iOS गाइड",
  samsungGuide: "Samsung गाइड",
  installationGuide: "या पूरी इंस्टॉलेशन गाइड पढ़ें"
},
// Footer
footer: {
  description: "+30,000 यात्रियों के साथ जुड़ें जो Airvoy eSIM का उपयोग कर रहे हैं। समझदारी से यात्रा करें, जुड़े रहें — चाहे आपकी यात्रा जहाँ भी ले जाए।",
  company: "कंपनी",
  aboutUs: "हमारे बारे में",
  resources: "संसाधन",
  documentation: "दस्तावेज़ीकरण",
  support: "सपोर्ट",
  legal: "कानूनी",
  privacyPolicy: "गोपनीयता नीति",
  termsOfService: "सेवा की शर्तें",
  followUs: "हमें फॉलो करें",
  copyright: "सर्वाधिकार सुरक्षित।",
  madeWith: "से बनाया गया",
  forTravelers: "दुनिया भर के यात्रियों के लिए"
},
// Auth
aut: {
  authenticationRequired: "प्रमाणीकरण आवश्यक",
  signInPrompt: "डैशबोर्ड तक पहुँचने और eSIM प्लान खरीदने के लिए कृपया साइन इन करें।"
},
// Common
common: {
  close: "बंद करें",
  loading: "लोड हो रहा है...",
  tryAgain: "फिर से कोशिश करें",
  noResults: "के लिए कोई देश नहीं मिला"
},

activate: {
  altText: "Airvoy eSIM वैश्विक सक्रियण",
  activeInThailand: "Airvoy थाईलैंड में सक्रिय",
  activeInSpain: "Airvoy स्पेन में सक्रिय", 
  activeWorldwide: "Airvoy दुनिया भर में सक्रिय",
  activeInGreece: "Airvoy ग्रीस में सक्रिय",
  activeInMexico: "Airvoy मेक्सिको में सक्रिय",
  title: "अपना WhatsApp नंबर रखें",
  description: "आप WhatsApp पर अपने सभी संपर्कों को उसी देश में होने की तरह कॉल और मैसेज कर सकते हैं।\nपरिवार और दोस्तों से जुड़े रहें।"
},
regionalPlans: {
  multiCountryCoverage: "मल्टी-कंट्री कवरेज",
  title: "क्षेत्रीय प्लान", 
  subtitle: "एक क्षेत्र चुनें, फिर अपनी ज़रूरत के अनुसार अवधि/डेटा का चयन करें।",
  noPlansAvailable: "कोई क्षेत्रीय प्लान उपलब्ध नहीं है।",
  from: "से",
  seePlans: "प्लान देखें",
  countries: "देश",
  plans: "प्लान", 
  startingFrom: "की शुरुआत",
  browseOptions: "विकल्प ब्राउज़ करें",
  viewPlans: "प्लान देखें"
},
partnerships: {
  headerLabel: "साझेदारियाँ",
  title: "Airvoy साझेदारियाँ",
  subtitle: "आइए साझेदारी करें और मिलकर शानदार काम करें।",
  join: "शामिल हों",
  airvoyAffiliate: "Airvoy\nएफिलिएट प्रोग्राम", 
  affiliateDescription: "Airvoy eSIM को प्रमोट करके 20% तक कमीशन कमाएँ — आज ही हमारे आधिकारिक एफिलिएट नेटवर्क से जुड़ें!",
  joinNow: "अभी जुड़ें!",
  learnMore: "और जानें",
  partnershipImageAlt: "Airvoy साझेदारी",
  
  // Partnership types
  affiliateProgram: "एफिलिएट प्रोग्राम",
  eventPartnership: "इवेंट साझेदारी", 
  travelPartnership: "ट्रैवल साझेदारी",
  contentPartnership: "कंटेंट साझेदारी",
  sportsPartnership: "स्पोर्ट्स साझेदारी",
  musicCulturePartnership: "संगीत एवं संस्कृति साझेदारी",
  athleteCollaboration: "एथलीट सहयोग",
  other: "अन्य",
  
  // Partnership descriptions
  eventPartnerships: "इवेंट साझेदारियाँ",
  eventDescription1: "क्या आप एक अंतरराष्ट्रीय कार्यक्रम आयोजित कर रहे हैं और अपने प्रतिभागियों को एक बेहतरीन सुविधा देना चाहते हैं: मुफ्त मोबाइल डेटा?",
  eventDescription2: "हम आपके और आपके मेहमानों के लिए सही समाधान तैयार कर सकते हैं ताकि वे कार्यक्रम से पहले, दौरान और बाद में सहजता से जुड़े रहें।",
  
  travelPartnerships: "ट्रैवल साझेदारियाँ",
  travelDescription1: "क्या आप अपने ग्राहकों के कर्मचारियों और यात्रियों को सहज और सस्ते मोबाइल डेटा और वॉयस कॉल सेवाएँ प्रदान करना चाहते हैं?",
  travelDescription2: "हमारे एकीकृत मोबाइल कनेक्टिविटी सूट के साथ, हम आपको न्यूनतम प्रयास और अधिकतम सुविधा के साथ अपने ग्राहकों को मूल्य वर्धित ट्रैवल समाधान प्रदान करने में मदद कर सकते हैं।",
  
  contentPartnerships: "कंटेंट साझेदारियाँ", 
  contentDescription1: "क्या आप सोशल मीडिया पर कंटेंट क्रिएटर हैं जिनके पास रचनात्मक विचार, सक्रिय दर्शक और उपयोगी #TravelHacks और #LifeHacks के लिए पैनी नज़र है?",
  contentDescription2: "या आप बस Airvoy को पसंद करते हैं और इसे साझा करना चाहते हैं ताकि अन्य लोग भी दुनिया भर में सहज मोबाइल कनेक्टिविटी का आनंद ले सकें?",
  
  sportsPartnerships: "स्पोर्ट्स साझेदारियाँ",
  sportsDescription1: "क्या आप किसी खेल प्रतियोगिता का आयोजन कर रहे हैं और एथलीटों, टीमों और प्रशंसकों को पूरे कार्यक्रम के दौरान जुड़े रहने का एक विश्वसनीय तरीका प्रदान करना चाहते हैं?",
  sportsDescription2: "Airvoy के साथ साझेदारी करें ताकि उद्घाटन समारोह से लेकर अंतिम सीटी तक सभी के लिए सहज मोबाइल डेटा समाधान उपलब्ध कराए जा सकें।",
  
  musicCulturePartnerships: "संगीत एवं संस्कृति साझेदारियाँ",
  musicDescription1: "क्या आप संगीत महोत्सव, सांस्कृतिक कार्यक्रम या लाइव परफॉर्मेंस आयोजित कर रहे हैं और प्रतिभागियों के अनुभव को बेहतर बनाने के तरीके खोज रहे हैं?",
  musicDescription2: "Airvoy आपके दर्शकों को विश्वसनीय मोबाइल डेटा सेवाएँ प्रदान कर सकता है, ताकि वे कार्यक्रम का आनंद लेते हुए साझा कर सकें, स्ट्रीम कर सकें और जुड़े रहें।",
  
  athleteCollaborations: "एथलीट सहयोग",
  athleteDescription1: "क्या आप एक ऐसे एथलीट हैं जो दुनिया भर में प्रतियोगिताओं में भाग ले रहे हैं और आपकी ट्रॉफी अलमारी में जगह नहीं बची है?",
  athleteDescription2: "Airvoy के साथ साझेदारी करें ताकि आप जहाँ भी खेलें, जुड़े रहें और अपने प्रशंसकों के साथ अपनी यात्रा साझा करें।",
  
  letsTalk: "बात करें",
  
  // Contact form
  getInTouch: "संपर्क करें",
  successMessage: "हमसे संपर्क करने के लिए धन्यवाद! हम जल्द ही आपसे जुड़ेंगे।",
  errorMessage: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  emailPlaceholder: "अपना ईमेल दर्ज करें",
  fullNamePlaceholder: "पूरा नाम",
  partnerTypePlaceholder: "आप किस पर साझेदारी करना चाहते हैं?",
  messagePlaceholder: "संक्षेप में बताएं कि आपके मन में क्या है",
  privacyConsent: "आप हमारी अनुकूल",
  privacyPolicy: "गोपनीयता नीति",
  sending: "भेजा जा रहा है...",
  send: "भेजें"
},

faq: {
  headerLabel: "सामान्य प्रश्न",
  title: "सबसे अधिक पूछे जाने वाले प्रश्नों के उत्तर खोजें",
  learnMore: "और जानें",
  
  whatIsEsim: {
    question: "eSIM क्या है?",
    answer: "eSIM एक उद्योग मानक डिजिटल सिम है जो आपको बिना किसी भौतिक सिम का उपयोग किए अपने कैरियर से सेल्युलर प्लान सक्रिय करने की अनुमति देता है। आप iPhone पर आठ या अधिक eSIM इंस्टॉल कर सकते हैं और एक ही समय में दो फोन नंबर का उपयोग कर सकते हैं।"
  },
  
  howToSetup: {
    question: "अपना eSIM कैसे सेटअप करें?",
    answer: "eSIM तकनीक बहुत सुविधाजनक है। हालांकि, इसे सेटअप करना थोड़ा परेशान कर सकता है, खासकर अगर आप इसे पहली बार कर रहे हैं। लेकिन चिंता न करें, हमारे पास यहां चरण-दर-चरण गाइड हैं, जो आपको तुरंत Airvoy के साथ शुरू करने में मदद करेंगे।"
  },
  
  whatIsAirvoy: {
    question: "Airvoy क्या है?",
    answer: "Airvoy एक मोबाइल ऐप है जो वैश्विक मोबाइल कनेक्टिविटी समाधान प्रदान करता है। यह यात्रा के दौरान बिना भौतिक सिम कार्ड या महंगे रोमिंग शुल्क के आसानी से जुड़े रहने का तरीका प्रदान करता है।"
  },
  
  howSaveRoaming: {
    question: "Airvoy मुझे रोमिंग शुल्क में कैसे बचत करने में मदद करता है?",
    answer: "यह सामान्य रोमिंग शुल्क की तुलना में 90% तक सस्ता मोबाइल डेटा प्रदान करता है। इस तरह, आप पारंपरिक रोमिंग सेवाओं से जुड़े उच्च खर्च से बच सकते हैं।"
  },
  
  needNewSim: {
    question: "क्या मुझे Airvoy के साथ हर बार यात्रा करने पर नया सिम कार्ड लेना होगा?",
    answer: "नहीं, Airvoy eSIM तकनीक का उपयोग करता है, जिसका मतलब है कि इसमें किसी भौतिक सिम कार्ड की आवश्यकता नहीं है। Airvoy eSIM वैश्विक है, यानी एक बार डाउनलोड और सक्रिय करने के बाद आप इसे वैश्विक स्तर पर उपयोग कर सकते हैं या विशिष्ट देशों के लिए नए खरीद सकते हैं।"
  },
  
  constantConnectivity: {
    question: "Airvoy यात्रा के दौरान लगातार कनेक्टिविटी कैसे सुनिश्चित करता है?",
    answer: "यह सामान्य रोमिंग शुल्क की तुलना में 90% तक सस्ता मोबाइल डेटा प्रदान करता है। इस तरह, आप पारंपरिक रोमिंग सेवाओं से जुड़े उच्च खर्च से बच सकते हैं।"
  },
  
  freeCallsTexts: {
    question: "क्या Airvoy मुफ्त कॉलिंग और टेक्स्टिंग प्रदान करता है?",
    answer: "अभी नहीं। लेकिन जल्द ही Airvoy अन्य Airvoy उपयोगकर्ताओं के लिए मुफ्त कॉलिंग और टेक्स्टिंग प्रदान करेगा। इसका मतलब है कि आप बिना किसी अतिरिक्त लागत के अन्य Airvoy उपयोगकर्ताओं से जुड़े रह सकेंगे।"
  },
  
  whyChooseAirvoy: {
    question: "मुझे अन्य रोमिंग विकल्पों के बजाय Airvoy क्यों चुनना चाहिए?",
    answer: "आपको अन्य रोमिंग विकल्पों की तुलना में Airvoy चुनना चाहिए क्योंकि यह एक ही eSIM के साथ सहज वैश्विक कनेक्टिविटी, किफायती मॉडल और अतिरिक्त सुविधाएँ प्रदान करता है, जैसे कि मैसेजिंग (जल्द ही), और स्थानीय नंबर (जल्द ही), वह भी एक उपयोगकर्ता-अनुकूल ऐप में। यह सस्ता, आसान है और आपको पूरी तरह नियंत्रित करता है कि आप कहीं भी कैसे कनेक्ट होना चाहते हैं।"
  }
},
browse: {
  main: {
    title: "eSIM प्लान ब्राउज़ करें",
    subtitle: "दुनिया भर के गंतव्यों के लिए eSIM प्लान खोजें, रियल-टाइम मूल्य निर्धारण के साथ"
  },
  search: {
    placeholder: "देश खोजें (जैसे, संयुक्त राज्य अमेरिका, स्पेन, जापान)...",
    clearSearch: "खोज साफ़ करें",
    noCountriesFound: "आपकी खोज से मेल खाने वाले कोई देश नहीं मिले।",
    noCountriesAvailable: "कोई देश उपलब्ध नहीं है।",
    clearSearchButton: "खोज साफ़ करें",
    searching: "देश खोजे जा रहे हैं...",
    country: "देश",
    countries: "देश",
    foundFor: "मिले इसके लिए"
  },
  loading: {
    loadingText: "लोड हो रहा है...",
    allCountriesLoaded: "सभी देश लोड हो गए",
    total: "कुल"
  },
  buttons: {
    showMoreCountries: "और देश दिखाएँ",
    showLessPlans: "कम प्लान दिखाएँ",
    showLess: "कम दिखाएँ",
    seeMorePlans: "और प्लान देखें",
    more: "अधिक",
    buyNow: "अभी खरीदें"
  },
  navigation: {
    backToCountries: "देशों पर वापस जाएँ"
  }, 
  countryDetails: {
    description: "हमारे eSIM डेटा प्लानों के साथ {{country}} को लचीलापन के साथ एक्सप्लोर करें। चाहे आप थोड़े समय के लिए जा रहे हों या लंबे प्रवास के लिए, हमारे प्लान आपको बिना किसी परेशानी के जुड़े रखते हैं।"
  },
  plans: {
    noPlansAvailable: "चुने गए फ़िल्टर के लिए कोई प्लान उपलब्ध नहीं है।",
    planDetails: "प्लान विवरण",
    details: "विवरण",
    unlimited: "अनलिमिटेड",
    for: "के लिए",
    day: "दिन",
    days: "दिन"
  },
  checkout: {
    total: "कुल"
  },
  planDetails: {
    title: "प्लान विवरण",
    unlimitedData: "अनलिमिटेड डेटा",
    data: "डेटा",
    country: "देश",
    duration: "अवधि",
    day: "दिन",
    days: "दिन",
    network: "नेटवर्क", 
    autoStart: "ऑटो-स्टार्ट",
    enabled: "सक्रिय",
    disabled: "निष्क्रिय",
    planType: "प्लान प्रकार",
    description: "विवरण",
    purchaseThisPlan: "यह प्लान खरीदें",
    signInToPurchase: "खरीदने के लिए साइन इन करें"
  }
},

installation: {
  title: "मैं अपना eSIM कैसे इंस्टॉल और सेटअप करूँ?",
  metaUpdated: "2 महीने पहले • अपडेट किया गया",
  intro: {
    p1: "चाहे आप एंड्रॉइड या एप्पल पर हों, पहले सुनिश्चित करें कि आपका फोन eSIM-संगत और नेटवर्क-अनलॉक्ड है। आपको एक स्थिर इंटरनेट कनेक्शन (अधिमानतः वाई-फाई) की भी आवश्यकता होगी।",
    p2: "फिर, आप या तो:",
    ol1: "स्वचालित इंस्टॉलेशन के लिए QR कोड स्कैन करें",
    ol2: "अपना eSIM मैन्युअल रूप से इंस्टॉल करें",
    note: "QR कोड के साथ इंस्टॉल करना सबसे आसान तरीका है।"
  },
  ios: {
    qr: {
      title: "QR कोड का उपयोग करके अपना eSIM इंस्टॉल करें (iOS)",
      s1: "1. सेटिंग्स > मोबाइल डेटा पर जाएँ",
      s2: "2. “eSIM जोड़ें” पर टैप करें और QR कोड का उपयोग चुनें",
      s3: "3. QR कोड स्कैन करें और यदि पूछा जाए तो 4-अंकीय पुष्टि कोड दर्ज करें",
      s4: "4. अपने eSIM को लेबल करें और डिफ़ॉल्ट लाइन के तहत “केवल सेलुलर डेटा” चुनें",
      s5: "5. अब आपको “मोबाइल डेटा” के तहत अपना eSIM दिखना चाहिए"
    },
    manual: {
      title: "अपना eSIM मैन्युअल रूप से कैसे इंस्टॉल करें (iOS)",
      s1: "1. सेटिंग्स > मोबाइल डेटा > eSIM जोड़ें",
      s2: "2. “eSIM जोड़ें” पर टैप करें और QR कोड का उपयोग चुनें",
      s3: "3. स्कैन करने के बजाय, विवरण मैन्युअल रूप से दर्ज करें पर टैप करें",
      s4: "4. अपने Airvoy ऐप से SM-DP+ पता, एक्टिवेशन कोड, और वैकल्पिक पुष्टि कोड दर्ज करें",
      s5: "5. अपने eSIM को लेबल करें और डिफ़ॉल्ट लाइन के तहत “केवल सेलुलर डेटा” चुनें",
      s6: "6. अब आपको मोबाइल डेटा के तहत अपना eSIM दिखना चाहिए"
    }
  },
  android: {
    qr: {
      title: "QR कोड का उपयोग करके अपना eSIM इंस्टॉल करें (Android)",
      s1: "1. सेटिंग्स > नेटवर्क और इंटरनेट > SIMs पर जाएँ",
      s2: "2. “SIMs” के दाईं ओर “+” आइकन पर टैप करें",
      s3: "3. नीचे “इसके बजाय एक SIM डाउनलोड करें?” पर टैप करें",
      s4: "4. “अपना SIM डाउनलोड करें” पर, “अगला” टैप करें — आपको “नेटवर्क जानकारी जांच रहा है...” दिखाई देगा",
      s5: "5. जांच के बाद, QR कोड स्कैन करने के लिए व्यूफ़ाइंडर दिखाई देगा",
      s6: "6. इसे मुद्रित QR कोड या कोड दिखाने वाले किसी अन्य डिवाइस पर पॉइंट करें",
      s7: "7. स्कैनिंग के बाद, आपका डिवाइस फिर से जानकारी जांचेगा",
      s8: "8. पुष्टि करने के लिए डाउनलोड पर टैप करें — eSIM डेटा डाउनलोड हो जाएगा",
      s9: "9. पूरा होने पर, आपको “डाउनलोड पूरा हुआ” दिखाई देगा",
      s10: "10. जब आप तैयार हों, इंटरनेट एक्सेस के लिए eSIM सेटअप करें।"
    }
  },
  notes: {
    title: "महत्वपूर्ण नोट्स",
    n1: "सुनिश्चित करें कि आपका डिवाइस eSIM-संगत और नेटवर्क-अनलॉक्ड है",
    n2: "इंस्टॉलेशन के दौरान आपको स्थिर वाई-फाई कनेक्शन की आवश्यकता होगी",
    n3: "eSIM केवल एक बार इंस्टॉल किया जा सकता है — जब आप तैयार हों तभी शुरू करें",
    n4: "कॉल और टेक्स्ट के लिए अपने प्राथमिक सिम को सक्रिय रखें",
    n5: "आपका eSIM आपके गंतव्य देश में पहुँचने पर सक्रिय हो जाएगा"
  },
  support: {
    title: "मदद चाहिए?",
    body: "यदि आपको अपना eSIM इंस्टॉल करने में परेशानी हो रही है, तो हमारी सपोर्ट टीम मदद के लिए यहाँ है!",
    emailLabel: "ईमेल:",
    websiteLabel: "वेबसाइट:"
  }
},

installGuide: {
  header: {
    title: "पूर्ण eSIM इंस्टॉलेशन गाइड",
    subtitle: "अपने eSIM को इंस्टॉल, सक्रिय और उपयोग करने के लिए आवश्यक सभी जानकारी — ताकि वैश्विक कनेक्टिविटी निर्बाध रहे। सबसे सुगम सेटअप अनुभव के लिए हमारे डिवाइस-विशिष्ट निर्देशों का पालन करें।",
    link: "Android पर इंस्टॉल करने की विस्तृत गाइड भी देखें",
    ios: "iOS के लिए विस्तृत गाइड",
        android: "Android के लिए विस्तृत गाइड"
  },
  iphoneHero: "iPhone पर अपना eSIM इंस्टॉल और सक्रिय करें",
  cards: {
    c1: {
      alt: "टॉगल स्विच और घड़ी आइकन के साथ iPhone",
      install: "इंस्टॉल",
      activate: "सक्रिय",
      textA: "अपनी यात्रा से कुछ घंटे पहले और",
      textB: "उड़ान के दौरान या अपने गंतव्य पर पहुँचने पर।"
    },
    c2: {
      alt: "QR कोड स्कैनर इंटरफ़ेस के साथ iPhone",
      line1: "“Install with QR Code” चुनें",
      line2: "यदि आपके पास कोड किसी अन्य डिवाइस पर है",
      line3: "जिसे स्कैन करना है।"
    },
    c3: {
      alt: "मैनुअल इंस्टॉलेशन इंटरफ़ेस वाला iPhone",
      line1: "“Install Manually” चुनें",
      line2: "यदि आप QR कोड स्कैन करने में असमर्थ हैं।"
    }
  },
  learn: {
    title: "चरण-दर-चरण सीखें",
    subtitle: "वह इंस्टॉलेशन प्रकार चुनें जिसे आप करना चाहते हैं",
    btnQr: "QR कोड के साथ इंस्टॉलेशन",
    btnManual: "मैनुअल इंस्टॉलेशन"
  },
  prep: {
    alt: "फ़ोन चेतावनी आइकन",
    qr: {
      title: "QR कोड के साथ इंस्टॉलेशन शुरू करने से पहले, कुछ महत्वपूर्ण बिंदुओं पर ध्यान दें:",
      i1: "QR कोड स्कैन करने के लिए वह किसी दूसरे स्क्रीन/डिवाइस पर होना चाहिए ताकि आप अपने फ़ोन के कैमरे से स्कैन कर सकें।",
      i2: "सुनिश्चित करें कि पूरे प्रक्रिया के दौरान आपका इंटरनेट कनेक्शन स्थिर हो।",
      i3: "कृपया ध्यान दें कि QR कोड केवल एक बार स्कैन किया जा सकता है।",
      i4: "अपने डिवाइस से eSIM को हटाएँ नहीं, क्योंकि आप इसे फिर से उपयोग नहीं कर पाएँगे।"
    },
    manual: {
      title: "मैनुअल इंस्टॉलेशन शुरू करने से पहले, कुछ महत्वपूर्ण बिंदुओं पर ध्यान दें:",
      i1: "मैनुअल इंस्टॉलेशन कोड केवल एक बार उपयोग किए जा सकते हैं।"
    },
    shared: {
      i2: "सुनिश्चित करें कि पूरे प्रक्रिया के दौरान आपका इंटरनेट कनेक्शन स्थिर हो।",
      i3: "अपने डिवाइस से eSIM को हटाएँ नहीं, क्योंकि आप इसे फिर से उपयोग नहीं कर पाएँगे।"
    }
  },
  start: {
    title: "आइए साथ में शुरू करें",
    c1: {
      title: "अपना ईमेल खोलें",
      qr: { p1: "इंस्टॉलेशन के लिए जिस iPhone का उपयोग करेंगे उससे अलग डिवाइस पर अपना ईमेल खोलें और वह ईमेल ढूँढें जिसमें हमने आपको QR कोड भेजा है।" },
      manual: { p1: "वह ईमेल जाँचें जिसमें “SM-DP+ address” और “Activation Code” दोनों हैं और उन्हें इंस्टॉलेशन शुरू करने के लिए पास रखें। हम आपको इन्हें SMS से भी भेजते हैं।" },
      shared: { missing: "यदि आपको अपना कोड/कोड्स प्राप्त नहीं हुआ है, तो कृपया", contact: "हमसे संपर्क करें" }
    },
    c2: {
      qr: { title: "QR कोड स्कैन करें", p1: "उस iPhone पर कैमरा खोलें जहाँ आप eSIM इंस्टॉल करेंगे और कोड स्कैन करें। आप Settings → Mobile Data में जाकर “Add Data Plan” भी चुन सकते हैं और वहाँ से स्कैन कर सकते हैं।" },
      manual: { title: "अपने iPhone में “Settings” खोलें", p1: "फिर Mobile Data पर जाएँ, “Add eSIM” या “Add Data Plan” टैप करें और “Use QR Code” चुनें। इसके बाद संकेत मिलने पर “Enter Details Manually” चुनें।" }
    },
    c3: {
      title: "अपने iPhone पर इंस्टॉलेशन चरणों का पालन करें",
      qr: { p1: "कोड स्कैन करने से इंस्टॉलेशन प्रक्रिया शुरू हो जाएगी। नीचे दी गई हमारी गाइड का उपयोग करके चरण-दर-चरण कॉन्फ़िगरेशन करें।" },
      manual: { p1: "जब आप “Scan QR Code” पर पहुँचे, तो “Enter Details Manually” चुनें और अपने iPhone पर दिखाए गए चरणों का पालन करें।" }
    }
  },
  compat: {
    title: "डिवाइस कम्पैटिबिलिटी चेकर",
    subtitle: "जाँचें कि आपका डिवाइस eSIM तकनीक सपोर्ट करता है या नहीं। अपने विशेष डिवाइस मॉडल को जल्दी खोजने के लिए सर्च का उपयोग करें।",
    iosTab: "iPhone / iPad",
    androidTab: "Android",
    searchIos: "iPhone/iPad मॉडल खोजें...",
    searchAndroid: "Android मॉडल खोजें...",
    iphones: "कम्पैटिबल iPhones",
    ipads: "कम्पैटिबल iPads (केवल 4G)",
    androids: "कम्पैटिबल Android डिवाइस",
    noMatch: "आपकी खोज से मेल खाते कोई डिवाइस नहीं मिले।",
    iosNotesTitle: "महत्वपूर्ण नोट्स:",
    iosNotes: {
      i1: "iPhone 13 और 14 मॉडल एक साथ दो eSIM सक्रिय रख सकते हैं",
      i2: "मेनलैंड चीन और हांगकांग के iPhones में eSIM क्षमता नहीं होती (कुछ मॉडलों को छोड़कर)",
      i3: "USA में बेचे गए iPhone 14+ मॉडल फिज़िकल SIM कार्ड सपोर्ट नहीं करते"
    },
    androidNotesTitle: "महत्वपूर्ण प्रतिबंध:",
    androidNotes: {
      i1: "US और हांगकांग के Samsung डिवाइस eSIM सपोर्ट नहीं कर सकते",
      i2: "ऑस्ट्रेलिया, जापान और ताइवान के Google Pixel डिवाइस में eSIM सपोर्ट नहीं होता",
      i3: "हांगकांग में बेचे गए फ़ोन्स आमतौर पर eSIM सपोर्ट नहीं करते",
      i4: "eSIM उपयोग के लिए डिवाइस कैरियर-अनलॉक होना चाहिए"
    },
    empty: "कम्पैटिबिलिटी जाँचने के लिए अपने डिवाइस मॉडल का नाम टाइप करना शुरू करें"
  },
  tips: {
    title: "प्रो टिप्स: यात्रा से पहले सक्रिय करें",
    body: "निर्बाध यात्रा अनुभव के लिए, प्रस्थान से पहले अपना eSIM इंस्टॉल करें और आगमन पर सक्रिय करें। इससे आप लैंड करते ही जुड़े रहते हैं — बिना वाई-फाई ढूँढे या स्थानीय SIM कार्ड खरीदे।",
    before: {
      title: "प्रस्थान से पहले",
      i1: "घर पर eSIM प्रोफ़ाइल इंस्टॉल करें",
      i2: "इंस्टॉलेशन प्रक्रिया का परीक्षण करें",
      i3: "अपने QR कोड का स्क्रीनशॉट बैकअप के रूप में रखें",
      i4: "सुनिश्चित करें कि आपका डिवाइस कैरियर-अनलॉक है"
    },
    after: {
      title: "आगमन पर",
      i1: "अपने eSIM के लिए सेल्युलर डेटा चालू करें",
      i2: "नेटवर्क रजिस्ट्रेशन के लिए 2–3 मिनट प्रतीक्षा करें",
      i3: "वेब सर्च से कनेक्टिविटी जाँचें",
      i4: "आवश्यक हो तो डेटा रोमिंग कॉन्फ़िगर करें"
    }
  },
  support: {
    title: "अतिरिक्त सहायता चाहिए?",
    body: "हमारी विशेषज्ञ सपोर्ट टीम हर कदम पर आपकी मदद के लिए तैयार है। डिवाइस कम्पैटिबिलिटी के सवालों से लेकर इंस्टॉलेशन सहायता तक — हम आपके साथ हैं।",
    btnEmail: "ईमेल सपोर्ट",
    btnCenter: "सपोर्ट सेंटर पर जाएँ"
  },
  steps: {
    ios: {
      s1: { title: "सेटिंग्स खोलें", desc: "Settings → Cellular (कुछ क्षेत्रों में Mobile Data) पर जाएँ", detail: "अपने मुख्य Settings मेनू में “Cellular” विकल्प देखें। कुछ देशों में इसे “Mobile Data” कहा जाता है।" },
      s2: { title: "सेल्युलर प्लान जोड़ें", desc: "“Add Cellular Plan” या “Add eSIM” टैप करें", detail: "यह विकल्प Cellular सेटिंग्स पेज के नीचे दिखाई देता है। यदि यह नहीं दिखता, तो संभवतः आपका डिवाइस eSIM सपोर्ट नहीं करता।" },
      s3: { title: "QR कोड स्कैन करें", desc: "“Use QR Code” चुनें और अपने ईमेल से कोड स्कैन करें", detail: "कैमरा को QR कोड की ओर इंगित करें। अच्छी रोशनी सुनिश्चित करें और तब तक स्थिर रखें जब तक कोड पहचान न लिया जाए।" },
      s4: { title: "सेल्युलर प्लान जोड़ें", desc: "प्लान विवरण दिखाई देने पर “Add Cellular Plan” टैप करें", detail: "कन्फ़र्म करने से पहले कैरियर जानकारी और प्लान विवरण की समीक्षा करें। यह चरण आपका eSIM प्रोफ़ाइल डाउनलोड करता है।" },
      s5: { title: "अपने प्लान को लेबल करें", desc: "अपने प्लान के लिए लेबल चुनें (जैसे “Primary”, “Travel”, “Secondary”)", detail: "यह आपको डेटा, कॉल और संदेशों के लिए उपयोग होने वाले प्लान की पहचान करने में मदद करता है। अधिकांश यात्री केवल डेटा के लिए eSIM का उपयोग करते हैं।" },
      s6: { title: "डिफ़ॉल्ट लाइन कॉन्फ़िगर करें", desc: "सेल्युलर डेटा के लिए कौन-सी लाइन उपयोग करनी है, चुनें", detail: "आप डेटा के लिए eSIM चुन सकते हैं जबकि कॉल और टेक्स्ट के लिए अपनी मूल SIM रख सकते हैं।" }
    },
    android: {
      s1: { title: "सेटिंग्स खोलें", desc: "Settings → Network & Internet → SIMs पर जाएँ", detail: "सटीक पथ निर्माता के अनुसार बदल सकता है। Samsung डिवाइस पर यह Settings → Connections → SIM card manager हो सकता है।" },
      s2: { title: "मोबाइल प्लान जोड़ें", desc: "“+” बटन या “Add mobile plan” टैप करें", detail: "अपने डिवाइस के अनुसार “Add mobile plan”, “Download a SIM instead”, या “Add carrier” जैसे विकल्प देखें।" },
      s3: { title: "SIM डाउनलोड करें", desc: "“Don't have a SIM card?” या “Download a SIM instead” चुनें", detail: "यह विकल्प आपके फ़ोन को बताता है कि आप फिज़िकल SIM डालने के बजाय eSIM इंस्टॉल करना चाहते हैं।" },
      s4: { title: "QR कोड स्कैन करें", desc: "“Scan QR code” चुनें और कैमरा को कोड पर रखें", detail: "अच्छी रोशनी और स्थिर हाथ सुनिश्चित करें। कैमरा अपने-आप ईमेल में दिए QR कोड का पता लगाकर स्कैन कर लेगा।" },
      s5: { title: "प्रोफ़ाइल डाउनलोड करें", desc: "कैरियर प्रोफ़ाइल आने पर “Download” टैप करें", detail: "आपका डिवाइस eSIM प्रोफ़ाइल डाउनलोड करने के लिए इंटरनेट से कनेक्ट होगा। इसमें कुछ क्षण लग सकते हैं।" },
      s6: { title: "eSIM सक्रिय करें", desc: "eSIM सक्षम करें और इसे अपनी पसंदीदा डेटा कनेक्शन के रूप में सेट करें", detail: "आप डेटा, कॉल और SMS के लिए किस SIM का उपयोग करना चाहते हैं, चुन सकते हैं। अधिकांश यात्री केवल डेटा के लिए eSIM का उपयोग करते हैं।" }
    }
  }
},

profile: {
  loading: "आपकी प्रोफ़ाइल लोड हो रही है…",
  errors: {
    load: "आपके eSIM लोड करने में विफल",
    delete: "eSIM हटाने में विफल। कृपया पुनः प्रयास करें।",
    bundle: "बंडल स्थिति प्राप्त करने में विफल",
    network: "बंडल स्थिति प्राप्त करते समय नेटवर्क त्रुटि",
    invoice: "इनवॉइस डाउनलोड करने में विफल"
  },
  auth: {
    title: "प्रमाणीकरण आवश्यक",
    subtitle: "अपनी प्रोफ़ाइल और eSIM इतिहास देखने के लिए कृपया साइन इन करें।",
    cta: "साइन इन"
  },
  header: {
    fallback: "यूज़र प्रोफ़ाइल",
    count: "{{count}} eSIM{{count, plural, =1{} other{s}}} खरीदे गए"
  },
  list: {
    title: "आपके eSIM",
    subtitle: "अपने खरीदे गए प्रोफ़ाइल प्रबंधित करें और QR कोड व इनवॉइस तक पहुँचें।",
    total: "{{count}} कुल"
  },
  empty: {
    title: "अभी तक कोई eSIM नहीं",
    subtitle: "हमारे प्लान ब्राउज़ करें और कुछ ही सेकंड में कनेक्ट हो जाएँ — फिज़िकल सिम की आवश्यकता नहीं।",
    cta: "प्लान ब्राउज़ करें",
    tip: "टिप: आप अपनी यात्रा से पहले eSIM इंस्टॉल कर सकते हैं और आगमन पर इसे सक्रिय कर सकते हैं।"
  },
  item: {
    country: "देश",
    statusTitle: "वर्तमान स्थिति",
    pricePaid: "अदा की गई राशि",
    purchaseDate: "खरीद की तारीख"
  },
  actions: {
    details: "विवरण देखें",
    showQr: "QR दिखाएँ",
    invoice: "इनवॉइस"
  },
  hint: "eSIM इंस्टॉल करने में मदद चाहिए? iOS पर: सेटिंग्स → सेल्युलर → eSIM जोड़ें। Android पर: सेटिंग्स → नेटवर्क और इंटरनेट → SIMs → eSIM जोड़ें।",
  delete: {
    title: "eSIM हटाएँ",
    confirm: "क्या आप वाकई इस eSIM को अपने इतिहास से हटाना चाहते हैं? यह क्रिया वापस नहीं की जा सकती।",
    deleting: "हटा रहा है…",
    cta: "eSIM हटाएँ"
  },
  details: {
    title: "eSIM विवरण और लाइव स्थिति",
    refresh: "बंडल स्थिति रिफ्रेश करें",
    live: "लाइव बंडल स्थिति",
    updated: "अपडेट किया गया:",
    fetching: "रीयल-टाइम स्थिति प्राप्त की जा रही है...",
    ref: "संदर्भ:",
    discount: "छूट लागू",
    usage: {
      title: "डेटा उपयोग",
      used: "उपयोग किया गया",
      remaining: "शेष",
      total: "कुल"
    },
    assigned: "बंडल असाइन किया गया",
    plan: {
      title: "प्लान जानकारी",
      destination: "गंतव्य",
      name: "प्लान का नाम",
      allowance: "डेटा भत्ता",
      validity: "वैधता"
    },
    tech: {
      title: "तकनीकी विवरण",
      activation: "सक्रियण कोड",
      copyActivation: "सक्रियण कोड कॉपी करें",
      iccid: "ICCID",
      copyIccid: "ICCID कॉपी करें",
      orderRef: "GOeSIM ऑर्डर संदर्भ"
    },
    install: {
      title: "इंस्टॉलेशन निर्देश",
      iosTitle: "iOS के लिए:",
      androidTitle: "Android के लिए:",
      ios: "Settings → Cellular → Add eSIM → QR कोड का उपयोग करें",
      android: "Settings → Network & Internet → SIMs → Add eSIM → QR कोड स्कैन करें",
      important: "महत्वपूर्ण:",
      once: "आप इस eSIM को केवल एक बार ही इंस्टॉल कर सकते हैं। आगे बढ़ने से पहले सुनिश्चित करें कि आपका डिवाइस अनलॉक और eSIM-संगत है।"
    },
    purchase: {
      title: "खरीदारी जानकारी",
      date: "खरीद की तारीख",
      amount: "भुगतान की गई राशि",
      method: "भुगतान विधि",
      txn: "लेन-देन आईडी"
    },
    referral: {
      title: "रेफ़रल छूट लागू",
      code: "रेफ़रल कोड",
      original: "मूल कीमत",
      saved: "आपने बचाया"
    },
    billing: {
      title: "बिलिंग जानकारी",
      name: "पूरा नाम",
      email: "ईमेल",
      country: "देश",
      zip: "ZIP कोड"
    }
  },
  qr: {
    title: "eSIM QR कोड",
    alt: "eSIM QR कोड",
    copy: "सक्रियण कोड कॉपी करें",
    tip: "टिप: अपने फ़ोन के कैमरे को खोलें और QR स्कैन करें। आप eSIM केवल एक बार ही इंस्टॉल कर सकते हैं।"
  },
  common: {
    usd: "USD",
    days: "दिन",
    na: "N/A",
    invalidDate: "अमान्य तारीख",
    cancel: "रद्द करें",
    close: "बंद करें",
    copied: "कॉपी किया गया"
  }
},
countryDetails: {
  loading: "देश विवरण लोड हो रहा है...",
  errors: {
    notFound: "देश नहीं मिला",
    loadFail: "देश डेटा लोड करने में विफल"
  },
  notFound: {
    title: "देश नहीं मिला",
    subtitle: "आप जिस देश को ढूंढ रहे हैं वह मौजूद नहीं है या वहाँ कोई उपलब्ध प्लान नहीं हैं।",
    cta: "सभी देश ब्राउज़ करें"
  },
  back: "देशों पर वापस जाएँ",
  blurb: "{{country}} को हमारे eSIM डेटा प्लानों के साथ लचीलेपन से एक्सप्लोर करें। चाहे आप छोटी यात्रा पर हों या लंबे समय के लिए, हमारे प्लान आपको बिना झंझट जुड़े रहने में मदद करते हैं।",
  noPlans: "चयनित फ़िल्टर के लिए कोई प्लान उपलब्ध नहीं है।",
  plan: {
    details: "प्लान विवरण",
    detailsShort: "विवरण",
    networkBadge: "5G",
    unlimited: "अनलिमिटेड",
    unlimitedData: "अनलिमिटेड डेटा",
    gb: "GB",
    gbShort: "GB",
    data: "डेटा",
    forDays: "{count, plural, one {# दिन} other {# दिन}} के लिए"
  },
  currency: {
    usd: "USD"
  },
  duration: {
    days: "{count, plural, one {# दिन} other {# दिन}}"
  },
  more: {
    more: "और प्लान देखें",
    moreShort: "+{extra} और",
    less: "कम प्लान दिखाएँ",
    lessShort: "कम दिखाएँ"
  },
  modal: {
    title: "प्लान विवरण",
    country: "देश:",
    duration: "अवधि:",
    network: "नेटवर्क:",
    autostart: "ऑटो-स्टार्ट:",
    enabled: "सक्रिय",
    disabled: "निष्क्रिय",
    planType: "प्लान प्रकार:",
    description: "विवरण",
    purchase: "यह प्लान खरीदें",
    signInToPurchase: "खरीदने के लिए साइन इन करें"
  },
  bar: {
    title: "{{country}} eSIM",
    total: "कुल",
    buy: "अभी खरीदें"
  }
},

checkout: {
  loading: "सुरक्षित चेकआउट लोड हो रहा है...",
  invalidPlan: {
    title: "अमान्य प्लान डेटा",
    subtitle: "चयनित प्लान की जानकारी लोड नहीं की जा सकी।",
    cta: "डैशबोर्ड पर वापस जाएं"
  },
  success: {
    title: "खरीद सफल!",
    message: "eSIM सफलतापूर्वक खरीदी गई! ICCID: {{iccid}}. {{targetEmail}}",
    sentBoth: "QR कोड और इंस्टॉलेशन निर्देश दोनों {{a}} और {{b}} पर भेज दिए गए हैं",
    sentOne: "QR कोड और इंस्टॉलेशन निर्देश {{email}} पर भेज दिए गए हैं",
    view: "मेरे eSIM देखें"
  },
  common: {
    close: "बंद करें"
  },
  header: {
    title: "सुरक्षित चेकआउट",
    subtitle: "अपनी eSIM खरीद को सुरक्षित रूप से पूरा करें"
  },
  benefits: {
    title: "लाभ पाने के लिए साइन इन करें",
    copy: "अपना खरीद इतिहास सहेजने, विशेष डील्स तक पहुँचने और अपने eSIM प्रबंधित करने के लिए खाता बनाएँ।",
    cta: "साइन अप / साइन इन"
  },
  billing: {
    title: "बिलिंग जानकारी",
    subtitle: "आपका चालान और eSIM इस ईमेल पते पर भेजा जाएगा"
  },
  form: {
    firstName: "पहला नाम",
    lastName: "अंतिम नाम",
    email: "ईमेल पता",
    referral: "रेफरल कोड (वैकल्पिक)"
  },
  placeholder: {
    firstName: "पहला नाम दर्ज करें",
    lastName: "अंतिम नाम दर्ज करें",
    email: "ईमेल पता दर्ज करें",
    referral: "रेफरल कोड दर्ज करें",
    altEmail: "वैकल्पिक ईमेल दर्ज करें"
  },
  referral: {
    validating: "सत्यापित किया जा रहा है...",
    invalid: "अमान्य रेफरल कोड",
    ownCode: "आप अपना खुद का रेफरल कोड उपयोग नहीं कर सकते",
    inactive: "यह रेफरल कोड अब सक्रिय नहीं है",
    used: "यह रेफरल कोड पहले ही उपयोग किया जा चुका है",
    valid: "मान्य! {{percent}}% छूट लागू की गई",
    error: "कोड सत्यापित करते समय त्रुटि"
  },
  altEmail: {
    title: "एक अलग ईमेल पता उपयोग करें",
    copy: "eSIM इस अलग ईमेल पर भी भेजी जाएगी और आपके खाते में सहेजी जाएगी",
    input: "वैकल्पिक ईमेल पता"
  },
  createAccount: {
    title: "खरीद इतिहास सहेजने के लिए खाता बनाएँ",
    copy: "वैकल्पिक - आपको eSIM प्रबंधित करने और समर्थन तक पहुँचने में मदद करता है"
  },
  payment: {
    title: "भुगतान विवरण",
    secured: "Stripe द्वारा सुरक्षित",
    method: "भुगतान विधि",
    card: "क्रेडिट या डेबिट कार्ड",
    cardTypes: "Visa, Mastercard, American Express",
    paypalCopy: "PayPal से भुगतान करें",
    cardInfo: "कार्ड जानकारी",
    loadingSecure: "सुरक्षित भुगतान फ़ॉर्म लोड हो रहा है...",
    cardComplete: "कार्ड जानकारी पूरी है",
    processing: "भुगतान प्रक्रिया में...",
    complete: "खरीद पूरी करें • ${{total}}"
  },
  legal: {
    agree: "ऑर्डर पूरा करने पर, आप हमारी शर्तों से सहमत होते हैं",
    terms: "नियम एवं शर्तें",
    and: "और",
    privacy: "गोपनीयता एवं रिफंड नीतियाँ"
  },
  summary: {
    title: "ऑर्डर सारांश",
    planLabel: "eSIM प्लान",
    digital: "डिजिटल",
    data: "डेटा सीमा:",
    validity: "वैधता:",
    coverage: "कवरेज:",
    nationwide: "राष्ट्रीय स्तर पर"
  },
  pricing: {
    planPrice: "प्लान की कीमत",
    referralDiscount: "रेफरल छूट ({{percent}}%)",
    stripeFee: "Stripe प्रोसेसिंग शुल्क",
    paypalFee: "PayPal प्रोसेसिंग शुल्क",
    taxes: "कर एवं सेवा शुल्क",
    included: "शामिल",
    total: "कुल"
  },
  paypal: {
    description: "{{country}} के लिए eSIM - {{days}} दिनों के लिए {{data}}"
  },
  duration: {
    days: "{count, plural, one {# दिन} other {# दिन}}"
  },
  alerts: {
    enterName: "कृपया अपना पूरा नाम दर्ज करें",
    formNotReady: "भुगतान फ़ॉर्म तैयार नहीं है। कृपया कुछ क्षण प्रतीक्षा करें और पुनः प्रयास करें।",
    cardIncomplete: "कृपया पूरी कार्ड जानकारी दर्ज करें",
    paypalFailed: "PayPal भुगतान विफल: {{msg}}",
    paypalGeneric: "PayPal भुगतान विफल। कृपया पुनः प्रयास करें।",
    purchaseFailed: "खरीद विफल: {{msg}}"
  }
},
privacy: {
  title: "गोपनीयता नीति",
  subtitle:
    "Routed Labs, Inc. द्वारा व्यक्तिगत जानकारी के संग्रह, उपयोग और सुरक्षा के संबंध में प्रथाओं का विवरण।",
  lastUpdated: {
    label: "अंतिम अपडेट:",
    date: "1 अगस्त, 2025"
  },
  sections: {
    intro: {
      heading: "परिचय",
      p1:
        "Routed Labs, Inc. (“Routed Labs,” “हम,” “हमारा,” या “हमें”) Airvoy वेबसाइट और मोबाइल एप्लिकेशन (“सेवा”) संचालित करता है। यह गोपनीयता नीति बताती है कि हम व्यक्तिगत जानकारी कैसे एकत्र करते हैं, उपयोग करते हैं, साझा करते हैं और सुरक्षित रखते हैं। सेवा का उपयोग करके, आप यहां वर्णित प्रथाओं से सहमत होते हैं।",
      p2:
        "Routed Labs आपकी व्यक्तिगत जानकारी की गोपनीयता, अखंडता और सुरक्षा बनाए रखने के लिए प्रतिबद्ध है। हमारे डेटा अभ्यास पारदर्शी, संतुलित और लागू कानूनों और विनियमों के अनुरूप बनाए गए हैं।"
    },
    collect: {
      heading: "हम कौन सी जानकारी एकत्र करते हैं",
      p1:
        "हम डेटा न्यूनतमकरण के सिद्धांतों का पालन करते हैं और केवल eSIM सेवाएं प्रदान करने के लिए आवश्यक जानकारी एकत्र करते हैं। विशेष रूप से, हम एकत्र करते हैं:",
      email: {
        title: "ईमेल पता",
        collectedWhen: "एकत्र किया जाता है जब आप:",
        items: [
          "खाता बनाते हैं",
          "eSIM प्लान खरीदते हैं",
          "न्यूज़लेटर की सदस्यता लेते हैं",
          "सपोर्ट से संपर्क करते हैं"
        ],
        purposeLabel: "उद्देश्य:",
        purpose:
          "खातों का प्रबंधन करने, eSIM वितरित करने, पुष्टि भेजने और ग्राहक सहायता सक्षम करने के लिए।"
      },
      notCollect: {
        title: "हम एकत्र नहीं करते:",
        items: [
          "फ़ोन नंबर या डिवाइस पहचानकर्ता",
          "स्थान या भू-ट्रैकिंग डेटा",
          "ब्राउज़िंग इतिहास या व्यवहार संबंधी कुकीज़",
          "सोशल मीडिया प्रोफाइल या व्यक्तिगत फ़ोटो",
          "वित्तीय डेटा (भुगतान तृतीय-पक्ष प्रदाताओं द्वारा संभाले जाते हैं)"
        ]
      }
    },
    use: {
      heading: "हम जानकारी का उपयोग कैसे करते हैं",
      p1: "संग्रहित जानकारी का उपयोग विशेष रूप से निर्धारित उद्देश्यों के लिए किया जाता है:",
      items: [
        "eSIM क्रेडेंशियल्स, खरीद पुष्टि और रसीदें भेजने के लिए",
        "तकनीकी और ग्राहक सहायता प्रदान करने के लिए",
        "आवश्यक सेवा अपडेट और सुरक्षा सूचनाएं भेजने के लिए",
        "वैकल्पिक मार्केटिंग सामग्री वितरित करने के लिए (सहमति के आधार पर)"
      ],
      optOut: "आप कभी भी मार्केटिंग संचार से बाहर निकल सकते हैं।"
    },
    share: {
      heading: "डेटा साझा करना और प्रकटीकरण",
      p1:
        "व्यक्तिगत जानकारी बेची, किराए पर नहीं दी जाती या व्यापार नहीं की जाती। इसे केवल निम्नलिखित परिस्थितियों में साझा किया जा सकता है:",
      items: [
        { title: "सेवा प्रदाता:", body: "भुगतान प्रसंस्करण या ईमेल डिलीवरी जैसी सेवाओं के लिए" },
        { title: "कानूनी आवश्यकताएं:", body: "जहाँ कानून, नियम या कानूनी प्रक्रिया द्वारा आवश्यक हो" },
        { title: "व्यावसायिक लेनदेन:", body: "विलय, अधिग्रहण या पुनर्गठन के संबंध में" },
        { title: "सुरक्षा:", body: "Routed Labs और इसके उपयोगकर्ताओं के अधिकारों, संपत्ति और सुरक्षा की रक्षा के लिए" }
      ]
    },
    retain: {
      heading: "डेटा भंडारण और हटाना",
      p1: "जानकारी को केवल उतने समय तक रखा जाता है जितना यहाँ उल्लिखित उद्देश्यों के लिए आवश्यक है:",
      items: [
        "सक्रिय खाते: डेटा तब तक रखा जाता है जब तक खाता सक्रिय रहता है और अंतिम इंटरैक्शन के दो साल बाद तक।",
        "अतिथि खरीद: ग्राहक सहायता और पूर्ति सुनिश्चित करने के लिए एक साल तक रखा जाता है।",
        "खाता हटाने पर: सभी व्यक्तिगत जानकारी को सक्रिय सिस्टम से स्थायी रूप से हटा दिया जाता है।"
      ]
    },
    rights: {
      heading: "व्यक्तिगत अधिकार",
      p1: "आप निम्नलिखित अधिकारों का प्रयोग कर सकते हैं:",
      items: [
        "व्यक्तिगत जानकारी तक पहुंच और उसकी एक प्रति प्राप्त करें",
        "गलत डेटा को सही करने का अनुरोध करें",
        "रिकॉर्ड हटाने का अनुरोध करें",
        "किसी भी समय मार्केटिंग संचार से सहमति वापस लें"
      ],
      contactPreamble: "अनुरोध यहाँ भेजे जा सकते हैं"
    },
    security: {
      heading: "डेटा सुरक्षा",
      p1:
        "Routed Labs व्यक्तिगत जानकारी की सुरक्षा के लिए उपयुक्त तकनीकी और संगठनात्मक उपाय लागू करता है, जिसमें शामिल हैं:",
      items: [
        "स्थानांतरण और संग्रहित स्थिति में एन्क्रिप्शन",
        "नियमित ऑडिट और भेद्यता आकलन",
        "सख्त एक्सेस नियंत्रण और प्रमाणीकरण प्रोटोकॉल",
        "सुरक्षित इन्फ्रास्ट्रक्चर और डेटा सेंटर"
      ]
    },
    contact: {
      heading: "संपर्क जानकारी",
      p1:
        "इस गोपनीयता नीति के बारे में प्रश्न या चिंताएँ यहाँ भेजी जा सकती हैं:",
      company: "Routed Labs, Inc.",
      emailLabel: "ईमेल:",
      addressLabel: "पता:",
      address: "451 निअंटिक एवेन्यू, डेली सिटी, CA 94014, संयुक्त राज्य अमेरिका",
      subjectLabel: "पत्राचार के लिए विषय पंक्ति:",
      subject: "“गोपनीयता नीति से संबंधित पूछताछ”"
    },
    updates: {
      heading: "इस नीति के अपडेट",
      p1:
        "यह गोपनीयता नीति समय-समय पर संचालन, कानूनी या नियामक परिवर्तनों को दर्शाने के लिए संशोधित की जा सकती है। प्रमुख संशोधन इस पृष्ठ पर अद्यतन “अंतिम अपडेट” तिथि के साथ प्रकाशित किए जाएंगे।",
      p2:
        "उपयोगकर्ताओं को सलाह दी जाती है कि वे इस दस्तावेज़ को नियमित अंतराल पर देखें ताकि यह जान सकें कि Routed Labs व्यक्तिगत जानकारी का प्रबंधन कैसे करता है।"
    }
  }
},
tos: {
  title: "सेवा की शर्तें",
  subtitle:
    "Airvoy प्लेटफ़ॉर्म और Routed Labs, Inc. द्वारा प्रदान की जाने वाली सेवाओं के उपयोग को नियंत्रित करने वाली कानूनी शर्तें और नियम।",
  lastUpdated: { label: "अंतिम अपडेट:", date: "1 अगस्त, 2025" },
  sections: {
    agreement: {
      heading: "शर्तों से सहमति",
      p1:
        "ये सेवा की शर्तें (“शर्तें”) उपयोगकर्ता (“आप”) और Routed Labs, Inc. (“Routed Labs,” “हम,” “हमारा,” या “हमें”) के बीच Airvoy वेबसाइट, मोबाइल एप्लिकेशन और संबंधित eSIM सेवाओं (सामूहिक रूप से, “सेवा”) के उपयोग के संबंध में एक कानूनी रूप से बाध्यकारी समझौता हैं।",
      p2:
        "सेवा तक पहुँचने या इसका उपयोग करने से, आप स्वीकार करते हैं कि आपने इन शर्तों को पढ़ा, समझा और उनसे बंधे रहने के लिए सहमत हैं। यदि आप सहमत नहीं हैं, तो आपको सेवा तक पहुँचने या इसका उपयोग करने से बचना होगा।"
    },
    service: {
      heading: "सेवा का विवरण",
      p1:
        "सेवा eSIM (एम्बेडेड सिम) की सुविधा प्रदान करती है, जो उपयोगकर्ताओं को अंतरराष्ट्रीय स्तर पर सेलुलर डेटा नेटवर्क तक पहुँचने में सक्षम बनाती है। पेशकश में शामिल हैं:",
      items: [
        "वैश्विक कनेक्टिविटी के लिए डिजिटल eSIM प्रोफ़ाइल",
        "विभिन्न अवधि वाले कई डेटा प्लान विकल्प",
        "सक्रियण और स्थापना के लिए QR कोड डिलीवरी",
        "तकनीकी प्रश्नों के लिए ग्राहक सहायता",
        "पंजीकृत उपयोगकर्ताओं के लिए खाता प्रबंधन उपकरण"
      ],
      notice:
        "महत्वपूर्ण: सेवा के लिए एक संगत, अनलॉक किया हुआ डिवाइस आवश्यक है। हम सभी उपकरणों के साथ संगतता या सभी भौगोलिक क्षेत्रों में कवरेज की गारंटी नहीं देते।"
    },
    eligibility: {
      heading: "पात्रता",
      p1: "सेवा का उपयोग करने के लिए, आप यह घोषित और आश्वासन देते हैं कि आप:",
      items: [
        "कम से कम 18 वर्ष के हैं या माता-पिता की सहमति है",
        "कानूनी रूप से बाध्यकारी अनुबंध में प्रवेश करने की क्षमता रखते हैं",
        "सटीक और पूर्ण पंजीकरण जानकारी प्रदान करते हैं",
        "एक संगत डिवाइस का स्वामी हैं या उसका उपयोग करने के लिए अधिकृत हैं",
        "लागू कानूनों और विनियमों का पालन करेंगे"
      ]
    },
    account: {
      heading: "खाता पंजीकरण",
      p1:
        "उपयोगकर्ता eSIM खरीद सकते हैं चाहे वे पंजीकृत खाता धारक हों या अतिथि के रूप में। पंजीकरण अतिरिक्त सुविधाएँ प्रदान करता है, जैसे खाता इतिहास और व्यापक सहायता।",
      registered: {
        title: "पंजीकृत खाते",
        items: [
          "वैध ईमेल पता आवश्यक",
          "खाता सुरक्षा बनाए रखने की जिम्मेदारी",
          "जानकारी को सटीक बनाए रखने की बाध्यता",
          "अनधिकृत पहुंच की तत्काल सूचना"
        ]
      },
      guest: {
        title: "अतिथि खरीदारी",
        items: [
          "केवल ईमेल पते की आवश्यकता",
          "eSIM इलेक्ट्रॉनिक रूप से डिलीवर की जाती है",
          "सहायता केवल खरीद-विशिष्ट मामलों तक सीमित",
          "कोई चल रहा खरीद इतिहास नहीं रखा जाता"
        ]
      }
    },
    payment: {
      heading: "भुगतान की शर्तें",
      p1:
        "खरीद पूरी करके, आप Routed Labs और उसके भुगतान प्रोसेसर को प्रदान की गई भुगतान विधि से शुल्क लेने के लिए अधिकृत करते हैं। मुख्य शर्तें शामिल हैं:",
      items: [
        "सभी कीमतें अमेरिकी डॉलर में उद्धृत हैं और लागू करों सहित हैं",
        "भुगतान खरीद के समय देय है",
        "भुगतान प्रसंस्करण तृतीय-पक्ष प्रदाताओं द्वारा संभाला जाता है",
        "भुगतान पूरा करने में विफलता से सेवा निलंबन हो सकता है"
      ]
    },
    refunds: {
      heading: "रिफंड नीति",
      p1: "रिफंड अनुरोध निम्नलिखित शर्तों के अधीन माने जाएंगे:",
      items: [
        "खरीद के 24 घंटों के भीतर अनुरोध करने पर पात्र",
        "एक बार eSIM सक्रिय या उपयोग हो जाने पर अपात्र",
        "तकनीकी मुद्दों की समीक्षा मामले-दर-मामला की जाएगी",
        "डिवाइस की संगतता उपयोगकर्ता की जिम्मेदारी है"
      ],
      p2: {
        prefix: "रिफंड अनुरोध इस पते पर भेजे जाने चाहिए ",
        suffix: ", जिसमें ऑर्डर विवरण और कारण शामिल होना चाहिए।"
      }
    },
    limitations: {
      heading: "सेवा की सीमाएँ",
      p1: "सेवा निम्नलिखित सीमाओं के अधीन है:",
      items: [
        "डिवाइस eSIM-संगत और अनलॉक होना चाहिए",
        "कवरेज स्थानीय पार्टनर नेटवर्क पर निर्भर करता है",
        "गति और उपलब्धता स्थान के अनुसार भिन्न हो सकती है",
        "अप्रयुक्त डेटा समाप्त हो जाता है और आगे नहीं बढ़ता",
        "प्लान को उपकरणों के बीच स्थानांतरित नहीं किया जा सकता"
      ]
    },
    prohibited: {
      heading: "निषिद्ध उपयोग",
      p1:
        "आप सहमत हैं कि आप सेवा का उपयोग किसी भी अवैध या निषिद्ध उद्देश्य के लिए नहीं करेंगे, जिसमें शामिल है लेकिन इन्हीं तक सीमित नहीं:",
      items: [
        "अवैध गतिविधि या नियामक उल्लंघन",
        "उत्पीड़न, दुर्व्यवहार या धोखाधड़ी गतिविधि",
        "अनधिकृत नेटवर्क एक्सेस या हस्तक्षेप",
        "अनुमति के बिना क्रेडेंशियल का पुनर्विक्रय या साझा करना",
        "अत्यधिक उपयोग जिससे नेटवर्क प्रदर्शन प्रभावित हो"
      ]
    },
    liability: {
      heading: "देयता की सीमा",
      p1:
        "कानून द्वारा अनुमत अधिकतम सीमा तक, Routed Labs सेवा के आपके उपयोग से उत्पन्न किसी भी अप्रत्यक्ष, आकस्मिक या परिणामी क्षति के लिए उत्तरदायी नहीं होगा। कुल देयता उस राशि से अधिक नहीं होगी जो आपने सेवा के लिए भुगतान की है, जिससे दावे का उद्भव हुआ, दावे से पूर्व बारह (12) महीनों के भीतर।"
    },
    indemnity: {
      heading: "प्रतिपूर्ति",
      p1:
        "आप सहमत हैं कि आप Routed Labs और उसकी संबद्ध कंपनियों को सेवा के आपके दुरुपयोग या इन शर्तों के उल्लंघन से उत्पन्न दावों, क्षतियों या खर्चों के खिलाफ क्षतिपूर्ति करेंगे और उन्हें हानि से बचाएँगे।"
    },
    termination: {
      heading: "समापन",
      p1:
        "यदि आप इन शर्तों का उल्लंघन करते हैं, अवैध आचरण में संलग्न होते हैं या Routed Labs या उसके उपयोगकर्ताओं के लिए हानिकारक तरीके से कार्य करते हैं, तो हम सेवा तक पहुँच को तुरंत निलंबित या समाप्त कर सकते हैं। समाप्ति पर, सेवा का उपयोग करने का आपका अधिकार तुरंत समाप्त हो जाएगा।"
    },
    law: {
      heading: "प्रचलित कानून",
      p1:
        "ये शर्तें संयुक्त राज्य अमेरिका के डेलावेयर राज्य के कानूनों द्वारा शासित हैं। आप विवादों के समाधान के लिए डेलावेयर में स्थित न्यायालयों के विशेष अधिकार क्षेत्र को स्वीकार करने के लिए सहमत हैं।"
    },
    amend: {
      heading: "संशोधन",
      p1:
        "Routed Labs अपने विवेक पर इन शर्तों में संशोधन करने का अधिकार सुरक्षित रखता है। अपडेट वेबसाइट पर प्रकाशित किए जाएंगे और अन्यथा निर्दिष्ट न होने पर तुरंत प्रभावी होंगे। संशोधन के बाद सेवा का निरंतर उपयोग संशोधित शर्तों की स्वीकृति माना जाएगा।"
    },
    contact: {
      heading: "संपर्क जानकारी",
      p1: "इन शर्तों के संबंध में प्रश्नों के लिए कृपया संपर्क करें:"
    }
  }
},
about: {
  title: "Airvoy के बारे में",
  sections: {
    overview: {
      heading: "सारांश",
      body:
        "Airvoy एक eSIM प्लेटफ़ॉर्म है जिसे Routed Labs, Inc. द्वारा विकसित किया गया है। यह प्लेटफ़ॉर्म अंतरराष्ट्रीय यात्रियों को सुलभ, किफायती और विश्वसनीय मोबाइल कनेक्टिविटी प्रदान करता है। भौतिक सिम कार्ड की आवश्यकता को समाप्त करके, सेवा 200 से अधिक गंतव्यों पर डेटा प्लान को आसानी से सक्रिय करने में सक्षम बनाती है।"
    },
    mission: {
      heading: "मिशन",
      body:
        "Routed Labs, Inc. का एकमात्र मिशन है: मोबाइल कनेक्टिविटी को सरल बनाना। कंपनी का उद्देश्य अंतरराष्ट्रीय रोमिंग और सिम कार्ड खरीद से जुड़ी अनिश्चितता, छिपी लागत और लॉजिस्टिक बाधाओं को दूर करना है ताकि यात्री आसानी से जुड़े रह सकें।"
    },
    background: {
      heading: "पृष्ठभूमि",
      p1:
        "Routed Labs, Inc. का मुख्यालय डेली सिटी, कैलिफोर्निया में है। हमारी कंपनी की स्थापना अंतरराष्ट्रीय स्तर पर जुड़े रहने में आने वाली कठिनाइयों, जैसे उच्च रोमिंग शुल्क और सीमित सिम उपलब्धता, के सीधे अनुभव से हुई।",
      p2:
        "इन चुनौतियों को देखते हुए, संस्थापक ने बेहतर वैश्विक कनेक्टिविटी के लिए eSIM तकनीक का उपयोग करने का अवसर पहचाना।",
      p3:
        "आज, कंपनी विश्वभर में हजारों उपयोगकर्ताओं को विश्वसनीयता, पारदर्शिता और पहुँच पर ध्यान केंद्रित करते हुए सेवाएँ प्रदान करती है।"
    },
    operations: {
      heading: "संचालन",
      items: [
        { title: "वैश्विक कवरेज:", desc: "200 से अधिक देशों और क्षेत्रों में उच्च गति वाले नेटवर्क तक पहुँच।" },
        { title: "eSIM प्रावधान:", desc: "कुछ ही मिनटों में डिजिटल प्लान इंस्टॉलेशन, बिना भौतिक सिम कार्ड के।" },
        { title: "ग्राहक उन्मुखता:", desc: "सेवा और सहायता को स्पष्टता और उपयोगकर्ता की जरूरतों को प्राथमिकता देने के लिए डिज़ाइन किया गया है।" }
      ]
    },
    corporate: {
      heading: "कॉर्पोरेट जानकारी",
      company: {
        title: "कंपनी विवरण",
        nameLabel: "कंपनी का नाम:",
        name: "Routed Labs, Inc.",
        repLabel: "प्रतिनिधि:",
        rep: "हेक्टर डियाज़",
        addrLabel: "मुख्यालय का पता:",
        addr: "451 नियांटिक एवेन्यू, डेली सिटी, CA 94014, संयुक्त राज्य अमेरिका",
        contactLabel: "संपर्क:"
      },
      agent: {
        title: "पंजीकृत एजेंट की जानकारी",
        nameLabel: "पंजीकृत एजेंट का नाम:",
        name: "लीगलिंक कॉर्पोरेट सर्विसेज इंक.",
        addrLabel: "पंजीकृत एजेंट का पता:",
        addr: "131 कॉन्टिनेंटल ड्राइव, सुइट 305, नेवार्क, DE 19713, संयुक्त राज्य अमेरिका"
      }
    },
    comms: {
      heading: "संचार",
      p1: {
        prefix: "आधिकारिक प्रश्नों या पत्राचार के लिए कृपया लिखें ",
        suffix:
          "। कॉर्पोरेट और कानूनी पत्राचार भी कंपनी के पंजीकृत एजेंट, लीगलिंक कॉर्पोरेट सर्विसेज इंक., के नेवार्क, डेलावेयर पते पर भेजा जा सकता है।"
      }
    }
  }
},

auth: {
  titles: {
    signin: 'वापसी पर स्वागत है',
    signup: 'खाता बनाएँ',
    forgot: 'पासवर्ड रीसेट करें',
  },
  subtitles: {
    signin: 'eSIM प्लान खरीदने के लिए साइन इन करें',
    signup: 'आज ही Airvoy से जुड़ें',
    forgot: 'अपना पासवर्ड रीसेट करने के लिए अपना ईमेल दर्ज करें',
  },
  fields: {
    email: 'ईमेल पता',
    password: 'पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
  },
  placeholders: {
    email: 'अपना ईमेल दर्ज करें',
    password: 'अपना पासवर्ड दर्ज करें',
    confirmPassword: 'अपना पासवर्ड पुष्टि करें',
  },
  actions: {
    close: 'बंद करें',
    continueWithGoogle: 'Google से जारी रखें',
    signingIn: 'साइन इन हो रहा है...',
    pleaseWait: 'कृपया प्रतीक्षा करें...',
    signIn: 'साइन इन',
    createAccount: 'खाता बनाएँ',
    sendReset: 'रीसेट ईमेल भेजें',
    showPassword: 'पासवर्ड दिखाएँ',
    hidePassword: 'पासवर्ड छिपाएँ',
  },
  labels: {
    orEmail: 'या ईमेल के साथ जारी रखें',
  },
  links: {
    noAccount: "क्या आपका खाता नहीं है?",
    signUp: 'साइन अप करें',
    forgot: 'क्या आपने अपना पासवर्ड भूल गए?',
    haveAccount: 'क्या आपके पास पहले से खाता है?',
    signIn: 'साइन इन करें',
    remembered: 'क्या आपको पासवर्ड याद आ गया?',
    backToSignIn: 'साइन इन पर वापस जाएँ',
  },
  messages: {
    resetSent: 'पासवर्ड रीसेट ईमेल भेजा गया! अपना इनबॉक्स जांचें।',
  },
  errors: {
    fillAll: 'कृपया सभी फ़ील्ड भरें',
    userNotFound: 'इस ईमेल पते से कोई खाता नहीं मिला',
    wrongPassword: 'गलत ईमेल या पासवर्ड',
    emailInUse: 'इस ईमेल के साथ पहले से ही खाता मौजूद है',
    weakPassword: 'पासवर्ड बहुत कमजोर है',
    invalidEmail: 'अमान्य ईमेल पता',
    tooManyRequests: 'बहुत अधिक असफल प्रयास। कृपया बाद में पुनः प्रयास करें',
    popupClosed: 'साइन-इन पॉपअप पूरा होने से पहले बंद हो गया',
    popupCancelled: 'साइन-इन रद्द कर दिया गया',
    popupBlocked: 'साइन-इन पॉपअप आपके ब्राउज़र द्वारा ब्लॉक कर दिया गया',
    passwordMismatch: 'पासवर्ड मेल नहीं खाते',
    passwordMin: 'पासवर्ड कम से कम 6 अक्षर लंबा होना चाहिए',
    enterEmail: 'कृपया अपना ईमेल पता दर्ज करें',
    generic: 'कोई त्रुटि हुई। कृपया पुनः प्रयास करें',
  },
  legal: {
    prefix: 'खाता बनाकर, आप हमारी सहमति देते हैं',
    terms: 'सेवा की शर्तें',
    and: 'और',
    privacy: 'गोपनीयता नीति',
  },
},
support: {
  title: "सहायता",
  contactInfo: "संपर्क जानकारी",
  channels: {
    email: {
      title: "ईमेल सहायता",
      description: "प्रश्नों, घटनाओं की रिपोर्ट और सहायता के अनुरोधों के लिए।",
      contact: "support@routedlabs.com",
      action: "ईमेल लिखें"
    },
    chat: {
      title: "लाइव चैट",
      description: "समय-संवेदनशील मामलों के लिए रियल-टाइम सहायता, उपलब्धता के आधार पर।",
      contact: "09:00–18:00 पैसिफिक समय में उपलब्ध",
      action: "चैट खोलें"
    }
  },
  faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
  noResults: "वर्तमान क्वेरी से कोई प्रविष्टि मेल नहीं खाती।",
  categoryLabel: "श्रेणी:",
  show: "दिखाएँ",
  hide: "छिपाएँ",
  noticesTitle: "सूचनाएँ और पत्राचार",
  noticesLine1: {
    before: "आधिकारिक प्रश्न और पत्राचार भेजा जाना चाहिए",
    after: "।"
  },
  noticesLine2:
    "यह पृष्ठ सहायता प्रक्रियाओं और संदर्भ सामग्री का वर्णन करने के लिए है। यह किसी भी लागू सेवा की शर्तों या नीतियों को संशोधित या प्रतिस्थापित नहीं करता है, जो सभी मामलों में लागू होते हैं।",
  categories: {
    overview: "eSIM अवलोकन",
    compatibility: "डिवाइस संगतता",
    installation: "इंस्टॉलेशन",
    dualSim: "डुअल सिम",
    dataUsage: "डेटा उपयोग",
    planMgmt: "प्लान प्रबंधन",
    deviceReqs: "डिवाइस आवश्यकताएँ",
    troubleshooting: "समस्या निवारण",
    refunds: "रिफंड",
    supportHours: "सहायता उपलब्धता"
  },
  faqs: {
    1: {
      q: "eSIM क्या है और यह कैसे काम करता है?",
      a: "eSIM (एम्बेडेड सिम) एक प्रोग्रामेबल, डिवाइस में मौजूद सिम है जो बिना भौतिक कार्ड के सेल्युलर सेवा को सक्रिय करने की अनुमति देता है। उपयोगकर्ता डिजिटल रूप से प्रोफ़ाइल सेट कर सकते हैं और Airvoy में कोड स्कैन करके या कॉन्फ़िगरेशन चरणों का पालन करके कनेक्टिविटी प्राप्त कर सकते हैं।"
    },
    2: {
      q: "कौन से डिवाइस eSIM फ़ंक्शन का समर्थन करते हैं?",
      a: "कई आधुनिक स्मार्टफोन eSIM फ़ंक्शन को लागू करते हैं, जिनमें प्रमुख निर्माताओं के हालिया मॉडल शामिल हैं। डिवाइस सेटिंग (अक्सर 'Cellular' या 'Mobile Data' के अंतर्गत) में देखें कि क्या 'Add Data Plan' विकल्प उपलब्ध है।"
    },
    3: {
      q: "eSIM कैसे इंस्टॉल किया जाता है?",
      a: "खरीदारी के बाद, आपको ईमेल द्वारा इंस्टॉलेशन निर्देश और एक QR कोड प्राप्त होगा। अपने डिवाइस पर जाएं सेटिंग्स → सेल्युलर/मोबाइल डेटा → डेटा प्लान जोड़ें और कोड स्कैन करें। संकेतों के बाद सक्रियण स्वचालित रूप से पूरा हो जाता है।"
    },
    4: {
      q: "क्या एक ही डिवाइस पर फिजिकल सिम और eSIM को एक साथ उपयोग किया जा सकता है?",
      a: "अधिकांश eSIM समर्थित डिवाइस डुअल सिम को सपोर्ट करते हैं। आप वॉयस और मैसेजिंग के लिए अपना प्राथमिक नंबर रख सकते हैं और डेटा के लिए eSIM का उपयोग कर सकते हैं। चयन डिवाइस सेटिंग में नियंत्रित किया जाता है।"
    },
    5: {
      q: "यदि आवंटित डेटा पूरी तरह से उपयोग नहीं किया जाता है तो क्या होगा?",
      a: "अप्रयुक्त डेटा आगे नहीं बढ़ता है और न ही रिफंड योग्य है। प्लान उनकी वैधता अवधि के अंत में समाप्त हो जाते हैं। अपनी अपेक्षित यात्रा उपयोग के अनुसार एक उपयुक्त प्लान चुनें।"
    },
    6: {
      q: "क्या सक्रिय प्लान में डेटा जोड़ना या उसे बढ़ाना संभव है?",
      a: "हाँ। आप अतिरिक्त डेटा प्राप्त कर सकते हैं या सेवा का विस्तार कर सकते हैं वेबसाइट या अपने खाते के पोर्टल के माध्यम से दूसरा प्लान खरीदकर, जो गंतव्य की उपलब्धता पर निर्भर करता है।"
    },
    7: {
      q: "क्या डिवाइस अनलॉक होना चाहिए?",
      a: "हाँ। किसी अन्य प्रदाता का eSIM उपयोग करने के लिए, आपका डिवाइस अनलॉक होना चाहिए। यदि यह कैरियर-लॉक है, तो सक्रियण से पहले अपने कैरियर से अनलॉक करने का अनुरोध करें।"
    },
    8: {
      q: "यदि eSIM अपेक्षित रूप से काम नहीं करता है तो क्या कदम उठाने चाहिए?",
      a: "सुनिश्चित करें कि डिवाइस अनलॉक है और eSIM समर्थित है। डेटा रोमिंग सक्षम करें, सही डेटा प्लान चुनें और डिवाइस को रीस्टार्ट करने का प्रयास करें। यदि समस्या बनी रहती है, तो सहायता से संपर्क करें।"
    },
    9: {
      q: "क्या रिफंड उपलब्ध हैं?",
      a: "यदि eSIM सक्रिय या उपयोग नहीं किया गया है, तो खरीद के 24 घंटों के भीतर रिफंड उपलब्ध हो सकता है। एक बार सक्रिय होने के बाद, बिक्री अंतिम होती है। तकनीकी समस्याओं के लिए, सहायता सुधार करने या उपयुक्त होने पर खाता क्रेडिट जारी करने का प्रयास करेगी।"
    },
    10: {
      q: "सहायता के घंटे और प्रतिक्रिया की अपेक्षाएँ क्या हैं?",
      a: "ईमेल सहायता निरंतर उपलब्ध है। सामान्य प्रतिक्रिया समय कुछ घंटों के भीतर होता है। यात्रा के दौरान रिपोर्ट की गई समय-संवेदनशील समस्याओं को उच्च प्राथमिकता दी जाती है।"
    }
  }
}

  },
};

export default translations;